export const tokens = {
    $nested: {
        animation: {
            duration: {
                fast: '150ms',
                quick: '300ms',
                slow: '600ms',
            },
            headerFlyout: {
                base: {
                    lg: {
                        background: 'rgb(255, 255, 255)',
                    },
                    md: {
                        background: 'rgb(255, 255, 255)',
                    },
                    sm: {
                        background: 'rgb(255, 255, 255)',
                    },
                },
            },
            timing: {
                snappy: 'cubic-bezier(0.65, 0.3, 0, 1)',
                soft: 'cubic-bezier(0.25, 0.1, 0, 1)',
            },
        },
        borderWidth: {
            none: '0',
            sm: '0.125rem',
            xs: '0.0625rem',
        },
        colors: {
            benefit: {
                base: {
                    '900': 'rgb(158, 40, 150)',
                },
                onBase: {
                    '900': 'rgb(255, 255, 255)',
                },
            },
            dark: {
                '900': 'rgb(0, 0, 0)',
            },
            error: {
                base: {
                    '900': 'rgb(237, 0, 7)',
                },
                onBase: {
                    '900': 'rgb(255, 255, 255)',
                },
            },
            light: {
                '900': 'rgb(255, 255, 255)',
            },
            overlay: {
                dark: {
                    '100': 'rgba(0, 0, 0, 0.1)',
                    '200': 'rgba(0, 0, 0, 0.2)',
                    '300': 'rgba(0, 0, 0, 0.3)',
                    '400': 'rgba(0, 0, 0, 0.4)',
                    '50': 'rgba(0, 0, 0, 0.05)',
                    '500': 'rgba(0, 0, 0, 0.5)',
                    '600': 'rgba(0, 0, 0, 0.6)',
                    '700': 'rgba(0, 0, 0, 0.7)',
                    '800': 'rgba(0, 0, 0, 0.8)',
                    '900': 'rgba(0, 0, 0, 0.9)',
                },
                light: {
                    '100': 'rgba(255, 255, 255, 0.1)',
                    '200': 'rgba(255, 255, 255, 0.2)',
                    '300': 'rgba(255, 255, 255, 0.3)',
                    '400': 'rgba(255, 255, 255, 0.4)',
                    '50': 'rgba(255, 255, 255, 0.05)',
                    '500': 'rgba(255, 255, 255, 0.5)',
                    '600': 'rgba(255, 255, 255, 0.6)',
                    '700': 'rgba(255, 255, 255, 0.7)',
                    '800': 'rgba(255, 255, 255, 0.8)',
                    '900': 'rgba(255, 255, 255, 0.9)',
                },
            },
            primary: {
                base: {
                    '100': 'rgb(209, 228, 255)',
                    '200': 'rgb(157, 201, 255)',
                    '300': 'rgb(86, 176, 255)',
                    '400': 'rgb(0, 150, 232)',
                    '50': 'rgb(232, 241, 255)',
                    '500': 'rgb(0, 123, 192)',
                    '600': 'rgb(0, 98, 154)',
                    '700': 'rgb(0, 73, 117)',
                    '800': 'rgb(0, 50, 83)',
                    '900': 'rgb(0, 18, 34)',
                },
                onBase: {
                    '100': 'rgb(0, 0, 0)',
                    '200': 'rgb(0, 0, 0)',
                    '300': 'rgb(0, 0, 0)',
                    '400': 'rgb(0, 0, 0)',
                    '50': 'rgb(0, 0, 0)',
                    '500': 'rgb(255, 255, 255)',
                    '600': 'rgb(255, 255, 255)',
                    '700': 'rgb(255, 255, 255)',
                    '800': 'rgb(255, 255, 255)',
                    '900': 'rgb(255, 255, 255)',
                },
                onUi: {
                    default: 'rgb(255, 255, 255)',
                    disabled: 'rgb(255, 255, 255)',
                    focused: 'rgb(255, 255, 255)',
                    hover: 'rgb(255, 255, 255)',
                    pressed: 'rgb(255, 255, 255)',
                },
                ui: {
                    default: 'rgb(0, 123, 192)',
                    disabled: 'rgb(0, 123, 192)',
                    focused: 'rgb(0, 98, 154)',
                    hover: 'rgb(0, 98, 154)',
                    pressed: 'rgb(0, 73, 117)',
                },
            },
            secondary: {
                base: {
                    '100': 'rgb(239, 241, 242)',
                    '200': 'rgb(224, 226, 229)',
                    '300': 'rgb(164, 171, 179)',
                    '400': 'rgb(138, 144, 151)',
                    '50': 'rgb(255, 255, 255)',
                    '500': 'rgb(113, 118, 124)',
                    '600': 'rgb(89, 94, 98)',
                    '700': 'rgb(67, 70, 74)',
                    '800': 'rgb(46, 48, 51)',
                    '900': 'rgb(26, 28, 29)',
                },
                onBase: {
                    '100': 'rgb(0, 0, 0)',
                    '200': 'rgb(0, 0, 0)',
                    '300': 'rgb(0, 0, 0)',
                    '400': 'rgb(0, 0, 0)',
                    '50': 'rgb(0, 0, 0)',
                    '500': 'rgb(255, 255, 255)',
                    '600': 'rgb(255, 255, 255)',
                    '700': 'rgb(255, 255, 255)',
                    '800': 'rgb(255, 255, 255)',
                    '900': 'rgb(255, 255, 255)',
                },
                onUi: {
                    default: 'rgb(0, 0, 0)',
                    disabled: 'rgb(0, 0, 0)',
                    focused: 'rgb(255, 255, 255)',
                    hover: 'rgb(255, 255, 255)',
                    pressed: 'rgb(255, 255, 255)',
                },
                ui: {
                    default: 'rgb(138, 144, 151)',
                    disabled: 'rgb(138, 144, 151)',
                    focused: 'rgb(113, 118, 124)',
                    hover: 'rgb(113, 118, 124)',
                    pressed: 'rgb(113, 118, 124)',
                },
            },
            selected: {
                base: {
                    default: 'rgb(0, 123, 192)',
                    disabled: 'rgb(193, 199, 204)',
                    focused: 'rgb(0, 98, 154)',
                    hover: 'rgb(0, 98, 154)',
                    pressed: 'rgb(0, 73, 117)',
                },
                onBase: {
                    default: 'rgb(255, 255, 255)',
                    disabled: 'rgb(67, 70, 74)',
                    focused: 'rgb(255, 255, 255)',
                    hover: 'rgb(255, 255, 255)',
                    pressed: 'rgb(255, 255, 255)',
                },
            },
            surface: {
                base: {
                    '100': 'rgb(239, 241, 242)',
                    '200': 'rgb(224, 226, 229)',
                    '300': 'rgb(193, 199, 204)',
                    '400': 'rgb(138, 144, 151)',
                    '50': 'rgb(255, 255, 255)',
                    '500': 'rgb(113, 118, 124)',
                    '600': 'rgb(89, 94, 98)',
                    '700': 'rgb(67, 70, 74)',
                    '800': 'rgb(46, 48, 51)',
                    '900': 'rgb(26, 28, 29)',
                },
                onBase: {
                    '100': 'rgb(0, 0, 0)',
                    '200': 'rgb(0, 0, 0)',
                    '300': 'rgb(0, 0, 0)',
                    '400': 'rgb(0, 0, 0)',
                    '50': 'rgb(0, 0, 0)',
                    '500': 'rgb(255, 255, 255)',
                    '600': 'rgb(255, 255, 255)',
                    '700': 'rgb(255, 255, 255)',
                    '800': 'rgb(255, 255, 255)',
                    '900': 'rgb(255, 255, 255)',
                },
                onUi: {
                    default: 'rgb(255, 255, 255)',
                    disabled: 'rgb(255, 255, 255)',
                    focused: 'rgb(255, 255, 255)',
                    hover: 'rgb(255, 255, 255)',
                    pressed: 'rgb(255, 255, 255)',
                },
                ui: {
                    default: 'rgb(26, 28, 29)',
                    disabled: 'rgb(113, 118, 124)',
                    focused: 'rgb(67, 70, 74)',
                    hover: 'rgb(46, 48, 51)',
                    pressed: 'rgb(67, 70, 74)',
                },
            },
            unselected: {
                base: {
                    default: 'rgb(138, 144, 151)',
                    disabled: 'rgb(193, 199, 204)',
                    focused: 'rgb(113, 118, 124)',
                    hover: 'rgb(113, 118, 124)',
                    pressed: 'rgb(89, 94, 98)',
                },
                onBase: {
                    default: 'rgb(0, 0, 0)',
                    disabled: 'rgb(67, 70, 74)',
                    focused: 'rgb(255, 255, 255)',
                    hover: 'rgb(255, 255, 255)',
                    pressed: 'rgb(255, 255, 255)',
                },
            },
            validated: {
                base: {
                    '900': 'rgb(0, 136, 74)',
                },
                onBase: {
                    '900': 'rgb(255, 255, 255)',
                },
            },
            warning: {
                base: {
                    '900': 'rgb(255, 207, 0)',
                },
                onBase: {
                    '900': 'rgb(255, 255, 255)',
                },
            },
        },
        emphasis: {
            full: 1,
            high: 0.8,
            low: 0.4,
            medium: 0.65,
            subtle: 0.2,
        },
        filter: {
            backdropBlur: {
                lg: 'blur(24px)',
                md: 'blur(16px)',
                sm: 'blur(4px)',
                xl: 'blur(48px)',
                xs: 'blur(2px)',
            },
            blur: {
                lg: 'blur(24px)',
                md: 'blur(16px)',
                sm: 'blur(4px)',
                xl: 'blur(48px)',
                xs: 'blur(2px)',
            },
            brightness: {
                darker: {
                    lg: 'brightness(0.94)',
                    md: 'brightness(0.96)',
                    sm: 'brightness(0.98)',
                },
                lighter: {
                    lg: 'brightness(1.16)',
                    md: 'brightness(1.10)',
                    sm: 'brightness(1.04)',
                },
            },
            contrast: {
                higher: {
                    lg: 'contrast(1.16)',
                    md: 'contrast(1.10)',
                    sm: 'contrast(1.04)',
                },
                lower: {
                    lg: 'contrast(0.92)',
                    md: 'contrast(0.96)',
                    sm: 'contrast(0.98)',
                },
            },
        },
        fontFamily: {
            bodytext: 'Bosch Sans, sans-serif',
            headline: 'Bosch Sans, sans-serif',
        },
        fontSize: {
            '2xl': '2rem',
            '2xs': '0.75rem',
            '3xl': '2.25rem',
            '3xs': '0.625rem',
            '4xl': '2.625rem',
            '5xl': '4rem',
            '6xl': '5rem',
            '7xl': '7.5rem',
            lg: '1.5rem',
            md: '1.25rem',
            sm: '1rem',
            xl: '1.75rem',
            xs: '0.875rem',
        },
        fontWeight: {
            bodytext: {
                bold: 'Bold',
                normal: 'Regular',
            },
            headline: {
                bold: 'Bold',
                normal: 'Regular',
            },
        },
        gradients: {
            imageOverlay: {
                base: {
                    bottomTop: 'linear-gradient(180deg, #0000000d 0%, #0000000d 50%, #00000099 100%);',
                    leftRight: 'linear-gradient(90deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
                    rightLeft: 'linear-gradient(90deg, #0000000d 0%, #0000000d 50%, #00000099 100%);',
                    topBottom: 'linear-gradient(180deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
                },
            },
        },
        letterSpacing: {
            default: '0em',
            extended: '0.04em',
            increased: '0.01em',
        },
        lineHeight: {
            '2xl': '2.5rem',
            '2xs': '1rem',
            '3xl': '2.75rem',
            '3xs': '0.75rem',
            '4xl': '3.5rem',
            '5xl': '4.5rem',
            '6xl': '6rem',
            '7xl': '8.5rem',
            lg: '2rem',
            md: '1.75rem',
            sm: '1.5rem',
            xl: '2.25rem',
            xs: '1.25rem',
        },
        radii: {
            full: '624.9375rem',
            lg: '0',
            md: '0',
            none: '0',
            sm: '0',
            xl: '0',
            xs: '0',
        },
        shadow: {
            boxShadow: {
                bottom: {
                    '2xl': {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04), 0px 32px 64px 0px rgba(0, 0, 0, 0.04), 0px 64px 128px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px 32px 64px rgba(0, 0, 0, 0.04)) drop-shadow(0px 64px 128px rgba(0, 0, 0, 0.04))',
                    },
                    lg: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
                    },
                    md: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
                    },
                    sm: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04))',
                    },
                    xl: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04), 0px 32px 64px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px 32px 64px rgba(0, 0, 0, 0.04))',
                    },
                },
                top: {
                    '2xl': {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04), 0px -32px 64px 0px rgba(0, 0, 0, 0.04), 0px -64px 128px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px -32px 64px rgba(0, 0, 0, 0.04)) drop-shadow(0px -64px 128px rgba(0, 0, 0, 0.04))',
                    },
                    lg: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04))',
                    },
                    md: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04))',
                    },
                    sm: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04))',
                    },
                    xl: {
                        'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04), 0px -32px 64px 0px rgba(0, 0, 0, 0.04)',
                        'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px -32px 64px rgba(0, 0, 0, 0.04))',
                    },
                },
            },
        },
        size: {
            large: {
                md: '11rem',
                sm: '6.5rem',
                xs: '5rem',
            },
            small: {
                '2xl': '3rem',
                '3xl': '4rem',
                lg: '1.5rem',
                md: '1rem',
                sm: '0.75rem',
                xl: '2rem',
                xs: '0.5rem',
                xxs: '0.25rem',
            },
        },
        space: {
            base: '0.25rem',
            large: {
                md: '11rem',
                sm: '6.5rem',
                xs: '5rem',
            },
            small: {
                '2xl': '3rem',
                '3xl': '4rem',
                lg: '1.5rem',
                md: '1rem',
                sm: '0.75rem',
                xl: '2rem',
                xs: '0.5rem',
                xxs: '0.25rem',
            },
        },
        styles: {
            award: {
                '2xs': {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '3rem',
                    padding: '0.25rem',
                    width: '3rem',
                },
                '3xs': {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '2.5rem',
                    padding: '0.25rem',
                    width: '2.5rem',
                },
                lg: {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '14.5rem',
                    padding: '2rem',
                    width: '14.5rem',
                },
                md: {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '11rem',
                    padding: '1.5rem',
                    width: '11rem',
                },
                sm: {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '9rem',
                    padding: '1rem',
                    width: '9rem',
                },
                xs: {
                    background: 'rgb(255, 255, 255)',
                    borderColor: 'rgb(224, 226, 229)',
                    borderRadius: '0',
                    borderStyle: 'solid',
                    borderWidth: '0.0625rem',
                    height: '4rem',
                    padding: '0.5rem',
                    width: '4rem',
                },
            },
        },
        transform: {
            scale: {
                down: {
                    lg: 'scale(0.94)',
                    md: 'scale(0.96)',
                    sm: 'scale(0.98)',
                },
                up: {
                    lg: 'scale(1.06)',
                    md: 'scale(1.04)',
                    sm: 'scale(1.02)',
                },
            },
        },
        wrapper: {
            width: {
                '2xl': '72.5rem',
                '2xs': '23.5rem',
                '3xl': '87.5rem',
                '3xs': '21.5rem',
                lg: '50rem',
                md: '42rem',
                sm: '28rem',
                xl: '60rem',
                xs: '26rem',
            },
        },
    },
    animation: {
        'duration-fast': '150ms',
        'duration-quick': '300ms',
        'duration-slow': '600ms',
        'headerFlyout-base-lg-background': 'rgb(255, 255, 255)',
        'headerFlyout-base-md-background': 'rgb(255, 255, 255)',
        'headerFlyout-base-sm-background': 'rgb(255, 255, 255)',
        'timing-snappy': 'cubic-bezier(0.65, 0.3, 0, 1)',
        'timing-soft': 'cubic-bezier(0.25, 0.1, 0, 1)',
    },
    borderWidth: {
        none: '0',
        sm: '0.125rem',
        xs: '0.0625rem',
    },
    colors: {
        'benefit-base-900': 'rgb(158, 40, 150)',
        'benefit-onBase-900': 'rgb(255, 255, 255)',
        'dark-900': 'rgb(0, 0, 0)',
        'error-base-900': 'rgb(237, 0, 7)',
        'error-onBase-900': 'rgb(255, 255, 255)',
        'light-900': 'rgb(255, 255, 255)',
        'overlay-dark-100': 'rgba(0, 0, 0, 0.1)',
        'overlay-dark-200': 'rgba(0, 0, 0, 0.2)',
        'overlay-dark-300': 'rgba(0, 0, 0, 0.3)',
        'overlay-dark-400': 'rgba(0, 0, 0, 0.4)',
        'overlay-dark-50': 'rgba(0, 0, 0, 0.05)',
        'overlay-dark-500': 'rgba(0, 0, 0, 0.5)',
        'overlay-dark-600': 'rgba(0, 0, 0, 0.6)',
        'overlay-dark-700': 'rgba(0, 0, 0, 0.7)',
        'overlay-dark-800': 'rgba(0, 0, 0, 0.8)',
        'overlay-dark-900': 'rgba(0, 0, 0, 0.9)',
        'overlay-light-100': 'rgba(255, 255, 255, 0.1)',
        'overlay-light-200': 'rgba(255, 255, 255, 0.2)',
        'overlay-light-300': 'rgba(255, 255, 255, 0.3)',
        'overlay-light-400': 'rgba(255, 255, 255, 0.4)',
        'overlay-light-50': 'rgba(255, 255, 255, 0.05)',
        'overlay-light-500': 'rgba(255, 255, 255, 0.5)',
        'overlay-light-600': 'rgba(255, 255, 255, 0.6)',
        'overlay-light-700': 'rgba(255, 255, 255, 0.7)',
        'overlay-light-800': 'rgba(255, 255, 255, 0.8)',
        'overlay-light-900': 'rgba(255, 255, 255, 0.9)',
        'primary-base-100': 'rgb(209, 228, 255)',
        'primary-base-200': 'rgb(157, 201, 255)',
        'primary-base-300': 'rgb(86, 176, 255)',
        'primary-base-400': 'rgb(0, 150, 232)',
        'primary-base-50': 'rgb(232, 241, 255)',
        'primary-base-500': 'rgb(0, 123, 192)',
        'primary-base-600': 'rgb(0, 98, 154)',
        'primary-base-700': 'rgb(0, 73, 117)',
        'primary-base-800': 'rgb(0, 50, 83)',
        'primary-base-900': 'rgb(0, 18, 34)',
        'primary-onBase-100': 'rgb(0, 0, 0)',
        'primary-onBase-200': 'rgb(0, 0, 0)',
        'primary-onBase-300': 'rgb(0, 0, 0)',
        'primary-onBase-400': 'rgb(0, 0, 0)',
        'primary-onBase-50': 'rgb(0, 0, 0)',
        'primary-onBase-500': 'rgb(255, 255, 255)',
        'primary-onBase-600': 'rgb(255, 255, 255)',
        'primary-onBase-700': 'rgb(255, 255, 255)',
        'primary-onBase-800': 'rgb(255, 255, 255)',
        'primary-onBase-900': 'rgb(255, 255, 255)',
        'primary-onUi-default': 'rgb(255, 255, 255)',
        'primary-onUi-disabled': 'rgb(255, 255, 255)',
        'primary-onUi-focused': 'rgb(255, 255, 255)',
        'primary-onUi-hover': 'rgb(255, 255, 255)',
        'primary-onUi-pressed': 'rgb(255, 255, 255)',
        'primary-ui-default': 'rgb(0, 123, 192)',
        'primary-ui-disabled': 'rgb(0, 123, 192)',
        'primary-ui-focused': 'rgb(0, 98, 154)',
        'primary-ui-hover': 'rgb(0, 98, 154)',
        'primary-ui-pressed': 'rgb(0, 73, 117)',
        'secondary-base-100': 'rgb(239, 241, 242)',
        'secondary-base-200': 'rgb(224, 226, 229)',
        'secondary-base-300': 'rgb(164, 171, 179)',
        'secondary-base-400': 'rgb(138, 144, 151)',
        'secondary-base-50': 'rgb(255, 255, 255)',
        'secondary-base-500': 'rgb(113, 118, 124)',
        'secondary-base-600': 'rgb(89, 94, 98)',
        'secondary-base-700': 'rgb(67, 70, 74)',
        'secondary-base-800': 'rgb(46, 48, 51)',
        'secondary-base-900': 'rgb(26, 28, 29)',
        'secondary-onBase-100': 'rgb(0, 0, 0)',
        'secondary-onBase-200': 'rgb(0, 0, 0)',
        'secondary-onBase-300': 'rgb(0, 0, 0)',
        'secondary-onBase-400': 'rgb(0, 0, 0)',
        'secondary-onBase-50': 'rgb(0, 0, 0)',
        'secondary-onBase-500': 'rgb(255, 255, 255)',
        'secondary-onBase-600': 'rgb(255, 255, 255)',
        'secondary-onBase-700': 'rgb(255, 255, 255)',
        'secondary-onBase-800': 'rgb(255, 255, 255)',
        'secondary-onBase-900': 'rgb(255, 255, 255)',
        'secondary-onUi-default': 'rgb(0, 0, 0)',
        'secondary-onUi-disabled': 'rgb(0, 0, 0)',
        'secondary-onUi-focused': 'rgb(255, 255, 255)',
        'secondary-onUi-hover': 'rgb(255, 255, 255)',
        'secondary-onUi-pressed': 'rgb(255, 255, 255)',
        'secondary-ui-default': 'rgb(138, 144, 151)',
        'secondary-ui-disabled': 'rgb(138, 144, 151)',
        'secondary-ui-focused': 'rgb(113, 118, 124)',
        'secondary-ui-hover': 'rgb(113, 118, 124)',
        'secondary-ui-pressed': 'rgb(113, 118, 124)',
        'selected-base-default': 'rgb(0, 123, 192)',
        'selected-base-disabled': 'rgb(193, 199, 204)',
        'selected-base-focused': 'rgb(0, 98, 154)',
        'selected-base-hover': 'rgb(0, 98, 154)',
        'selected-base-pressed': 'rgb(0, 73, 117)',
        'selected-onBase-default': 'rgb(255, 255, 255)',
        'selected-onBase-disabled': 'rgb(67, 70, 74)',
        'selected-onBase-focused': 'rgb(255, 255, 255)',
        'selected-onBase-hover': 'rgb(255, 255, 255)',
        'selected-onBase-pressed': 'rgb(255, 255, 255)',
        'surface-base-100': 'rgb(239, 241, 242)',
        'surface-base-200': 'rgb(224, 226, 229)',
        'surface-base-300': 'rgb(193, 199, 204)',
        'surface-base-400': 'rgb(138, 144, 151)',
        'surface-base-50': 'rgb(255, 255, 255)',
        'surface-base-500': 'rgb(113, 118, 124)',
        'surface-base-600': 'rgb(89, 94, 98)',
        'surface-base-700': 'rgb(67, 70, 74)',
        'surface-base-800': 'rgb(46, 48, 51)',
        'surface-base-900': 'rgb(26, 28, 29)',
        'surface-onBase-100': 'rgb(0, 0, 0)',
        'surface-onBase-200': 'rgb(0, 0, 0)',
        'surface-onBase-300': 'rgb(0, 0, 0)',
        'surface-onBase-400': 'rgb(0, 0, 0)',
        'surface-onBase-50': 'rgb(0, 0, 0)',
        'surface-onBase-500': 'rgb(255, 255, 255)',
        'surface-onBase-600': 'rgb(255, 255, 255)',
        'surface-onBase-700': 'rgb(255, 255, 255)',
        'surface-onBase-800': 'rgb(255, 255, 255)',
        'surface-onBase-900': 'rgb(255, 255, 255)',
        'surface-onUi-default': 'rgb(255, 255, 255)',
        'surface-onUi-disabled': 'rgb(255, 255, 255)',
        'surface-onUi-focused': 'rgb(255, 255, 255)',
        'surface-onUi-hover': 'rgb(255, 255, 255)',
        'surface-onUi-pressed': 'rgb(255, 255, 255)',
        'surface-ui-default': 'rgb(26, 28, 29)',
        'surface-ui-disabled': 'rgb(113, 118, 124)',
        'surface-ui-focused': 'rgb(67, 70, 74)',
        'surface-ui-hover': 'rgb(46, 48, 51)',
        'surface-ui-pressed': 'rgb(67, 70, 74)',
        'unselected-base-default': 'rgb(138, 144, 151)',
        'unselected-base-disabled': 'rgb(193, 199, 204)',
        'unselected-base-focused': 'rgb(113, 118, 124)',
        'unselected-base-hover': 'rgb(113, 118, 124)',
        'unselected-base-pressed': 'rgb(89, 94, 98)',
        'unselected-onBase-default': 'rgb(0, 0, 0)',
        'unselected-onBase-disabled': 'rgb(67, 70, 74)',
        'unselected-onBase-focused': 'rgb(255, 255, 255)',
        'unselected-onBase-hover': 'rgb(255, 255, 255)',
        'unselected-onBase-pressed': 'rgb(255, 255, 255)',
        'validated-base-900': 'rgb(0, 136, 74)',
        'validated-onBase-900': 'rgb(255, 255, 255)',
        'warning-base-900': 'rgb(255, 207, 0)',
        'warning-onBase-900': 'rgb(255, 255, 255)',
    },
    emphasis: {
        full: 1,
        high: 0.8,
        low: 0.4,
        medium: 0.65,
        subtle: 0.2,
    },
    filter: {
        'backdropBlur-lg': 'blur(24px)',
        'backdropBlur-md': 'blur(16px)',
        'backdropBlur-sm': 'blur(4px)',
        'backdropBlur-xl': 'blur(48px)',
        'backdropBlur-xs': 'blur(2px)',
        'blur-lg': 'blur(24px)',
        'blur-md': 'blur(16px)',
        'blur-sm': 'blur(4px)',
        'blur-xl': 'blur(48px)',
        'blur-xs': 'blur(2px)',
        'brightness-darker-lg': 'brightness(0.94)',
        'brightness-darker-md': 'brightness(0.96)',
        'brightness-darker-sm': 'brightness(0.98)',
        'brightness-lighter-lg': 'brightness(1.16)',
        'brightness-lighter-md': 'brightness(1.10)',
        'brightness-lighter-sm': 'brightness(1.04)',
        'contrast-higher-lg': 'contrast(1.16)',
        'contrast-higher-md': 'contrast(1.10)',
        'contrast-higher-sm': 'contrast(1.04)',
        'contrast-lower-lg': 'contrast(0.92)',
        'contrast-lower-md': 'contrast(0.96)',
        'contrast-lower-sm': 'contrast(0.98)',
    },
    fontFamily: {
        bodytext: 'Bosch Sans, sans-serif',
        headline: 'Bosch Sans, sans-serif',
    },
    fontSize: {
        '2xl': '2rem',
        '2xs': '0.75rem',
        '3xl': '2.25rem',
        '3xs': '0.625rem',
        '4xl': '2.625rem',
        '5xl': '4rem',
        '6xl': '5rem',
        '7xl': '7.5rem',
        lg: '1.5rem',
        md: '1.25rem',
        sm: '1rem',
        xl: '1.75rem',
        xs: '0.875rem',
    },
    fontWeight: {
        'bodytext-bold': 'Bold',
        'bodytext-normal': 'Regular',
        'headline-bold': 'Bold',
        'headline-normal': 'Regular',
    },
    gradients: {
        'imageOverlay-base-bottomTop': 'linear-gradient(180deg, #0000000d 0%, #0000000d 50%, #00000099 100%);',
        'imageOverlay-base-leftRight': 'linear-gradient(90deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
        'imageOverlay-base-rightLeft': 'linear-gradient(90deg, #0000000d 0%, #0000000d 50%, #00000099 100%);',
        'imageOverlay-base-topBottom': 'linear-gradient(180deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
    },
    letterSpacing: {
        default: '0em',
        extended: '0.04em',
        increased: '0.01em',
    },
    lineHeight: {
        '2xl': '2.5rem',
        '2xs': '1rem',
        '3xl': '2.75rem',
        '3xs': '0.75rem',
        '4xl': '3.5rem',
        '5xl': '4.5rem',
        '6xl': '6rem',
        '7xl': '8.5rem',
        lg: '2rem',
        md: '1.75rem',
        sm: '1.5rem',
        xl: '2.25rem',
        xs: '1.25rem',
    },
    radii: {
        full: '624.9375rem',
        lg: '0',
        md: '0',
        none: '0',
        sm: '0',
        xl: '0',
        xs: '0',
    },
    shadow: {
        'boxShadow-bottom-2xl': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04), 0px 32px 64px 0px rgba(0, 0, 0, 0.04), 0px 64px 128px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px 32px 64px rgba(0, 0, 0, 0.04)) drop-shadow(0px 64px 128px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-bottom-lg': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-bottom-md': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-bottom-sm': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-bottom-xl': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04), 0px 32px 64px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px 32px 64px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-top-2xl': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04), 0px -32px 64px 0px rgba(0, 0, 0, 0.04), 0px -64px 128px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px -32px 64px rgba(0, 0, 0, 0.04)) drop-shadow(0px -64px 128px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-top-lg': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-top-md': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-top-sm': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04))',
        },
        'boxShadow-top-xl': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04), 0px -32px 64px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04)) drop-shadow(0px -32px 64px rgba(0, 0, 0, 0.04))',
        },
    },
    size: {
        'large-md': '11rem',
        'large-sm': '6.5rem',
        'large-xs': '5rem',
        'small-2xl': '3rem',
        'small-3xl': '4rem',
        'small-lg': '1.5rem',
        'small-md': '1rem',
        'small-sm': '0.75rem',
        'small-xl': '2rem',
        'small-xs': '0.5rem',
        'small-xxs': '0.25rem',
    },
    space: {
        base: '0.25rem',
        'large-md': '11rem',
        'large-sm': '6.5rem',
        'large-xs': '5rem',
        'small-2xl': '3rem',
        'small-3xl': '4rem',
        'small-lg': '1.5rem',
        'small-md': '1rem',
        'small-sm': '0.75rem',
        'small-xl': '2rem',
        'small-xs': '0.5rem',
        'small-xxs': '0.25rem',
    },
    styles: {
        'accordion-button-base-lg-closed-hover-gap': '1.5rem',
        'accordion-button-base-lg-closed-hover-paddingBottom': '1.5rem',
        'accordion-button-base-lg-closed-hover-paddingLeft': '0',
        'accordion-button-base-lg-closed-hover-paddingRight': '0',
        'accordion-button-base-lg-closed-hover-paddingTop': '1.5rem',
        'accordion-button-base-lg-closed-initial-gap': '1.5rem',
        'accordion-button-base-lg-closed-initial-paddingBottom': '1.5rem',
        'accordion-button-base-lg-closed-initial-paddingLeft': '0',
        'accordion-button-base-lg-closed-initial-paddingRight': '0',
        'accordion-button-base-lg-closed-initial-paddingTop': '1.5rem',
        'accordion-button-base-lg-closed-pressed-gap': '1.5rem',
        'accordion-button-base-lg-closed-pressed-paddingBottom': '1.5rem',
        'accordion-button-base-lg-closed-pressed-paddingLeft': '0',
        'accordion-button-base-lg-closed-pressed-paddingRight': '0',
        'accordion-button-base-lg-closed-pressed-paddingTop': '1.5rem',
        'accordion-button-base-lg-open-hover-gap': '1.5rem',
        'accordion-button-base-lg-open-hover-paddingBottom': '1.5rem',
        'accordion-button-base-lg-open-hover-paddingLeft': '0',
        'accordion-button-base-lg-open-hover-paddingRight': '0',
        'accordion-button-base-lg-open-hover-paddingTop': '1.5rem',
        'accordion-button-base-lg-open-initial-gap': '1.5rem',
        'accordion-button-base-lg-open-initial-paddingBottom': '1.5rem',
        'accordion-button-base-lg-open-initial-paddingLeft': '0',
        'accordion-button-base-lg-open-initial-paddingRight': '0',
        'accordion-button-base-lg-open-initial-paddingTop': '1.5rem',
        'accordion-button-base-lg-open-pressed-gap': '1.5rem',
        'accordion-button-base-lg-open-pressed-paddingBottom': '1.5rem',
        'accordion-button-base-lg-open-pressed-paddingLeft': '0',
        'accordion-button-base-lg-open-pressed-paddingRight': '0',
        'accordion-button-base-lg-open-pressed-paddingTop': '1.5rem',
        'accordion-button-base-md-closed-hover-gap': '1rem',
        'accordion-button-base-md-closed-hover-paddingBottom': '1rem',
        'accordion-button-base-md-closed-hover-paddingLeft': '0',
        'accordion-button-base-md-closed-hover-paddingRight': '0',
        'accordion-button-base-md-closed-hover-paddingTop': '1rem',
        'accordion-button-base-md-closed-initial-gap': '1rem',
        'accordion-button-base-md-closed-initial-paddingBottom': '1rem',
        'accordion-button-base-md-closed-initial-paddingLeft': '0',
        'accordion-button-base-md-closed-initial-paddingRight': '0',
        'accordion-button-base-md-closed-initial-paddingTop': '1rem',
        'accordion-button-base-md-closed-pressed-gap': '1rem',
        'accordion-button-base-md-closed-pressed-paddingBottom': '1rem',
        'accordion-button-base-md-closed-pressed-paddingLeft': '0',
        'accordion-button-base-md-closed-pressed-paddingRight': '0',
        'accordion-button-base-md-closed-pressed-paddingTop': '1rem',
        'accordion-button-base-md-open-hover-gap': '1rem',
        'accordion-button-base-md-open-hover-paddingBottom': '1rem',
        'accordion-button-base-md-open-hover-paddingLeft': '0',
        'accordion-button-base-md-open-hover-paddingRight': '0',
        'accordion-button-base-md-open-hover-paddingTop': '1rem',
        'accordion-button-base-md-open-initial-gap': '1rem',
        'accordion-button-base-md-open-initial-paddingBottom': '1rem',
        'accordion-button-base-md-open-initial-paddingLeft': '0',
        'accordion-button-base-md-open-initial-paddingRight': '0',
        'accordion-button-base-md-open-initial-paddingTop': '1rem',
        'accordion-button-base-md-open-pressed-gap': '1rem',
        'accordion-button-base-md-open-pressed-paddingBottom': '1rem',
        'accordion-button-base-md-open-pressed-paddingLeft': '0',
        'accordion-button-base-md-open-pressed-paddingRight': '0',
        'accordion-button-base-md-open-pressed-paddingTop': '1rem',
        'accordion-button-base-sm-closed-hover-gap': '1rem',
        'accordion-button-base-sm-closed-hover-paddingBottom': '0.75rem',
        'accordion-button-base-sm-closed-hover-paddingLeft': '0',
        'accordion-button-base-sm-closed-hover-paddingRight': '0',
        'accordion-button-base-sm-closed-hover-paddingTop': '0.75rem',
        'accordion-button-base-sm-closed-initial-gap': '1rem',
        'accordion-button-base-sm-closed-initial-paddingBottom': '0.75rem',
        'accordion-button-base-sm-closed-initial-paddingLeft': '0',
        'accordion-button-base-sm-closed-initial-paddingRight': '0',
        'accordion-button-base-sm-closed-initial-paddingTop': '0.75rem',
        'accordion-button-base-sm-closed-pressed-gap': '1rem',
        'accordion-button-base-sm-closed-pressed-paddingBottom': '0.75rem',
        'accordion-button-base-sm-closed-pressed-paddingLeft': '0',
        'accordion-button-base-sm-closed-pressed-paddingRight': '0',
        'accordion-button-base-sm-closed-pressed-paddingTop': '0.75rem',
        'accordion-button-base-sm-open-hover-gap': '1rem',
        'accordion-button-base-sm-open-hover-paddingBottom': '0.75rem',
        'accordion-button-base-sm-open-hover-paddingLeft': '0',
        'accordion-button-base-sm-open-hover-paddingRight': '0',
        'accordion-button-base-sm-open-hover-paddingTop': '0.75rem',
        'accordion-button-base-sm-open-initial-gap': '1rem',
        'accordion-button-base-sm-open-initial-paddingBottom': '0.75rem',
        'accordion-button-base-sm-open-initial-paddingLeft': '0',
        'accordion-button-base-sm-open-initial-paddingRight': '0',
        'accordion-button-base-sm-open-initial-paddingTop': '0.75rem',
        'accordion-button-base-sm-open-pressed-gap': '1rem',
        'accordion-button-base-sm-open-pressed-paddingBottom': '0.75rem',
        'accordion-button-base-sm-open-pressed-paddingLeft': '0',
        'accordion-button-base-sm-open-pressed-paddingRight': '0',
        'accordion-button-base-sm-open-pressed-paddingTop': '0.75rem',
        'accordion-button-base-xl-closed-hover-gap': '1.5rem',
        'accordion-button-base-xl-closed-hover-paddingBottom': '2rem',
        'accordion-button-base-xl-closed-hover-paddingLeft': '0',
        'accordion-button-base-xl-closed-hover-paddingRight': '0',
        'accordion-button-base-xl-closed-hover-paddingTop': '2rem',
        'accordion-button-base-xl-closed-initial-gap': '1.5rem',
        'accordion-button-base-xl-closed-initial-paddingBottom': '2rem',
        'accordion-button-base-xl-closed-initial-paddingLeft': '0',
        'accordion-button-base-xl-closed-initial-paddingRight': '0',
        'accordion-button-base-xl-closed-initial-paddingTop': '2rem',
        'accordion-button-base-xl-closed-pressed-gap': '1.5rem',
        'accordion-button-base-xl-closed-pressed-paddingBottom': '2rem',
        'accordion-button-base-xl-closed-pressed-paddingLeft': '0',
        'accordion-button-base-xl-closed-pressed-paddingRight': '0',
        'accordion-button-base-xl-closed-pressed-paddingTop': '2rem',
        'accordion-button-base-xl-open-hover-gap': '1.5rem',
        'accordion-button-base-xl-open-hover-paddingBottom': '2rem',
        'accordion-button-base-xl-open-hover-paddingLeft': '0',
        'accordion-button-base-xl-open-hover-paddingRight': '0',
        'accordion-button-base-xl-open-hover-paddingTop': '2rem',
        'accordion-button-base-xl-open-initial-gap': '1.5rem',
        'accordion-button-base-xl-open-initial-paddingBottom': '2rem',
        'accordion-button-base-xl-open-initial-paddingLeft': '0',
        'accordion-button-base-xl-open-initial-paddingRight': '0',
        'accordion-button-base-xl-open-initial-paddingTop': '2rem',
        'accordion-button-base-xl-open-pressed-gap': '1.5rem',
        'accordion-button-base-xl-open-pressed-paddingBottom': '2rem',
        'accordion-button-base-xl-open-pressed-paddingLeft': '0',
        'accordion-button-base-xl-open-pressed-paddingRight': '0',
        'accordion-button-base-xl-open-pressed-paddingTop': '2rem',
        'accordion-button-base-xs-closed-hover-gap': '0.75rem',
        'accordion-button-base-xs-closed-hover-paddingBottom': '0.5rem',
        'accordion-button-base-xs-closed-hover-paddingLeft': '0',
        'accordion-button-base-xs-closed-hover-paddingRight': '0',
        'accordion-button-base-xs-closed-hover-paddingTop': '0.5rem',
        'accordion-button-base-xs-closed-initial-gap': '0.75rem',
        'accordion-button-base-xs-closed-initial-paddingBottom': '0.5rem',
        'accordion-button-base-xs-closed-initial-paddingLeft': '0',
        'accordion-button-base-xs-closed-initial-paddingRight': '0',
        'accordion-button-base-xs-closed-initial-paddingTop': '0.5rem',
        'accordion-button-base-xs-closed-pressed-gap': '0.75rem',
        'accordion-button-base-xs-closed-pressed-paddingBottom': '0.5rem',
        'accordion-button-base-xs-closed-pressed-paddingLeft': '0',
        'accordion-button-base-xs-closed-pressed-paddingRight': '0',
        'accordion-button-base-xs-closed-pressed-paddingTop': '0.5rem',
        'accordion-button-base-xs-open-hover-gap': '0.75rem',
        'accordion-button-base-xs-open-hover-paddingBottom': '0.5rem',
        'accordion-button-base-xs-open-hover-paddingLeft': '0',
        'accordion-button-base-xs-open-hover-paddingRight': '0',
        'accordion-button-base-xs-open-hover-paddingTop': '0.5rem',
        'accordion-button-base-xs-open-initial-gap': '0.75rem',
        'accordion-button-base-xs-open-initial-paddingBottom': '0.5rem',
        'accordion-button-base-xs-open-initial-paddingLeft': '0',
        'accordion-button-base-xs-open-initial-paddingRight': '0',
        'accordion-button-base-xs-open-initial-paddingTop': '0.5rem',
        'accordion-button-base-xs-open-pressed-gap': '0.75rem',
        'accordion-button-base-xs-open-pressed-paddingBottom': '0.5rem',
        'accordion-button-base-xs-open-pressed-paddingLeft': '0',
        'accordion-button-base-xs-open-pressed-paddingRight': '0',
        'accordion-button-base-xs-open-pressed-paddingTop': '0.5rem',
        'accordion-button-icon-hover-background': 'rgb(0, 0, 0)',
        'accordion-button-icon-hover-opacity': 0.8,
        'accordion-button-icon-initial-background': 'rgb(0, 0, 0)',
        'accordion-button-icon-initial-opacity': 1,
        'accordion-button-icon-pressed-background': 'rgb(0, 0, 0)',
        'accordion-button-icon-pressed-opacity': 0.65,
        'accordion-button-title-base-lg-gap': '0.5rem',
        'accordion-button-title-base-md-gap': '0.25rem',
        'accordion-button-title-base-sm-gap': '0.25rem',
        'accordion-button-title-base-xl-gap': '0.5rem',
        'accordion-button-title-base-xs-gap': '0.25rem',
        'accordion-button-title-headline-lg-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-lg-hover-fontSize': '1.5rem',
        'accordion-button-title-headline-lg-hover-fontWeight': 'bold',
        'accordion-button-title-headline-lg-hover-letterSpacing': '0em',
        'accordion-button-title-headline-lg-hover-lineHeight': '2rem',
        'accordion-button-title-headline-lg-hover-opacity': 0.8,
        'accordion-button-title-headline-lg-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-lg-initial-fontSize': '1.5rem',
        'accordion-button-title-headline-lg-initial-fontWeight': 'bold',
        'accordion-button-title-headline-lg-initial-letterSpacing': '0em',
        'accordion-button-title-headline-lg-initial-lineHeight': '2rem',
        'accordion-button-title-headline-lg-initial-opacity': 1,
        'accordion-button-title-headline-lg-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-lg-pressed-fontSize': '1.5rem',
        'accordion-button-title-headline-lg-pressed-fontWeight': 'bold',
        'accordion-button-title-headline-lg-pressed-letterSpacing': '0em',
        'accordion-button-title-headline-lg-pressed-lineHeight': '2rem',
        'accordion-button-title-headline-lg-pressed-opacity': 0.65,
        'accordion-button-title-headline-md-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-md-hover-fontSize': '1.25rem',
        'accordion-button-title-headline-md-hover-fontWeight': 'bold',
        'accordion-button-title-headline-md-hover-letterSpacing': '0em',
        'accordion-button-title-headline-md-hover-lineHeight': '1.75rem',
        'accordion-button-title-headline-md-hover-opacity': 0.8,
        'accordion-button-title-headline-md-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-md-initial-fontSize': '1.25rem',
        'accordion-button-title-headline-md-initial-fontWeight': 'bold',
        'accordion-button-title-headline-md-initial-letterSpacing': '0em',
        'accordion-button-title-headline-md-initial-lineHeight': '1.75rem',
        'accordion-button-title-headline-md-initial-opacity': 1,
        'accordion-button-title-headline-md-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-md-pressed-fontSize': '1.25rem',
        'accordion-button-title-headline-md-pressed-fontWeight': 'bold',
        'accordion-button-title-headline-md-pressed-letterSpacing': '0em',
        'accordion-button-title-headline-md-pressed-lineHeight': '1.75rem',
        'accordion-button-title-headline-md-pressed-opacity': 0.65,
        'accordion-button-title-headline-sm-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-sm-hover-fontSize': '1rem',
        'accordion-button-title-headline-sm-hover-fontWeight': 'bold',
        'accordion-button-title-headline-sm-hover-letterSpacing': '0em',
        'accordion-button-title-headline-sm-hover-lineHeight': '1.5rem',
        'accordion-button-title-headline-sm-hover-opacity': 0.8,
        'accordion-button-title-headline-sm-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-sm-initial-fontSize': '1rem',
        'accordion-button-title-headline-sm-initial-fontWeight': 'bold',
        'accordion-button-title-headline-sm-initial-letterSpacing': '0em',
        'accordion-button-title-headline-sm-initial-lineHeight': '1.5rem',
        'accordion-button-title-headline-sm-initial-opacity': 1,
        'accordion-button-title-headline-sm-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-sm-pressed-fontSize': '1rem',
        'accordion-button-title-headline-sm-pressed-fontWeight': 'bold',
        'accordion-button-title-headline-sm-pressed-letterSpacing': '0em',
        'accordion-button-title-headline-sm-pressed-lineHeight': '1.5rem',
        'accordion-button-title-headline-sm-pressed-opacity': 0.65,
        'accordion-button-title-headline-xl-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xl-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xl-hover-fontSize': '1.75rem',
        'accordion-button-title-headline-xl-hover-fontWeight': 'bold',
        'accordion-button-title-headline-xl-hover-letterSpacing': '0em',
        'accordion-button-title-headline-xl-hover-lineHeight': '2.25rem',
        'accordion-button-title-headline-xl-hover-opacity': 0.8,
        'accordion-button-title-headline-xl-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xl-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xl-initial-fontSize': '1.75rem',
        'accordion-button-title-headline-xl-initial-fontWeight': 'bold',
        'accordion-button-title-headline-xl-initial-letterSpacing': '0em',
        'accordion-button-title-headline-xl-initial-lineHeight': '2.25rem',
        'accordion-button-title-headline-xl-initial-opacity': 1,
        'accordion-button-title-headline-xl-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xl-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xl-pressed-fontSize': '1.75rem',
        'accordion-button-title-headline-xl-pressed-fontWeight': 'bold',
        'accordion-button-title-headline-xl-pressed-letterSpacing': '0em',
        'accordion-button-title-headline-xl-pressed-lineHeight': '2.25rem',
        'accordion-button-title-headline-xl-pressed-opacity': 0.65,
        'accordion-button-title-headline-xs-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xs-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xs-hover-fontSize': '0.875rem',
        'accordion-button-title-headline-xs-hover-fontWeight': 'bold',
        'accordion-button-title-headline-xs-hover-letterSpacing': '0em',
        'accordion-button-title-headline-xs-hover-lineHeight': '1.25rem',
        'accordion-button-title-headline-xs-hover-opacity': 0.8,
        'accordion-button-title-headline-xs-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xs-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xs-initial-fontSize': '0.875rem',
        'accordion-button-title-headline-xs-initial-fontWeight': 'bold',
        'accordion-button-title-headline-xs-initial-letterSpacing': '0em',
        'accordion-button-title-headline-xs-initial-lineHeight': '1.25rem',
        'accordion-button-title-headline-xs-initial-opacity': 1,
        'accordion-button-title-headline-xs-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-headline-xs-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-headline-xs-pressed-fontSize': '0.875rem',
        'accordion-button-title-headline-xs-pressed-fontWeight': 'bold',
        'accordion-button-title-headline-xs-pressed-letterSpacing': '0em',
        'accordion-button-title-headline-xs-pressed-lineHeight': '1.25rem',
        'accordion-button-title-headline-xs-pressed-opacity': 0.65,
        'accordion-button-title-subline-lg-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-lg-hover-fontSize': '1rem',
        'accordion-button-title-subline-lg-hover-fontWeight': 'normal',
        'accordion-button-title-subline-lg-hover-letterSpacing': '0em',
        'accordion-button-title-subline-lg-hover-lineHeight': '1.5rem',
        'accordion-button-title-subline-lg-hover-opacity': 0.8,
        'accordion-button-title-subline-lg-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-lg-initial-fontSize': '1rem',
        'accordion-button-title-subline-lg-initial-fontWeight': 'normal',
        'accordion-button-title-subline-lg-initial-letterSpacing': '0em',
        'accordion-button-title-subline-lg-initial-lineHeight': '1.5rem',
        'accordion-button-title-subline-lg-initial-opacity': 1,
        'accordion-button-title-subline-lg-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-lg-pressed-fontSize': '1rem',
        'accordion-button-title-subline-lg-pressed-fontWeight': 'normal',
        'accordion-button-title-subline-lg-pressed-letterSpacing': '0em',
        'accordion-button-title-subline-lg-pressed-lineHeight': '1.5rem',
        'accordion-button-title-subline-lg-pressed-opacity': 0.65,
        'accordion-button-title-subline-md-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-md-hover-fontSize': '0.875rem',
        'accordion-button-title-subline-md-hover-fontWeight': 'normal',
        'accordion-button-title-subline-md-hover-letterSpacing': '0em',
        'accordion-button-title-subline-md-hover-lineHeight': '1.25rem',
        'accordion-button-title-subline-md-hover-opacity': 0.8,
        'accordion-button-title-subline-md-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-md-initial-fontSize': '0.875rem',
        'accordion-button-title-subline-md-initial-fontWeight': 'normal',
        'accordion-button-title-subline-md-initial-letterSpacing': '0em',
        'accordion-button-title-subline-md-initial-lineHeight': '1.25rem',
        'accordion-button-title-subline-md-initial-opacity': 1,
        'accordion-button-title-subline-md-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-md-pressed-fontSize': '0.875rem',
        'accordion-button-title-subline-md-pressed-fontWeight': 'normal',
        'accordion-button-title-subline-md-pressed-letterSpacing': '0em',
        'accordion-button-title-subline-md-pressed-lineHeight': '1.25rem',
        'accordion-button-title-subline-md-pressed-opacity': 0.65,
        'accordion-button-title-subline-sm-hover-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-sm-hover-fontSize': '0.75rem',
        'accordion-button-title-subline-sm-hover-fontWeight': 'normal',
        'accordion-button-title-subline-sm-hover-letterSpacing': '0em',
        'accordion-button-title-subline-sm-hover-lineHeight': '1rem',
        'accordion-button-title-subline-sm-hover-opacity': 0.8,
        'accordion-button-title-subline-sm-initial-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-sm-initial-fontSize': '0.75rem',
        'accordion-button-title-subline-sm-initial-fontWeight': 'normal',
        'accordion-button-title-subline-sm-initial-letterSpacing': '0em',
        'accordion-button-title-subline-sm-initial-lineHeight': '1rem',
        'accordion-button-title-subline-sm-initial-opacity': 1,
        'accordion-button-title-subline-sm-pressed-color': 'rgb(0, 0, 0)',
        'accordion-button-title-subline-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'accordion-button-title-subline-sm-pressed-fontSize': '0.75rem',
        'accordion-button-title-subline-sm-pressed-fontWeight': 'normal',
        'accordion-button-title-subline-sm-pressed-letterSpacing': '0em',
        'accordion-button-title-subline-sm-pressed-lineHeight': '1rem',
        'accordion-button-title-subline-sm-pressed-opacity': 0.65,
        'accordion-content-lg-paddingBottom': '1.5rem',
        'accordion-content-md-paddingBottom': '1rem',
        'accordion-content-sm-paddingBottom': '0.75rem',
        'accordion-content-xl-paddingBottom': '2rem',
        'accordion-content-xs-paddingBottom': '0.5rem',
        'accordion-divider-background': 'rgb(224, 226, 229)',
        'accordion-divider-height': '0.0625rem',
        'badge-benefit-base-lg-background': 'rgb(158, 40, 150)',
        'badge-benefit-base-lg-borderRadius': '0',
        'badge-benefit-base-lg-height': '2rem',
        'badge-benefit-base-lg-paddingLeft': '0.75rem',
        'badge-benefit-base-lg-paddingRight': '0.75rem',
        'badge-benefit-base-md-background': 'rgb(158, 40, 150)',
        'badge-benefit-base-md-borderRadius': '0',
        'badge-benefit-base-md-height': '1.5rem',
        'badge-benefit-base-md-paddingLeft': '0.5rem',
        'badge-benefit-base-md-paddingRight': '0.5rem',
        'badge-benefit-base-sm-background': 'rgb(158, 40, 150)',
        'badge-benefit-base-sm-borderRadius': '0',
        'badge-benefit-base-sm-height': '1.25rem',
        'badge-benefit-base-sm-paddingLeft': '0.5rem',
        'badge-benefit-base-sm-paddingRight': '0.5rem',
        'badge-benefit-icon-lg-background': 'rgb(255, 255, 255)',
        'badge-benefit-icon-md-background': 'rgb(255, 255, 255)',
        'badge-benefit-icon-sm-background': 'rgb(255, 255, 255)',
        'badge-benefit-text-lg-color': 'rgb(255, 255, 255)',
        'badge-benefit-text-lg-fontFamily': 'Bosch Sans, sans-serif',
        'badge-benefit-text-lg-fontSize': '0.875rem',
        'badge-benefit-text-lg-fontWeight': 'normal',
        'badge-benefit-text-lg-letterSpacing': '0em',
        'badge-benefit-text-lg-lineHeight': '1.25rem',
        'badge-benefit-text-md-color': 'rgb(255, 255, 255)',
        'badge-benefit-text-md-fontFamily': 'Bosch Sans, sans-serif',
        'badge-benefit-text-md-fontSize': '0.75rem',
        'badge-benefit-text-md-fontWeight': 'normal',
        'badge-benefit-text-md-letterSpacing': '0em',
        'badge-benefit-text-md-lineHeight': '1rem',
        'badge-benefit-text-sm-color': 'rgb(255, 255, 255)',
        'badge-benefit-text-sm-fontFamily': 'Bosch Sans, sans-serif',
        'badge-benefit-text-sm-fontSize': '0.75rem',
        'badge-benefit-text-sm-fontWeight': 'normal',
        'badge-benefit-text-sm-letterSpacing': '0em',
        'badge-benefit-text-sm-lineHeight': '1rem',
        'badge-primary-base-lg-background': 'rgb(0, 123, 192)',
        'badge-primary-base-lg-borderRadius': '0',
        'badge-primary-base-lg-height': '2rem',
        'badge-primary-base-lg-paddingLeft': '0.75rem',
        'badge-primary-base-lg-paddingRight': '0.75rem',
        'badge-primary-base-md-background': 'rgb(0, 123, 192)',
        'badge-primary-base-md-borderRadius': '0',
        'badge-primary-base-md-height': '1.5rem',
        'badge-primary-base-md-paddingLeft': '0.5rem',
        'badge-primary-base-md-paddingRight': '0.5rem',
        'badge-primary-base-sm-background': 'rgb(0, 123, 192)',
        'badge-primary-base-sm-borderRadius': '0',
        'badge-primary-base-sm-height': '1.25rem',
        'badge-primary-base-sm-paddingLeft': '0.5rem',
        'badge-primary-base-sm-paddingRight': '0.5rem',
        'badge-primary-icon-lg-background': 'rgb(255, 255, 255)',
        'badge-primary-icon-md-background': 'rgb(255, 255, 255)',
        'badge-primary-icon-sm-background': 'rgb(255, 255, 255)',
        'badge-primary-text-lg-color': 'rgb(255, 255, 255)',
        'badge-primary-text-lg-fontFamily': 'Bosch Sans, sans-serif',
        'badge-primary-text-lg-fontSize': '0.875rem',
        'badge-primary-text-lg-fontWeight': 'normal',
        'badge-primary-text-lg-letterSpacing': '0em',
        'badge-primary-text-lg-lineHeight': '1.25rem',
        'badge-primary-text-md-color': 'rgb(255, 255, 255)',
        'badge-primary-text-md-fontFamily': 'Bosch Sans, sans-serif',
        'badge-primary-text-md-fontSize': '0.75rem',
        'badge-primary-text-md-fontWeight': 'normal',
        'badge-primary-text-md-letterSpacing': '0em',
        'badge-primary-text-md-lineHeight': '1rem',
        'badge-primary-text-sm-color': 'rgb(255, 255, 255)',
        'badge-primary-text-sm-fontFamily': 'Bosch Sans, sans-serif',
        'badge-primary-text-sm-fontSize': '0.75rem',
        'badge-primary-text-sm-fontWeight': 'normal',
        'badge-primary-text-sm-letterSpacing': '0em',
        'badge-primary-text-sm-lineHeight': '1rem',
        'badge-secondary-base-lg-background': 'rgb(224, 226, 229)',
        'badge-secondary-base-lg-borderRadius': '0',
        'badge-secondary-base-lg-height': '2rem',
        'badge-secondary-base-lg-paddingLeft': '0.75rem',
        'badge-secondary-base-lg-paddingRight': '0.75rem',
        'badge-secondary-base-md-background': 'rgb(224, 226, 229)',
        'badge-secondary-base-md-borderRadius': '0',
        'badge-secondary-base-md-height': '1.5rem',
        'badge-secondary-base-md-paddingLeft': '0.5rem',
        'badge-secondary-base-md-paddingRight': '0.5rem',
        'badge-secondary-base-sm-background': 'rgb(224, 226, 229)',
        'badge-secondary-base-sm-borderRadius': '0',
        'badge-secondary-base-sm-height': '1.25rem',
        'badge-secondary-base-sm-paddingLeft': '0.5rem',
        'badge-secondary-base-sm-paddingRight': '0.5rem',
        'badge-secondary-icon-lg-background': 'rgb(0, 0, 0)',
        'badge-secondary-icon-md-background': 'rgb(0, 0, 0)',
        'badge-secondary-icon-sm-background': 'rgb(0, 0, 0)',
        'badge-secondary-text-lg-color': 'rgb(0, 0, 0)',
        'badge-secondary-text-lg-fontFamily': 'Bosch Sans, sans-serif',
        'badge-secondary-text-lg-fontSize': '0.875rem',
        'badge-secondary-text-lg-fontWeight': 'normal',
        'badge-secondary-text-lg-letterSpacing': '0em',
        'badge-secondary-text-lg-lineHeight': '1.25rem',
        'badge-secondary-text-md-color': 'rgb(0, 0, 0)',
        'badge-secondary-text-md-fontFamily': 'Bosch Sans, sans-serif',
        'badge-secondary-text-md-fontSize': '0.75rem',
        'badge-secondary-text-md-fontWeight': 'normal',
        'badge-secondary-text-md-letterSpacing': '0em',
        'badge-secondary-text-md-lineHeight': '1rem',
        'badge-secondary-text-sm-color': 'rgb(0, 0, 0)',
        'badge-secondary-text-sm-fontFamily': 'Bosch Sans, sans-serif',
        'badge-secondary-text-sm-fontSize': '0.75rem',
        'badge-secondary-text-sm-fontWeight': 'normal',
        'badge-secondary-text-sm-letterSpacing': '0em',
        'badge-secondary-text-sm-lineHeight': '1rem',
        'badge-subtle-base-lg-background': 'rgb(239, 241, 242)',
        'badge-subtle-base-lg-borderRadius': '0',
        'badge-subtle-base-lg-height': '2rem',
        'badge-subtle-base-lg-paddingLeft': '0.75rem',
        'badge-subtle-base-lg-paddingRight': '0.75rem',
        'badge-subtle-base-md-background': 'rgb(239, 241, 242)',
        'badge-subtle-base-md-borderRadius': '0',
        'badge-subtle-base-md-height': '1.5rem',
        'badge-subtle-base-md-paddingLeft': '0.5rem',
        'badge-subtle-base-md-paddingRight': '0.5rem',
        'badge-subtle-base-sm-background': 'rgb(239, 241, 242)',
        'badge-subtle-base-sm-borderRadius': '0',
        'badge-subtle-base-sm-height': '1.25rem',
        'badge-subtle-base-sm-paddingLeft': '0.5rem',
        'badge-subtle-base-sm-paddingRight': '0.5rem',
        'badge-subtle-icon-lg-background': 'rgb(0, 0, 0)',
        'badge-subtle-icon-lg-opacity': 1,
        'badge-subtle-icon-md-background': 'rgb(0, 0, 0)',
        'badge-subtle-icon-md-opacity': 1,
        'badge-subtle-icon-sm-background': 'rgb(0, 0, 0)',
        'badge-subtle-icon-sm-opacity': 1,
        'badge-subtle-text-lg-color': 'rgb(0, 0, 0)',
        'badge-subtle-text-lg-fontFamily': 'Bosch Sans, sans-serif',
        'badge-subtle-text-lg-fontSize': '0.875rem',
        'badge-subtle-text-lg-fontWeight': 'normal',
        'badge-subtle-text-lg-letterSpacing': '0em',
        'badge-subtle-text-lg-lineHeight': '1.25rem',
        'badge-subtle-text-lg-opacity': 1,
        'badge-subtle-text-md-color': 'rgb(0, 0, 0)',
        'badge-subtle-text-md-fontFamily': 'Bosch Sans, sans-serif',
        'badge-subtle-text-md-fontSize': '0.75rem',
        'badge-subtle-text-md-fontWeight': 'normal',
        'badge-subtle-text-md-letterSpacing': '0em',
        'badge-subtle-text-md-lineHeight': '1rem',
        'badge-subtle-text-md-opacity': 1,
        'badge-subtle-text-sm-color': 'rgb(0, 0, 0)',
        'badge-subtle-text-sm-fontFamily': 'Bosch Sans, sans-serif',
        'badge-subtle-text-sm-fontSize': '0.75rem',
        'badge-subtle-text-sm-fontWeight': 'normal',
        'badge-subtle-text-sm-letterSpacing': '0em',
        'badge-subtle-text-sm-lineHeight': '1rem',
        'badge-subtle-text-sm-opacity': 1,
        'benefitInfo-base-lg-gap': '1rem',
        'benefitInfo-base-sm-gap': '0.75rem',
        'benefitInfo-description-lg-color': 'rgb(0, 0, 0)',
        'benefitInfo-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'benefitInfo-description-lg-fontSize': '0.875rem',
        'benefitInfo-description-lg-fontWeight': 'normal',
        'benefitInfo-description-lg-letterSpacing': '0em',
        'benefitInfo-description-lg-lineHeight': '1.25rem',
        'benefitInfo-description-sm-color': 'rgb(0, 0, 0)',
        'benefitInfo-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'benefitInfo-description-sm-fontSize': '0.75rem',
        'benefitInfo-description-sm-fontWeight': 'normal',
        'benefitInfo-description-sm-letterSpacing': '0em',
        'benefitInfo-description-sm-lineHeight': '1rem',
        'benefitInfo-icon-background': 'rgb(0, 0, 0)',
        'benefitInfo-label-lg-color': 'rgb(0, 0, 0)',
        'benefitInfo-label-lg-fontFamily': 'Bosch Sans, sans-serif',
        'benefitInfo-label-lg-fontSize': '1rem',
        'benefitInfo-label-lg-fontWeight': 'bold',
        'benefitInfo-label-lg-letterSpacing': '0em',
        'benefitInfo-label-lg-lineHeight': '1.5rem',
        'benefitInfo-label-sm-color': 'rgb(0, 0, 0)',
        'benefitInfo-label-sm-fontFamily': 'Bosch Sans, sans-serif',
        'benefitInfo-label-sm-fontSize': '0.875rem',
        'benefitInfo-label-sm-fontWeight': 'bold',
        'benefitInfo-label-sm-letterSpacing': '0em',
        'benefitInfo-label-sm-lineHeight': '1.25rem',
        'benefitInfo-title-lg-gap': '0.25rem',
        'benefitInfo-title-sm-gap': '0.25rem',
        'bodytext-large-fontFamily': 'Bosch Sans, sans-serif',
        'bodytext-large-fontSize': '1.25rem',
        'bodytext-large-fontWeight': 'normal',
        'bodytext-large-letterSpacing': '0em',
        'bodytext-large-lineHeight': '1.75rem',
        'bodytext-medium-fontFamily': 'Bosch Sans, sans-serif',
        'bodytext-medium-fontSize': '1rem',
        'bodytext-medium-fontWeight': 'normal',
        'bodytext-medium-letterSpacing': '0em',
        'bodytext-medium-lineHeight': '1.5rem',
        'bodytext-nano-fontFamily': 'Bosch Sans, sans-serif',
        'bodytext-nano-fontSize': '0.625rem',
        'bodytext-nano-fontWeight': 'normal',
        'bodytext-nano-letterSpacing': '0em',
        'bodytext-nano-lineHeight': '0.75rem',
        'bodytext-small-fontFamily': 'Bosch Sans, sans-serif',
        'bodytext-small-fontSize': '0.875rem',
        'bodytext-small-fontWeight': 'normal',
        'bodytext-small-letterSpacing': '0em',
        'bodytext-small-lineHeight': '1.25rem',
        'bodytext-tiny-fontFamily': 'Bosch Sans, sans-serif',
        'bodytext-tiny-fontSize': '0.75rem',
        'bodytext-tiny-fontWeight': 'normal',
        'bodytext-tiny-letterSpacing': '0em',
        'bodytext-tiny-lineHeight': '1rem',
        'border-color-default': 'rgb(224, 226, 229)',
        'border-color-highlighted': 'rgb(193, 199, 204)',
        'border-color-subtle': 'rgb(239, 241, 242)',
        'breadcrumb-base-gap': '0.75rem',
        'breadcrumb-currentPage-color': 'rgb(0, 0, 0)',
        'breadcrumb-currentPage-fontFamily': 'Bosch Sans, sans-serif',
        'breadcrumb-currentPage-fontSize': '0.875rem',
        'breadcrumb-currentPage-fontWeight': 'normal',
        'breadcrumb-currentPage-letterSpacing': '0em',
        'breadcrumb-currentPage-lineHeight': '1.25rem',
        'breadcrumb-currentPage-opacity': 0.4,
        'breadcrumb-divider-background': 'rgb(0, 0, 0)',
        'breadcrumb-divider-opacity': 0.4,
        'button-base-default-lg-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-lg-disabled-borderColor': 'rgb(113, 118, 124)',
        'button-base-default-lg-disabled-borderRadius': '0',
        'button-base-default-lg-disabled-borderStyle': 'solid',
        'button-base-default-lg-disabled-borderWidth': '0.0625rem',
        'button-base-default-lg-disabled-gap': '0.5rem',
        'button-base-default-lg-disabled-height': '4rem',
        'button-base-default-lg-disabled-opacity': 0.4,
        'button-base-default-lg-disabled-paddingLeft': '1.5rem',
        'button-base-default-lg-disabled-paddingRight': '1.5rem',
        'button-base-default-lg-focused-background': 'rgb(209, 228, 255)',
        'button-base-default-lg-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-lg-focused-borderRadius': '0',
        'button-base-default-lg-focused-borderStyle': 'solid',
        'button-base-default-lg-focused-borderWidth': '0.0625rem',
        'button-base-default-lg-focused-gap': '0.5rem',
        'button-base-default-lg-focused-height': '4rem',
        'button-base-default-lg-focused-opacity': 1,
        'button-base-default-lg-focused-paddingLeft': '1.5rem',
        'button-base-default-lg-focused-paddingRight': '1.5rem',
        'button-base-default-lg-hover-background': 'rgb(209, 228, 255)',
        'button-base-default-lg-hover-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-lg-hover-borderRadius': '0',
        'button-base-default-lg-hover-borderStyle': 'solid',
        'button-base-default-lg-hover-borderWidth': '0.0625rem',
        'button-base-default-lg-hover-gap': '0.5rem',
        'button-base-default-lg-hover-height': '4rem',
        'button-base-default-lg-hover-opacity': 1,
        'button-base-default-lg-hover-paddingLeft': '1.5rem',
        'button-base-default-lg-hover-paddingRight': '1.5rem',
        'button-base-default-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-lg-initial-borderColor': 'rgb(0, 123, 192)',
        'button-base-default-lg-initial-borderRadius': '0',
        'button-base-default-lg-initial-borderStyle': 'solid',
        'button-base-default-lg-initial-borderWidth': '0.0625rem',
        'button-base-default-lg-initial-gap': '0.5rem',
        'button-base-default-lg-initial-height': '4rem',
        'button-base-default-lg-initial-opacity': 1,
        'button-base-default-lg-initial-paddingLeft': '1.5rem',
        'button-base-default-lg-initial-paddingRight': '1.5rem',
        'button-base-default-lg-pressed-background': 'rgb(157, 201, 255)',
        'button-base-default-lg-pressed-borderColor': 'rgb(0, 73, 117)',
        'button-base-default-lg-pressed-borderRadius': '0',
        'button-base-default-lg-pressed-borderStyle': 'solid',
        'button-base-default-lg-pressed-borderWidth': '0.0625rem',
        'button-base-default-lg-pressed-gap': '0.5rem',
        'button-base-default-lg-pressed-height': '4rem',
        'button-base-default-lg-pressed-opacity': 1,
        'button-base-default-lg-pressed-paddingLeft': '1.5rem',
        'button-base-default-lg-pressed-paddingRight': '1.5rem',
        'button-base-default-md-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-md-disabled-borderColor': 'rgb(113, 118, 124)',
        'button-base-default-md-disabled-borderRadius': '0',
        'button-base-default-md-disabled-borderStyle': 'solid',
        'button-base-default-md-disabled-borderWidth': '0.0625rem',
        'button-base-default-md-disabled-gap': '0.5rem',
        'button-base-default-md-disabled-height': '3rem',
        'button-base-default-md-disabled-opacity': 0.4,
        'button-base-default-md-disabled-paddingLeft': '1rem',
        'button-base-default-md-disabled-paddingRight': '1rem',
        'button-base-default-md-focused-background': 'rgb(209, 228, 255)',
        'button-base-default-md-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-md-focused-borderRadius': '0',
        'button-base-default-md-focused-borderStyle': 'solid',
        'button-base-default-md-focused-borderWidth': '0.0625rem',
        'button-base-default-md-focused-gap': '0.5rem',
        'button-base-default-md-focused-height': '3rem',
        'button-base-default-md-focused-opacity': 1,
        'button-base-default-md-focused-paddingLeft': '1rem',
        'button-base-default-md-focused-paddingRight': '1rem',
        'button-base-default-md-hover-background': 'rgb(209, 228, 255)',
        'button-base-default-md-hover-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-md-hover-borderRadius': '0',
        'button-base-default-md-hover-borderStyle': 'solid',
        'button-base-default-md-hover-borderWidth': '0.0625rem',
        'button-base-default-md-hover-gap': '0.5rem',
        'button-base-default-md-hover-height': '3rem',
        'button-base-default-md-hover-opacity': 1,
        'button-base-default-md-hover-paddingLeft': '1rem',
        'button-base-default-md-hover-paddingRight': '1rem',
        'button-base-default-md-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-md-initial-borderColor': 'rgb(0, 123, 192)',
        'button-base-default-md-initial-borderRadius': '0',
        'button-base-default-md-initial-borderStyle': 'solid',
        'button-base-default-md-initial-borderWidth': '0.0625rem',
        'button-base-default-md-initial-gap': '0.5rem',
        'button-base-default-md-initial-height': '3rem',
        'button-base-default-md-initial-opacity': 1,
        'button-base-default-md-initial-paddingLeft': '1rem',
        'button-base-default-md-initial-paddingRight': '1rem',
        'button-base-default-md-pressed-background': 'rgb(157, 201, 255)',
        'button-base-default-md-pressed-borderColor': 'rgb(0, 73, 117)',
        'button-base-default-md-pressed-borderRadius': '0',
        'button-base-default-md-pressed-borderStyle': 'solid',
        'button-base-default-md-pressed-borderWidth': '0.0625rem',
        'button-base-default-md-pressed-gap': '0.5rem',
        'button-base-default-md-pressed-height': '3rem',
        'button-base-default-md-pressed-opacity': 1,
        'button-base-default-md-pressed-paddingLeft': '1rem',
        'button-base-default-md-pressed-paddingRight': '1rem',
        'button-base-default-sm-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-sm-disabled-borderColor': 'rgb(113, 118, 124)',
        'button-base-default-sm-disabled-borderRadius': '0',
        'button-base-default-sm-disabled-borderStyle': 'solid',
        'button-base-default-sm-disabled-borderWidth': '0.0625rem',
        'button-base-default-sm-disabled-gap': '0.25rem',
        'button-base-default-sm-disabled-height': '2rem',
        'button-base-default-sm-disabled-opacity': 0.4,
        'button-base-default-sm-disabled-paddingLeft': '0.75rem',
        'button-base-default-sm-disabled-paddingRight': '0.75rem',
        'button-base-default-sm-focused-background': 'rgb(209, 228, 255)',
        'button-base-default-sm-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-sm-focused-borderRadius': '0',
        'button-base-default-sm-focused-borderStyle': 'solid',
        'button-base-default-sm-focused-borderWidth': '0.0625rem',
        'button-base-default-sm-focused-gap': '0.25rem',
        'button-base-default-sm-focused-height': '2rem',
        'button-base-default-sm-focused-opacity': 1,
        'button-base-default-sm-focused-paddingLeft': '0.75rem',
        'button-base-default-sm-focused-paddingRight': '0.75rem',
        'button-base-default-sm-hover-background': 'rgb(209, 228, 255)',
        'button-base-default-sm-hover-borderColor': 'rgb(0, 98, 154)',
        'button-base-default-sm-hover-borderRadius': '0',
        'button-base-default-sm-hover-borderStyle': 'solid',
        'button-base-default-sm-hover-borderWidth': '0.0625rem',
        'button-base-default-sm-hover-gap': '0.25rem',
        'button-base-default-sm-hover-height': '2rem',
        'button-base-default-sm-hover-opacity': 1,
        'button-base-default-sm-hover-paddingLeft': '0.75rem',
        'button-base-default-sm-hover-paddingRight': '0.75rem',
        'button-base-default-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-default-sm-initial-borderColor': 'rgb(0, 123, 192)',
        'button-base-default-sm-initial-borderRadius': '0',
        'button-base-default-sm-initial-borderStyle': 'solid',
        'button-base-default-sm-initial-borderWidth': '0.0625rem',
        'button-base-default-sm-initial-gap': '0.25rem',
        'button-base-default-sm-initial-height': '2rem',
        'button-base-default-sm-initial-opacity': 1,
        'button-base-default-sm-initial-paddingLeft': '0.75rem',
        'button-base-default-sm-initial-paddingRight': '0.75rem',
        'button-base-default-sm-pressed-background': 'rgb(157, 201, 255)',
        'button-base-default-sm-pressed-borderColor': 'rgb(0, 73, 117)',
        'button-base-default-sm-pressed-borderRadius': '0',
        'button-base-default-sm-pressed-borderStyle': 'solid',
        'button-base-default-sm-pressed-borderWidth': '0.0625rem',
        'button-base-default-sm-pressed-gap': '0.25rem',
        'button-base-default-sm-pressed-height': '2rem',
        'button-base-default-sm-pressed-opacity': 1,
        'button-base-default-sm-pressed-paddingLeft': '0.75rem',
        'button-base-default-sm-pressed-paddingRight': '0.75rem',
        'button-base-prominent-lg-disabled-background': 'rgb(193, 199, 204)',
        'button-base-prominent-lg-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-lg-disabled-borderRadius': '0',
        'button-base-prominent-lg-disabled-borderStyle': 'solid',
        'button-base-prominent-lg-disabled-borderWidth': '0.0625rem',
        'button-base-prominent-lg-disabled-gap': '0.5rem',
        'button-base-prominent-lg-disabled-height': '4rem',
        'button-base-prominent-lg-disabled-opacity': 0.4,
        'button-base-prominent-lg-disabled-paddingLeft': '1.5rem',
        'button-base-prominent-lg-disabled-paddingRight': '1.5rem',
        'button-base-prominent-lg-focused-background': 'rgb(0, 98, 154)',
        'button-base-prominent-lg-focused-borderColor': 'rgb(0, 18, 34)',
        'button-base-prominent-lg-focused-borderRadius': '0',
        'button-base-prominent-lg-focused-borderStyle': 'solid',
        'button-base-prominent-lg-focused-borderWidth': '0.0625rem',
        'button-base-prominent-lg-focused-gap': '0.5rem',
        'button-base-prominent-lg-focused-height': '4rem',
        'button-base-prominent-lg-focused-opacity': 1,
        'button-base-prominent-lg-focused-paddingLeft': '1.5rem',
        'button-base-prominent-lg-focused-paddingRight': '1.5rem',
        'button-base-prominent-lg-hover-background': 'rgb(0, 98, 154)',
        'button-base-prominent-lg-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-lg-hover-borderRadius': '0',
        'button-base-prominent-lg-hover-borderStyle': 'solid',
        'button-base-prominent-lg-hover-borderWidth': '0.0625rem',
        'button-base-prominent-lg-hover-gap': '0.5rem',
        'button-base-prominent-lg-hover-height': '4rem',
        'button-base-prominent-lg-hover-opacity': 1,
        'button-base-prominent-lg-hover-paddingLeft': '1.5rem',
        'button-base-prominent-lg-hover-paddingRight': '1.5rem',
        'button-base-prominent-lg-initial-background': 'rgb(0, 123, 192)',
        'button-base-prominent-lg-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-lg-initial-borderRadius': '0',
        'button-base-prominent-lg-initial-borderStyle': 'solid',
        'button-base-prominent-lg-initial-borderWidth': '0.0625rem',
        'button-base-prominent-lg-initial-gap': '0.5rem',
        'button-base-prominent-lg-initial-height': '4rem',
        'button-base-prominent-lg-initial-opacity': 1,
        'button-base-prominent-lg-initial-paddingLeft': '1.5rem',
        'button-base-prominent-lg-initial-paddingRight': '1.5rem',
        'button-base-prominent-lg-pressed-background': 'rgb(0, 73, 117)',
        'button-base-prominent-lg-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-lg-pressed-borderRadius': '0',
        'button-base-prominent-lg-pressed-borderStyle': 'solid',
        'button-base-prominent-lg-pressed-borderWidth': '0.0625rem',
        'button-base-prominent-lg-pressed-gap': '0.5rem',
        'button-base-prominent-lg-pressed-height': '4rem',
        'button-base-prominent-lg-pressed-opacity': 1,
        'button-base-prominent-lg-pressed-paddingLeft': '1.5rem',
        'button-base-prominent-lg-pressed-paddingRight': '1.5rem',
        'button-base-prominent-md-disabled-background': 'rgb(193, 199, 204)',
        'button-base-prominent-md-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-md-disabled-borderRadius': '0',
        'button-base-prominent-md-disabled-borderStyle': 'solid',
        'button-base-prominent-md-disabled-borderWidth': '0.0625rem',
        'button-base-prominent-md-disabled-gap': '0.5rem',
        'button-base-prominent-md-disabled-height': '3rem',
        'button-base-prominent-md-disabled-opacity': 0.4,
        'button-base-prominent-md-disabled-paddingLeft': '1rem',
        'button-base-prominent-md-disabled-paddingRight': '1rem',
        'button-base-prominent-md-focused-background': 'rgb(0, 98, 154)',
        'button-base-prominent-md-focused-borderColor': 'rgb(0, 18, 34)',
        'button-base-prominent-md-focused-borderRadius': '0',
        'button-base-prominent-md-focused-borderStyle': 'solid',
        'button-base-prominent-md-focused-borderWidth': '0.0625rem',
        'button-base-prominent-md-focused-gap': '0.5rem',
        'button-base-prominent-md-focused-height': '3rem',
        'button-base-prominent-md-focused-opacity': 1,
        'button-base-prominent-md-focused-paddingLeft': '1rem',
        'button-base-prominent-md-focused-paddingRight': '1rem',
        'button-base-prominent-md-hover-background': 'rgb(0, 98, 154)',
        'button-base-prominent-md-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-md-hover-borderRadius': '0',
        'button-base-prominent-md-hover-borderStyle': 'solid',
        'button-base-prominent-md-hover-borderWidth': '0.0625rem',
        'button-base-prominent-md-hover-gap': '0.5rem',
        'button-base-prominent-md-hover-height': '3rem',
        'button-base-prominent-md-hover-opacity': 1,
        'button-base-prominent-md-hover-paddingLeft': '1rem',
        'button-base-prominent-md-hover-paddingRight': '1rem',
        'button-base-prominent-md-initial-background': 'rgb(0, 123, 192)',
        'button-base-prominent-md-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-md-initial-borderRadius': '0',
        'button-base-prominent-md-initial-borderStyle': 'solid',
        'button-base-prominent-md-initial-borderWidth': '0.0625rem',
        'button-base-prominent-md-initial-gap': '0.5rem',
        'button-base-prominent-md-initial-height': '3rem',
        'button-base-prominent-md-initial-opacity': 1,
        'button-base-prominent-md-initial-paddingLeft': '1rem',
        'button-base-prominent-md-initial-paddingRight': '1rem',
        'button-base-prominent-md-pressed-background': 'rgb(0, 73, 117)',
        'button-base-prominent-md-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-md-pressed-borderRadius': '0',
        'button-base-prominent-md-pressed-borderStyle': 'solid',
        'button-base-prominent-md-pressed-borderWidth': '0.0625rem',
        'button-base-prominent-md-pressed-gap': '0.5rem',
        'button-base-prominent-md-pressed-height': '3rem',
        'button-base-prominent-md-pressed-opacity': 1,
        'button-base-prominent-md-pressed-paddingLeft': '1rem',
        'button-base-prominent-md-pressed-paddingRight': '1rem',
        'button-base-prominent-sm-disabled-background': 'rgb(193, 199, 204)',
        'button-base-prominent-sm-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-sm-disabled-borderRadius': '0',
        'button-base-prominent-sm-disabled-borderStyle': 'solid',
        'button-base-prominent-sm-disabled-borderWidth': '0.0625rem',
        'button-base-prominent-sm-disabled-gap': '0.25rem',
        'button-base-prominent-sm-disabled-height': '2rem',
        'button-base-prominent-sm-disabled-opacity': 0.4,
        'button-base-prominent-sm-disabled-paddingLeft': '0.75rem',
        'button-base-prominent-sm-disabled-paddingRight': '0.75rem',
        'button-base-prominent-sm-focused-background': 'rgb(0, 98, 154)',
        'button-base-prominent-sm-focused-borderColor': 'rgb(0, 18, 34)',
        'button-base-prominent-sm-focused-borderRadius': '0',
        'button-base-prominent-sm-focused-borderStyle': 'solid',
        'button-base-prominent-sm-focused-borderWidth': '0.0625rem',
        'button-base-prominent-sm-focused-gap': '0.25rem',
        'button-base-prominent-sm-focused-height': '2rem',
        'button-base-prominent-sm-focused-opacity': 1,
        'button-base-prominent-sm-focused-paddingLeft': '0.75rem',
        'button-base-prominent-sm-focused-paddingRight': '0.75rem',
        'button-base-prominent-sm-hover-background': 'rgb(0, 98, 154)',
        'button-base-prominent-sm-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-sm-hover-borderRadius': '0',
        'button-base-prominent-sm-hover-borderStyle': 'solid',
        'button-base-prominent-sm-hover-borderWidth': '0.0625rem',
        'button-base-prominent-sm-hover-gap': '0.25rem',
        'button-base-prominent-sm-hover-height': '2rem',
        'button-base-prominent-sm-hover-opacity': 1,
        'button-base-prominent-sm-hover-paddingLeft': '0.75rem',
        'button-base-prominent-sm-hover-paddingRight': '0.75rem',
        'button-base-prominent-sm-initial-background': 'rgb(0, 123, 192)',
        'button-base-prominent-sm-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-sm-initial-borderRadius': '0',
        'button-base-prominent-sm-initial-borderStyle': 'solid',
        'button-base-prominent-sm-initial-borderWidth': '0.0625rem',
        'button-base-prominent-sm-initial-gap': '0.25rem',
        'button-base-prominent-sm-initial-height': '2rem',
        'button-base-prominent-sm-initial-opacity': 1,
        'button-base-prominent-sm-initial-paddingLeft': '0.75rem',
        'button-base-prominent-sm-initial-paddingRight': '0.75rem',
        'button-base-prominent-sm-pressed-background': 'rgb(0, 73, 117)',
        'button-base-prominent-sm-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-prominent-sm-pressed-borderRadius': '0',
        'button-base-prominent-sm-pressed-borderStyle': 'solid',
        'button-base-prominent-sm-pressed-borderWidth': '0.0625rem',
        'button-base-prominent-sm-pressed-gap': '0.25rem',
        'button-base-prominent-sm-pressed-height': '2rem',
        'button-base-prominent-sm-pressed-opacity': 1,
        'button-base-prominent-sm-pressed-paddingLeft': '0.75rem',
        'button-base-prominent-sm-pressed-paddingRight': '0.75rem',
        'button-base-subtle-lg-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-disabled-borderRadius': '0',
        'button-base-subtle-lg-disabled-borderStyle': 'solid',
        'button-base-subtle-lg-disabled-borderWidth': '0.0625rem',
        'button-base-subtle-lg-disabled-gap': '0.5rem',
        'button-base-subtle-lg-disabled-height': '4rem',
        'button-base-subtle-lg-disabled-opacity': 0.4,
        'button-base-subtle-lg-disabled-paddingLeft': '1.5rem',
        'button-base-subtle-lg-disabled-paddingRight': '1.5rem',
        'button-base-subtle-lg-focused-background': 'rgb(232, 241, 255)',
        'button-base-subtle-lg-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-subtle-lg-focused-borderRadius': '0',
        'button-base-subtle-lg-focused-borderStyle': 'solid',
        'button-base-subtle-lg-focused-borderWidth': '0.0625rem',
        'button-base-subtle-lg-focused-gap': '0.5rem',
        'button-base-subtle-lg-focused-height': '4rem',
        'button-base-subtle-lg-focused-opacity': 1,
        'button-base-subtle-lg-focused-paddingLeft': '1.5rem',
        'button-base-subtle-lg-focused-paddingRight': '1.5rem',
        'button-base-subtle-lg-hover-background': 'rgb(232, 241, 255)',
        'button-base-subtle-lg-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-hover-borderRadius': '0',
        'button-base-subtle-lg-hover-borderStyle': 'solid',
        'button-base-subtle-lg-hover-borderWidth': '0.0625rem',
        'button-base-subtle-lg-hover-gap': '0.5rem',
        'button-base-subtle-lg-hover-height': '4rem',
        'button-base-subtle-lg-hover-opacity': 1,
        'button-base-subtle-lg-hover-paddingLeft': '1.5rem',
        'button-base-subtle-lg-hover-paddingRight': '1.5rem',
        'button-base-subtle-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-initial-borderRadius': '0',
        'button-base-subtle-lg-initial-borderStyle': 'solid',
        'button-base-subtle-lg-initial-borderWidth': '0.0625rem',
        'button-base-subtle-lg-initial-gap': '0.5rem',
        'button-base-subtle-lg-initial-height': '4rem',
        'button-base-subtle-lg-initial-opacity': 1,
        'button-base-subtle-lg-initial-paddingLeft': '1.5rem',
        'button-base-subtle-lg-initial-paddingRight': '1.5rem',
        'button-base-subtle-lg-pressed-background': 'rgb(209, 228, 255)',
        'button-base-subtle-lg-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-lg-pressed-borderRadius': '0',
        'button-base-subtle-lg-pressed-borderStyle': 'solid',
        'button-base-subtle-lg-pressed-borderWidth': '0.0625rem',
        'button-base-subtle-lg-pressed-gap': '0.5rem',
        'button-base-subtle-lg-pressed-height': '4rem',
        'button-base-subtle-lg-pressed-opacity': 1,
        'button-base-subtle-lg-pressed-paddingLeft': '1.5rem',
        'button-base-subtle-lg-pressed-paddingRight': '1.5rem',
        'button-base-subtle-md-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-disabled-borderRadius': '0',
        'button-base-subtle-md-disabled-borderStyle': 'solid',
        'button-base-subtle-md-disabled-borderWidth': '0.0625rem',
        'button-base-subtle-md-disabled-gap': '0.5rem',
        'button-base-subtle-md-disabled-height': '3rem',
        'button-base-subtle-md-disabled-opacity': 0.4,
        'button-base-subtle-md-disabled-paddingLeft': '1rem',
        'button-base-subtle-md-disabled-paddingRight': '1rem',
        'button-base-subtle-md-focused-background': 'rgb(232, 241, 255)',
        'button-base-subtle-md-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-subtle-md-focused-borderRadius': '0',
        'button-base-subtle-md-focused-borderStyle': 'solid',
        'button-base-subtle-md-focused-borderWidth': '0.0625rem',
        'button-base-subtle-md-focused-gap': '0.5rem',
        'button-base-subtle-md-focused-height': '3rem',
        'button-base-subtle-md-focused-opacity': 1,
        'button-base-subtle-md-focused-paddingLeft': '1rem',
        'button-base-subtle-md-focused-paddingRight': '1rem',
        'button-base-subtle-md-hover-background': 'rgb(232, 241, 255)',
        'button-base-subtle-md-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-hover-borderRadius': '0',
        'button-base-subtle-md-hover-borderStyle': 'solid',
        'button-base-subtle-md-hover-borderWidth': '0.0625rem',
        'button-base-subtle-md-hover-gap': '0.5rem',
        'button-base-subtle-md-hover-height': '3rem',
        'button-base-subtle-md-hover-opacity': 1,
        'button-base-subtle-md-hover-paddingLeft': '1rem',
        'button-base-subtle-md-hover-paddingRight': '1rem',
        'button-base-subtle-md-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-initial-borderRadius': '0',
        'button-base-subtle-md-initial-borderStyle': 'solid',
        'button-base-subtle-md-initial-borderWidth': '0.0625rem',
        'button-base-subtle-md-initial-gap': '0.5rem',
        'button-base-subtle-md-initial-height': '3rem',
        'button-base-subtle-md-initial-opacity': 1,
        'button-base-subtle-md-initial-paddingLeft': '1rem',
        'button-base-subtle-md-initial-paddingRight': '1rem',
        'button-base-subtle-md-pressed-background': 'rgb(209, 228, 255)',
        'button-base-subtle-md-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-md-pressed-borderRadius': '0',
        'button-base-subtle-md-pressed-borderStyle': 'solid',
        'button-base-subtle-md-pressed-borderWidth': '0.0625rem',
        'button-base-subtle-md-pressed-gap': '0.5rem',
        'button-base-subtle-md-pressed-height': '3rem',
        'button-base-subtle-md-pressed-opacity': 1,
        'button-base-subtle-md-pressed-paddingLeft': '1rem',
        'button-base-subtle-md-pressed-paddingRight': '1rem',
        'button-base-subtle-sm-disabled-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-disabled-borderRadius': '0',
        'button-base-subtle-sm-disabled-borderStyle': 'solid',
        'button-base-subtle-sm-disabled-borderWidth': '0.0625rem',
        'button-base-subtle-sm-disabled-gap': '0.25rem',
        'button-base-subtle-sm-disabled-height': '2rem',
        'button-base-subtle-sm-disabled-opacity': 0.4,
        'button-base-subtle-sm-disabled-paddingLeft': '0.75rem',
        'button-base-subtle-sm-disabled-paddingRight': '0.75rem',
        'button-base-subtle-sm-focused-background': 'rgb(232, 241, 255)',
        'button-base-subtle-sm-focused-borderColor': 'rgb(0, 98, 154)',
        'button-base-subtle-sm-focused-borderRadius': '0',
        'button-base-subtle-sm-focused-borderStyle': 'solid',
        'button-base-subtle-sm-focused-borderWidth': '0.0625rem',
        'button-base-subtle-sm-focused-gap': '0.25rem',
        'button-base-subtle-sm-focused-height': '2rem',
        'button-base-subtle-sm-focused-opacity': 1,
        'button-base-subtle-sm-focused-paddingLeft': '0.75rem',
        'button-base-subtle-sm-focused-paddingRight': '0.75rem',
        'button-base-subtle-sm-hover-background': 'rgb(232, 241, 255)',
        'button-base-subtle-sm-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-hover-borderRadius': '0',
        'button-base-subtle-sm-hover-borderStyle': 'solid',
        'button-base-subtle-sm-hover-borderWidth': '0.0625rem',
        'button-base-subtle-sm-hover-gap': '0.25rem',
        'button-base-subtle-sm-hover-height': '2rem',
        'button-base-subtle-sm-hover-opacity': 1,
        'button-base-subtle-sm-hover-paddingLeft': '0.75rem',
        'button-base-subtle-sm-hover-paddingRight': '0.75rem',
        'button-base-subtle-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-initial-borderRadius': '0',
        'button-base-subtle-sm-initial-borderStyle': 'solid',
        'button-base-subtle-sm-initial-borderWidth': '0.0625rem',
        'button-base-subtle-sm-initial-gap': '0.25rem',
        'button-base-subtle-sm-initial-height': '2rem',
        'button-base-subtle-sm-initial-opacity': 1,
        'button-base-subtle-sm-initial-paddingLeft': '0.75rem',
        'button-base-subtle-sm-initial-paddingRight': '0.75rem',
        'button-base-subtle-sm-pressed-background': 'rgb(209, 228, 255)',
        'button-base-subtle-sm-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'button-base-subtle-sm-pressed-borderRadius': '0',
        'button-base-subtle-sm-pressed-borderStyle': 'solid',
        'button-base-subtle-sm-pressed-borderWidth': '0.0625rem',
        'button-base-subtle-sm-pressed-gap': '0.25rem',
        'button-base-subtle-sm-pressed-height': '2rem',
        'button-base-subtle-sm-pressed-opacity': 1,
        'button-base-subtle-sm-pressed-paddingLeft': '0.75rem',
        'button-base-subtle-sm-pressed-paddingRight': '0.75rem',
        'button-icon-default-lg-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-default-lg-disabled-opacity': 1,
        'button-icon-default-lg-focused-background': 'rgb(0, 98, 154)',
        'button-icon-default-lg-focused-opacity': 1,
        'button-icon-default-lg-hover-background': 'rgb(0, 98, 154)',
        'button-icon-default-lg-hover-opacity': 1,
        'button-icon-default-lg-initial-background': 'rgb(0, 123, 192)',
        'button-icon-default-lg-initial-opacity': 1,
        'button-icon-default-lg-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-default-lg-pressed-opacity': 0.65,
        'button-icon-default-md-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-default-md-disabled-opacity': 1,
        'button-icon-default-md-focused-background': 'rgb(0, 98, 154)',
        'button-icon-default-md-focused-opacity': 1,
        'button-icon-default-md-hover-background': 'rgb(0, 98, 154)',
        'button-icon-default-md-hover-opacity': 1,
        'button-icon-default-md-initial-background': 'rgb(0, 123, 192)',
        'button-icon-default-md-initial-opacity': 1,
        'button-icon-default-md-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-default-md-pressed-opacity': 0.65,
        'button-icon-default-sm-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-default-sm-disabled-opacity': 1,
        'button-icon-default-sm-focused-background': 'rgb(0, 98, 154)',
        'button-icon-default-sm-focused-opacity': 1,
        'button-icon-default-sm-hover-background': 'rgb(0, 98, 154)',
        'button-icon-default-sm-hover-opacity': 1,
        'button-icon-default-sm-initial-background': 'rgb(0, 123, 192)',
        'button-icon-default-sm-initial-opacity': 1,
        'button-icon-default-sm-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-default-sm-pressed-opacity': 0.65,
        'button-icon-prominent-lg-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-prominent-lg-disabled-opacity': 1,
        'button-icon-prominent-lg-focused-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-lg-focused-opacity': 1,
        'button-icon-prominent-lg-hover-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-lg-hover-opacity': 1,
        'button-icon-prominent-lg-initial-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-lg-initial-opacity': 1,
        'button-icon-prominent-lg-pressed-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-lg-pressed-opacity': 0.65,
        'button-icon-prominent-md-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-prominent-md-disabled-opacity': 1,
        'button-icon-prominent-md-focused-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-md-focused-opacity': 1,
        'button-icon-prominent-md-hover-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-md-hover-opacity': 1,
        'button-icon-prominent-md-initial-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-md-initial-opacity': 1,
        'button-icon-prominent-md-pressed-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-md-pressed-opacity': 0.65,
        'button-icon-prominent-sm-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-prominent-sm-disabled-opacity': 1,
        'button-icon-prominent-sm-focused-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-sm-focused-opacity': 1,
        'button-icon-prominent-sm-hover-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-sm-hover-opacity': 1,
        'button-icon-prominent-sm-initial-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-sm-initial-opacity': 1,
        'button-icon-prominent-sm-pressed-background': 'rgb(255, 255, 255)',
        'button-icon-prominent-sm-pressed-opacity': 0.65,
        'button-icon-subtle-lg-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-subtle-lg-disabled-opacity': 1,
        'button-icon-subtle-lg-focused-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-lg-focused-opacity': 1,
        'button-icon-subtle-lg-hover-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-lg-hover-opacity': 1,
        'button-icon-subtle-lg-initial-background': 'rgb(0, 123, 192)',
        'button-icon-subtle-lg-initial-opacity': 1,
        'button-icon-subtle-lg-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-subtle-lg-pressed-opacity': 0.65,
        'button-icon-subtle-md-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-subtle-md-disabled-opacity': 1,
        'button-icon-subtle-md-focused-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-md-focused-opacity': 1,
        'button-icon-subtle-md-hover-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-md-hover-opacity': 1,
        'button-icon-subtle-md-initial-background': 'rgb(0, 123, 192)',
        'button-icon-subtle-md-initial-opacity': 1,
        'button-icon-subtle-md-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-subtle-md-pressed-opacity': 0.65,
        'button-icon-subtle-sm-disabled-background': 'rgb(0, 0, 0)',
        'button-icon-subtle-sm-disabled-opacity': 1,
        'button-icon-subtle-sm-focused-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-sm-focused-opacity': 1,
        'button-icon-subtle-sm-hover-background': 'rgb(0, 98, 154)',
        'button-icon-subtle-sm-hover-opacity': 1,
        'button-icon-subtle-sm-initial-background': 'rgb(0, 123, 192)',
        'button-icon-subtle-sm-initial-opacity': 1,
        'button-icon-subtle-sm-pressed-background': 'rgb(0, 73, 117)',
        'button-icon-subtle-sm-pressed-opacity': 0.65,
        'button-label-default-lg-disabled-color': 'rgb(0, 0, 0)',
        'button-label-default-lg-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-lg-disabled-fontSize': '1.25rem',
        'button-label-default-lg-disabled-fontWeight': 'normal',
        'button-label-default-lg-disabled-letterSpacing': '0em',
        'button-label-default-lg-disabled-lineHeight': '1.75rem',
        'button-label-default-lg-disabled-opacity': 1,
        'button-label-default-lg-focused-color': 'rgb(0, 98, 154)',
        'button-label-default-lg-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-lg-focused-fontSize': '1.25rem',
        'button-label-default-lg-focused-fontWeight': 'normal',
        'button-label-default-lg-focused-letterSpacing': '0em',
        'button-label-default-lg-focused-lineHeight': '1.75rem',
        'button-label-default-lg-focused-opacity': 1,
        'button-label-default-lg-hover-color': 'rgb(0, 98, 154)',
        'button-label-default-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-lg-hover-fontSize': '1.25rem',
        'button-label-default-lg-hover-fontWeight': 'normal',
        'button-label-default-lg-hover-letterSpacing': '0em',
        'button-label-default-lg-hover-lineHeight': '1.75rem',
        'button-label-default-lg-hover-opacity': 1,
        'button-label-default-lg-initial-color': 'rgb(0, 123, 192)',
        'button-label-default-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-lg-initial-fontSize': '1.25rem',
        'button-label-default-lg-initial-fontWeight': 'normal',
        'button-label-default-lg-initial-letterSpacing': '0em',
        'button-label-default-lg-initial-lineHeight': '1.75rem',
        'button-label-default-lg-initial-opacity': 1,
        'button-label-default-lg-pressed-color': 'rgb(0, 73, 117)',
        'button-label-default-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-lg-pressed-fontSize': '1.25rem',
        'button-label-default-lg-pressed-fontWeight': 'normal',
        'button-label-default-lg-pressed-letterSpacing': '0em',
        'button-label-default-lg-pressed-lineHeight': '1.75rem',
        'button-label-default-lg-pressed-opacity': 0.65,
        'button-label-default-md-disabled-color': 'rgb(0, 0, 0)',
        'button-label-default-md-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-md-disabled-fontSize': '1rem',
        'button-label-default-md-disabled-fontWeight': 'normal',
        'button-label-default-md-disabled-letterSpacing': '0em',
        'button-label-default-md-disabled-lineHeight': '1.5rem',
        'button-label-default-md-disabled-opacity': 1,
        'button-label-default-md-focused-color': 'rgb(0, 98, 154)',
        'button-label-default-md-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-md-focused-fontSize': '1rem',
        'button-label-default-md-focused-fontWeight': 'normal',
        'button-label-default-md-focused-letterSpacing': '0em',
        'button-label-default-md-focused-lineHeight': '1.5rem',
        'button-label-default-md-focused-opacity': 1,
        'button-label-default-md-hover-color': 'rgb(0, 98, 154)',
        'button-label-default-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-md-hover-fontSize': '1rem',
        'button-label-default-md-hover-fontWeight': 'normal',
        'button-label-default-md-hover-letterSpacing': '0em',
        'button-label-default-md-hover-lineHeight': '1.5rem',
        'button-label-default-md-hover-opacity': 1,
        'button-label-default-md-initial-color': 'rgb(0, 123, 192)',
        'button-label-default-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-md-initial-fontSize': '1rem',
        'button-label-default-md-initial-fontWeight': 'normal',
        'button-label-default-md-initial-letterSpacing': '0em',
        'button-label-default-md-initial-lineHeight': '1.5rem',
        'button-label-default-md-initial-opacity': 1,
        'button-label-default-md-pressed-color': 'rgb(0, 73, 117)',
        'button-label-default-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-md-pressed-fontSize': '1rem',
        'button-label-default-md-pressed-fontWeight': 'normal',
        'button-label-default-md-pressed-letterSpacing': '0em',
        'button-label-default-md-pressed-lineHeight': '1.5rem',
        'button-label-default-md-pressed-opacity': 0.65,
        'button-label-default-sm-disabled-color': 'rgb(0, 0, 0)',
        'button-label-default-sm-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-sm-disabled-fontSize': '0.875rem',
        'button-label-default-sm-disabled-fontWeight': 'normal',
        'button-label-default-sm-disabled-letterSpacing': '0em',
        'button-label-default-sm-disabled-lineHeight': '1.25rem',
        'button-label-default-sm-disabled-opacity': 1,
        'button-label-default-sm-focused-color': 'rgb(0, 98, 154)',
        'button-label-default-sm-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-sm-focused-fontSize': '0.875rem',
        'button-label-default-sm-focused-fontWeight': 'normal',
        'button-label-default-sm-focused-letterSpacing': '0em',
        'button-label-default-sm-focused-lineHeight': '1.25rem',
        'button-label-default-sm-focused-opacity': 1,
        'button-label-default-sm-hover-color': 'rgb(0, 98, 154)',
        'button-label-default-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-sm-hover-fontSize': '0.875rem',
        'button-label-default-sm-hover-fontWeight': 'normal',
        'button-label-default-sm-hover-letterSpacing': '0em',
        'button-label-default-sm-hover-lineHeight': '1.25rem',
        'button-label-default-sm-hover-opacity': 1,
        'button-label-default-sm-initial-color': 'rgb(0, 123, 192)',
        'button-label-default-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-sm-initial-fontSize': '0.875rem',
        'button-label-default-sm-initial-fontWeight': 'normal',
        'button-label-default-sm-initial-letterSpacing': '0em',
        'button-label-default-sm-initial-lineHeight': '1.25rem',
        'button-label-default-sm-initial-opacity': 1,
        'button-label-default-sm-pressed-color': 'rgb(0, 73, 117)',
        'button-label-default-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-default-sm-pressed-fontSize': '0.875rem',
        'button-label-default-sm-pressed-fontWeight': 'normal',
        'button-label-default-sm-pressed-letterSpacing': '0em',
        'button-label-default-sm-pressed-lineHeight': '1.25rem',
        'button-label-default-sm-pressed-opacity': 0.65,
        'button-label-prominent-lg-disabled-color': 'rgb(0, 0, 0)',
        'button-label-prominent-lg-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-lg-disabled-fontSize': '1.25rem',
        'button-label-prominent-lg-disabled-fontWeight': 'normal',
        'button-label-prominent-lg-disabled-letterSpacing': '0em',
        'button-label-prominent-lg-disabled-lineHeight': '1.75rem',
        'button-label-prominent-lg-disabled-opacity': 1,
        'button-label-prominent-lg-focused-color': 'rgb(255, 255, 255)',
        'button-label-prominent-lg-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-lg-focused-fontSize': '1.25rem',
        'button-label-prominent-lg-focused-fontWeight': 'normal',
        'button-label-prominent-lg-focused-letterSpacing': '0em',
        'button-label-prominent-lg-focused-lineHeight': '1.75rem',
        'button-label-prominent-lg-focused-opacity': 1,
        'button-label-prominent-lg-hover-color': 'rgb(255, 255, 255)',
        'button-label-prominent-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-lg-hover-fontSize': '1.25rem',
        'button-label-prominent-lg-hover-fontWeight': 'normal',
        'button-label-prominent-lg-hover-letterSpacing': '0em',
        'button-label-prominent-lg-hover-lineHeight': '1.75rem',
        'button-label-prominent-lg-hover-opacity': 1,
        'button-label-prominent-lg-initial-color': 'rgb(255, 255, 255)',
        'button-label-prominent-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-lg-initial-fontSize': '1.25rem',
        'button-label-prominent-lg-initial-fontWeight': 'normal',
        'button-label-prominent-lg-initial-letterSpacing': '0em',
        'button-label-prominent-lg-initial-lineHeight': '1.75rem',
        'button-label-prominent-lg-initial-opacity': 1,
        'button-label-prominent-lg-pressed-color': 'rgb(255, 255, 255)',
        'button-label-prominent-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-lg-pressed-fontSize': '1.25rem',
        'button-label-prominent-lg-pressed-fontWeight': 'normal',
        'button-label-prominent-lg-pressed-letterSpacing': '0em',
        'button-label-prominent-lg-pressed-lineHeight': '1.75rem',
        'button-label-prominent-lg-pressed-opacity': 0.65,
        'button-label-prominent-md-disabled-color': 'rgb(0, 0, 0)',
        'button-label-prominent-md-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-md-disabled-fontSize': '1rem',
        'button-label-prominent-md-disabled-fontWeight': 'normal',
        'button-label-prominent-md-disabled-letterSpacing': '0em',
        'button-label-prominent-md-disabled-lineHeight': '1.5rem',
        'button-label-prominent-md-disabled-opacity': 1,
        'button-label-prominent-md-focused-color': 'rgb(255, 255, 255)',
        'button-label-prominent-md-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-md-focused-fontSize': '1rem',
        'button-label-prominent-md-focused-fontWeight': 'normal',
        'button-label-prominent-md-focused-letterSpacing': '0em',
        'button-label-prominent-md-focused-lineHeight': '1.5rem',
        'button-label-prominent-md-focused-opacity': 1,
        'button-label-prominent-md-hover-color': 'rgb(255, 255, 255)',
        'button-label-prominent-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-md-hover-fontSize': '1rem',
        'button-label-prominent-md-hover-fontWeight': 'normal',
        'button-label-prominent-md-hover-letterSpacing': '0em',
        'button-label-prominent-md-hover-lineHeight': '1.5rem',
        'button-label-prominent-md-hover-opacity': 1,
        'button-label-prominent-md-initial-color': 'rgb(255, 255, 255)',
        'button-label-prominent-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-md-initial-fontSize': '1rem',
        'button-label-prominent-md-initial-fontWeight': 'normal',
        'button-label-prominent-md-initial-letterSpacing': '0em',
        'button-label-prominent-md-initial-lineHeight': '1.5rem',
        'button-label-prominent-md-initial-opacity': 1,
        'button-label-prominent-md-pressed-color': 'rgb(255, 255, 255)',
        'button-label-prominent-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-md-pressed-fontSize': '1rem',
        'button-label-prominent-md-pressed-fontWeight': 'normal',
        'button-label-prominent-md-pressed-letterSpacing': '0em',
        'button-label-prominent-md-pressed-lineHeight': '1.5rem',
        'button-label-prominent-md-pressed-opacity': 0.65,
        'button-label-prominent-sm-disabled-color': 'rgb(0, 0, 0)',
        'button-label-prominent-sm-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-sm-disabled-fontSize': '0.875rem',
        'button-label-prominent-sm-disabled-fontWeight': 'normal',
        'button-label-prominent-sm-disabled-letterSpacing': '0em',
        'button-label-prominent-sm-disabled-lineHeight': '1.25rem',
        'button-label-prominent-sm-disabled-opacity': 1,
        'button-label-prominent-sm-focused-color': 'rgb(255, 255, 255)',
        'button-label-prominent-sm-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-sm-focused-fontSize': '0.875rem',
        'button-label-prominent-sm-focused-fontWeight': 'normal',
        'button-label-prominent-sm-focused-letterSpacing': '0em',
        'button-label-prominent-sm-focused-lineHeight': '1.25rem',
        'button-label-prominent-sm-focused-opacity': 1,
        'button-label-prominent-sm-hover-color': 'rgb(255, 255, 255)',
        'button-label-prominent-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-sm-hover-fontSize': '0.875rem',
        'button-label-prominent-sm-hover-fontWeight': 'normal',
        'button-label-prominent-sm-hover-letterSpacing': '0em',
        'button-label-prominent-sm-hover-lineHeight': '1.25rem',
        'button-label-prominent-sm-hover-opacity': 1,
        'button-label-prominent-sm-initial-color': 'rgb(255, 255, 255)',
        'button-label-prominent-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-sm-initial-fontSize': '0.875rem',
        'button-label-prominent-sm-initial-fontWeight': 'normal',
        'button-label-prominent-sm-initial-letterSpacing': '0em',
        'button-label-prominent-sm-initial-lineHeight': '1.25rem',
        'button-label-prominent-sm-initial-opacity': 1,
        'button-label-prominent-sm-pressed-color': 'rgb(255, 255, 255)',
        'button-label-prominent-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-prominent-sm-pressed-fontSize': '0.875rem',
        'button-label-prominent-sm-pressed-fontWeight': 'normal',
        'button-label-prominent-sm-pressed-letterSpacing': '0em',
        'button-label-prominent-sm-pressed-lineHeight': '1.25rem',
        'button-label-prominent-sm-pressed-opacity': 0.65,
        'button-label-subtle-lg-disabled-color': 'rgb(0, 0, 0)',
        'button-label-subtle-lg-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-lg-disabled-fontSize': '1.25rem',
        'button-label-subtle-lg-disabled-fontWeight': 'normal',
        'button-label-subtle-lg-disabled-letterSpacing': '0em',
        'button-label-subtle-lg-disabled-lineHeight': '1.75rem',
        'button-label-subtle-lg-disabled-opacity': 1,
        'button-label-subtle-lg-focused-color': 'rgb(0, 98, 154)',
        'button-label-subtle-lg-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-lg-focused-fontSize': '1.25rem',
        'button-label-subtle-lg-focused-fontWeight': 'normal',
        'button-label-subtle-lg-focused-letterSpacing': '0em',
        'button-label-subtle-lg-focused-lineHeight': '1.75rem',
        'button-label-subtle-lg-focused-opacity': 1,
        'button-label-subtle-lg-hover-color': 'rgb(0, 98, 154)',
        'button-label-subtle-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-lg-hover-fontSize': '1.25rem',
        'button-label-subtle-lg-hover-fontWeight': 'normal',
        'button-label-subtle-lg-hover-letterSpacing': '0em',
        'button-label-subtle-lg-hover-lineHeight': '1.75rem',
        'button-label-subtle-lg-hover-opacity': 1,
        'button-label-subtle-lg-initial-color': 'rgb(0, 123, 192)',
        'button-label-subtle-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-lg-initial-fontSize': '1.25rem',
        'button-label-subtle-lg-initial-fontWeight': 'normal',
        'button-label-subtle-lg-initial-letterSpacing': '0em',
        'button-label-subtle-lg-initial-lineHeight': '1.75rem',
        'button-label-subtle-lg-initial-opacity': 1,
        'button-label-subtle-lg-pressed-color': 'rgb(0, 73, 117)',
        'button-label-subtle-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-lg-pressed-fontSize': '1.25rem',
        'button-label-subtle-lg-pressed-fontWeight': 'normal',
        'button-label-subtle-lg-pressed-letterSpacing': '0em',
        'button-label-subtle-lg-pressed-lineHeight': '1.75rem',
        'button-label-subtle-lg-pressed-opacity': 0.65,
        'button-label-subtle-md-disabled-color': 'rgb(0, 0, 0)',
        'button-label-subtle-md-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-md-disabled-fontSize': '1rem',
        'button-label-subtle-md-disabled-fontWeight': 'normal',
        'button-label-subtle-md-disabled-letterSpacing': '0em',
        'button-label-subtle-md-disabled-lineHeight': '1.5rem',
        'button-label-subtle-md-disabled-opacity': 1,
        'button-label-subtle-md-focused-color': 'rgb(0, 98, 154)',
        'button-label-subtle-md-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-md-focused-fontSize': '1rem',
        'button-label-subtle-md-focused-fontWeight': 'normal',
        'button-label-subtle-md-focused-letterSpacing': '0em',
        'button-label-subtle-md-focused-lineHeight': '1.5rem',
        'button-label-subtle-md-focused-opacity': 1,
        'button-label-subtle-md-hover-color': 'rgb(0, 98, 154)',
        'button-label-subtle-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-md-hover-fontSize': '1rem',
        'button-label-subtle-md-hover-fontWeight': 'normal',
        'button-label-subtle-md-hover-letterSpacing': '0em',
        'button-label-subtle-md-hover-lineHeight': '1.5rem',
        'button-label-subtle-md-hover-opacity': 1,
        'button-label-subtle-md-initial-color': 'rgb(0, 123, 192)',
        'button-label-subtle-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-md-initial-fontSize': '1rem',
        'button-label-subtle-md-initial-fontWeight': 'normal',
        'button-label-subtle-md-initial-letterSpacing': '0em',
        'button-label-subtle-md-initial-lineHeight': '1.5rem',
        'button-label-subtle-md-initial-opacity': 1,
        'button-label-subtle-md-pressed-color': 'rgb(0, 73, 117)',
        'button-label-subtle-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-md-pressed-fontSize': '1rem',
        'button-label-subtle-md-pressed-fontWeight': 'normal',
        'button-label-subtle-md-pressed-letterSpacing': '0em',
        'button-label-subtle-md-pressed-lineHeight': '1.5rem',
        'button-label-subtle-md-pressed-opacity': 0.65,
        'button-label-subtle-sm-disabled-color': 'rgb(0, 0, 0)',
        'button-label-subtle-sm-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-sm-disabled-fontSize': '0.875rem',
        'button-label-subtle-sm-disabled-fontWeight': 'normal',
        'button-label-subtle-sm-disabled-letterSpacing': '0em',
        'button-label-subtle-sm-disabled-lineHeight': '1.25rem',
        'button-label-subtle-sm-disabled-opacity': 1,
        'button-label-subtle-sm-focused-color': 'rgb(0, 98, 154)',
        'button-label-subtle-sm-focused-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-sm-focused-fontSize': '0.875rem',
        'button-label-subtle-sm-focused-fontWeight': 'normal',
        'button-label-subtle-sm-focused-letterSpacing': '0em',
        'button-label-subtle-sm-focused-lineHeight': '1.25rem',
        'button-label-subtle-sm-focused-opacity': 1,
        'button-label-subtle-sm-hover-color': 'rgb(0, 98, 154)',
        'button-label-subtle-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-sm-hover-fontSize': '0.875rem',
        'button-label-subtle-sm-hover-fontWeight': 'normal',
        'button-label-subtle-sm-hover-letterSpacing': '0em',
        'button-label-subtle-sm-hover-lineHeight': '1.25rem',
        'button-label-subtle-sm-hover-opacity': 1,
        'button-label-subtle-sm-initial-color': 'rgb(0, 123, 192)',
        'button-label-subtle-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-sm-initial-fontSize': '0.875rem',
        'button-label-subtle-sm-initial-fontWeight': 'normal',
        'button-label-subtle-sm-initial-letterSpacing': '0em',
        'button-label-subtle-sm-initial-lineHeight': '1.25rem',
        'button-label-subtle-sm-initial-opacity': 1,
        'button-label-subtle-sm-pressed-color': 'rgb(0, 73, 117)',
        'button-label-subtle-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'button-label-subtle-sm-pressed-fontSize': '0.875rem',
        'button-label-subtle-sm-pressed-fontWeight': 'normal',
        'button-label-subtle-sm-pressed-letterSpacing': '0em',
        'button-label-subtle-sm-pressed-lineHeight': '1.25rem',
        'button-label-subtle-sm-pressed-opacity': 0.65,
        'buttonAction-base-default-lg-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-lg-disabled-borderColor': 'rgb(113, 118, 124)',
        'buttonAction-base-default-lg-disabled-borderRadius': '0',
        'buttonAction-base-default-lg-disabled-borderStyle': 'solid',
        'buttonAction-base-default-lg-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-default-lg-disabled-gap': '0.5rem',
        'buttonAction-base-default-lg-disabled-height': '4rem',
        'buttonAction-base-default-lg-disabled-opacity': 0.4,
        'buttonAction-base-default-lg-disabled-width': '4rem',
        'buttonAction-base-default-lg-focused-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-lg-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-lg-focused-borderRadius': '0',
        'buttonAction-base-default-lg-focused-borderStyle': 'solid',
        'buttonAction-base-default-lg-focused-borderWidth': '0.0625rem',
        'buttonAction-base-default-lg-focused-gap': '0.5rem',
        'buttonAction-base-default-lg-focused-height': '4rem',
        'buttonAction-base-default-lg-focused-opacity': 1,
        'buttonAction-base-default-lg-focused-width': '4rem',
        'buttonAction-base-default-lg-hover-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-lg-hover-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-lg-hover-borderRadius': '0',
        'buttonAction-base-default-lg-hover-borderStyle': 'solid',
        'buttonAction-base-default-lg-hover-borderWidth': '0.0625rem',
        'buttonAction-base-default-lg-hover-gap': '0.5rem',
        'buttonAction-base-default-lg-hover-height': '4rem',
        'buttonAction-base-default-lg-hover-opacity': 1,
        'buttonAction-base-default-lg-hover-width': '4rem',
        'buttonAction-base-default-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-lg-initial-borderColor': 'rgb(193, 199, 204)',
        'buttonAction-base-default-lg-initial-borderRadius': '0',
        'buttonAction-base-default-lg-initial-borderStyle': 'solid',
        'buttonAction-base-default-lg-initial-borderWidth': '0.0625rem',
        'buttonAction-base-default-lg-initial-gap': '0.5rem',
        'buttonAction-base-default-lg-initial-height': '4rem',
        'buttonAction-base-default-lg-initial-opacity': 1,
        'buttonAction-base-default-lg-initial-width': '4rem',
        'buttonAction-base-default-lg-pressed-background': 'rgb(157, 201, 255)',
        'buttonAction-base-default-lg-pressed-borderColor': 'rgb(0, 73, 117)',
        'buttonAction-base-default-lg-pressed-borderRadius': '0',
        'buttonAction-base-default-lg-pressed-borderStyle': 'solid',
        'buttonAction-base-default-lg-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-default-lg-pressed-gap': '0.5rem',
        'buttonAction-base-default-lg-pressed-height': '4rem',
        'buttonAction-base-default-lg-pressed-opacity': 1,
        'buttonAction-base-default-lg-pressed-width': '4rem',
        'buttonAction-base-default-md-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-md-disabled-borderColor': 'rgb(113, 118, 124)',
        'buttonAction-base-default-md-disabled-borderRadius': '0',
        'buttonAction-base-default-md-disabled-borderStyle': 'solid',
        'buttonAction-base-default-md-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-default-md-disabled-gap': '0.5rem',
        'buttonAction-base-default-md-disabled-height': '3rem',
        'buttonAction-base-default-md-disabled-opacity': 0.4,
        'buttonAction-base-default-md-disabled-width': '3rem',
        'buttonAction-base-default-md-focused-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-md-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-md-focused-borderRadius': '0',
        'buttonAction-base-default-md-focused-borderStyle': 'solid',
        'buttonAction-base-default-md-focused-borderWidth': '0.0625rem',
        'buttonAction-base-default-md-focused-gap': '0.5rem',
        'buttonAction-base-default-md-focused-height': '3rem',
        'buttonAction-base-default-md-focused-opacity': 1,
        'buttonAction-base-default-md-focused-width': '3rem',
        'buttonAction-base-default-md-hover-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-md-hover-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-md-hover-borderRadius': '0',
        'buttonAction-base-default-md-hover-borderStyle': 'solid',
        'buttonAction-base-default-md-hover-borderWidth': '0.0625rem',
        'buttonAction-base-default-md-hover-gap': '0.5rem',
        'buttonAction-base-default-md-hover-height': '3rem',
        'buttonAction-base-default-md-hover-opacity': 1,
        'buttonAction-base-default-md-hover-width': '3rem',
        'buttonAction-base-default-md-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-md-initial-borderColor': 'rgb(193, 199, 204)',
        'buttonAction-base-default-md-initial-borderRadius': '0',
        'buttonAction-base-default-md-initial-borderStyle': 'solid',
        'buttonAction-base-default-md-initial-borderWidth': '0.0625rem',
        'buttonAction-base-default-md-initial-gap': '0.5rem',
        'buttonAction-base-default-md-initial-height': '3rem',
        'buttonAction-base-default-md-initial-opacity': 1,
        'buttonAction-base-default-md-initial-width': '3rem',
        'buttonAction-base-default-md-pressed-background': 'rgb(157, 201, 255)',
        'buttonAction-base-default-md-pressed-borderColor': 'rgb(0, 73, 117)',
        'buttonAction-base-default-md-pressed-borderRadius': '0',
        'buttonAction-base-default-md-pressed-borderStyle': 'solid',
        'buttonAction-base-default-md-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-default-md-pressed-gap': '0.5rem',
        'buttonAction-base-default-md-pressed-height': '3rem',
        'buttonAction-base-default-md-pressed-opacity': 1,
        'buttonAction-base-default-md-pressed-width': '3rem',
        'buttonAction-base-default-sm-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-sm-disabled-borderColor': 'rgb(113, 118, 124)',
        'buttonAction-base-default-sm-disabled-borderRadius': '0',
        'buttonAction-base-default-sm-disabled-borderStyle': 'solid',
        'buttonAction-base-default-sm-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-default-sm-disabled-gap': '0.25rem',
        'buttonAction-base-default-sm-disabled-height': '2rem',
        'buttonAction-base-default-sm-disabled-opacity': 0.4,
        'buttonAction-base-default-sm-disabled-width': '2rem',
        'buttonAction-base-default-sm-focused-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-sm-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-sm-focused-borderRadius': '0',
        'buttonAction-base-default-sm-focused-borderStyle': 'solid',
        'buttonAction-base-default-sm-focused-borderWidth': '0.0625rem',
        'buttonAction-base-default-sm-focused-gap': '0.25rem',
        'buttonAction-base-default-sm-focused-height': '2rem',
        'buttonAction-base-default-sm-focused-opacity': 1,
        'buttonAction-base-default-sm-focused-width': '2rem',
        'buttonAction-base-default-sm-hover-background': 'rgb(209, 228, 255)',
        'buttonAction-base-default-sm-hover-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-default-sm-hover-borderRadius': '0',
        'buttonAction-base-default-sm-hover-borderStyle': 'solid',
        'buttonAction-base-default-sm-hover-borderWidth': '0.0625rem',
        'buttonAction-base-default-sm-hover-gap': '0.25rem',
        'buttonAction-base-default-sm-hover-height': '2rem',
        'buttonAction-base-default-sm-hover-opacity': 1,
        'buttonAction-base-default-sm-hover-width': '2rem',
        'buttonAction-base-default-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-default-sm-initial-borderColor': 'rgb(193, 199, 204)',
        'buttonAction-base-default-sm-initial-borderRadius': '0',
        'buttonAction-base-default-sm-initial-borderStyle': 'solid',
        'buttonAction-base-default-sm-initial-borderWidth': '0.0625rem',
        'buttonAction-base-default-sm-initial-gap': '0.25rem',
        'buttonAction-base-default-sm-initial-height': '2rem',
        'buttonAction-base-default-sm-initial-opacity': 1,
        'buttonAction-base-default-sm-initial-width': '2rem',
        'buttonAction-base-default-sm-pressed-background': 'rgb(157, 201, 255)',
        'buttonAction-base-default-sm-pressed-borderColor': 'rgb(0, 73, 117)',
        'buttonAction-base-default-sm-pressed-borderRadius': '0',
        'buttonAction-base-default-sm-pressed-borderStyle': 'solid',
        'buttonAction-base-default-sm-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-default-sm-pressed-gap': '0.25rem',
        'buttonAction-base-default-sm-pressed-height': '2rem',
        'buttonAction-base-default-sm-pressed-opacity': 1,
        'buttonAction-base-default-sm-pressed-width': '2rem',
        'buttonAction-base-prominent-lg-disabled-background': 'rgb(193, 199, 204)',
        'buttonAction-base-prominent-lg-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-lg-disabled-borderRadius': '0',
        'buttonAction-base-prominent-lg-disabled-borderStyle': 'solid',
        'buttonAction-base-prominent-lg-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-lg-disabled-gap': '0.5rem',
        'buttonAction-base-prominent-lg-disabled-height': '4rem',
        'buttonAction-base-prominent-lg-disabled-opacity': 0.4,
        'buttonAction-base-prominent-lg-disabled-width': '4rem',
        'buttonAction-base-prominent-lg-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-lg-focused-borderColor': 'rgb(0, 18, 34)',
        'buttonAction-base-prominent-lg-focused-borderRadius': '0',
        'buttonAction-base-prominent-lg-focused-borderStyle': 'solid',
        'buttonAction-base-prominent-lg-focused-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-lg-focused-gap': '0.5rem',
        'buttonAction-base-prominent-lg-focused-height': '4rem',
        'buttonAction-base-prominent-lg-focused-opacity': 1,
        'buttonAction-base-prominent-lg-focused-width': '4rem',
        'buttonAction-base-prominent-lg-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-lg-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-lg-hover-borderRadius': '0',
        'buttonAction-base-prominent-lg-hover-borderStyle': 'solid',
        'buttonAction-base-prominent-lg-hover-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-lg-hover-gap': '0.5rem',
        'buttonAction-base-prominent-lg-hover-height': '4rem',
        'buttonAction-base-prominent-lg-hover-opacity': 1,
        'buttonAction-base-prominent-lg-hover-width': '4rem',
        'buttonAction-base-prominent-lg-initial-background': 'rgb(0, 123, 192)',
        'buttonAction-base-prominent-lg-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-lg-initial-borderRadius': '0',
        'buttonAction-base-prominent-lg-initial-borderStyle': 'solid',
        'buttonAction-base-prominent-lg-initial-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-lg-initial-gap': '0.5rem',
        'buttonAction-base-prominent-lg-initial-height': '4rem',
        'buttonAction-base-prominent-lg-initial-opacity': 1,
        'buttonAction-base-prominent-lg-initial-width': '4rem',
        'buttonAction-base-prominent-lg-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-base-prominent-lg-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-lg-pressed-borderRadius': '0',
        'buttonAction-base-prominent-lg-pressed-borderStyle': 'solid',
        'buttonAction-base-prominent-lg-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-lg-pressed-gap': '0.5rem',
        'buttonAction-base-prominent-lg-pressed-height': '4rem',
        'buttonAction-base-prominent-lg-pressed-opacity': 1,
        'buttonAction-base-prominent-lg-pressed-width': '4rem',
        'buttonAction-base-prominent-md-disabled-background': 'rgb(193, 199, 204)',
        'buttonAction-base-prominent-md-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-md-disabled-borderRadius': '0',
        'buttonAction-base-prominent-md-disabled-borderStyle': 'solid',
        'buttonAction-base-prominent-md-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-md-disabled-gap': '0.5rem',
        'buttonAction-base-prominent-md-disabled-height': '3rem',
        'buttonAction-base-prominent-md-disabled-opacity': 0.4,
        'buttonAction-base-prominent-md-disabled-width': '3rem',
        'buttonAction-base-prominent-md-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-md-focused-borderColor': 'rgb(0, 18, 34)',
        'buttonAction-base-prominent-md-focused-borderRadius': '0',
        'buttonAction-base-prominent-md-focused-borderStyle': 'solid',
        'buttonAction-base-prominent-md-focused-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-md-focused-gap': '0.5rem',
        'buttonAction-base-prominent-md-focused-height': '3rem',
        'buttonAction-base-prominent-md-focused-opacity': 1,
        'buttonAction-base-prominent-md-focused-width': '3rem',
        'buttonAction-base-prominent-md-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-md-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-md-hover-borderRadius': '0',
        'buttonAction-base-prominent-md-hover-borderStyle': 'solid',
        'buttonAction-base-prominent-md-hover-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-md-hover-gap': '0.5rem',
        'buttonAction-base-prominent-md-hover-height': '3rem',
        'buttonAction-base-prominent-md-hover-opacity': 1,
        'buttonAction-base-prominent-md-hover-width': '3rem',
        'buttonAction-base-prominent-md-initial-background': 'rgb(0, 123, 192)',
        'buttonAction-base-prominent-md-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-md-initial-borderRadius': '0',
        'buttonAction-base-prominent-md-initial-borderStyle': 'solid',
        'buttonAction-base-prominent-md-initial-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-md-initial-gap': '0.5rem',
        'buttonAction-base-prominent-md-initial-height': '3rem',
        'buttonAction-base-prominent-md-initial-opacity': 1,
        'buttonAction-base-prominent-md-initial-width': '3rem',
        'buttonAction-base-prominent-md-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-base-prominent-md-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-md-pressed-borderRadius': '0',
        'buttonAction-base-prominent-md-pressed-borderStyle': 'solid',
        'buttonAction-base-prominent-md-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-md-pressed-gap': '0.5rem',
        'buttonAction-base-prominent-md-pressed-height': '3rem',
        'buttonAction-base-prominent-md-pressed-opacity': 1,
        'buttonAction-base-prominent-md-pressed-width': '3rem',
        'buttonAction-base-prominent-sm-disabled-background': 'rgb(193, 199, 204)',
        'buttonAction-base-prominent-sm-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-sm-disabled-borderRadius': '0',
        'buttonAction-base-prominent-sm-disabled-borderStyle': 'solid',
        'buttonAction-base-prominent-sm-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-sm-disabled-gap': '0.25rem',
        'buttonAction-base-prominent-sm-disabled-height': '2rem',
        'buttonAction-base-prominent-sm-disabled-opacity': 0.4,
        'buttonAction-base-prominent-sm-disabled-width': '2rem',
        'buttonAction-base-prominent-sm-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-sm-focused-borderColor': 'rgb(0, 18, 34)',
        'buttonAction-base-prominent-sm-focused-borderRadius': '0',
        'buttonAction-base-prominent-sm-focused-borderStyle': 'solid',
        'buttonAction-base-prominent-sm-focused-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-sm-focused-gap': '0.25rem',
        'buttonAction-base-prominent-sm-focused-height': '2rem',
        'buttonAction-base-prominent-sm-focused-opacity': 1,
        'buttonAction-base-prominent-sm-focused-width': '2rem',
        'buttonAction-base-prominent-sm-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-base-prominent-sm-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-sm-hover-borderRadius': '0',
        'buttonAction-base-prominent-sm-hover-borderStyle': 'solid',
        'buttonAction-base-prominent-sm-hover-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-sm-hover-gap': '0.25rem',
        'buttonAction-base-prominent-sm-hover-height': '2rem',
        'buttonAction-base-prominent-sm-hover-opacity': 1,
        'buttonAction-base-prominent-sm-hover-width': '2rem',
        'buttonAction-base-prominent-sm-initial-background': 'rgb(0, 123, 192)',
        'buttonAction-base-prominent-sm-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-sm-initial-borderRadius': '0',
        'buttonAction-base-prominent-sm-initial-borderStyle': 'solid',
        'buttonAction-base-prominent-sm-initial-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-sm-initial-gap': '0.25rem',
        'buttonAction-base-prominent-sm-initial-height': '2rem',
        'buttonAction-base-prominent-sm-initial-opacity': 1,
        'buttonAction-base-prominent-sm-initial-width': '2rem',
        'buttonAction-base-prominent-sm-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-base-prominent-sm-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-prominent-sm-pressed-borderRadius': '0',
        'buttonAction-base-prominent-sm-pressed-borderStyle': 'solid',
        'buttonAction-base-prominent-sm-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-prominent-sm-pressed-gap': '0.25rem',
        'buttonAction-base-prominent-sm-pressed-height': '2rem',
        'buttonAction-base-prominent-sm-pressed-opacity': 1,
        'buttonAction-base-prominent-sm-pressed-width': '2rem',
        'buttonAction-base-subtle-lg-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-disabled-borderRadius': '0',
        'buttonAction-base-subtle-lg-disabled-borderStyle': 'solid',
        'buttonAction-base-subtle-lg-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-lg-disabled-gap': '0.5rem',
        'buttonAction-base-subtle-lg-disabled-height': '4rem',
        'buttonAction-base-subtle-lg-disabled-opacity': 0.4,
        'buttonAction-base-subtle-lg-disabled-width': '4rem',
        'buttonAction-base-subtle-lg-focused-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-lg-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-subtle-lg-focused-borderRadius': '0',
        'buttonAction-base-subtle-lg-focused-borderStyle': 'solid',
        'buttonAction-base-subtle-lg-focused-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-lg-focused-gap': '0.5rem',
        'buttonAction-base-subtle-lg-focused-height': '4rem',
        'buttonAction-base-subtle-lg-focused-opacity': 1,
        'buttonAction-base-subtle-lg-focused-width': '4rem',
        'buttonAction-base-subtle-lg-hover-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-lg-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-hover-borderRadius': '0',
        'buttonAction-base-subtle-lg-hover-borderStyle': 'solid',
        'buttonAction-base-subtle-lg-hover-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-lg-hover-gap': '0.5rem',
        'buttonAction-base-subtle-lg-hover-height': '4rem',
        'buttonAction-base-subtle-lg-hover-opacity': 1,
        'buttonAction-base-subtle-lg-hover-width': '4rem',
        'buttonAction-base-subtle-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-initial-borderRadius': '0',
        'buttonAction-base-subtle-lg-initial-borderStyle': 'solid',
        'buttonAction-base-subtle-lg-initial-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-lg-initial-gap': '0.5rem',
        'buttonAction-base-subtle-lg-initial-height': '4rem',
        'buttonAction-base-subtle-lg-initial-opacity': 1,
        'buttonAction-base-subtle-lg-initial-width': '4rem',
        'buttonAction-base-subtle-lg-pressed-background': 'rgb(209, 228, 255)',
        'buttonAction-base-subtle-lg-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-lg-pressed-borderRadius': '0',
        'buttonAction-base-subtle-lg-pressed-borderStyle': 'solid',
        'buttonAction-base-subtle-lg-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-lg-pressed-gap': '0.5rem',
        'buttonAction-base-subtle-lg-pressed-height': '4rem',
        'buttonAction-base-subtle-lg-pressed-opacity': 1,
        'buttonAction-base-subtle-lg-pressed-width': '4rem',
        'buttonAction-base-subtle-md-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-disabled-borderRadius': '0',
        'buttonAction-base-subtle-md-disabled-borderStyle': 'solid',
        'buttonAction-base-subtle-md-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-md-disabled-gap': '0.5rem',
        'buttonAction-base-subtle-md-disabled-height': '3rem',
        'buttonAction-base-subtle-md-disabled-opacity': 0.4,
        'buttonAction-base-subtle-md-disabled-width': '3rem',
        'buttonAction-base-subtle-md-focused-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-md-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-subtle-md-focused-borderRadius': '0',
        'buttonAction-base-subtle-md-focused-borderStyle': 'solid',
        'buttonAction-base-subtle-md-focused-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-md-focused-gap': '0.5rem',
        'buttonAction-base-subtle-md-focused-height': '3rem',
        'buttonAction-base-subtle-md-focused-opacity': 1,
        'buttonAction-base-subtle-md-focused-width': '3rem',
        'buttonAction-base-subtle-md-hover-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-md-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-hover-borderRadius': '0',
        'buttonAction-base-subtle-md-hover-borderStyle': 'solid',
        'buttonAction-base-subtle-md-hover-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-md-hover-gap': '0.5rem',
        'buttonAction-base-subtle-md-hover-height': '3rem',
        'buttonAction-base-subtle-md-hover-opacity': 1,
        'buttonAction-base-subtle-md-hover-width': '3rem',
        'buttonAction-base-subtle-md-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-initial-borderRadius': '0',
        'buttonAction-base-subtle-md-initial-borderStyle': 'solid',
        'buttonAction-base-subtle-md-initial-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-md-initial-gap': '0.5rem',
        'buttonAction-base-subtle-md-initial-height': '3rem',
        'buttonAction-base-subtle-md-initial-opacity': 1,
        'buttonAction-base-subtle-md-initial-width': '3rem',
        'buttonAction-base-subtle-md-pressed-background': 'rgb(209, 228, 255)',
        'buttonAction-base-subtle-md-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-md-pressed-borderRadius': '0',
        'buttonAction-base-subtle-md-pressed-borderStyle': 'solid',
        'buttonAction-base-subtle-md-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-md-pressed-gap': '0.5rem',
        'buttonAction-base-subtle-md-pressed-height': '3rem',
        'buttonAction-base-subtle-md-pressed-opacity': 1,
        'buttonAction-base-subtle-md-pressed-width': '3rem',
        'buttonAction-base-subtle-sm-disabled-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-disabled-borderRadius': '0',
        'buttonAction-base-subtle-sm-disabled-borderStyle': 'solid',
        'buttonAction-base-subtle-sm-disabled-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-sm-disabled-gap': '0.25rem',
        'buttonAction-base-subtle-sm-disabled-height': '2rem',
        'buttonAction-base-subtle-sm-disabled-opacity': 0.4,
        'buttonAction-base-subtle-sm-disabled-width': '2rem',
        'buttonAction-base-subtle-sm-focused-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-sm-focused-borderColor': 'rgb(0, 98, 154)',
        'buttonAction-base-subtle-sm-focused-borderRadius': '0',
        'buttonAction-base-subtle-sm-focused-borderStyle': 'solid',
        'buttonAction-base-subtle-sm-focused-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-sm-focused-gap': '0.25rem',
        'buttonAction-base-subtle-sm-focused-height': '2rem',
        'buttonAction-base-subtle-sm-focused-opacity': 1,
        'buttonAction-base-subtle-sm-focused-width': '2rem',
        'buttonAction-base-subtle-sm-hover-background': 'rgb(232, 241, 255)',
        'buttonAction-base-subtle-sm-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-hover-borderRadius': '0',
        'buttonAction-base-subtle-sm-hover-borderStyle': 'solid',
        'buttonAction-base-subtle-sm-hover-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-sm-hover-gap': '0.25rem',
        'buttonAction-base-subtle-sm-hover-height': '2rem',
        'buttonAction-base-subtle-sm-hover-opacity': 1,
        'buttonAction-base-subtle-sm-hover-width': '2rem',
        'buttonAction-base-subtle-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-initial-borderRadius': '0',
        'buttonAction-base-subtle-sm-initial-borderStyle': 'solid',
        'buttonAction-base-subtle-sm-initial-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-sm-initial-gap': '0.25rem',
        'buttonAction-base-subtle-sm-initial-height': '2rem',
        'buttonAction-base-subtle-sm-initial-opacity': 1,
        'buttonAction-base-subtle-sm-initial-width': '2rem',
        'buttonAction-base-subtle-sm-pressed-background': 'rgb(209, 228, 255)',
        'buttonAction-base-subtle-sm-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'buttonAction-base-subtle-sm-pressed-borderRadius': '0',
        'buttonAction-base-subtle-sm-pressed-borderStyle': 'solid',
        'buttonAction-base-subtle-sm-pressed-borderWidth': '0.0625rem',
        'buttonAction-base-subtle-sm-pressed-gap': '0.25rem',
        'buttonAction-base-subtle-sm-pressed-height': '2rem',
        'buttonAction-base-subtle-sm-pressed-opacity': 1,
        'buttonAction-base-subtle-sm-pressed-width': '2rem',
        'buttonAction-icon-default-lg-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-lg-disabled-opacity': 1,
        'buttonAction-icon-default-lg-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-lg-focused-opacity': 1,
        'buttonAction-icon-default-lg-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-lg-hover-opacity': 1,
        'buttonAction-icon-default-lg-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-lg-initial-opacity': 1,
        'buttonAction-icon-default-lg-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-default-lg-pressed-opacity': 0.65,
        'buttonAction-icon-default-md-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-md-disabled-opacity': 1,
        'buttonAction-icon-default-md-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-md-focused-opacity': 1,
        'buttonAction-icon-default-md-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-md-hover-opacity': 1,
        'buttonAction-icon-default-md-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-md-initial-opacity': 1,
        'buttonAction-icon-default-md-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-default-md-pressed-opacity': 0.65,
        'buttonAction-icon-default-sm-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-sm-disabled-opacity': 1,
        'buttonAction-icon-default-sm-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-sm-focused-opacity': 1,
        'buttonAction-icon-default-sm-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-default-sm-hover-opacity': 1,
        'buttonAction-icon-default-sm-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-default-sm-initial-opacity': 1,
        'buttonAction-icon-default-sm-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-default-sm-pressed-opacity': 0.65,
        'buttonAction-icon-prominent-lg-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-prominent-lg-disabled-opacity': 1,
        'buttonAction-icon-prominent-lg-focused-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-lg-focused-opacity': 1,
        'buttonAction-icon-prominent-lg-hover-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-lg-hover-opacity': 1,
        'buttonAction-icon-prominent-lg-initial-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-lg-initial-opacity': 1,
        'buttonAction-icon-prominent-lg-pressed-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-lg-pressed-opacity': 0.65,
        'buttonAction-icon-prominent-md-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-prominent-md-disabled-opacity': 1,
        'buttonAction-icon-prominent-md-focused-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-md-focused-opacity': 1,
        'buttonAction-icon-prominent-md-hover-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-md-hover-opacity': 1,
        'buttonAction-icon-prominent-md-initial-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-md-initial-opacity': 1,
        'buttonAction-icon-prominent-md-pressed-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-md-pressed-opacity': 0.65,
        'buttonAction-icon-prominent-sm-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-prominent-sm-disabled-opacity': 1,
        'buttonAction-icon-prominent-sm-focused-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-sm-focused-opacity': 1,
        'buttonAction-icon-prominent-sm-hover-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-sm-hover-opacity': 1,
        'buttonAction-icon-prominent-sm-initial-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-sm-initial-opacity': 1,
        'buttonAction-icon-prominent-sm-pressed-background': 'rgb(255, 255, 255)',
        'buttonAction-icon-prominent-sm-pressed-opacity': 0.65,
        'buttonAction-icon-subtle-lg-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-lg-disabled-opacity': 1,
        'buttonAction-icon-subtle-lg-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-lg-focused-opacity': 1,
        'buttonAction-icon-subtle-lg-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-lg-hover-opacity': 1,
        'buttonAction-icon-subtle-lg-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-lg-initial-opacity': 1,
        'buttonAction-icon-subtle-lg-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-subtle-lg-pressed-opacity': 0.65,
        'buttonAction-icon-subtle-md-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-md-disabled-opacity': 1,
        'buttonAction-icon-subtle-md-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-md-focused-opacity': 1,
        'buttonAction-icon-subtle-md-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-md-hover-opacity': 1,
        'buttonAction-icon-subtle-md-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-md-initial-opacity': 1,
        'buttonAction-icon-subtle-md-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-subtle-md-pressed-opacity': 0.65,
        'buttonAction-icon-subtle-sm-disabled-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-sm-disabled-opacity': 1,
        'buttonAction-icon-subtle-sm-focused-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-sm-focused-opacity': 1,
        'buttonAction-icon-subtle-sm-hover-background': 'rgb(0, 98, 154)',
        'buttonAction-icon-subtle-sm-hover-opacity': 1,
        'buttonAction-icon-subtle-sm-initial-background': 'rgb(0, 0, 0)',
        'buttonAction-icon-subtle-sm-initial-opacity': 1,
        'buttonAction-icon-subtle-sm-pressed-background': 'rgb(0, 73, 117)',
        'buttonAction-icon-subtle-sm-pressed-opacity': 0.65,
        'buttontext-large-fontFamily': 'Bosch Sans, sans-serif',
        'buttontext-large-fontSize': '1.25rem',
        'buttontext-large-fontWeight': 'normal',
        'buttontext-large-letterSpacing': '0em',
        'buttontext-large-lineHeight': '1.75rem',
        'buttontext-medium-fontFamily': 'Bosch Sans, sans-serif',
        'buttontext-medium-fontSize': '1rem',
        'buttontext-medium-fontWeight': 'normal',
        'buttontext-medium-letterSpacing': '0em',
        'buttontext-medium-lineHeight': '1.5rem',
        'buttontext-small-fontFamily': 'Bosch Sans, sans-serif',
        'buttontext-small-fontSize': '0.875rem',
        'buttontext-small-fontWeight': 'normal',
        'buttontext-small-letterSpacing': '0em',
        'buttontext-small-lineHeight': '1.25rem',
        'buyArea-base-lg-gap': '2rem',
        'buyArea-base-sm-gap': '1.5rem',
        'buyArea-benefitList-base-lg-gap': '2rem',
        'buyArea-benefitList-base-sm-gap': '1.5rem',
        'buyArea-configurationList-base-lg-gap': '1.5rem',
        'buyArea-configurationList-base-sm-gap': '1rem',
        'buyArea-configurationList-configuration-header-base-lg-gap': '0.25rem',
        'buyArea-configurationList-configuration-header-base-sm-gap': '0.25rem',
        'buyArea-configurationList-configuration-header-description-lg-color': 'rgb(0, 0, 0)',
        'buyArea-configurationList-configuration-header-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-configurationList-configuration-header-description-lg-fontSize': '0.875rem',
        'buyArea-configurationList-configuration-header-description-lg-fontWeight': 'normal',
        'buyArea-configurationList-configuration-header-description-lg-letterSpacing': '0em',
        'buyArea-configurationList-configuration-header-description-lg-lineHeight': '1.25rem',
        'buyArea-configurationList-configuration-header-description-lg-opacity': 0.8,
        'buyArea-configurationList-configuration-header-description-sm-color': 'rgb(0, 0, 0)',
        'buyArea-configurationList-configuration-header-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-configurationList-configuration-header-description-sm-fontSize': '0.75rem',
        'buyArea-configurationList-configuration-header-description-sm-fontWeight': 'normal',
        'buyArea-configurationList-configuration-header-description-sm-letterSpacing': '0em',
        'buyArea-configurationList-configuration-header-description-sm-lineHeight': '1rem',
        'buyArea-configurationList-configuration-header-description-sm-opacity': 0.8,
        'buyArea-configurationList-configuration-header-label-lg-color': 'rgb(0, 0, 0)',
        'buyArea-configurationList-configuration-header-label-lg-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-configurationList-configuration-header-label-lg-fontSize': '0.875rem',
        'buyArea-configurationList-configuration-header-label-lg-fontWeight': 'bold',
        'buyArea-configurationList-configuration-header-label-lg-letterSpacing': '0em',
        'buyArea-configurationList-configuration-header-label-lg-lineHeight': '1.25rem',
        'buyArea-configurationList-configuration-header-label-lg-opacity': 0.8,
        'buyArea-configurationList-configuration-header-label-sm-color': 'rgb(0, 0, 0)',
        'buyArea-configurationList-configuration-header-label-sm-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-configurationList-configuration-header-label-sm-fontSize': '0.75rem',
        'buyArea-configurationList-configuration-header-label-sm-fontWeight': 'bold',
        'buyArea-configurationList-configuration-header-label-sm-letterSpacing': '0em',
        'buyArea-configurationList-configuration-header-label-sm-lineHeight': '1rem',
        'buyArea-configurationList-configuration-header-label-sm-opacity': 0.8,
        'buyArea-configurationList-configuration-lg-gap': '0.75rem',
        'buyArea-configurationList-configuration-sm-gap': '0.75rem',
        'buyArea-meta-base-lg-gap': '1.5rem',
        'buyArea-meta-base-sm-gap': '1rem',
        'buyArea-productTitle-base-lg-gap': '1rem',
        'buyArea-productTitle-base-sm-gap': '1rem',
        'buyArea-productTitle-replacement-base-gap': '0.25rem',
        'buyArea-productTitle-replacement-description-color': 'rgb(0, 0, 0)',
        'buyArea-productTitle-replacement-description-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-productTitle-replacement-description-fontSize': '0.75rem',
        'buyArea-productTitle-replacement-description-fontWeight': 'normal',
        'buyArea-productTitle-replacement-description-letterSpacing': '0em',
        'buyArea-productTitle-replacement-description-lineHeight': '1rem',
        'buyArea-productTitle-replacement-description-opacity': 0.65,
        'buyArea-productTitle-replacement-headline-color': 'rgb(0, 0, 0)',
        'buyArea-productTitle-replacement-headline-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-productTitle-replacement-headline-fontSize': '0.75rem',
        'buyArea-productTitle-replacement-headline-fontWeight': 'bold',
        'buyArea-productTitle-replacement-headline-letterSpacing': '0em',
        'buyArea-productTitle-replacement-headline-lineHeight': '1rem',
        'buyArea-productTitle-replacement-headline-opacity': 0.8,
        'buyArea-retailer-base-lg-gap': '1.5rem',
        'buyArea-retailer-base-sm-gap': '1rem',
        'buyArea-retailer-headline-lg-color': 'rgb(0, 0, 0)',
        'buyArea-retailer-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-retailer-headline-lg-fontSize': '1.5rem',
        'buyArea-retailer-headline-lg-fontWeight': 'bold',
        'buyArea-retailer-headline-lg-letterSpacing': '0em',
        'buyArea-retailer-headline-lg-lineHeight': '2rem',
        'buyArea-retailer-headline-sm-color': 'rgb(0, 0, 0)',
        'buyArea-retailer-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'buyArea-retailer-headline-sm-fontSize': '1.25rem',
        'buyArea-retailer-headline-sm-fontWeight': 'bold',
        'buyArea-retailer-headline-sm-letterSpacing': '0em',
        'buyArea-retailer-headline-sm-lineHeight': '1.75rem',
        'buyArea-retailer-list-base-lg-gap': '1rem',
        'buyArea-retailer-list-base-sm-gap': '0.75rem',
        'buyArea-selector-color-base-lg-gap': '1rem',
        'buyArea-selector-color-base-sm-gap': '0.75rem',
        'buyArea-services-base-lg-gap': '1rem',
        'buyArea-services-base-sm-gap': '0.75rem',
        'categoryTeaser-base-default-lg-background': 'rgb(255, 255, 255)',
        'categoryTeaser-base-default-lg-borderColor': 'rgb(239, 241, 242)',
        'categoryTeaser-base-default-lg-borderRadius': '0',
        'categoryTeaser-base-default-lg-borderStyle': 'solid',
        'categoryTeaser-base-default-lg-borderWidth': '0.0625rem',
        'categoryTeaser-base-default-lg-gap': '1rem',
        'categoryTeaser-base-default-lg-paddingBottom': '1rem',
        'categoryTeaser-base-default-lg-paddingLeft': '0',
        'categoryTeaser-base-default-lg-paddingRight': '0',
        'categoryTeaser-base-default-lg-paddingTop': '0',
        'categoryTeaser-base-default-sm-background': 'rgb(255, 255, 255)',
        'categoryTeaser-base-default-sm-borderColor': 'rgb(239, 241, 242)',
        'categoryTeaser-base-default-sm-borderRadius': '0',
        'categoryTeaser-base-default-sm-borderStyle': 'solid',
        'categoryTeaser-base-default-sm-borderWidth': '0.0625rem',
        'categoryTeaser-base-default-sm-gap': '1rem',
        'categoryTeaser-base-default-sm-paddingBottom': '1rem',
        'categoryTeaser-base-default-sm-paddingLeft': '0',
        'categoryTeaser-base-default-sm-paddingRight': '0',
        'categoryTeaser-base-default-sm-paddingTop': '0',
        'categoryTeaser-base-highlighted-lg-background': 'rgb(239, 241, 242)',
        'categoryTeaser-base-highlighted-lg-borderColor': 'rgb(0, 0, 0)',
        'categoryTeaser-base-highlighted-lg-borderRadius': '0',
        'categoryTeaser-base-highlighted-lg-borderStyle': 'solid',
        'categoryTeaser-base-highlighted-lg-borderWidth': '0',
        'categoryTeaser-base-highlighted-lg-gap': '1rem',
        'categoryTeaser-base-highlighted-lg-paddingBottom': '1rem',
        'categoryTeaser-base-highlighted-lg-paddingLeft': '0',
        'categoryTeaser-base-highlighted-lg-paddingRight': '0',
        'categoryTeaser-base-highlighted-lg-paddingTop': '0',
        'categoryTeaser-base-highlighted-sm-background': 'rgb(239, 241, 242)',
        'categoryTeaser-base-highlighted-sm-borderColor': 'rgb(0, 0, 0)',
        'categoryTeaser-base-highlighted-sm-borderRadius': '0',
        'categoryTeaser-base-highlighted-sm-borderStyle': 'solid',
        'categoryTeaser-base-highlighted-sm-borderWidth': '0',
        'categoryTeaser-base-highlighted-sm-gap': '1rem',
        'categoryTeaser-base-highlighted-sm-paddingBottom': '1rem',
        'categoryTeaser-base-highlighted-sm-paddingLeft': '0',
        'categoryTeaser-base-highlighted-sm-paddingRight': '0',
        'categoryTeaser-base-highlighted-sm-paddingTop': '0',
        'categoryTeaser-image-default-background': 'rgba(0, 0, 0, 0)',
        'categoryTeaser-image-highlighted-background': 'rgba(0, 0, 0, 0)',
        'categoryTeaser-text-default-lg-color': 'rgb(0, 0, 0)',
        'categoryTeaser-text-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'categoryTeaser-text-default-lg-fontSize': '1.25rem',
        'categoryTeaser-text-default-lg-fontWeight': 'bold',
        'categoryTeaser-text-default-lg-letterSpacing': '0em',
        'categoryTeaser-text-default-lg-lineHeight': '1.75rem',
        'categoryTeaser-text-default-sm-color': 'rgb(0, 0, 0)',
        'categoryTeaser-text-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'categoryTeaser-text-default-sm-fontSize': '1rem',
        'categoryTeaser-text-default-sm-fontWeight': 'bold',
        'categoryTeaser-text-default-sm-letterSpacing': '0em',
        'categoryTeaser-text-default-sm-lineHeight': '1.5rem',
        'categoryTeaser-text-highlighted-lg-color': 'rgb(0, 0, 0)',
        'categoryTeaser-text-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'categoryTeaser-text-highlighted-lg-fontSize': '1.25rem',
        'categoryTeaser-text-highlighted-lg-fontWeight': 'bold',
        'categoryTeaser-text-highlighted-lg-letterSpacing': '0em',
        'categoryTeaser-text-highlighted-lg-lineHeight': '1.75rem',
        'categoryTeaser-text-highlighted-sm-color': 'rgb(0, 0, 0)',
        'categoryTeaser-text-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'categoryTeaser-text-highlighted-sm-fontSize': '1rem',
        'categoryTeaser-text-highlighted-sm-fontWeight': 'bold',
        'categoryTeaser-text-highlighted-sm-letterSpacing': '0em',
        'categoryTeaser-text-highlighted-sm-lineHeight': '1.5rem',
        'checkbox-base-selected-disabled-background': 'rgb(193, 199, 204)',
        'checkbox-base-selected-disabled-borderColor': 'rgb(0, 0, 0)',
        'checkbox-base-selected-disabled-borderRadius': '0',
        'checkbox-base-selected-disabled-borderStyle': 'solid',
        'checkbox-base-selected-disabled-borderWidth': '0',
        'checkbox-base-selected-disabled-height': '1.5rem',
        'checkbox-base-selected-disabled-opacity': 1,
        'checkbox-base-selected-disabled-width': '1.5rem',
        'checkbox-base-selected-hover-background': 'rgb(0, 98, 154)',
        'checkbox-base-selected-hover-borderColor': 'rgb(0, 0, 0)',
        'checkbox-base-selected-hover-borderRadius': '0',
        'checkbox-base-selected-hover-borderStyle': 'solid',
        'checkbox-base-selected-hover-borderWidth': '0',
        'checkbox-base-selected-hover-height': '1.5rem',
        'checkbox-base-selected-hover-opacity': 1,
        'checkbox-base-selected-hover-width': '1.5rem',
        'checkbox-base-selected-initial-background': 'rgb(0, 123, 192)',
        'checkbox-base-selected-initial-borderColor': 'rgb(0, 0, 0)',
        'checkbox-base-selected-initial-borderRadius': '0',
        'checkbox-base-selected-initial-borderStyle': 'solid',
        'checkbox-base-selected-initial-borderWidth': '0',
        'checkbox-base-selected-initial-height': '1.5rem',
        'checkbox-base-selected-initial-opacity': 1,
        'checkbox-base-selected-initial-width': '1.5rem',
        'checkbox-base-selected-pressed-background': 'rgb(0, 73, 117)',
        'checkbox-base-selected-pressed-borderColor': 'rgb(0, 0, 0)',
        'checkbox-base-selected-pressed-borderRadius': '0',
        'checkbox-base-selected-pressed-borderStyle': 'solid',
        'checkbox-base-selected-pressed-borderWidth': '0',
        'checkbox-base-selected-pressed-height': '1.5rem',
        'checkbox-base-selected-pressed-opacity': 1,
        'checkbox-base-selected-pressed-width': '1.5rem',
        'checkbox-base-unselected-disabled-background': 'rgb(193, 199, 204)',
        'checkbox-base-unselected-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'checkbox-base-unselected-disabled-borderRadius': '0',
        'checkbox-base-unselected-disabled-borderStyle': 'solid',
        'checkbox-base-unselected-disabled-borderWidth': '0',
        'checkbox-base-unselected-disabled-height': '1.5rem',
        'checkbox-base-unselected-disabled-opacity': 1,
        'checkbox-base-unselected-disabled-width': '1.5rem',
        'checkbox-base-unselected-hover-background': 'rgb(113, 118, 124)',
        'checkbox-base-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'checkbox-base-unselected-hover-borderRadius': '0',
        'checkbox-base-unselected-hover-borderStyle': 'solid',
        'checkbox-base-unselected-hover-borderWidth': '0',
        'checkbox-base-unselected-hover-height': '1.5rem',
        'checkbox-base-unselected-hover-opacity': 1,
        'checkbox-base-unselected-hover-width': '1.5rem',
        'checkbox-base-unselected-initial-background': 'rgb(138, 144, 151)',
        'checkbox-base-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'checkbox-base-unselected-initial-borderRadius': '0',
        'checkbox-base-unselected-initial-borderStyle': 'solid',
        'checkbox-base-unselected-initial-borderWidth': '0',
        'checkbox-base-unselected-initial-height': '1.5rem',
        'checkbox-base-unselected-initial-opacity': 1,
        'checkbox-base-unselected-initial-width': '1.5rem',
        'checkbox-base-unselected-pressed-background': 'rgb(89, 94, 98)',
        'checkbox-base-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'checkbox-base-unselected-pressed-borderRadius': '0',
        'checkbox-base-unselected-pressed-borderStyle': 'solid',
        'checkbox-base-unselected-pressed-borderWidth': '0',
        'checkbox-base-unselected-pressed-height': '1.5rem',
        'checkbox-base-unselected-pressed-opacity': 1,
        'checkbox-base-unselected-pressed-width': '1.5rem',
        'checkbox-icon-selected-disabled-background': 'rgb(67, 70, 74)',
        'checkbox-icon-selected-hover-background': 'rgb(255, 255, 255)',
        'checkbox-icon-selected-initial-background': 'rgb(255, 255, 255)',
        'checkbox-icon-selected-pressed-background': 'rgb(255, 255, 255)',
        'colorSwatch-base-contrast-high-borderColor': 'rgba(0, 0, 0, 0)',
        'colorSwatch-base-contrast-high-borderRadius': '624.9375rem',
        'colorSwatch-base-contrast-high-borderStyle': 'solid',
        'colorSwatch-base-contrast-high-borderWidth': '0.0625rem',
        'colorSwatch-base-contrast-high-height': '1.5rem',
        'colorSwatch-base-contrast-high-width': '1.5rem',
        'colorSwatch-base-contrast-low-borderColor': 'rgb(224, 226, 229)',
        'colorSwatch-base-contrast-low-borderRadius': '624.9375rem',
        'colorSwatch-base-contrast-low-borderStyle': 'solid',
        'colorSwatch-base-contrast-low-borderWidth': '0.0625rem',
        'colorSwatch-base-contrast-low-height': '1.5rem',
        'colorSwatch-base-contrast-low-width': '1.5rem',
        'compare-base-gap': '0.5rem',
        'compare-label-default-color': 'rgb(0, 0, 0)',
        'compare-label-default-fontFamily': 'Bosch Sans, sans-serif',
        'compare-label-default-fontSize': '0.75rem',
        'compare-label-default-fontWeight': 'normal',
        'compare-label-default-letterSpacing': '0em',
        'compare-label-default-lineHeight': '1rem',
        'compare-label-default-opacity': 0.65,
        'compare-label-highlighted-color': 'rgb(0, 0, 0)',
        'compare-label-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'compare-label-highlighted-fontSize': '0.75rem',
        'compare-label-highlighted-fontWeight': 'normal',
        'compare-label-highlighted-letterSpacing': '0em',
        'compare-label-highlighted-lineHeight': '1rem',
        'compare-label-highlighted-opacity': 0.65,
        'compareModal-content-base-lg-initial-height': 'auto',
        'compareModal-content-base-lg-sticky-height': '26rem',
        'compareModal-content-base-sm-initial-height': 'auto',
        'compareModal-content-base-sm-sticky-height': '26rem',
        'compareModal-content-button-base-lg-hover-background': 'rgb(46, 48, 51)',
        'compareModal-content-button-base-lg-hover-gap': '0.5rem',
        'compareModal-content-button-base-lg-hover-paddingBottom': '1rem',
        'compareModal-content-button-base-lg-hover-paddingLeft': '1.5rem',
        'compareModal-content-button-base-lg-hover-paddingRight': '1.5rem',
        'compareModal-content-button-base-lg-hover-paddingTop': '1rem',
        'compareModal-content-button-base-lg-initial-background': 'rgb(26, 28, 29)',
        'compareModal-content-button-base-lg-initial-gap': '0.5rem',
        'compareModal-content-button-base-lg-initial-paddingBottom': '1rem',
        'compareModal-content-button-base-lg-initial-paddingLeft': '1.5rem',
        'compareModal-content-button-base-lg-initial-paddingRight': '1.5rem',
        'compareModal-content-button-base-lg-initial-paddingTop': '1rem',
        'compareModal-content-button-base-lg-pressed-background': 'rgb(67, 70, 74)',
        'compareModal-content-button-base-lg-pressed-gap': '0.5rem',
        'compareModal-content-button-base-lg-pressed-paddingBottom': '1rem',
        'compareModal-content-button-base-lg-pressed-paddingLeft': '1.5rem',
        'compareModal-content-button-base-lg-pressed-paddingRight': '1.5rem',
        'compareModal-content-button-base-lg-pressed-paddingTop': '1rem',
        'compareModal-content-button-base-sm-hover-background': 'rgb(46, 48, 51)',
        'compareModal-content-button-base-sm-hover-borderRadius': '624.9375rem',
        'compareModal-content-button-base-sm-hover-height': '3rem',
        'compareModal-content-button-base-sm-hover-width': '3rem',
        'compareModal-content-button-base-sm-initial-background': 'rgb(26, 28, 29)',
        'compareModal-content-button-base-sm-initial-borderRadius': '624.9375rem',
        'compareModal-content-button-base-sm-initial-height': '3rem',
        'compareModal-content-button-base-sm-initial-width': '3rem',
        'compareModal-content-button-base-sm-pressed-background': 'rgb(46, 48, 51)',
        'compareModal-content-button-base-sm-pressed-borderRadius': '624.9375rem',
        'compareModal-content-button-base-sm-pressed-height': '3rem',
        'compareModal-content-button-base-sm-pressed-width': '3rem',
        'compareModal-content-button-icon-hover-background': 'rgb(255, 255, 255)',
        'compareModal-content-button-icon-hover-opacity': 1,
        'compareModal-content-button-icon-initial-background': 'rgb(255, 255, 255)',
        'compareModal-content-button-icon-initial-opacity': 0.8,
        'compareModal-content-button-icon-pressed-background': 'rgb(255, 255, 255)',
        'compareModal-content-button-icon-pressed-opacity': 0.65,
        'compareModal-content-button-label-hover-color': 'rgb(255, 255, 255)',
        'compareModal-content-button-label-hover-fontFamily': 'Bosch Sans, sans-serif',
        'compareModal-content-button-label-hover-fontSize': '0.875rem',
        'compareModal-content-button-label-hover-fontWeight': 'bold',
        'compareModal-content-button-label-hover-letterSpacing': '0em',
        'compareModal-content-button-label-hover-lineHeight': '1.25rem',
        'compareModal-content-button-label-hover-opacity': 1,
        'compareModal-content-button-label-initial-color': 'rgb(255, 255, 255)',
        'compareModal-content-button-label-initial-fontFamily': 'Bosch Sans, sans-serif',
        'compareModal-content-button-label-initial-fontSize': '0.875rem',
        'compareModal-content-button-label-initial-fontWeight': 'bold',
        'compareModal-content-button-label-initial-letterSpacing': '0em',
        'compareModal-content-button-label-initial-lineHeight': '1.25rem',
        'compareModal-content-button-label-initial-opacity': 0.8,
        'compareModal-content-button-label-pressed-color': 'rgb(255, 255, 255)',
        'compareModal-content-button-label-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'compareModal-content-button-label-pressed-fontSize': '0.875rem',
        'compareModal-content-button-label-pressed-fontWeight': 'bold',
        'compareModal-content-button-label-pressed-letterSpacing': '0em',
        'compareModal-content-button-label-pressed-lineHeight': '1.25rem',
        'compareModal-content-button-label-pressed-opacity': 0.65,
        'compareModal-content-productList-lg-gap': '0',
        'compareModal-content-productList-lg-paddingLeft': '0.5rem',
        'compareModal-content-productList-lg-paddingRight': '0.5rem',
        'compareModal-content-productList-sm-gap': '0',
        'compareModal-content-productList-sm-paddingLeft': '0',
        'compareModal-content-productList-sm-paddingRight': '0',
        'compareModal-footer-actions-lg-gap': '1rem',
        'compareModal-footer-actions-sm-gap': '0.75rem',
        'compareModal-footer-description-color': 'rgb(0, 0, 0)',
        'compareModal-footer-description-fontFamily': 'Bosch Sans, sans-serif',
        'compareModal-footer-description-fontSize': '0.875rem',
        'compareModal-footer-description-fontWeight': 'normal',
        'compareModal-footer-description-letterSpacing': '0em',
        'compareModal-footer-description-lineHeight': '1.25rem',
        'compareModal-footer-description-opacity': 0.65,
        'compareModal-footer-divider-background': 'rgb(224, 226, 229)',
        'compareModal-footer-divider-height': '0.0625rem',
        'compareModal-footer-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'compareModal-footer-lg-initial-gap': '1rem',
        'compareModal-footer-lg-initial-paddingBottom': '1.5rem',
        'compareModal-footer-lg-initial-paddingLeft': '1.5rem',
        'compareModal-footer-lg-initial-paddingRight': '1.5rem',
        'compareModal-footer-lg-sticky-background': 'rgb(255, 255, 255)',
        'compareModal-footer-lg-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04))',
        },
        'compareModal-footer-lg-sticky-gap': '1rem',
        'compareModal-footer-lg-sticky-paddingBottom': '1.5rem',
        'compareModal-footer-lg-sticky-paddingLeft': '1.5rem',
        'compareModal-footer-lg-sticky-paddingRight': '1.5rem',
        'compareModal-footer-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'compareModal-footer-sm-initial-gap': '0.75rem',
        'compareModal-footer-sm-initial-paddingBottom': '1rem',
        'compareModal-footer-sm-initial-paddingLeft': '1rem',
        'compareModal-footer-sm-initial-paddingRight': '1rem',
        'compareModal-footer-sm-sticky-background': 'rgb(255, 255, 255)',
        'compareModal-footer-sm-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04), 0px -16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px -16px 32px rgba(0, 0, 0, 0.04))',
        },
        'compareModal-footer-sm-sticky-gap': '0.75rem',
        'compareModal-footer-sm-sticky-paddingBottom': '1rem',
        'compareModal-footer-sm-sticky-paddingLeft': '1rem',
        'compareModal-footer-sm-sticky-paddingRight': '1rem',
        'compareTable-actions-base-lg-gap': '1rem',
        'compareTable-actions-base-lg-paddingLeft': '1.5rem',
        'compareTable-actions-base-lg-paddingRight': '1.5rem',
        'compareTable-actions-base-sm-gap': '0.75rem',
        'compareTable-actions-base-sm-paddingLeft': '1rem',
        'compareTable-actions-base-sm-paddingRight': '1rem',
        'compareTable-actions-buttonList-gap': '1rem',
        'compareTable-base-default-lg-paddingBottom': '0',
        'compareTable-base-default-lg-paddingTop': '0',
        'compareTable-base-default-sm-paddingBottom': '0',
        'compareTable-base-default-sm-paddingTop': '0',
        'compareTable-base-highlightProduct-lg-paddingBottom': '2rem',
        'compareTable-base-highlightProduct-lg-paddingTop': '2rem',
        'compareTable-base-highlightProduct-sm-paddingBottom': '1rem',
        'compareTable-base-highlightProduct-sm-paddingTop': '1rem',
        'compareTable-feature-headline-lg-paddingInline': '1.5rem',
        'compareTable-feature-headline-sm-paddingInline': '1rem',
        'compareTable-feature-icon-lg-paddingInline': '1.5rem',
        'compareTable-feature-icon-sm-paddingInline': '1rem',
        'compareTable-feature-label-lg-paddingInline': '1.5rem',
        'compareTable-feature-label-sm-paddingInline': '1rem',
        'compareTable-highlight-background': 'rgb(239, 241, 242)',
        'compareTable-highlight-borderRadius': '0',
        'compareTable-priceInformation-lg-paddingLeft': '1.5rem',
        'compareTable-priceInformation-lg-paddingRight': '1.5rem',
        'compareTable-priceInformation-sm-paddingLeft': '0.75rem',
        'compareTable-priceInformation-sm-paddingRight': '0.75rem',
        'compareTable-product-base-lg-gap': '1.5rem',
        'compareTable-product-base-lg-paddingLeft': '1.5rem',
        'compareTable-product-base-lg-paddingRight': '1.5rem',
        'compareTable-product-base-sm-gap': '1rem',
        'compareTable-product-base-sm-paddingLeft': '1rem',
        'compareTable-product-base-sm-paddingRight': '1rem',
        'compareTable-selector-lg-paddingLeft': '1.5rem',
        'compareTable-selector-lg-paddingRight': '1.5rem',
        'compareTable-selector-sm-paddingLeft': '1rem',
        'compareTable-selector-sm-paddingRight': '1rem',
        'contentCard-default-lg-background': 'rgb(255, 255, 255)',
        'contentCard-default-lg-borderColor': 'rgb(239, 241, 242)',
        'contentCard-default-lg-borderRadius': '0',
        'contentCard-default-lg-borderStyle': 'solid',
        'contentCard-default-lg-borderWidth': '0.0625rem',
        'contentCard-default-lg-paddingBottom': '2rem',
        'contentCard-default-lg-paddingLeft': '1.5rem',
        'contentCard-default-lg-paddingRight': '1.5rem',
        'contentCard-default-lg-paddingTop': '2rem',
        'contentCard-default-md-background': 'rgb(255, 255, 255)',
        'contentCard-default-md-borderColor': 'rgb(239, 241, 242)',
        'contentCard-default-md-borderRadius': '0',
        'contentCard-default-md-borderStyle': 'solid',
        'contentCard-default-md-borderWidth': '0.0625rem',
        'contentCard-default-md-paddingBottom': '2rem',
        'contentCard-default-md-paddingLeft': '1rem',
        'contentCard-default-md-paddingRight': '1rem',
        'contentCard-default-md-paddingTop': '2rem',
        'contentCard-default-sm-background': 'rgb(255, 255, 255)',
        'contentCard-default-sm-borderColor': 'rgb(239, 241, 242)',
        'contentCard-default-sm-borderRadius': '0',
        'contentCard-default-sm-borderStyle': 'solid',
        'contentCard-default-sm-borderWidth': '0.0625rem',
        'contentCard-default-sm-paddingBottom': '1.5rem',
        'contentCard-default-sm-paddingLeft': '1rem',
        'contentCard-default-sm-paddingRight': '1rem',
        'contentCard-default-sm-paddingTop': '1.5rem',
        'contentCard-highlighted-lg-background': 'rgb(239, 241, 242)',
        'contentCard-highlighted-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'contentCard-highlighted-lg-borderRadius': '0',
        'contentCard-highlighted-lg-borderStyle': 'solid',
        'contentCard-highlighted-lg-borderWidth': '0.0625rem',
        'contentCard-highlighted-lg-paddingBottom': '2rem',
        'contentCard-highlighted-lg-paddingLeft': '1.5rem',
        'contentCard-highlighted-lg-paddingRight': '1.5rem',
        'contentCard-highlighted-lg-paddingTop': '2rem',
        'contentCard-highlighted-md-background': 'rgb(239, 241, 242)',
        'contentCard-highlighted-md-borderColor': 'rgba(0, 0, 0, 0)',
        'contentCard-highlighted-md-borderRadius': '0',
        'contentCard-highlighted-md-borderStyle': 'solid',
        'contentCard-highlighted-md-borderWidth': '0.0625rem',
        'contentCard-highlighted-md-paddingBottom': '2rem',
        'contentCard-highlighted-md-paddingLeft': '1rem',
        'contentCard-highlighted-md-paddingRight': '1rem',
        'contentCard-highlighted-md-paddingTop': '2rem',
        'contentCard-highlighted-sm-background': 'rgb(239, 241, 242)',
        'contentCard-highlighted-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'contentCard-highlighted-sm-borderRadius': '0',
        'contentCard-highlighted-sm-borderStyle': 'solid',
        'contentCard-highlighted-sm-borderWidth': '0.0625rem',
        'contentCard-highlighted-sm-paddingBottom': '1.5rem',
        'contentCard-highlighted-sm-paddingLeft': '1rem',
        'contentCard-highlighted-sm-paddingRight': '1rem',
        'contentCard-highlighted-sm-paddingTop': '1.5rem',
        'contentStage-base-default-lg-background': 'rgb(255, 255, 255)',
        'contentStage-base-default-lg-paddingLeft': '3rem',
        'contentStage-base-default-lg-paddingRight': '3rem',
        'contentStage-base-default-lg-paddingTop': '5rem',
        'contentStage-base-default-md-background': 'rgb(255, 255, 255)',
        'contentStage-base-default-md-paddingLeft': '2rem',
        'contentStage-base-default-md-paddingRight': '2rem',
        'contentStage-base-default-md-paddingTop': '4rem',
        'contentStage-base-default-sm-background': 'rgb(255, 255, 255)',
        'contentStage-base-default-sm-paddingLeft': '1rem',
        'contentStage-base-default-sm-paddingRight': '1rem',
        'contentStage-base-default-sm-paddingTop': '3rem',
        'contentStage-base-highlighted-lg-background': 'rgb(239, 241, 242)',
        'contentStage-base-highlighted-lg-paddingLeft': '3rem',
        'contentStage-base-highlighted-lg-paddingRight': '3rem',
        'contentStage-base-highlighted-lg-paddingTop': '5rem',
        'contentStage-base-highlighted-md-background': 'rgb(239, 241, 242)',
        'contentStage-base-highlighted-md-paddingLeft': '2rem',
        'contentStage-base-highlighted-md-paddingRight': '2rem',
        'contentStage-base-highlighted-md-paddingTop': '4rem',
        'contentStage-base-highlighted-sm-background': 'rgb(239, 241, 242)',
        'contentStage-base-highlighted-sm-paddingLeft': '1rem',
        'contentStage-base-highlighted-sm-paddingRight': '1rem',
        'contentStage-base-highlighted-sm-paddingTop': '3rem',
        'contentStage-base-image-lg-background': 'rgba(0, 0, 0, 0.6)',
        'contentStage-base-image-lg-paddingBottom': '5rem',
        'contentStage-base-image-lg-paddingLeft': '3rem',
        'contentStage-base-image-lg-paddingRight': '3rem',
        'contentStage-base-image-lg-paddingTop': '5rem',
        'contentStage-base-image-md-background': 'rgba(0, 0, 0, 0.6)',
        'contentStage-base-image-md-paddingBottom': '4rem',
        'contentStage-base-image-md-paddingLeft': '2rem',
        'contentStage-base-image-md-paddingRight': '2rem',
        'contentStage-base-image-md-paddingTop': '4rem',
        'contentStage-base-image-sm-background': 'rgba(0, 0, 0, 0.6)',
        'contentStage-base-image-sm-paddingBottom': '3rem',
        'contentStage-base-image-sm-paddingLeft': '1rem',
        'contentStage-base-image-sm-paddingRight': '1rem',
        'contentStage-base-image-sm-paddingTop': '3rem',
        'contentStage-content-base-lg-gap': '3rem',
        'contentStage-content-base-md-gap': '2rem',
        'contentStage-content-base-sm-gap': '1.5rem',
        'contentStage-content-title-base-lg-gap': '1rem',
        'contentStage-content-title-base-md-gap': '0.75rem',
        'contentStage-content-title-base-sm-gap': '0.5rem',
        'contentStage-content-title-headline-default-lg-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-default-lg-fontSize': '2.25rem',
        'contentStage-content-title-headline-default-lg-fontWeight': 'bold',
        'contentStage-content-title-headline-default-lg-letterSpacing': '0em',
        'contentStage-content-title-headline-default-lg-lineHeight': '2.75rem',
        'contentStage-content-title-headline-default-md-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-default-md-fontSize': '2rem',
        'contentStage-content-title-headline-default-md-fontWeight': 'bold',
        'contentStage-content-title-headline-default-md-letterSpacing': '0em',
        'contentStage-content-title-headline-default-md-lineHeight': '2.5rem',
        'contentStage-content-title-headline-default-sm-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-default-sm-fontSize': '1.75rem',
        'contentStage-content-title-headline-default-sm-fontWeight': 'bold',
        'contentStage-content-title-headline-default-sm-letterSpacing': '0em',
        'contentStage-content-title-headline-default-sm-lineHeight': '2.25rem',
        'contentStage-content-title-headline-highlighted-lg-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-highlighted-lg-fontSize': '2.25rem',
        'contentStage-content-title-headline-highlighted-lg-fontWeight': 'bold',
        'contentStage-content-title-headline-highlighted-lg-letterSpacing': '0em',
        'contentStage-content-title-headline-highlighted-lg-lineHeight': '2.75rem',
        'contentStage-content-title-headline-highlighted-md-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-highlighted-md-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-highlighted-md-fontSize': '2rem',
        'contentStage-content-title-headline-highlighted-md-fontWeight': 'bold',
        'contentStage-content-title-headline-highlighted-md-letterSpacing': '0em',
        'contentStage-content-title-headline-highlighted-md-lineHeight': '2.5rem',
        'contentStage-content-title-headline-highlighted-sm-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-headline-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-highlighted-sm-fontSize': '1.75rem',
        'contentStage-content-title-headline-highlighted-sm-fontWeight': 'bold',
        'contentStage-content-title-headline-highlighted-sm-letterSpacing': '0em',
        'contentStage-content-title-headline-highlighted-sm-lineHeight': '2.25rem',
        'contentStage-content-title-headline-image-lg-color': 'rgb(255, 255, 255)',
        'contentStage-content-title-headline-image-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-image-lg-fontSize': '2.25rem',
        'contentStage-content-title-headline-image-lg-fontWeight': 'bold',
        'contentStage-content-title-headline-image-lg-letterSpacing': '0em',
        'contentStage-content-title-headline-image-lg-lineHeight': '2.75rem',
        'contentStage-content-title-headline-image-md-color': 'rgb(255, 255, 255)',
        'contentStage-content-title-headline-image-md-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-image-md-fontSize': '2rem',
        'contentStage-content-title-headline-image-md-fontWeight': 'bold',
        'contentStage-content-title-headline-image-md-letterSpacing': '0em',
        'contentStage-content-title-headline-image-md-lineHeight': '2.5rem',
        'contentStage-content-title-headline-image-sm-color': 'rgb(255, 255, 255)',
        'contentStage-content-title-headline-image-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-headline-image-sm-fontSize': '1.75rem',
        'contentStage-content-title-headline-image-sm-fontWeight': 'bold',
        'contentStage-content-title-headline-image-sm-letterSpacing': '0em',
        'contentStage-content-title-headline-image-sm-lineHeight': '2.25rem',
        'contentStage-content-title-link-image-iconColor': 'rgb(255, 255, 255)',
        'contentStage-content-title-link-image-textColor': 'rgb(255, 255, 255)',
        'contentStage-content-title-subline-default-lg-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-subline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-default-lg-fontSize': '1.25rem',
        'contentStage-content-title-subline-default-lg-fontWeight': 'normal',
        'contentStage-content-title-subline-default-lg-letterSpacing': '0em',
        'contentStage-content-title-subline-default-lg-lineHeight': '1.75rem',
        'contentStage-content-title-subline-default-lg-opacity': 0.8,
        'contentStage-content-title-subline-default-sm-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-subline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-default-sm-fontSize': '1rem',
        'contentStage-content-title-subline-default-sm-fontWeight': 'normal',
        'contentStage-content-title-subline-default-sm-letterSpacing': '0em',
        'contentStage-content-title-subline-default-sm-lineHeight': '1.5rem',
        'contentStage-content-title-subline-default-sm-opacity': 0.8,
        'contentStage-content-title-subline-highlighted-lg-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-subline-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-highlighted-lg-fontSize': '1.25rem',
        'contentStage-content-title-subline-highlighted-lg-fontWeight': 'normal',
        'contentStage-content-title-subline-highlighted-lg-letterSpacing': '0em',
        'contentStage-content-title-subline-highlighted-lg-lineHeight': '1.75rem',
        'contentStage-content-title-subline-highlighted-lg-opacity': 0.8,
        'contentStage-content-title-subline-highlighted-sm-color': 'rgb(0, 0, 0)',
        'contentStage-content-title-subline-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-highlighted-sm-fontSize': '1rem',
        'contentStage-content-title-subline-highlighted-sm-fontWeight': 'normal',
        'contentStage-content-title-subline-highlighted-sm-letterSpacing': '0em',
        'contentStage-content-title-subline-highlighted-sm-lineHeight': '1.5rem',
        'contentStage-content-title-subline-highlighted-sm-opacity': 0.8,
        'contentStage-content-title-subline-image-lg-color': 'rgb(255, 255, 255)',
        'contentStage-content-title-subline-image-lg-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-image-lg-fontSize': '1.25rem',
        'contentStage-content-title-subline-image-lg-fontWeight': 'normal',
        'contentStage-content-title-subline-image-lg-letterSpacing': '0em',
        'contentStage-content-title-subline-image-lg-lineHeight': '1.75rem',
        'contentStage-content-title-subline-image-lg-opacity': 0.8,
        'contentStage-content-title-subline-image-sm-color': 'rgb(255, 255, 255)',
        'contentStage-content-title-subline-image-sm-fontFamily': 'Bosch Sans, sans-serif',
        'contentStage-content-title-subline-image-sm-fontSize': '1rem',
        'contentStage-content-title-subline-image-sm-fontWeight': 'normal',
        'contentStage-content-title-subline-image-sm-letterSpacing': '0em',
        'contentStage-content-title-subline-image-sm-lineHeight': '1.5rem',
        'contentStage-content-title-subline-image-sm-opacity': 0.8,
        'decoration-level1-fontFamily': 'Bosch Sans, sans-serif',
        'decoration-level1-fontSize': '7.5rem',
        'decoration-level1-fontWeight': 'bold',
        'decoration-level1-letterSpacing': '0em',
        'decoration-level1-lineHeight': '8.5rem',
        'decoration-level2-fontFamily': 'Bosch Sans, sans-serif',
        'decoration-level2-fontSize': '5rem',
        'decoration-level2-fontWeight': 'bold',
        'decoration-level2-letterSpacing': '0em',
        'decoration-level2-lineHeight': '6rem',
        'decoration-level3-fontFamily': 'Bosch Sans, sans-serif',
        'decoration-level3-fontSize': '4rem',
        'decoration-level3-fontWeight': 'bold',
        'decoration-level3-letterSpacing': '0em',
        'decoration-level3-lineHeight': '4.5rem',
        'divider-color-default': 'rgb(224, 226, 229)',
        'divider-color-highlighted': 'rgb(193, 199, 204)',
        'divider-size-default': '0.0625rem',
        'dividerAdd-divider-default-background': 'rgb(239, 241, 242)',
        'dividerAdd-divider-default-borderRadius': '624.9375rem',
        'dividerAdd-divider-default-width': '0.0625rem',
        'dividerAdd-divider-highlighted-background': 'rgb(224, 226, 229)',
        'dividerAdd-divider-highlighted-borderRadius': '624.9375rem',
        'dividerAdd-divider-highlighted-width': '0.0625rem',
        'dividerAdd-indicator-base-default-background': 'rgb(255, 255, 255)',
        'dividerAdd-indicator-base-default-borderColor': 'rgb(224, 226, 229)',
        'dividerAdd-indicator-base-default-borderRadius': '624.9375rem',
        'dividerAdd-indicator-base-default-borderStyle': 'solid',
        'dividerAdd-indicator-base-default-borderWidth': '0.0625rem',
        'dividerAdd-indicator-base-default-height': '1.5rem',
        'dividerAdd-indicator-base-default-width': '1.5rem',
        'dividerAdd-indicator-base-highlighted-background': 'rgb(239, 241, 242)',
        'dividerAdd-indicator-base-highlighted-borderColor': 'rgb(193, 199, 204)',
        'dividerAdd-indicator-base-highlighted-borderRadius': '624.9375rem',
        'dividerAdd-indicator-base-highlighted-borderStyle': 'solid',
        'dividerAdd-indicator-base-highlighted-borderWidth': '0.0625rem',
        'dividerAdd-indicator-base-highlighted-height': '1.5rem',
        'dividerAdd-indicator-base-highlighted-width': '1.5rem',
        'dividerAdd-indicator-icon-default-background': 'rgb(0, 0, 0)',
        'dividerAdd-indicator-icon-default-opacity': 0.4,
        'dividerAdd-indicator-icon-highlighted-background': 'rgb(0, 0, 0)',
        'dividerAdd-indicator-icon-highlighted-opacity': 0.4,
        'drawer-default-lg-width': '28rem',
        'drawer-default-md-width': '26rem',
        'drawer-default-sm-width': '23.5rem',
        'dropdown-content-base-paddingBottom': '0.5rem',
        'dropdown-content-base-paddingTop': '0.5rem',
        'dropdown-content-list-base-gap': '0',
        'dropdown-content-list-item-base-hover-background': 'rgb(239, 241, 242)',
        'dropdown-content-list-item-base-hover-gap': '1rem',
        'dropdown-content-list-item-base-hover-paddingBottom': '0.75rem',
        'dropdown-content-list-item-base-hover-paddingLeft': '1rem',
        'dropdown-content-list-item-base-hover-paddingRight': '1rem',
        'dropdown-content-list-item-base-hover-paddingTop': '0.75rem',
        'dropdown-content-list-item-base-initial-background': 'rgb(255, 255, 255)',
        'dropdown-content-list-item-base-initial-gap': '1rem',
        'dropdown-content-list-item-base-initial-paddingBottom': '0.75rem',
        'dropdown-content-list-item-base-initial-paddingLeft': '1rem',
        'dropdown-content-list-item-base-initial-paddingRight': '1rem',
        'dropdown-content-list-item-base-initial-paddingTop': '0.75rem',
        'dropdown-content-list-item-base-pressed-background': 'rgb(239, 241, 242)',
        'dropdown-content-list-item-base-pressed-gap': '1rem',
        'dropdown-content-list-item-base-pressed-paddingBottom': '0.75rem',
        'dropdown-content-list-item-base-pressed-paddingLeft': '1rem',
        'dropdown-content-list-item-base-pressed-paddingRight': '1rem',
        'dropdown-content-list-item-base-pressed-paddingTop': '0.75rem',
        'dropdown-content-list-item-icon-hover-background': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-icon-hover-opacity': 1,
        'dropdown-content-list-item-icon-initial-background': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-icon-initial-opacity': 0.8,
        'dropdown-content-list-item-icon-pressed-background': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-icon-pressed-opacity': 0.65,
        'dropdown-content-list-item-label-hover-color': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-label-hover-fontFamily': 'Bosch Sans, sans-serif',
        'dropdown-content-list-item-label-hover-fontSize': '0.875rem',
        'dropdown-content-list-item-label-hover-fontWeight': 'normal',
        'dropdown-content-list-item-label-hover-letterSpacing': '0em',
        'dropdown-content-list-item-label-hover-lineHeight': '1.25rem',
        'dropdown-content-list-item-label-hover-opacity': 1,
        'dropdown-content-list-item-label-initial-color': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-label-initial-fontFamily': 'Bosch Sans, sans-serif',
        'dropdown-content-list-item-label-initial-fontSize': '0.875rem',
        'dropdown-content-list-item-label-initial-fontWeight': 'normal',
        'dropdown-content-list-item-label-initial-letterSpacing': '0em',
        'dropdown-content-list-item-label-initial-lineHeight': '1.25rem',
        'dropdown-content-list-item-label-initial-opacity': 0.8,
        'dropdown-content-list-item-label-pressed-color': 'rgb(0, 0, 0)',
        'dropdown-content-list-item-label-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'dropdown-content-list-item-label-pressed-fontSize': '0.875rem',
        'dropdown-content-list-item-label-pressed-fontWeight': 'normal',
        'dropdown-content-list-item-label-pressed-letterSpacing': '0em',
        'dropdown-content-list-item-label-pressed-lineHeight': '1.25rem',
        'dropdown-content-list-item-label-pressed-opacity': 0.65,
        'dropdownButton-base-lg-background': 'rgb(239, 241, 242)',
        'dropdownButton-base-lg-borderRadius': '0',
        'dropdownButton-base-lg-gap': '1rem',
        'dropdownButton-base-lg-height': '4rem',
        'dropdownButton-base-lg-paddingLeft': '1.5rem',
        'dropdownButton-base-sm-background': 'rgb(239, 241, 242)',
        'dropdownButton-base-sm-borderRadius': '0',
        'dropdownButton-base-sm-gap': '0.75rem',
        'dropdownButton-base-sm-height': '3rem',
        'dropdownButton-base-sm-paddingLeft': '1rem',
        'dropdownButton-label-lg-hover-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-lg-hover-fontSize': '1rem',
        'dropdownButton-label-lg-hover-fontWeight': 'bold',
        'dropdownButton-label-lg-hover-letterSpacing': '0em',
        'dropdownButton-label-lg-hover-lineHeight': '1.5rem',
        'dropdownButton-label-lg-hover-opacity': 0.8,
        'dropdownButton-label-lg-initial-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-lg-initial-fontSize': '1rem',
        'dropdownButton-label-lg-initial-fontWeight': 'bold',
        'dropdownButton-label-lg-initial-letterSpacing': '0em',
        'dropdownButton-label-lg-initial-lineHeight': '1.5rem',
        'dropdownButton-label-lg-initial-opacity': 0.65,
        'dropdownButton-label-lg-pressed-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-lg-pressed-fontSize': '1rem',
        'dropdownButton-label-lg-pressed-fontWeight': 'bold',
        'dropdownButton-label-lg-pressed-letterSpacing': '0em',
        'dropdownButton-label-lg-pressed-lineHeight': '1.5rem',
        'dropdownButton-label-lg-pressed-opacity': 0.65,
        'dropdownButton-label-sm-hover-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-sm-hover-fontSize': '0.875rem',
        'dropdownButton-label-sm-hover-fontWeight': 'bold',
        'dropdownButton-label-sm-hover-letterSpacing': '0em',
        'dropdownButton-label-sm-hover-lineHeight': '1.25rem',
        'dropdownButton-label-sm-hover-opacity': 0.8,
        'dropdownButton-label-sm-initial-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-sm-initial-fontSize': '0.875rem',
        'dropdownButton-label-sm-initial-fontWeight': 'bold',
        'dropdownButton-label-sm-initial-letterSpacing': '0em',
        'dropdownButton-label-sm-initial-lineHeight': '1.25rem',
        'dropdownButton-label-sm-initial-opacity': 0.65,
        'dropdownButton-label-sm-pressed-color': 'rgb(0, 0, 0)',
        'dropdownButton-label-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'dropdownButton-label-sm-pressed-fontSize': '0.875rem',
        'dropdownButton-label-sm-pressed-fontWeight': 'bold',
        'dropdownButton-label-sm-pressed-letterSpacing': '0em',
        'dropdownButton-label-sm-pressed-lineHeight': '1.25rem',
        'dropdownButton-label-sm-pressed-opacity': 0.65,
        'editorialTeaser-base-default-background': 'rgb(255, 255, 255)',
        'editorialTeaser-base-default-borderColor': 'rgb(239, 241, 242)',
        'editorialTeaser-base-default-borderStyle': 'solid',
        'editorialTeaser-base-default-borderWidth': '0.0625rem',
        'editorialTeaser-base-highlighted-background': 'rgb(239, 241, 242)',
        'editorialTeaser-base-highlighted-borderColor': 'rgb(0, 0, 0)',
        'editorialTeaser-base-highlighted-borderStyle': 'solid',
        'editorialTeaser-base-highlighted-borderWidth': '0.0625rem',
        'editorialTeaser-content-base-lg-default-gap': '3rem',
        'editorialTeaser-content-base-lg-highlighted-gap': '3rem',
        'editorialTeaser-content-base-md-default-gap': '2rem',
        'editorialTeaser-content-base-md-highlighted-gap': '2rem',
        'editorialTeaser-content-base-sm-default-gap': '1.5rem',
        'editorialTeaser-content-base-sm-highlighted-gap': '1.5rem',
        'editorialTeaser-content-base-xs-default-gap': '1.5rem',
        'editorialTeaser-content-base-xs-highlighted-gap': '1.5rem',
        'editorialTeaser-content-title-base-lg-default-gap': '1rem',
        'editorialTeaser-content-title-base-lg-highlighted-gap': '1rem',
        'editorialTeaser-content-title-base-md-default-gap': '0.75rem',
        'editorialTeaser-content-title-base-md-highlighted-gap': '0.75rem',
        'editorialTeaser-content-title-base-sm-default-gap': '0.5rem',
        'editorialTeaser-content-title-base-sm-highlighted-gap': '0.5rem',
        'editorialTeaser-content-title-base-xs-default-gap': '0.5rem',
        'editorialTeaser-content-title-base-xs-highlighted-gap': '0.5rem',
        'editorialTeaser-content-title-description-default-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-description-default-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-description-default-fontSize': '1rem',
        'editorialTeaser-content-title-description-default-fontWeight': 'normal',
        'editorialTeaser-content-title-description-default-letterSpacing': '0em',
        'editorialTeaser-content-title-description-default-lineHeight': '1.5rem',
        'editorialTeaser-content-title-description-default-opacity': 0.8,
        'editorialTeaser-content-title-description-highlighted-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-description-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-description-highlighted-fontSize': '1rem',
        'editorialTeaser-content-title-description-highlighted-fontWeight': 'normal',
        'editorialTeaser-content-title-description-highlighted-letterSpacing': '0em',
        'editorialTeaser-content-title-description-highlighted-lineHeight': '1.5rem',
        'editorialTeaser-content-title-description-highlighted-opacity': 0.8,
        'editorialTeaser-content-title-headline-lg-default-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-lg-default-fontSize': '2.25rem',
        'editorialTeaser-content-title-headline-lg-default-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-lg-default-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-lg-default-lineHeight': '2.75rem',
        'editorialTeaser-content-title-headline-lg-highlighted-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-lg-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-lg-highlighted-fontSize': '2.25rem',
        'editorialTeaser-content-title-headline-lg-highlighted-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-lg-highlighted-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-lg-highlighted-lineHeight': '2.75rem',
        'editorialTeaser-content-title-headline-md-default-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-md-default-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-md-default-fontSize': '2rem',
        'editorialTeaser-content-title-headline-md-default-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-md-default-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-md-default-lineHeight': '2.5rem',
        'editorialTeaser-content-title-headline-md-highlighted-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-md-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-md-highlighted-fontSize': '2rem',
        'editorialTeaser-content-title-headline-md-highlighted-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-md-highlighted-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-md-highlighted-lineHeight': '2.5rem',
        'editorialTeaser-content-title-headline-sm-default-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-sm-default-fontSize': '1.75rem',
        'editorialTeaser-content-title-headline-sm-default-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-sm-default-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-sm-default-lineHeight': '2.25rem',
        'editorialTeaser-content-title-headline-sm-highlighted-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-sm-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-sm-highlighted-fontSize': '1.75rem',
        'editorialTeaser-content-title-headline-sm-highlighted-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-sm-highlighted-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-sm-highlighted-lineHeight': '2.25rem',
        'editorialTeaser-content-title-headline-xs-default-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-xs-default-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-xs-default-fontSize': '1.5rem',
        'editorialTeaser-content-title-headline-xs-default-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-xs-default-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-xs-default-lineHeight': '2rem',
        'editorialTeaser-content-title-headline-xs-highlighted-color': 'rgb(0, 0, 0)',
        'editorialTeaser-content-title-headline-xs-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'editorialTeaser-content-title-headline-xs-highlighted-fontSize': '1.5rem',
        'editorialTeaser-content-title-headline-xs-highlighted-fontWeight': 'bold',
        'editorialTeaser-content-title-headline-xs-highlighted-letterSpacing': '0em',
        'editorialTeaser-content-title-headline-xs-highlighted-lineHeight': '2rem',
        'energyLabel-2xs': '1rem',
        'energyLabel-lg': '2rem',
        'energyLabel-md': '1.75rem',
        'energyLabel-sm': '1.5rem',
        'energyLabel-xs': '1.25rem',
        'energylabel-base-gap': '0.25rem',
        'energylabel-classification-image-2xs-height': '1rem',
        'energylabel-classification-image-lg-height': '2rem',
        'energylabel-classification-image-md-height': '1.75rem',
        'energylabel-classification-image-sm-height': '1.5rem',
        'energylabel-classification-image-xs-height': '1.25rem',
        'energylabel-classification-lg-gap': '0.5rem',
        'energylabel-classification-sm-gap': '0.25rem',
        'energylabel-description-lg-color': 'rgb(0, 0, 0)',
        'energylabel-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'energylabel-description-lg-fontSize': '0.75rem',
        'energylabel-description-lg-fontWeight': 'normal',
        'energylabel-description-lg-letterSpacing': '0em',
        'energylabel-description-lg-lineHeight': '1rem',
        'energylabel-description-lg-opacity': 0.4,
        'energylabel-description-sm-color': 'rgb(0, 0, 0)',
        'energylabel-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'energylabel-description-sm-fontSize': '0.625rem',
        'energylabel-description-sm-fontWeight': 'normal',
        'energylabel-description-sm-letterSpacing': '0em',
        'energylabel-description-sm-lineHeight': '0.75rem',
        'energylabel-description-sm-opacity': 0.4,
        'energylabel-label-lg-color': 'rgb(0, 0, 0)',
        'energylabel-label-lg-fontFamily': 'Bosch Sans, sans-serif',
        'energylabel-label-lg-fontSize': '0.75rem',
        'energylabel-label-lg-fontWeight': 'normal',
        'energylabel-label-lg-letterSpacing': '0em',
        'energylabel-label-lg-lineHeight': '1rem',
        'energylabel-label-lg-opacity': 0.65,
        'energylabel-label-sm-color': 'rgb(0, 0, 0)',
        'energylabel-label-sm-fontFamily': 'Bosch Sans, sans-serif',
        'energylabel-label-sm-fontSize': '0.625rem',
        'energylabel-label-sm-fontWeight': 'normal',
        'energylabel-label-sm-letterSpacing': '0em',
        'energylabel-label-sm-lineHeight': '0.75rem',
        'energylabel-label-sm-opacity': 0.65,
        'expandArea-gradient-default': 'linear-gradient(180deg, #ffffff00 0%, #ffffffcc 50%, #ffffff 100%)',
        'expandArea-gradient-highlighted': 'linear-gradient(180deg, #eff1f200 0%, #eff1f2cc 50%, #eff1f2 100%)',
        'expandArea-lg-default-gap': '0',
        'expandArea-lg-default-height': '17.5rem',
        'expandArea-lg-expanded-gap': '1.5rem',
        'expandArea-lg-expanded-height': 'auto',
        'expandArea-md-default-gap': '0',
        'expandArea-md-default-height': '12rem',
        'expandArea-md-expanded-gap': '1rem',
        'expandArea-md-expanded-height': 'auto',
        'expandArea-sm-default-gap': '0',
        'expandArea-sm-default-height': '10rem',
        'expandArea-sm-expanded-gap': '1rem',
        'expandArea-sm-expanded-height': 'auto',
        'expandArea-xs-default-gap': '0',
        'expandArea-xs-default-height': '7.5rem',
        'expandArea-xs-expanded-gap': '1rem',
        'expandArea-xs-expanded-height': 'auto',
        'feature-base-lg-gap': '0.25rem',
        'feature-base-sm-gap': '0.25rem',
        'feature-description-lg-color': 'rgb(0, 0, 0)',
        'feature-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'feature-description-lg-fontSize': '0.875rem',
        'feature-description-lg-fontWeight': 'normal',
        'feature-description-lg-letterSpacing': '0em',
        'feature-description-lg-lineHeight': '1.25rem',
        'feature-description-lg-opacity': 0.65,
        'feature-description-sm-color': 'rgb(0, 0, 0)',
        'feature-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'feature-description-sm-fontSize': '0.75rem',
        'feature-description-sm-fontWeight': 'normal',
        'feature-description-sm-letterSpacing': '0em',
        'feature-description-sm-lineHeight': '1rem',
        'feature-description-sm-opacity': 0.65,
        'feature-headline-lg-color': 'rgb(0, 0, 0)',
        'feature-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'feature-headline-lg-fontSize': '1.5rem',
        'feature-headline-lg-fontWeight': 'bold',
        'feature-headline-lg-letterSpacing': '0em',
        'feature-headline-lg-lineHeight': '2rem',
        'feature-headline-sm-color': 'rgb(0, 0, 0)',
        'feature-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'feature-headline-sm-fontSize': '1.25rem',
        'feature-headline-sm-fontWeight': 'bold',
        'feature-headline-sm-letterSpacing': '0em',
        'feature-headline-sm-lineHeight': '1.75rem',
        'feature-icon-available-background': 'rgb(0, 0, 0)',
        'feature-icon-available-opacity': 1,
        'feature-icon-unavailable-background': 'rgb(0, 0, 0)',
        'feature-icon-unavailable-opacity': 0.65,
        'featureList-base-lg-gap': '1rem',
        'featureList-base-sm-gap': '0.75rem',
        'featureList-feature-base-default-default-lg-borderBottomWidth': '0',
        'featureList-feature-base-default-default-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'featureList-feature-base-default-default-lg-borderStyle': 'solid',
        'featureList-feature-base-default-default-lg-paddingBottom': '0',
        'featureList-feature-base-default-default-sm-borderBottomWidth': '0',
        'featureList-feature-base-default-default-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'featureList-feature-base-default-default-sm-borderStyle': 'solid',
        'featureList-feature-base-default-default-sm-paddingBottom': '0',
        'featureList-feature-base-default-divided-lg-borderBottomWidth': '0.0625rem',
        'featureList-feature-base-default-divided-lg-borderColor': 'rgb(239, 241, 242)',
        'featureList-feature-base-default-divided-lg-borderStyle': 'solid',
        'featureList-feature-base-default-divided-lg-paddingBottom': '1rem',
        'featureList-feature-base-default-divided-sm-borderBottomWidth': '0.0625rem',
        'featureList-feature-base-default-divided-sm-borderColor': 'rgb(239, 241, 242)',
        'featureList-feature-base-default-divided-sm-borderStyle': 'solid',
        'featureList-feature-base-default-divided-sm-paddingBottom': '0.75rem',
        'featureList-feature-base-highlighted-default-lg-borderBottomWidth': '0',
        'featureList-feature-base-highlighted-default-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'featureList-feature-base-highlighted-default-lg-borderStyle': 'solid',
        'featureList-feature-base-highlighted-default-lg-paddingBottom': '0',
        'featureList-feature-base-highlighted-default-sm-borderBottomWidth': '0',
        'featureList-feature-base-highlighted-default-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'featureList-feature-base-highlighted-default-sm-borderStyle': 'solid',
        'featureList-feature-base-highlighted-default-sm-paddingBottom': '0',
        'featureList-feature-base-highlighted-divided-lg-borderBottomWidth': '0.0625rem',
        'featureList-feature-base-highlighted-divided-lg-borderColor': 'rgb(193, 199, 204)',
        'featureList-feature-base-highlighted-divided-lg-borderStyle': 'solid',
        'featureList-feature-base-highlighted-divided-lg-paddingBottom': '1rem',
        'featureList-feature-base-highlighted-divided-sm-borderBottomWidth': '0.0625rem',
        'featureList-feature-base-highlighted-divided-sm-borderColor': 'rgb(193, 199, 204)',
        'featureList-feature-base-highlighted-divided-sm-borderStyle': 'solid',
        'featureList-feature-base-highlighted-divided-sm-paddingBottom': '0.75rem',
        'featureList-feature-content-base-lg-gap': '0.25rem',
        'featureList-feature-content-base-sm-gap': '0.25rem',
        'featureList-feature-content-header-base-lg-gap': '0.25rem',
        'featureList-feature-content-header-base-sm-gap': '0.25rem',
        'featureList-feature-content-header-description-default-lg-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-description-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-description-default-lg-fontSize': '0.875rem',
        'featureList-feature-content-header-description-default-lg-fontWeight': 'normal',
        'featureList-feature-content-header-description-default-lg-letterSpacing': '0em',
        'featureList-feature-content-header-description-default-lg-lineHeight': '1.25rem',
        'featureList-feature-content-header-description-default-lg-opacity': 0.8,
        'featureList-feature-content-header-description-default-sm-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-description-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-description-default-sm-fontSize': '0.75rem',
        'featureList-feature-content-header-description-default-sm-fontWeight': 'normal',
        'featureList-feature-content-header-description-default-sm-letterSpacing': '0em',
        'featureList-feature-content-header-description-default-sm-lineHeight': '1rem',
        'featureList-feature-content-header-description-default-sm-opacity': 0.8,
        'featureList-feature-content-header-description-highlighted-lg-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-description-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-description-highlighted-lg-fontSize': '0.875rem',
        'featureList-feature-content-header-description-highlighted-lg-fontWeight': 'normal',
        'featureList-feature-content-header-description-highlighted-lg-letterSpacing': '0em',
        'featureList-feature-content-header-description-highlighted-lg-lineHeight': '1.25rem',
        'featureList-feature-content-header-description-highlighted-lg-opacity': 0.8,
        'featureList-feature-content-header-description-highlighted-sm-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-description-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-description-highlighted-sm-fontSize': '0.75rem',
        'featureList-feature-content-header-description-highlighted-sm-fontWeight': 'normal',
        'featureList-feature-content-header-description-highlighted-sm-letterSpacing': '0em',
        'featureList-feature-content-header-description-highlighted-sm-lineHeight': '1rem',
        'featureList-feature-content-header-description-highlighted-sm-opacity': 0.8,
        'featureList-feature-content-header-headline-default-lg-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-headline-default-lg-fontSize': '0.875rem',
        'featureList-feature-content-header-headline-default-lg-fontWeight': 'bold',
        'featureList-feature-content-header-headline-default-lg-letterSpacing': '0em',
        'featureList-feature-content-header-headline-default-lg-lineHeight': '1.25rem',
        'featureList-feature-content-header-headline-default-lg-opacity': 1,
        'featureList-feature-content-header-headline-default-sm-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-headline-default-sm-fontSize': '0.75rem',
        'featureList-feature-content-header-headline-default-sm-fontWeight': 'bold',
        'featureList-feature-content-header-headline-default-sm-letterSpacing': '0em',
        'featureList-feature-content-header-headline-default-sm-lineHeight': '1rem',
        'featureList-feature-content-header-headline-default-sm-opacity': 1,
        'featureList-feature-content-header-headline-highlighted-lg-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-headline-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-headline-highlighted-lg-fontSize': '0.875rem',
        'featureList-feature-content-header-headline-highlighted-lg-fontWeight': 'bold',
        'featureList-feature-content-header-headline-highlighted-lg-letterSpacing': '0em',
        'featureList-feature-content-header-headline-highlighted-lg-lineHeight': '1.25rem',
        'featureList-feature-content-header-headline-highlighted-lg-opacity': 1,
        'featureList-feature-content-header-headline-highlighted-sm-color': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-headline-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'featureList-feature-content-header-headline-highlighted-sm-fontSize': '0.75rem',
        'featureList-feature-content-header-headline-highlighted-sm-fontWeight': 'bold',
        'featureList-feature-content-header-headline-highlighted-sm-letterSpacing': '0em',
        'featureList-feature-content-header-headline-highlighted-sm-lineHeight': '1rem',
        'featureList-feature-content-header-headline-highlighted-sm-opacity': 1,
        'featureList-feature-content-header-icon-default-background': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-icon-default-opacity': 1,
        'featureList-feature-content-header-icon-highlighted-background': 'rgb(0, 0, 0)',
        'featureList-feature-content-header-icon-highlighted-opacity': 1,
        'featureList-row-base-lg-gap': '1rem',
        'featureList-row-base-sm-gap': '0.75rem',
        'filterButton-base-lg-default-preselected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-preselected-hover-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-lg-default-preselected-hover-borderRadius': '0',
        'filterButton-base-lg-default-preselected-hover-borderStyle': 'solid',
        'filterButton-base-lg-default-preselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-preselected-hover-height': '3rem',
        'filterButton-base-lg-default-preselected-hover-opacity': 1,
        'filterButton-base-lg-default-preselected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-preselected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-default-preselected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-preselected-initial-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-lg-default-preselected-initial-borderRadius': '0',
        'filterButton-base-lg-default-preselected-initial-borderStyle': 'solid',
        'filterButton-base-lg-default-preselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-preselected-initial-height': '3rem',
        'filterButton-base-lg-default-preselected-initial-opacity': 0.8,
        'filterButton-base-lg-default-preselected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-preselected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-default-preselected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-preselected-pressed-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-lg-default-preselected-pressed-borderRadius': '0',
        'filterButton-base-lg-default-preselected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-default-preselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-preselected-pressed-height': '3rem',
        'filterButton-base-lg-default-preselected-pressed-opacity': 0.65,
        'filterButton-base-lg-default-preselected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-preselected-pressed-paddingRight': '1.5rem',
        'filterButton-base-lg-default-selected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'filterButton-base-lg-default-selected-hover-borderRadius': '0',
        'filterButton-base-lg-default-selected-hover-borderStyle': 'solid',
        'filterButton-base-lg-default-selected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-selected-hover-height': '3rem',
        'filterButton-base-lg-default-selected-hover-opacity': 1,
        'filterButton-base-lg-default-selected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-selected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-default-selected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'filterButton-base-lg-default-selected-initial-borderRadius': '0',
        'filterButton-base-lg-default-selected-initial-borderStyle': 'solid',
        'filterButton-base-lg-default-selected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-selected-initial-height': '3rem',
        'filterButton-base-lg-default-selected-initial-opacity': 0.8,
        'filterButton-base-lg-default-selected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-selected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-default-selected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'filterButton-base-lg-default-selected-pressed-borderRadius': '0',
        'filterButton-base-lg-default-selected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-default-selected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-selected-pressed-height': '3rem',
        'filterButton-base-lg-default-selected-pressed-opacity': 0.65,
        'filterButton-base-lg-default-selected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-selected-pressed-paddingRight': '1.5rem',
        'filterButton-base-lg-default-unselected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-default-unselected-hover-borderRadius': '0',
        'filterButton-base-lg-default-unselected-hover-borderStyle': 'solid',
        'filterButton-base-lg-default-unselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-unselected-hover-height': '3rem',
        'filterButton-base-lg-default-unselected-hover-opacity': 1,
        'filterButton-base-lg-default-unselected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-unselected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-default-unselected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-default-unselected-initial-borderRadius': '0',
        'filterButton-base-lg-default-unselected-initial-borderStyle': 'solid',
        'filterButton-base-lg-default-unselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-unselected-initial-height': '3rem',
        'filterButton-base-lg-default-unselected-initial-opacity': 0.8,
        'filterButton-base-lg-default-unselected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-unselected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-default-unselected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-lg-default-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-default-unselected-pressed-borderRadius': '0',
        'filterButton-base-lg-default-unselected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-default-unselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-default-unselected-pressed-height': '3rem',
        'filterButton-base-lg-default-unselected-pressed-opacity': 0.65,
        'filterButton-base-lg-default-unselected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-default-unselected-pressed-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-preselected-hover-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-lg-highlighted-preselected-hover-borderRadius': '0',
        'filterButton-base-lg-highlighted-preselected-hover-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-preselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-preselected-hover-height': '3rem',
        'filterButton-base-lg-highlighted-preselected-hover-opacity': 1,
        'filterButton-base-lg-highlighted-preselected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-preselected-initial-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-lg-highlighted-preselected-initial-borderRadius': '0',
        'filterButton-base-lg-highlighted-preselected-initial-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-preselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-preselected-initial-height': '3rem',
        'filterButton-base-lg-highlighted-preselected-initial-opacity': 0.8,
        'filterButton-base-lg-highlighted-preselected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-preselected-pressed-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-lg-highlighted-preselected-pressed-borderRadius': '0',
        'filterButton-base-lg-highlighted-preselected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-preselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-preselected-pressed-height': '3rem',
        'filterButton-base-lg-highlighted-preselected-pressed-opacity': 0.65,
        'filterButton-base-lg-highlighted-preselected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-preselected-pressed-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-selected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'filterButton-base-lg-highlighted-selected-hover-borderRadius': '0',
        'filterButton-base-lg-highlighted-selected-hover-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-selected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-selected-hover-height': '3rem',
        'filterButton-base-lg-highlighted-selected-hover-opacity': 1,
        'filterButton-base-lg-highlighted-selected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-selected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-selected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'filterButton-base-lg-highlighted-selected-initial-borderRadius': '0',
        'filterButton-base-lg-highlighted-selected-initial-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-selected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-selected-initial-height': '3rem',
        'filterButton-base-lg-highlighted-selected-initial-opacity': 0.8,
        'filterButton-base-lg-highlighted-selected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-selected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-selected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'filterButton-base-lg-highlighted-selected-pressed-borderRadius': '0',
        'filterButton-base-lg-highlighted-selected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-selected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-selected-pressed-height': '3rem',
        'filterButton-base-lg-highlighted-selected-pressed-opacity': 0.65,
        'filterButton-base-lg-highlighted-selected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-selected-pressed-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-highlighted-unselected-hover-borderRadius': '0',
        'filterButton-base-lg-highlighted-unselected-hover-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-unselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-unselected-hover-height': '3rem',
        'filterButton-base-lg-highlighted-unselected-hover-opacity': 1,
        'filterButton-base-lg-highlighted-unselected-hover-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-hover-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-highlighted-unselected-initial-borderRadius': '0',
        'filterButton-base-lg-highlighted-unselected-initial-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-unselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-unselected-initial-height': '3rem',
        'filterButton-base-lg-highlighted-unselected-initial-opacity': 0.8,
        'filterButton-base-lg-highlighted-unselected-initial-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-initial-paddingRight': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-lg-highlighted-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-lg-highlighted-unselected-pressed-borderRadius': '0',
        'filterButton-base-lg-highlighted-unselected-pressed-borderStyle': 'solid',
        'filterButton-base-lg-highlighted-unselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-lg-highlighted-unselected-pressed-height': '3rem',
        'filterButton-base-lg-highlighted-unselected-pressed-opacity': 0.8,
        'filterButton-base-lg-highlighted-unselected-pressed-paddingLeft': '1.5rem',
        'filterButton-base-lg-highlighted-unselected-pressed-paddingRight': '1.5rem',
        'filterButton-base-sm-default-preselected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-preselected-hover-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-sm-default-preselected-hover-borderRadius': '0',
        'filterButton-base-sm-default-preselected-hover-borderStyle': 'solid',
        'filterButton-base-sm-default-preselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-preselected-hover-height': '2rem',
        'filterButton-base-sm-default-preselected-hover-opacity': 1,
        'filterButton-base-sm-default-preselected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-default-preselected-hover-paddingRight': '1rem',
        'filterButton-base-sm-default-preselected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-preselected-initial-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-sm-default-preselected-initial-borderRadius': '0',
        'filterButton-base-sm-default-preselected-initial-borderStyle': 'solid',
        'filterButton-base-sm-default-preselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-preselected-initial-height': '2rem',
        'filterButton-base-sm-default-preselected-initial-opacity': 0.8,
        'filterButton-base-sm-default-preselected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-default-preselected-initial-paddingRight': '1rem',
        'filterButton-base-sm-default-preselected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-preselected-pressed-borderColor': 'rgb(224, 226, 229)',
        'filterButton-base-sm-default-preselected-pressed-borderRadius': '0',
        'filterButton-base-sm-default-preselected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-default-preselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-preselected-pressed-height': '2rem',
        'filterButton-base-sm-default-preselected-pressed-opacity': 0.65,
        'filterButton-base-sm-default-preselected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-default-preselected-pressed-paddingRight': '1rem',
        'filterButton-base-sm-default-selected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'filterButton-base-sm-default-selected-hover-borderRadius': '0',
        'filterButton-base-sm-default-selected-hover-borderStyle': 'solid',
        'filterButton-base-sm-default-selected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-selected-hover-height': '2rem',
        'filterButton-base-sm-default-selected-hover-opacity': 1,
        'filterButton-base-sm-default-selected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-default-selected-hover-paddingRight': '1rem',
        'filterButton-base-sm-default-selected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'filterButton-base-sm-default-selected-initial-borderRadius': '0',
        'filterButton-base-sm-default-selected-initial-borderStyle': 'solid',
        'filterButton-base-sm-default-selected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-selected-initial-height': '2rem',
        'filterButton-base-sm-default-selected-initial-opacity': 0.8,
        'filterButton-base-sm-default-selected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-default-selected-initial-paddingRight': '1rem',
        'filterButton-base-sm-default-selected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'filterButton-base-sm-default-selected-pressed-borderRadius': '0',
        'filterButton-base-sm-default-selected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-default-selected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-selected-pressed-height': '2rem',
        'filterButton-base-sm-default-selected-pressed-opacity': 0.65,
        'filterButton-base-sm-default-selected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-default-selected-pressed-paddingRight': '1rem',
        'filterButton-base-sm-default-unselected-hover-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-default-unselected-hover-borderRadius': '0',
        'filterButton-base-sm-default-unselected-hover-borderStyle': 'solid',
        'filterButton-base-sm-default-unselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-unselected-hover-height': '2rem',
        'filterButton-base-sm-default-unselected-hover-opacity': 1,
        'filterButton-base-sm-default-unselected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-default-unselected-hover-paddingRight': '1rem',
        'filterButton-base-sm-default-unselected-initial-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-default-unselected-initial-borderRadius': '0',
        'filterButton-base-sm-default-unselected-initial-borderStyle': 'solid',
        'filterButton-base-sm-default-unselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-unselected-initial-height': '2rem',
        'filterButton-base-sm-default-unselected-initial-opacity': 0.8,
        'filterButton-base-sm-default-unselected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-default-unselected-initial-paddingRight': '1rem',
        'filterButton-base-sm-default-unselected-pressed-background': 'rgb(239, 241, 242)',
        'filterButton-base-sm-default-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-default-unselected-pressed-borderRadius': '0',
        'filterButton-base-sm-default-unselected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-default-unselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-default-unselected-pressed-height': '2rem',
        'filterButton-base-sm-default-unselected-pressed-opacity': 0.65,
        'filterButton-base-sm-default-unselected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-default-unselected-pressed-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-preselected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-preselected-hover-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-sm-highlighted-preselected-hover-borderRadius': '0',
        'filterButton-base-sm-highlighted-preselected-hover-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-preselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-preselected-hover-height': '2rem',
        'filterButton-base-sm-highlighted-preselected-hover-opacity': 1,
        'filterButton-base-sm-highlighted-preselected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-preselected-hover-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-preselected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-preselected-initial-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-sm-highlighted-preselected-initial-borderRadius': '0',
        'filterButton-base-sm-highlighted-preselected-initial-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-preselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-preselected-initial-height': '2rem',
        'filterButton-base-sm-highlighted-preselected-initial-opacity': 0.8,
        'filterButton-base-sm-highlighted-preselected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-preselected-initial-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-preselected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-preselected-pressed-borderColor': 'rgb(193, 199, 204)',
        'filterButton-base-sm-highlighted-preselected-pressed-borderRadius': '0',
        'filterButton-base-sm-highlighted-preselected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-preselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-preselected-pressed-height': '2rem',
        'filterButton-base-sm-highlighted-preselected-pressed-opacity': 0.65,
        'filterButton-base-sm-highlighted-preselected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-preselected-pressed-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-selected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'filterButton-base-sm-highlighted-selected-hover-borderRadius': '0',
        'filterButton-base-sm-highlighted-selected-hover-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-selected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-selected-hover-height': '2rem',
        'filterButton-base-sm-highlighted-selected-hover-opacity': 1,
        'filterButton-base-sm-highlighted-selected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-selected-hover-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-selected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'filterButton-base-sm-highlighted-selected-initial-borderRadius': '0',
        'filterButton-base-sm-highlighted-selected-initial-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-selected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-selected-initial-height': '2rem',
        'filterButton-base-sm-highlighted-selected-initial-opacity': 0.8,
        'filterButton-base-sm-highlighted-selected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-selected-initial-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-selected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'filterButton-base-sm-highlighted-selected-pressed-borderRadius': '0',
        'filterButton-base-sm-highlighted-selected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-selected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-selected-pressed-height': '2rem',
        'filterButton-base-sm-highlighted-selected-pressed-opacity': 0.65,
        'filterButton-base-sm-highlighted-selected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-selected-pressed-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-unselected-hover-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-highlighted-unselected-hover-borderRadius': '0',
        'filterButton-base-sm-highlighted-unselected-hover-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-unselected-hover-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-unselected-hover-height': '2rem',
        'filterButton-base-sm-highlighted-unselected-hover-opacity': 1,
        'filterButton-base-sm-highlighted-unselected-hover-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-unselected-hover-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-unselected-initial-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-highlighted-unselected-initial-borderRadius': '0',
        'filterButton-base-sm-highlighted-unselected-initial-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-unselected-initial-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-unselected-initial-height': '2rem',
        'filterButton-base-sm-highlighted-unselected-initial-opacity': 0.8,
        'filterButton-base-sm-highlighted-unselected-initial-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-unselected-initial-paddingRight': '1rem',
        'filterButton-base-sm-highlighted-unselected-pressed-background': 'rgb(255, 255, 255)',
        'filterButton-base-sm-highlighted-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'filterButton-base-sm-highlighted-unselected-pressed-borderRadius': '0',
        'filterButton-base-sm-highlighted-unselected-pressed-borderStyle': 'solid',
        'filterButton-base-sm-highlighted-unselected-pressed-borderWidth': '0.0625rem',
        'filterButton-base-sm-highlighted-unselected-pressed-height': '2rem',
        'filterButton-base-sm-highlighted-unselected-pressed-opacity': 0.65,
        'filterButton-base-sm-highlighted-unselected-pressed-paddingLeft': '1rem',
        'filterButton-base-sm-highlighted-unselected-pressed-paddingRight': '1rem',
        'filterButton-content-base-lg-gap': '0.75rem',
        'filterButton-content-base-sm-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-base-sm-fontSize': '1rem',
        'filterButton-content-base-sm-fontWeight': 'bold',
        'filterButton-content-base-sm-gap': '0.5rem',
        'filterButton-content-base-sm-letterSpacing': '0em',
        'filterButton-content-base-sm-lineHeight': '1.5rem',
        'filterButton-content-icon-default-lg-default-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-lg-default-opacity': 1,
        'filterButton-content-icon-default-lg-hover-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-lg-hover-opacity': 1,
        'filterButton-content-icon-default-lg-pressed-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-lg-pressed-opacity': 0.8,
        'filterButton-content-icon-default-sm-default-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-sm-default-opacity': 1,
        'filterButton-content-icon-default-sm-hover-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-sm-hover-opacity': 1,
        'filterButton-content-icon-default-sm-pressed-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-default-sm-pressed-opacity': 0.8,
        'filterButton-content-icon-highlighted-lg-default-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-lg-default-opacity': 1,
        'filterButton-content-icon-highlighted-lg-hover-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-lg-hover-opacity': 1,
        'filterButton-content-icon-highlighted-lg-pressed-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-lg-pressed-opacity': 0.8,
        'filterButton-content-icon-highlighted-sm-default-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-sm-default-opacity': 1,
        'filterButton-content-icon-highlighted-sm-hover-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-sm-hover-opacity': 1,
        'filterButton-content-icon-highlighted-sm-pressed-background': 'rgb(0, 0, 0)',
        'filterButton-content-icon-highlighted-sm-pressed-opacity': 0.8,
        'filterButton-content-label-default-lg-default-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-lg-default-fontSize': '1.25rem',
        'filterButton-content-label-default-lg-default-fontWeight': 'normal',
        'filterButton-content-label-default-lg-default-letterSpacing': '0em',
        'filterButton-content-label-default-lg-default-lineHeight': '1.75rem',
        'filterButton-content-label-default-lg-default-opacity': 1,
        'filterButton-content-label-default-lg-hover-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-lg-hover-fontSize': '1.25rem',
        'filterButton-content-label-default-lg-hover-fontWeight': 'normal',
        'filterButton-content-label-default-lg-hover-letterSpacing': '0em',
        'filterButton-content-label-default-lg-hover-lineHeight': '1.75rem',
        'filterButton-content-label-default-lg-hover-opacity': 1,
        'filterButton-content-label-default-lg-pressed-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-lg-pressed-fontSize': '1.25rem',
        'filterButton-content-label-default-lg-pressed-fontWeight': 'normal',
        'filterButton-content-label-default-lg-pressed-letterSpacing': '0em',
        'filterButton-content-label-default-lg-pressed-lineHeight': '1.75rem',
        'filterButton-content-label-default-lg-pressed-opacity': 0.8,
        'filterButton-content-label-default-sm-default-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-sm-default-fontSize': '1rem',
        'filterButton-content-label-default-sm-default-fontWeight': 'normal',
        'filterButton-content-label-default-sm-default-letterSpacing': '0em',
        'filterButton-content-label-default-sm-default-lineHeight': '1.5rem',
        'filterButton-content-label-default-sm-default-opacity': 1,
        'filterButton-content-label-default-sm-hover-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-sm-hover-fontSize': '1rem',
        'filterButton-content-label-default-sm-hover-fontWeight': 'normal',
        'filterButton-content-label-default-sm-hover-letterSpacing': '0em',
        'filterButton-content-label-default-sm-hover-lineHeight': '1.5rem',
        'filterButton-content-label-default-sm-hover-opacity': 1,
        'filterButton-content-label-default-sm-pressed-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-default-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-default-sm-pressed-fontSize': '1rem',
        'filterButton-content-label-default-sm-pressed-fontWeight': 'normal',
        'filterButton-content-label-default-sm-pressed-letterSpacing': '0em',
        'filterButton-content-label-default-sm-pressed-lineHeight': '1.5rem',
        'filterButton-content-label-default-sm-pressed-opacity': 0.8,
        'filterButton-content-label-highlighted-lg-default-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-lg-default-fontSize': '1.25rem',
        'filterButton-content-label-highlighted-lg-default-fontWeight': 'normal',
        'filterButton-content-label-highlighted-lg-default-letterSpacing': '0em',
        'filterButton-content-label-highlighted-lg-default-lineHeight': '1.75rem',
        'filterButton-content-label-highlighted-lg-default-opacity': 1,
        'filterButton-content-label-highlighted-lg-hover-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-lg-hover-fontSize': '1.25rem',
        'filterButton-content-label-highlighted-lg-hover-fontWeight': 'normal',
        'filterButton-content-label-highlighted-lg-hover-letterSpacing': '0em',
        'filterButton-content-label-highlighted-lg-hover-lineHeight': '1.75rem',
        'filterButton-content-label-highlighted-lg-hover-opacity': 1,
        'filterButton-content-label-highlighted-lg-pressed-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-lg-pressed-fontSize': '1.25rem',
        'filterButton-content-label-highlighted-lg-pressed-fontWeight': 'normal',
        'filterButton-content-label-highlighted-lg-pressed-letterSpacing': '0em',
        'filterButton-content-label-highlighted-lg-pressed-lineHeight': '1.75rem',
        'filterButton-content-label-highlighted-lg-pressed-opacity': 0.8,
        'filterButton-content-label-highlighted-sm-default-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-sm-default-fontSize': '1rem',
        'filterButton-content-label-highlighted-sm-default-fontWeight': 'normal',
        'filterButton-content-label-highlighted-sm-default-letterSpacing': '0em',
        'filterButton-content-label-highlighted-sm-default-lineHeight': '1.5rem',
        'filterButton-content-label-highlighted-sm-default-opacity': 1,
        'filterButton-content-label-highlighted-sm-hover-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-sm-hover-fontSize': '1rem',
        'filterButton-content-label-highlighted-sm-hover-fontWeight': 'normal',
        'filterButton-content-label-highlighted-sm-hover-letterSpacing': '0em',
        'filterButton-content-label-highlighted-sm-hover-lineHeight': '1.5rem',
        'filterButton-content-label-highlighted-sm-hover-opacity': 1,
        'filterButton-content-label-highlighted-sm-pressed-color': 'rgb(0, 0, 0)',
        'filterButton-content-label-highlighted-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'filterButton-content-label-highlighted-sm-pressed-fontSize': '1rem',
        'filterButton-content-label-highlighted-sm-pressed-fontWeight': 'normal',
        'filterButton-content-label-highlighted-sm-pressed-letterSpacing': '0em',
        'filterButton-content-label-highlighted-sm-pressed-lineHeight': '1.5rem',
        'filterButton-content-label-highlighted-sm-pressed-opacity': 0.8,
        'floating-default-base': 'rgb(255, 255, 255)',
        'floating-default-onBase': 'rgb(0, 0, 0)',
        'floating-default-onDefault-base': 'rgb(239, 241, 242)',
        'floating-default-onDefault-onBase': 'rgb(0, 0, 0)',
        'floating-highlighted-base': 'rgb(239, 241, 242)',
        'floating-highlighted-onBase': 'rgb(0, 0, 0)',
        'floating-highlighted-onHighlighted-base': 'rgb(224, 226, 229)',
        'floating-highlighted-onHighlighted-onBase': 'rgb(0, 0, 0)',
        'floatingCard-base-bottom-default-high-background': 'rgb(255, 255, 255)',
        'floatingCard-base-bottom-default-high-borderBottomLeftRadius': '0',
        'floatingCard-base-bottom-default-high-borderBottomRightRadius': '0',
        'floatingCard-base-bottom-default-high-borderTopLeftRadius': '0',
        'floatingCard-base-bottom-default-high-borderTopRightRadius': '0',
        'floatingCard-base-bottom-default-high-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-bottom-default-low-background': 'rgb(255, 255, 255)',
        'floatingCard-base-bottom-default-low-borderBottomLeftRadius': '0',
        'floatingCard-base-bottom-default-low-borderBottomRightRadius': '0',
        'floatingCard-base-bottom-default-low-borderTopLeftRadius': '0',
        'floatingCard-base-bottom-default-low-borderTopRightRadius': '0',
        'floatingCard-base-bottom-default-low-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-bottom-highlighted-high-background': 'rgb(26, 28, 29)',
        'floatingCard-base-bottom-highlighted-high-borderBottomLeftRadius': '0',
        'floatingCard-base-bottom-highlighted-high-borderBottomRightRadius': '0',
        'floatingCard-base-bottom-highlighted-high-borderTopLeftRadius': '0',
        'floatingCard-base-bottom-highlighted-high-borderTopRightRadius': '0',
        'floatingCard-base-bottom-highlighted-high-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-bottom-highlighted-low-background': 'rgb(26, 28, 29)',
        'floatingCard-base-bottom-highlighted-low-borderBottomLeftRadius': '0',
        'floatingCard-base-bottom-highlighted-low-borderBottomRightRadius': '0',
        'floatingCard-base-bottom-highlighted-low-borderTopLeftRadius': '0',
        'floatingCard-base-bottom-highlighted-low-borderTopRightRadius': '0',
        'floatingCard-base-bottom-highlighted-low-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-edgeless-default-high-background': 'rgb(255, 255, 255)',
        'floatingCard-base-edgeless-default-high-borderBottomLeftRadius': '0',
        'floatingCard-base-edgeless-default-high-borderBottomRightRadius': '0',
        'floatingCard-base-edgeless-default-high-borderTopLeftRadius': '0',
        'floatingCard-base-edgeless-default-high-borderTopRightRadius': '0',
        'floatingCard-base-edgeless-default-high-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-edgeless-default-low-background': 'rgb(255, 255, 255)',
        'floatingCard-base-edgeless-default-low-borderBottomLeftRadius': '0',
        'floatingCard-base-edgeless-default-low-borderBottomRightRadius': '0',
        'floatingCard-base-edgeless-default-low-borderTopLeftRadius': '0',
        'floatingCard-base-edgeless-default-low-borderTopRightRadius': '0',
        'floatingCard-base-edgeless-default-low-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-edgeless-highlighted-high-background': 'rgb(26, 28, 29)',
        'floatingCard-base-edgeless-highlighted-high-borderBottomLeftRadius': '0',
        'floatingCard-base-edgeless-highlighted-high-borderBottomRightRadius': '0',
        'floatingCard-base-edgeless-highlighted-high-borderTopLeftRadius': '0',
        'floatingCard-base-edgeless-highlighted-high-borderTopRightRadius': '0',
        'floatingCard-base-edgeless-highlighted-high-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-base-edgeless-highlighted-low-background': 'rgb(26, 28, 29)',
        'floatingCard-base-edgeless-highlighted-low-borderBottomLeftRadius': '0',
        'floatingCard-base-edgeless-highlighted-low-borderBottomRightRadius': '0',
        'floatingCard-base-edgeless-highlighted-low-borderTopLeftRadius': '0',
        'floatingCard-base-edgeless-highlighted-low-borderTopRightRadius': '0',
        'floatingCard-base-edgeless-highlighted-low-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'floatingCard-tail-default-background': 'rgb(255, 255, 255)',
        'floatingCard-tail-highlighted-background': 'rgb(26, 28, 29)',
        'footer-accordion-base-borderColor': 'rgb(0, 0, 0)',
        'footer-accordion-base-borderStyle': 'solid',
        'footer-accordion-icon-background': 'rgb(0, 0, 0)',
        'footer-accordion-text-background': 'rgb(0, 0, 0)',
        'footer-base-background': 'rgb(255, 255, 255)',
        'footer-copyrightText-background': 'rgb(0, 0, 0)',
        'footer-divider-background': 'rgb(224, 226, 229)',
        'footer-legalText-background': 'rgb(0, 0, 0)',
        'footer-linklist-headline-background': 'rgb(0, 0, 0)',
        'footer-social-headline-background': 'rgb(0, 0, 0)',
        'footer-social-text-background': 'rgb(0, 0, 0)',
        'footer-tagline-background': 'rgb(0, 0, 0)',
        'formField-base-lg-gap': '0.5rem',
        'formField-base-sm-gap': '0.5rem',
        'formField-message-base-gap': '0.5rem',
        'formField-message-count-default-error-color': 'rgb(237, 0, 7)',
        'formField-message-count-default-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-default-error-fontSize': '0.75rem',
        'formField-message-count-default-error-fontWeight': 'normal',
        'formField-message-count-default-error-letterSpacing': '0em',
        'formField-message-count-default-error-lineHeight': '1rem',
        'formField-message-count-default-error-opacity': 0.8,
        'formField-message-count-default-resting-color': 'rgb(0, 0, 0)',
        'formField-message-count-default-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-default-resting-fontSize': '0.75rem',
        'formField-message-count-default-resting-fontWeight': 'normal',
        'formField-message-count-default-resting-letterSpacing': '0em',
        'formField-message-count-default-resting-lineHeight': '1rem',
        'formField-message-count-default-resting-opacity': 0.8,
        'formField-message-count-highlighted-error-color': 'rgb(237, 0, 7)',
        'formField-message-count-highlighted-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-highlighted-error-fontSize': '0.75rem',
        'formField-message-count-highlighted-error-fontWeight': 'normal',
        'formField-message-count-highlighted-error-letterSpacing': '0em',
        'formField-message-count-highlighted-error-lineHeight': '1rem',
        'formField-message-count-highlighted-error-opacity': 0.8,
        'formField-message-count-highlighted-resting-color': 'rgb(0, 0, 0)',
        'formField-message-count-highlighted-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-highlighted-resting-fontSize': '0.75rem',
        'formField-message-count-highlighted-resting-fontWeight': 'normal',
        'formField-message-count-highlighted-resting-letterSpacing': '0em',
        'formField-message-count-highlighted-resting-lineHeight': '1rem',
        'formField-message-count-highlighted-resting-opacity': 0.8,
        'formField-message-count-image-error-color': 'rgb(237, 0, 7)',
        'formField-message-count-image-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-image-error-fontSize': '0.75rem',
        'formField-message-count-image-error-fontWeight': 'normal',
        'formField-message-count-image-error-letterSpacing': '0em',
        'formField-message-count-image-error-lineHeight': '1rem',
        'formField-message-count-image-error-opacity': 0.8,
        'formField-message-count-image-resting-color': 'rgb(255, 255, 255)',
        'formField-message-count-image-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-count-image-resting-fontSize': '0.75rem',
        'formField-message-count-image-resting-fontWeight': 'normal',
        'formField-message-count-image-resting-letterSpacing': '0em',
        'formField-message-count-image-resting-lineHeight': '1rem',
        'formField-message-count-image-resting-opacity': 0.8,
        'formField-message-description-default-error-color': 'rgb(237, 0, 7)',
        'formField-message-description-default-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-default-error-fontSize': '0.75rem',
        'formField-message-description-default-error-fontWeight': 'normal',
        'formField-message-description-default-error-letterSpacing': '0em',
        'formField-message-description-default-error-lineHeight': '1rem',
        'formField-message-description-default-error-opacity': 0.8,
        'formField-message-description-default-resting-color': 'rgb(0, 0, 0)',
        'formField-message-description-default-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-default-resting-fontSize': '0.75rem',
        'formField-message-description-default-resting-fontWeight': 'normal',
        'formField-message-description-default-resting-letterSpacing': '0em',
        'formField-message-description-default-resting-lineHeight': '1rem',
        'formField-message-description-default-resting-opacity': 0.8,
        'formField-message-description-highlighted-error-color': 'rgb(237, 0, 7)',
        'formField-message-description-highlighted-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-highlighted-error-fontSize': '0.75rem',
        'formField-message-description-highlighted-error-fontWeight': 'normal',
        'formField-message-description-highlighted-error-letterSpacing': '0em',
        'formField-message-description-highlighted-error-lineHeight': '1rem',
        'formField-message-description-highlighted-error-opacity': 0.8,
        'formField-message-description-highlighted-resting-color': 'rgb(0, 0, 0)',
        'formField-message-description-highlighted-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-highlighted-resting-fontSize': '0.75rem',
        'formField-message-description-highlighted-resting-fontWeight': 'normal',
        'formField-message-description-highlighted-resting-letterSpacing': '0em',
        'formField-message-description-highlighted-resting-lineHeight': '1rem',
        'formField-message-description-highlighted-resting-opacity': 0.8,
        'formField-message-description-image-error-color': 'rgb(237, 0, 7)',
        'formField-message-description-image-error-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-image-error-fontSize': '0.75rem',
        'formField-message-description-image-error-fontWeight': 'normal',
        'formField-message-description-image-error-letterSpacing': '0em',
        'formField-message-description-image-error-lineHeight': '1rem',
        'formField-message-description-image-error-opacity': 0.8,
        'formField-message-description-image-resting-color': 'rgb(255, 255, 255)',
        'formField-message-description-image-resting-fontFamily': 'Bosch Sans, sans-serif',
        'formField-message-description-image-resting-fontSize': '0.75rem',
        'formField-message-description-image-resting-fontWeight': 'normal',
        'formField-message-description-image-resting-letterSpacing': '0em',
        'formField-message-description-image-resting-lineHeight': '1rem',
        'formField-message-description-image-resting-opacity': 0.8,
        'gallery-backgroundColor-default': 'rgb(255, 255, 255)',
        'gallery-badgeList-gap': '1rem',
        'gallery-base-lg-gap': '2rem',
        'gallery-base-md-gap': '2rem',
        'gallery-base-sm-gap': '2rem',
        'gallery-borderColor-default': 'rgb(239, 241, 242)',
        'gallery-borderColor-selected': 'rgb(0, 123, 192)',
        'gallery-content-base-lg-gap': '2rem',
        'gallery-content-base-lg-paddingLeft': '3rem',
        'gallery-content-base-lg-paddingRight': '3rem',
        'gallery-content-base-lg-paddingTop': '4rem',
        'gallery-content-base-md-gap': '2rem',
        'gallery-content-base-md-paddingLeft': '2rem',
        'gallery-content-base-md-paddingRight': '2rem',
        'gallery-content-base-md-paddingTop': '4rem',
        'gallery-content-base-sm-gap': '1.5rem',
        'gallery-content-base-sm-paddingLeft': '1rem',
        'gallery-content-base-sm-paddingRight': '1rem',
        'gallery-content-base-sm-paddingTop': '3rem',
        'gallery-content-slider-slide-base-lg-gap': '2rem',
        'gallery-content-slider-slide-base-md-gap': '1.5rem',
        'gallery-content-slider-slide-base-sm-gap': '1rem',
        'gallery-content-slider-slide-caption-color': 'rgb(0, 0, 0)',
        'gallery-content-slider-slide-caption-fontFamily': 'Bosch Sans, sans-serif',
        'gallery-content-slider-slide-caption-fontSize': '0.75rem',
        'gallery-content-slider-slide-caption-fontWeight': 'normal',
        'gallery-content-slider-slide-caption-letterSpacing': '0em',
        'gallery-content-slider-slide-caption-lineHeight': '1rem',
        'gallery-navigation-gap': '1.5rem',
        'gallery-selectColor-default': 'rgba(0, 0, 0, 0)',
        'gallery-thumbList-base-lg-gap': '1rem',
        'gallery-thumbList-base-lg-paddingLeft': '3rem',
        'gallery-thumbList-base-lg-paddingRight': '3rem',
        'gallery-thumbList-base-md-gap': '0.75rem',
        'gallery-thumbList-base-md-paddingLeft': '2rem',
        'gallery-thumbList-base-md-paddingRight': '2rem',
        'gallery-thumbList-base-sm-gap': '0.5rem',
        'gallery-thumbList-base-sm-paddingLeft': '1rem',
        'gallery-thumbList-base-sm-paddingRight': '1rem',
        'gallery-thumbList-thumb-lg-active-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-active-hover-borderColor': 'rgb(0, 98, 154)',
        'gallery-thumbList-thumb-lg-active-hover-borderRadius': '0',
        'gallery-thumbList-thumb-lg-active-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-active-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-active-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-lg-active-hover-height': '8rem',
        'gallery-thumbList-thumb-lg-active-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-active-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-active-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-active-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-active-hover-width': '13rem',
        'gallery-thumbList-thumb-lg-active-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-active-initial-borderColor': 'rgb(0, 123, 192)',
        'gallery-thumbList-thumb-lg-active-initial-borderRadius': '0',
        'gallery-thumbList-thumb-lg-active-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-active-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-active-initial-filter': 'none',
        'gallery-thumbList-thumb-lg-active-initial-height': '8rem',
        'gallery-thumbList-thumb-lg-active-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-active-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-active-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-active-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-active-initial-width': '13rem',
        'gallery-thumbList-thumb-lg-active-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-active-pressed-borderColor': 'rgb(0, 73, 117)',
        'gallery-thumbList-thumb-lg-active-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-lg-active-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-active-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-active-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-lg-active-pressed-height': '8rem',
        'gallery-thumbList-thumb-lg-active-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-active-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-active-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-active-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-active-pressed-width': '13rem',
        'gallery-thumbList-thumb-lg-inactive-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-inactive-hover-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-lg-inactive-hover-borderRadius': '0',
        'gallery-thumbList-thumb-lg-inactive-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-inactive-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-inactive-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-lg-inactive-hover-height': '8rem',
        'gallery-thumbList-thumb-lg-inactive-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-hover-width': '13rem',
        'gallery-thumbList-thumb-lg-inactive-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-inactive-initial-borderColor': 'rgb(239, 241, 242)',
        'gallery-thumbList-thumb-lg-inactive-initial-borderRadius': '0',
        'gallery-thumbList-thumb-lg-inactive-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-inactive-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-inactive-initial-filter': 'none',
        'gallery-thumbList-thumb-lg-inactive-initial-height': '8rem',
        'gallery-thumbList-thumb-lg-inactive-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-initial-width': '13rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-lg-inactive-pressed-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-lg-inactive-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-lg-inactive-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-lg-inactive-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-lg-inactive-pressed-height': '8rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-lg-inactive-pressed-width': '13rem',
        'gallery-thumbList-thumb-md-active-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-active-hover-borderColor': 'rgb(0, 98, 154)',
        'gallery-thumbList-thumb-md-active-hover-borderRadius': '0',
        'gallery-thumbList-thumb-md-active-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-active-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-active-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-md-active-hover-height': '6rem',
        'gallery-thumbList-thumb-md-active-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-active-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-active-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-active-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-active-hover-width': '9.75rem',
        'gallery-thumbList-thumb-md-active-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-active-initial-borderColor': 'rgb(0, 123, 192)',
        'gallery-thumbList-thumb-md-active-initial-borderRadius': '0',
        'gallery-thumbList-thumb-md-active-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-active-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-active-initial-filter': 'none',
        'gallery-thumbList-thumb-md-active-initial-height': '6rem',
        'gallery-thumbList-thumb-md-active-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-active-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-active-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-active-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-active-initial-width': '9.75rem',
        'gallery-thumbList-thumb-md-active-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-active-pressed-borderColor': 'rgb(0, 73, 117)',
        'gallery-thumbList-thumb-md-active-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-md-active-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-active-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-active-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-md-active-pressed-height': '6rem',
        'gallery-thumbList-thumb-md-active-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-active-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-active-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-active-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-active-pressed-width': '9.75rem',
        'gallery-thumbList-thumb-md-inactive-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-inactive-hover-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-md-inactive-hover-borderRadius': '0',
        'gallery-thumbList-thumb-md-inactive-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-inactive-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-inactive-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-md-inactive-hover-height': '6rem',
        'gallery-thumbList-thumb-md-inactive-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-hover-width': '9.75rem',
        'gallery-thumbList-thumb-md-inactive-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-inactive-initial-borderColor': 'rgb(239, 241, 242)',
        'gallery-thumbList-thumb-md-inactive-initial-borderRadius': '0',
        'gallery-thumbList-thumb-md-inactive-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-inactive-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-inactive-initial-filter': 'none',
        'gallery-thumbList-thumb-md-inactive-initial-height': '6rem',
        'gallery-thumbList-thumb-md-inactive-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-initial-width': '9.75rem',
        'gallery-thumbList-thumb-md-inactive-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-md-inactive-pressed-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-md-inactive-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-md-inactive-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-md-inactive-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-md-inactive-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-md-inactive-pressed-height': '6rem',
        'gallery-thumbList-thumb-md-inactive-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-md-inactive-pressed-width': '9.75rem',
        'gallery-thumbList-thumb-sm-active-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-active-hover-borderColor': 'rgb(0, 98, 154)',
        'gallery-thumbList-thumb-sm-active-hover-borderRadius': '0',
        'gallery-thumbList-thumb-sm-active-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-active-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-active-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-sm-active-hover-height': '5rem',
        'gallery-thumbList-thumb-sm-active-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-active-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-active-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-active-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-active-hover-width': '8rem',
        'gallery-thumbList-thumb-sm-active-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-active-initial-borderColor': 'rgb(0, 123, 192)',
        'gallery-thumbList-thumb-sm-active-initial-borderRadius': '0',
        'gallery-thumbList-thumb-sm-active-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-active-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-active-initial-filter': 'none',
        'gallery-thumbList-thumb-sm-active-initial-height': '5rem',
        'gallery-thumbList-thumb-sm-active-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-active-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-active-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-active-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-active-initial-width': '8rem',
        'gallery-thumbList-thumb-sm-active-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-active-pressed-borderColor': 'rgb(0, 73, 117)',
        'gallery-thumbList-thumb-sm-active-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-sm-active-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-active-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-active-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-sm-active-pressed-height': '5rem',
        'gallery-thumbList-thumb-sm-active-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-active-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-active-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-active-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-active-pressed-width': '8rem',
        'gallery-thumbList-thumb-sm-inactive-hover-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-inactive-hover-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-sm-inactive-hover-borderRadius': '0',
        'gallery-thumbList-thumb-sm-inactive-hover-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-inactive-hover-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-inactive-hover-filter': 'brightness(0.96) contrast(1)',
        'gallery-thumbList-thumb-sm-inactive-hover-height': '5rem',
        'gallery-thumbList-thumb-sm-inactive-hover-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-hover-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-hover-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-hover-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-hover-width': '8rem',
        'gallery-thumbList-thumb-sm-inactive-initial-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-inactive-initial-borderColor': 'rgb(239, 241, 242)',
        'gallery-thumbList-thumb-sm-inactive-initial-borderRadius': '0',
        'gallery-thumbList-thumb-sm-inactive-initial-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-inactive-initial-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-inactive-initial-filter': 'none',
        'gallery-thumbList-thumb-sm-inactive-initial-height': '5rem',
        'gallery-thumbList-thumb-sm-inactive-initial-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-initial-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-initial-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-initial-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-initial-width': '8rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-background': 'rgb(255, 255, 255)',
        'gallery-thumbList-thumb-sm-inactive-pressed-borderColor': 'rgb(224, 226, 229)',
        'gallery-thumbList-thumb-sm-inactive-pressed-borderRadius': '0',
        'gallery-thumbList-thumb-sm-inactive-pressed-borderStyle': 'solid',
        'gallery-thumbList-thumb-sm-inactive-pressed-borderWidth': '0.125rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-filter': 'brightness(0.94) contrast(1)',
        'gallery-thumbList-thumb-sm-inactive-pressed-height': '5rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-paddingBottom': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-paddingLeft': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-paddingRight': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-paddingTop': '0.5rem',
        'gallery-thumbList-thumb-sm-inactive-pressed-width': '8rem',
        'grid-base-lg-gap': '1.5rem',
        'grid-base-sm-gap': '1rem',
        'grid-divider-background': 'rgb(224, 226, 229)',
        'grid-divider-borderRadius': '624.9375rem',
        'grid-divider-minHeight': '0.0625rem',
        'grid-divider-minWidth': '0.0625rem',
        'grid-row-base-lg-gap': '1.5rem',
        'grid-row-base-sm-gap': '1rem',
        'headerFlyout-bar-base-lg-gap': '3rem',
        'headerFlyout-bar-base-lg-paddingLeft': '3rem',
        'headerFlyout-bar-base-lg-paddingRight': '3rem',
        'headerFlyout-bar-base-md-gap': '2rem',
        'headerFlyout-bar-base-md-paddingLeft': '2rem',
        'headerFlyout-bar-base-md-paddingRight': '2rem',
        'headerFlyout-bar-base-sm-gap': '1rem',
        'headerFlyout-bar-base-sm-paddingLeft': '1rem',
        'headerFlyout-bar-base-sm-paddingRight': '1rem',
        'headerFlyout-bar-buttonAction-lg-maxWidth': '11.1875rem',
        'headerFlyout-bar-input-base-lg-maxWidth': '76.5rem',
        'headerFlyout-bar-input-base-lg-paddingLeft': '1rem',
        'headerFlyout-bar-input-base-lg-paddingRight': '1rem',
        'headerFlyout-bar-input-base-sm-maxWidth': 'auto',
        'headerFlyout-base-lg-background': 'rgb(255, 255, 255)',
        'headerFlyout-base-lg-gap': '1rem',
        'headerFlyout-base-lg-paddingBottom': '5rem',
        'headerFlyout-base-lg-paddingTop': '2rem',
        'headerFlyout-base-md-background': 'rgb(255, 255, 255)',
        'headerFlyout-base-md-gap': '1rem',
        'headerFlyout-base-md-paddingBottom': '4rem',
        'headerFlyout-base-md-paddingTop': '2rem',
        'headerFlyout-base-sm-background': 'rgb(255, 255, 255)',
        'headerFlyout-base-sm-gap': '1.5rem',
        'headerFlyout-base-sm-paddingBottom': '2rem',
        'headerFlyout-base-sm-paddingTop': '1rem',
        'headerFlyout-content-information-base-lg-gap': '4rem',
        'headerFlyout-content-information-base-lg-maxWidth': '78.5rem',
        'headerFlyout-content-information-base-lg-paddingLeft': '3rem',
        'headerFlyout-content-information-base-lg-paddingRight': '3rem',
        'headerFlyout-content-information-base-md-gap': '3rem',
        'headerFlyout-content-information-base-md-paddingLeft': '2rem',
        'headerFlyout-content-information-base-md-paddingRight': '2rem',
        'headerFlyout-content-information-base-sm-gap': '2rem',
        'headerFlyout-content-information-base-sm-paddingLeft': '1rem',
        'headerFlyout-content-information-base-sm-paddingRight': '1rem',
        'headerFlyout-content-information-item-base-gap': '1.5rem',
        'headerFlyout-content-information-item-base-maxWidth': '28rem',
        'headerFlyout-content-information-item-content-base-gap': '0.75rem',
        'headerFlyout-content-information-item-content-description-color': 'rgb(0, 0, 0)',
        'headerFlyout-content-information-item-content-description-fontFamily': 'Bosch Sans, sans-serif',
        'headerFlyout-content-information-item-content-description-fontSize': '0.875rem',
        'headerFlyout-content-information-item-content-description-fontWeight': 'normal',
        'headerFlyout-content-information-item-content-description-letterSpacing': '0em',
        'headerFlyout-content-information-item-content-description-lineHeight': '1.25rem',
        'headerFlyout-content-information-item-content-description-opacity': 0.8,
        'headerFlyout-content-information-item-content-headline-color': 'rgb(0, 0, 0)',
        'headerFlyout-content-information-item-content-headline-fontFamily': 'Bosch Sans, sans-serif',
        'headerFlyout-content-information-item-content-headline-fontSize': '1.25rem',
        'headerFlyout-content-information-item-content-headline-fontWeight': 'normal',
        'headerFlyout-content-information-item-content-headline-letterSpacing': '0em',
        'headerFlyout-content-information-item-content-headline-lineHeight': '1.75rem',
        'headerFlyout-content-information-item-content-headline-opacity': 1,
        'headerFlyout-content-results-base-lg-gap': '2rem',
        'headerFlyout-content-results-base-lg-maxWidth': '78.5rem',
        'headerFlyout-content-results-base-lg-paddingLeft': '2.5rem',
        'headerFlyout-content-results-base-lg-paddingRight': '3rem',
        'headerFlyout-content-results-base-lg-paddingTop': '3rem',
        'headerFlyout-content-results-base-md-gap': '2rem',
        'headerFlyout-content-results-base-md-paddingLeft': '1.5rem',
        'headerFlyout-content-results-base-md-paddingRight': '1.5rem',
        'headerFlyout-content-results-base-md-paddingTop': '2rem',
        'headerFlyout-content-results-base-sm-gap': '1.5rem',
        'headerFlyout-content-results-base-sm-paddingLeft': '0.5rem',
        'headerFlyout-content-results-base-sm-paddingRight': '0.5rem',
        'headerFlyout-content-results-base-sm-paddingTop': '1rem',
        'headerFlyout-content-results-section-base-lg-gap': '1rem',
        'headerFlyout-content-results-section-base-sm-gap': '0.5rem',
        'headerFlyout-content-results-section-content-keywordList-lg-gap': '0.25rem',
        'headerFlyout-content-results-section-content-keywordList-sm-gap': '0',
        'headerFlyout-content-results-section-content-productGrid-base-lg-gap': '1rem',
        'headerFlyout-content-results-section-content-productGrid-base-lg-paddingTop': '0.5rem',
        'headerFlyout-content-results-section-content-productGrid-base-sm-gap': '1rem',
        'headerFlyout-content-results-section-content-productGrid-base-sm-paddingTop': '0',
        'headerFlyout-content-results-section-content-productGrid-row-lg-gap': '1rem',
        'headerFlyout-content-results-section-content-productGrid-row-sm-gap': '1rem',
        'headerFlyout-content-results-section-header-base-default-gap': '1rem',
        'headerFlyout-content-results-section-header-base-default-paddingLeft': '0',
        'headerFlyout-content-results-section-header-base-indented-gap': '1rem',
        'headerFlyout-content-results-section-header-base-indented-paddingLeft': '0.5rem',
        'headerFlyout-content-results-section-header-headline-color': 'rgb(0, 0, 0)',
        'headerFlyout-content-results-section-header-headline-fontFamily': 'Bosch Sans, sans-serif',
        'headerFlyout-content-results-section-header-headline-fontSize': '1rem',
        'headerFlyout-content-results-section-header-headline-fontWeight': 'bold',
        'headerFlyout-content-results-section-header-headline-letterSpacing': '0em',
        'headerFlyout-content-results-section-header-headline-lineHeight': '1.5rem',
        'headerFlyout-content-results-section-header-headline-opacity': 1,
        'headerFlyout-content-results-suggestions-base-lg-gap': '2rem',
        'headerFlyout-content-results-suggestions-base-sm-gap': '1rem',
        'headline-large-level1-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level1-fontSize': '2.625rem',
        'headline-large-level1-fontWeight': 'bold',
        'headline-large-level1-letterSpacing': '0em',
        'headline-large-level1-lineHeight': '3.5rem',
        'headline-large-level2-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level2-fontSize': '2.25rem',
        'headline-large-level2-fontWeight': 'bold',
        'headline-large-level2-letterSpacing': '0em',
        'headline-large-level2-lineHeight': '2.75rem',
        'headline-large-level3-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level3-fontSize': '2rem',
        'headline-large-level3-fontWeight': 'bold',
        'headline-large-level3-letterSpacing': '0em',
        'headline-large-level3-lineHeight': '2.5rem',
        'headline-large-level4-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level4-fontSize': '1.75rem',
        'headline-large-level4-fontWeight': 'bold',
        'headline-large-level4-letterSpacing': '0em',
        'headline-large-level4-lineHeight': '2.25rem',
        'headline-large-level5-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level5-fontSize': '1.5rem',
        'headline-large-level5-fontWeight': 'bold',
        'headline-large-level5-letterSpacing': '0em',
        'headline-large-level5-lineHeight': '2rem',
        'headline-large-level6-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level6-fontSize': '1.25rem',
        'headline-large-level6-fontWeight': 'bold',
        'headline-large-level6-letterSpacing': '0em',
        'headline-large-level6-lineHeight': '1.75rem',
        'headline-large-level7-fontFamily': 'Bosch Sans, sans-serif',
        'headline-large-level7-fontSize': '1rem',
        'headline-large-level7-fontWeight': 'bold',
        'headline-large-level7-letterSpacing': '0em',
        'headline-large-level7-lineHeight': '1.5rem',
        'headline-small-level1-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level1-fontSize': '2.25rem',
        'headline-small-level1-fontWeight': 'bold',
        'headline-small-level1-letterSpacing': '0em',
        'headline-small-level1-lineHeight': '2.75rem',
        'headline-small-level2-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level2-fontSize': '2rem',
        'headline-small-level2-fontWeight': 'bold',
        'headline-small-level2-letterSpacing': '0em',
        'headline-small-level2-lineHeight': '2.5rem',
        'headline-small-level3-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level3-fontSize': '1.75rem',
        'headline-small-level3-fontWeight': 'bold',
        'headline-small-level3-letterSpacing': '0em',
        'headline-small-level3-lineHeight': '2.25rem',
        'headline-small-level4-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level4-fontSize': '1.5rem',
        'headline-small-level4-fontWeight': 'bold',
        'headline-small-level4-letterSpacing': '0em',
        'headline-small-level4-lineHeight': '2rem',
        'headline-small-level5-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level5-fontSize': '1.25rem',
        'headline-small-level5-fontWeight': 'bold',
        'headline-small-level5-letterSpacing': '0em',
        'headline-small-level5-lineHeight': '1.75rem',
        'headline-small-level6-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level6-fontSize': '1rem',
        'headline-small-level6-fontWeight': 'bold',
        'headline-small-level6-letterSpacing': '0em',
        'headline-small-level6-lineHeight': '1.5rem',
        'headline-small-level7-fontFamily': 'Bosch Sans, sans-serif',
        'headline-small-level7-fontSize': '0.875rem',
        'headline-small-level7-fontWeight': 'bold',
        'headline-small-level7-letterSpacing': '0em',
        'headline-small-level7-lineHeight': '1.25rem',
        'highlightOfferBadge-base-center-background': 'rgba(0, 0, 0, 0)',
        'highlightOfferBadge-base-center-borderBottomWidth': '0.0625rem',
        'highlightOfferBadge-base-center-borderColor': 'rgb(158, 40, 150)',
        'highlightOfferBadge-base-center-borderLeftWidth': '0.0625rem',
        'highlightOfferBadge-base-center-borderRadius': '0',
        'highlightOfferBadge-base-center-borderRightWidth': '0.0625rem',
        'highlightOfferBadge-base-center-borderStyle': 'solid',
        'highlightOfferBadge-base-center-borderTopWidth': '0.5rem',
        'highlightOfferBadge-base-center-paddingBottom': '1rem',
        'highlightOfferBadge-base-center-paddingLeft': '1rem',
        'highlightOfferBadge-base-center-paddingRight': '1rem',
        'highlightOfferBadge-base-center-paddingTop': '1rem',
        'highlightOfferBadge-base-left-background': 'rgba(0, 0, 0, 0)',
        'highlightOfferBadge-base-left-borderBottomWidth': '0.0625rem',
        'highlightOfferBadge-base-left-borderColor': 'rgb(158, 40, 150)',
        'highlightOfferBadge-base-left-borderLeftWidth': '0.5rem',
        'highlightOfferBadge-base-left-borderRadius': '0',
        'highlightOfferBadge-base-left-borderRightWidth': '0.0625rem',
        'highlightOfferBadge-base-left-borderStyle': 'solid',
        'highlightOfferBadge-base-left-borderTopWidth': '0.0625rem',
        'highlightOfferBadge-base-left-paddingBottom': '1rem',
        'highlightOfferBadge-base-left-paddingLeft': '1rem',
        'highlightOfferBadge-base-left-paddingRight': '1rem',
        'highlightOfferBadge-base-left-paddingTop': '1rem',
        'highlightOfferBadge-text-color': 'rgb(158, 40, 150)',
        'highlightOfferBadge-text-fontFamily': 'Bosch Sans, sans-serif',
        'highlightOfferBadge-text-fontSize': '0.75rem',
        'highlightOfferBadge-text-fontWeight': 'normal',
        'highlightOfferBadge-text-letterSpacing': '0em',
        'highlightOfferBadge-text-lineHeight': '1rem',
        'highlightOfferBadge-text-opacity': 1,
        'highlightWrapper-lg-background': 'rgb(239, 241, 242)',
        'highlightWrapper-lg-paddingBottom': '5rem',
        'highlightWrapper-lg-paddingTop': '5rem',
        'highlightWrapper-md-background': 'rgb(239, 241, 242)',
        'highlightWrapper-md-paddingBottom': '4rem',
        'highlightWrapper-md-paddingTop': '4rem',
        'highlightWrapper-sm-background': 'rgb(239, 241, 242)',
        'highlightWrapper-sm-paddingBottom': '3rem',
        'highlightWrapper-sm-paddingTop': '3rem',
        'hint-base-background': 'rgb(239, 241, 242)',
        'hint-base-borderRadius': '0',
        'hint-base-paddingBottom': '0.75rem',
        'hint-base-paddingLeft': '1rem',
        'hint-base-paddingRight': '1rem',
        'hint-base-paddingTop': '0.75rem',
        'hint-content-base-gap': '0.75rem',
        'hint-content-description-color': 'rgb(0, 0, 0)',
        'hint-content-description-fontFamily': 'Bosch Sans, sans-serif',
        'hint-content-description-fontSize': '0.875rem',
        'hint-content-description-fontWeight': 'normal',
        'hint-content-description-letterSpacing': '0em',
        'hint-content-description-lineHeight': '1.25rem',
        'hint-content-icon-background': 'rgb(0, 0, 0)',
        'imageStage-base-lg-gap': '3rem',
        'imageStage-base-lg-paddingBottom': '5rem',
        'imageStage-base-lg-paddingLeft': '3rem',
        'imageStage-base-lg-paddingRight': '3rem',
        'imageStage-base-lg-paddingTop': '5rem',
        'imageStage-base-md-background': 'linear-gradient(90deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
        'imageStage-base-md-gap': '2rem',
        'imageStage-base-md-paddingBottom': '4rem',
        'imageStage-base-md-paddingLeft': '2rem',
        'imageStage-base-md-paddingRight': '2rem',
        'imageStage-base-md-paddingTop': '4rem',
        'imageStage-base-sm-gap': '1.5rem',
        'imageStage-base-sm-paddingBottom': '3rem',
        'imageStage-base-sm-paddingLeft': '1rem',
        'imageStage-base-sm-paddingRight': '1rem',
        'imageStage-base-sm-paddingTop': '3rem',
        'imageStage-content-base-lg-gap': '3rem',
        'imageStage-content-base-md-gap': '2rem',
        'imageStage-content-base-sm-gap': '1.5rem',
        'imageStage-content-title-base-lg-gap': '0.75rem',
        'imageStage-content-title-base-md-gap': '0.75rem',
        'imageStage-content-title-base-sm-gap': '0.5rem',
        'imageStage-content-title-description-default-lg-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-default-lg-fontSize': '1.75rem',
        'imageStage-content-title-description-default-lg-fontWeight': 'bold',
        'imageStage-content-title-description-default-lg-letterSpacing': '0em',
        'imageStage-content-title-description-default-lg-lineHeight': '2.25rem',
        'imageStage-content-title-description-default-md-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-default-md-fontSize': '1.5rem',
        'imageStage-content-title-description-default-md-fontWeight': 'bold',
        'imageStage-content-title-description-default-md-letterSpacing': '0em',
        'imageStage-content-title-description-default-md-lineHeight': '2rem',
        'imageStage-content-title-description-default-sm-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-default-sm-fontSize': '1.25rem',
        'imageStage-content-title-description-default-sm-fontWeight': 'bold',
        'imageStage-content-title-description-default-sm-letterSpacing': '0em',
        'imageStage-content-title-description-default-sm-lineHeight': '1.75rem',
        'imageStage-content-title-description-prominent-lg-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-prominent-lg-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-prominent-lg-fontSize': '2rem',
        'imageStage-content-title-description-prominent-lg-fontWeight': 'bold',
        'imageStage-content-title-description-prominent-lg-letterSpacing': '0em',
        'imageStage-content-title-description-prominent-lg-lineHeight': '2.5rem',
        'imageStage-content-title-description-prominent-md-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-prominent-md-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-prominent-md-fontSize': '1.75rem',
        'imageStage-content-title-description-prominent-md-fontWeight': 'bold',
        'imageStage-content-title-description-prominent-md-letterSpacing': '0em',
        'imageStage-content-title-description-prominent-md-lineHeight': '2.25rem',
        'imageStage-content-title-description-prominent-sm-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-description-prominent-sm-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-description-prominent-sm-fontSize': '1.5rem',
        'imageStage-content-title-description-prominent-sm-fontWeight': 'bold',
        'imageStage-content-title-description-prominent-sm-letterSpacing': '0em',
        'imageStage-content-title-description-prominent-sm-lineHeight': '2rem',
        'imageStage-content-title-headline-default-lg-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-default-lg-fontSize': '4rem',
        'imageStage-content-title-headline-default-lg-fontWeight': 'bold',
        'imageStage-content-title-headline-default-lg-letterSpacing': '0em',
        'imageStage-content-title-headline-default-lg-lineHeight': '4.5rem',
        'imageStage-content-title-headline-default-md-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-default-md-fontSize': '2.625rem',
        'imageStage-content-title-headline-default-md-fontWeight': 'bold',
        'imageStage-content-title-headline-default-md-letterSpacing': '0em',
        'imageStage-content-title-headline-default-md-lineHeight': '3.5rem',
        'imageStage-content-title-headline-default-sm-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-default-sm-fontSize': '2.25rem',
        'imageStage-content-title-headline-default-sm-fontWeight': 'bold',
        'imageStage-content-title-headline-default-sm-letterSpacing': '0em',
        'imageStage-content-title-headline-default-sm-lineHeight': '2.75rem',
        'imageStage-content-title-headline-prominent-lg-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-prominent-lg-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-prominent-lg-fontSize': '7.5rem',
        'imageStage-content-title-headline-prominent-lg-fontWeight': 'bold',
        'imageStage-content-title-headline-prominent-lg-letterSpacing': '0em',
        'imageStage-content-title-headline-prominent-lg-lineHeight': '8.5rem',
        'imageStage-content-title-headline-prominent-md-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-prominent-md-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-prominent-md-fontSize': '5rem',
        'imageStage-content-title-headline-prominent-md-fontWeight': 'bold',
        'imageStage-content-title-headline-prominent-md-letterSpacing': '0em',
        'imageStage-content-title-headline-prominent-md-lineHeight': '6rem',
        'imageStage-content-title-headline-prominent-sm-color': 'rgb(255, 255, 255)',
        'imageStage-content-title-headline-prominent-sm-fontFamily': 'Bosch Sans, sans-serif',
        'imageStage-content-title-headline-prominent-sm-fontSize': '4rem',
        'imageStage-content-title-headline-prominent-sm-fontWeight': 'bold',
        'imageStage-content-title-headline-prominent-sm-letterSpacing': '0em',
        'imageStage-content-title-headline-prominent-sm-lineHeight': '4.5rem',
        'imageStage-gradient-lg-background': 'linear-gradient(90deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
        'imageStage-gradient-md-background': 'linear-gradient(90deg, #00000099 0%, #0000000d 50%, #0000000d 100%);',
        'imageStage-gradient-sm-background': 'linear-gradient(180deg, #0000000d 0%, #0000000d 50%, #00000099 100%);',
        'infoLabel-base-lg-gap': '-0.25rem',
        'infoLabel-base-lg-height': '1.25rem',
        'infoLabel-base-sm-gap': '-0.25rem',
        'infoLabel-base-sm-height': '1rem',
        'infoLabel-headline-default-lg-color': 'rgb(0, 0, 0)',
        'infoLabel-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'infoLabel-headline-default-lg-fontSize': '0.875rem',
        'infoLabel-headline-default-lg-fontWeight': 'bold',
        'infoLabel-headline-default-lg-letterSpacing': '0em',
        'infoLabel-headline-default-lg-lineHeight': '1.25rem',
        'infoLabel-headline-default-sm-color': 'rgb(0, 0, 0)',
        'infoLabel-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'infoLabel-headline-default-sm-fontSize': '0.75rem',
        'infoLabel-headline-default-sm-fontWeight': 'bold',
        'infoLabel-headline-default-sm-letterSpacing': '0em',
        'infoLabel-headline-default-sm-lineHeight': '1rem',
        'infoLabel-headline-highlighted-lg-color': 'rgb(0, 0, 0)',
        'infoLabel-headline-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'infoLabel-headline-highlighted-lg-fontSize': '0.875rem',
        'infoLabel-headline-highlighted-lg-fontWeight': 'bold',
        'infoLabel-headline-highlighted-lg-letterSpacing': '0em',
        'infoLabel-headline-highlighted-lg-lineHeight': '1.25rem',
        'infoLabel-headline-highlighted-sm-color': 'rgb(0, 0, 0)',
        'infoLabel-headline-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'infoLabel-headline-highlighted-sm-fontSize': '0.75rem',
        'infoLabel-headline-highlighted-sm-fontWeight': 'bold',
        'infoLabel-headline-highlighted-sm-letterSpacing': '0em',
        'infoLabel-headline-highlighted-sm-lineHeight': '1rem',
        'infoLabel-iconWrapper-base-default-hover-background': 'rgba(0, 0, 0, 0.1)',
        'infoLabel-iconWrapper-base-default-hover-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-default-hover-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-default-hover-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-default-hover-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-default-hover-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-base-default-initial-background': 'rgba(0, 0, 0, 0)',
        'infoLabel-iconWrapper-base-default-initial-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-default-initial-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-default-initial-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-default-initial-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-default-initial-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-base-default-pressed-background': 'rgba(0, 0, 0, 0.05)',
        'infoLabel-iconWrapper-base-default-pressed-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-default-pressed-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-default-pressed-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-default-pressed-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-default-pressed-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-hover-background': 'rgba(0, 0, 0, 0.1)',
        'infoLabel-iconWrapper-base-highlighted-hover-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-highlighted-hover-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-hover-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-hover-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-hover-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-initial-background': 'rgba(0, 0, 0, 0)',
        'infoLabel-iconWrapper-base-highlighted-initial-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-highlighted-initial-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-initial-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-initial-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-initial-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-pressed-background': 'rgba(0, 0, 0, 0.05)',
        'infoLabel-iconWrapper-base-highlighted-pressed-borderRadius': '624.9375rem',
        'infoLabel-iconWrapper-base-highlighted-pressed-paddingBottom': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-pressed-paddingLeft': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-pressed-paddingRight': '0.5rem',
        'infoLabel-iconWrapper-base-highlighted-pressed-paddingTop': '0.5rem',
        'infoLabel-iconWrapper-icon-default-hover-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-default-hover-opacity': 0.8,
        'infoLabel-iconWrapper-icon-default-initial-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-default-initial-opacity': 1,
        'infoLabel-iconWrapper-icon-default-pressed-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-default-pressed-opacity': 0.65,
        'infoLabel-iconWrapper-icon-highlighted-hover-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-highlighted-hover-opacity': 0.8,
        'infoLabel-iconWrapper-icon-highlighted-initial-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-highlighted-initial-opacity': 1,
        'infoLabel-iconWrapper-icon-highlighted-pressed-background': 'rgb(0, 0, 0)',
        'infoLabel-iconWrapper-icon-highlighted-pressed-opacity': 0.65,
        'input-base-lg-error-filled-background': 'rgb(224, 226, 229)',
        'input-base-lg-error-filled-borderBottomLeftRadius': '0',
        'input-base-lg-error-filled-borderBottomRightRadius': '0',
        'input-base-lg-error-filled-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-filled-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-filled-borderLeftWidth': '0',
        'input-base-lg-error-filled-borderRightWidth': '0',
        'input-base-lg-error-filled-borderStyle': 'solid',
        'input-base-lg-error-filled-borderTopLeftRadius': '0',
        'input-base-lg-error-filled-borderTopRightRadius': '0',
        'input-base-lg-error-filled-borderTopWidth': '0',
        'input-base-lg-error-filled-disabled-background': 'rgb(224, 226, 229)',
        'input-base-lg-error-filled-disabled-borderBottomLeftRadius': '0',
        'input-base-lg-error-filled-disabled-borderBottomRightRadius': '0',
        'input-base-lg-error-filled-disabled-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-filled-disabled-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-filled-disabled-borderLeftWidth': '0',
        'input-base-lg-error-filled-disabled-borderRightWidth': '0',
        'input-base-lg-error-filled-disabled-borderStyle': 'solid',
        'input-base-lg-error-filled-disabled-borderTopLeftRadius': '0',
        'input-base-lg-error-filled-disabled-borderTopRightRadius': '0',
        'input-base-lg-error-filled-disabled-borderTopWidth': '0',
        'input-base-lg-error-filled-disabled-height': '4rem',
        'input-base-lg-error-filled-disabled-paddingLeft': '0.75rem',
        'input-base-lg-error-filled-disabled-paddingRight': '0.75rem',
        'input-base-lg-error-filled-height': '4rem',
        'input-base-lg-error-filled-paddingLeft': '0.75rem',
        'input-base-lg-error-filled-paddingRight': '0.75rem',
        'input-base-lg-error-focused-background': 'rgb(209, 228, 255)',
        'input-base-lg-error-focused-borderBottomLeftRadius': '0',
        'input-base-lg-error-focused-borderBottomRightRadius': '0',
        'input-base-lg-error-focused-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-focused-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-focused-borderLeftWidth': '0',
        'input-base-lg-error-focused-borderRightWidth': '0',
        'input-base-lg-error-focused-borderStyle': 'solid',
        'input-base-lg-error-focused-borderTopLeftRadius': '0',
        'input-base-lg-error-focused-borderTopRightRadius': '0',
        'input-base-lg-error-focused-borderTopWidth': '0',
        'input-base-lg-error-focused-height': '4rem',
        'input-base-lg-error-focused-paddingLeft': '0.75rem',
        'input-base-lg-error-focused-paddingRight': '0.75rem',
        'input-base-lg-error-hover-background': 'rgb(193, 199, 204)',
        'input-base-lg-error-hover-borderBottomLeftRadius': '0',
        'input-base-lg-error-hover-borderBottomRightRadius': '0',
        'input-base-lg-error-hover-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-hover-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-hover-borderLeftWidth': '0',
        'input-base-lg-error-hover-borderRightWidth': '0',
        'input-base-lg-error-hover-borderStyle': 'solid',
        'input-base-lg-error-hover-borderTopLeftRadius': '0',
        'input-base-lg-error-hover-borderTopRightRadius': '0',
        'input-base-lg-error-hover-borderTopWidth': '0',
        'input-base-lg-error-hover-height': '4rem',
        'input-base-lg-error-hover-paddingLeft': '0.75rem',
        'input-base-lg-error-hover-paddingRight': '0.75rem',
        'input-base-lg-error-initial-background': 'rgb(224, 226, 229)',
        'input-base-lg-error-initial-borderBottomLeftRadius': '0',
        'input-base-lg-error-initial-borderBottomRightRadius': '0',
        'input-base-lg-error-initial-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-initial-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-initial-borderLeftWidth': '0',
        'input-base-lg-error-initial-borderRightWidth': '0',
        'input-base-lg-error-initial-borderStyle': 'solid',
        'input-base-lg-error-initial-borderTopLeftRadius': '0',
        'input-base-lg-error-initial-borderTopRightRadius': '0',
        'input-base-lg-error-initial-borderTopWidth': '0',
        'input-base-lg-error-initial-disabled-background': 'rgb(224, 226, 229)',
        'input-base-lg-error-initial-disabled-borderBottomLeftRadius': '0',
        'input-base-lg-error-initial-disabled-borderBottomRightRadius': '0',
        'input-base-lg-error-initial-disabled-borderBottomWidth': '0.0625rem',
        'input-base-lg-error-initial-disabled-borderColor': 'rgb(237, 0, 7)',
        'input-base-lg-error-initial-disabled-borderLeftWidth': '0',
        'input-base-lg-error-initial-disabled-borderRightWidth': '0',
        'input-base-lg-error-initial-disabled-borderStyle': 'solid',
        'input-base-lg-error-initial-disabled-borderTopLeftRadius': '0',
        'input-base-lg-error-initial-disabled-borderTopRightRadius': '0',
        'input-base-lg-error-initial-disabled-borderTopWidth': '0',
        'input-base-lg-error-initial-disabled-height': '4rem',
        'input-base-lg-error-initial-disabled-paddingLeft': '0.75rem',
        'input-base-lg-error-initial-disabled-paddingRight': '0.75rem',
        'input-base-lg-error-initial-height': '4rem',
        'input-base-lg-error-initial-paddingLeft': '0.75rem',
        'input-base-lg-error-initial-paddingRight': '0.75rem',
        'input-base-lg-idle-filled-background': 'rgb(224, 226, 229)',
        'input-base-lg-idle-filled-borderBottomLeftRadius': '0',
        'input-base-lg-idle-filled-borderBottomRightRadius': '0',
        'input-base-lg-idle-filled-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-filled-borderColor': 'rgb(0, 0, 0)',
        'input-base-lg-idle-filled-borderLeftWidth': '0',
        'input-base-lg-idle-filled-borderRightWidth': '0',
        'input-base-lg-idle-filled-borderStyle': 'solid',
        'input-base-lg-idle-filled-borderTopLeftRadius': '0',
        'input-base-lg-idle-filled-borderTopRightRadius': '0',
        'input-base-lg-idle-filled-borderTopWidth': '0',
        'input-base-lg-idle-filled-disabled-background': 'rgb(224, 226, 229)',
        'input-base-lg-idle-filled-disabled-borderBottomLeftRadius': '0',
        'input-base-lg-idle-filled-disabled-borderBottomRightRadius': '0',
        'input-base-lg-idle-filled-disabled-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-filled-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'input-base-lg-idle-filled-disabled-borderLeftWidth': '0',
        'input-base-lg-idle-filled-disabled-borderRightWidth': '0',
        'input-base-lg-idle-filled-disabled-borderStyle': 'solid',
        'input-base-lg-idle-filled-disabled-borderTopLeftRadius': '0',
        'input-base-lg-idle-filled-disabled-borderTopRightRadius': '0',
        'input-base-lg-idle-filled-disabled-borderTopWidth': '0',
        'input-base-lg-idle-filled-disabled-height': '4rem',
        'input-base-lg-idle-filled-disabled-paddingLeft': '0.75rem',
        'input-base-lg-idle-filled-disabled-paddingRight': '0.75rem',
        'input-base-lg-idle-filled-height': '4rem',
        'input-base-lg-idle-filled-paddingLeft': '0.75rem',
        'input-base-lg-idle-filled-paddingRight': '0.75rem',
        'input-base-lg-idle-focused-background': 'rgb(209, 228, 255)',
        'input-base-lg-idle-focused-borderBottomLeftRadius': '0',
        'input-base-lg-idle-focused-borderBottomRightRadius': '0',
        'input-base-lg-idle-focused-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-focused-borderColor': 'rgb(0, 0, 0)',
        'input-base-lg-idle-focused-borderLeftWidth': '0',
        'input-base-lg-idle-focused-borderRightWidth': '0',
        'input-base-lg-idle-focused-borderStyle': 'solid',
        'input-base-lg-idle-focused-borderTopLeftRadius': '0',
        'input-base-lg-idle-focused-borderTopRightRadius': '0',
        'input-base-lg-idle-focused-borderTopWidth': '0',
        'input-base-lg-idle-focused-height': '4rem',
        'input-base-lg-idle-focused-paddingLeft': '0.75rem',
        'input-base-lg-idle-focused-paddingRight': '0.75rem',
        'input-base-lg-idle-hover-background': 'rgb(193, 199, 204)',
        'input-base-lg-idle-hover-borderBottomLeftRadius': '0',
        'input-base-lg-idle-hover-borderBottomRightRadius': '0',
        'input-base-lg-idle-hover-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-hover-borderColor': 'rgb(0, 0, 0)',
        'input-base-lg-idle-hover-borderLeftWidth': '0',
        'input-base-lg-idle-hover-borderRightWidth': '0',
        'input-base-lg-idle-hover-borderStyle': 'solid',
        'input-base-lg-idle-hover-borderTopLeftRadius': '0',
        'input-base-lg-idle-hover-borderTopRightRadius': '0',
        'input-base-lg-idle-hover-borderTopWidth': '0',
        'input-base-lg-idle-hover-height': '4rem',
        'input-base-lg-idle-hover-paddingLeft': '0.75rem',
        'input-base-lg-idle-hover-paddingRight': '0.75rem',
        'input-base-lg-idle-initial-background': 'rgb(224, 226, 229)',
        'input-base-lg-idle-initial-borderBottomLeftRadius': '0',
        'input-base-lg-idle-initial-borderBottomRightRadius': '0',
        'input-base-lg-idle-initial-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-initial-borderColor': 'rgb(0, 0, 0)',
        'input-base-lg-idle-initial-borderLeftWidth': '0',
        'input-base-lg-idle-initial-borderRightWidth': '0',
        'input-base-lg-idle-initial-borderStyle': 'solid',
        'input-base-lg-idle-initial-borderTopLeftRadius': '0',
        'input-base-lg-idle-initial-borderTopRightRadius': '0',
        'input-base-lg-idle-initial-borderTopWidth': '0',
        'input-base-lg-idle-initial-disabled-background': 'rgb(224, 226, 229)',
        'input-base-lg-idle-initial-disabled-borderBottomLeftRadius': '0',
        'input-base-lg-idle-initial-disabled-borderBottomRightRadius': '0',
        'input-base-lg-idle-initial-disabled-borderBottomWidth': '0.0625rem',
        'input-base-lg-idle-initial-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'input-base-lg-idle-initial-disabled-borderLeftWidth': '0',
        'input-base-lg-idle-initial-disabled-borderRightWidth': '0',
        'input-base-lg-idle-initial-disabled-borderStyle': 'solid',
        'input-base-lg-idle-initial-disabled-borderTopLeftRadius': '0',
        'input-base-lg-idle-initial-disabled-borderTopRightRadius': '0',
        'input-base-lg-idle-initial-disabled-borderTopWidth': '0',
        'input-base-lg-idle-initial-disabled-height': '4rem',
        'input-base-lg-idle-initial-disabled-paddingLeft': '0.75rem',
        'input-base-lg-idle-initial-disabled-paddingRight': '0.75rem',
        'input-base-lg-idle-initial-height': '4rem',
        'input-base-lg-idle-initial-paddingLeft': '0.75rem',
        'input-base-lg-idle-initial-paddingRight': '0.75rem',
        'input-base-sm-error-filled-background': 'rgb(224, 226, 229)',
        'input-base-sm-error-filled-borderBottomLeftRadius': '0',
        'input-base-sm-error-filled-borderBottomRightRadius': '0',
        'input-base-sm-error-filled-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-filled-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-filled-borderLeftWidth': '0',
        'input-base-sm-error-filled-borderRightWidth': '0',
        'input-base-sm-error-filled-borderStyle': 'solid',
        'input-base-sm-error-filled-borderTopLeftRadius': '0',
        'input-base-sm-error-filled-borderTopRightRadius': '0',
        'input-base-sm-error-filled-borderTopWidth': '0',
        'input-base-sm-error-filled-disabled-background': 'rgb(224, 226, 229)',
        'input-base-sm-error-filled-disabled-borderBottomLeftRadius': '0',
        'input-base-sm-error-filled-disabled-borderBottomRightRadius': '0',
        'input-base-sm-error-filled-disabled-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-filled-disabled-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-filled-disabled-borderLeftWidth': '0',
        'input-base-sm-error-filled-disabled-borderRightWidth': '0',
        'input-base-sm-error-filled-disabled-borderStyle': 'solid',
        'input-base-sm-error-filled-disabled-borderTopLeftRadius': '0',
        'input-base-sm-error-filled-disabled-borderTopRightRadius': '0',
        'input-base-sm-error-filled-disabled-borderTopWidth': '0',
        'input-base-sm-error-filled-disabled-height': '3rem',
        'input-base-sm-error-filled-disabled-paddingLeft': '0.5rem',
        'input-base-sm-error-filled-disabled-paddingRight': '0.5rem',
        'input-base-sm-error-filled-height': '3rem',
        'input-base-sm-error-filled-paddingLeft': '0.5rem',
        'input-base-sm-error-filled-paddingRight': '0.5rem',
        'input-base-sm-error-focused-background': 'rgb(209, 228, 255)',
        'input-base-sm-error-focused-borderBottomLeftRadius': '0',
        'input-base-sm-error-focused-borderBottomRightRadius': '0',
        'input-base-sm-error-focused-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-focused-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-focused-borderLeftWidth': '0',
        'input-base-sm-error-focused-borderRightWidth': '0',
        'input-base-sm-error-focused-borderStyle': 'solid',
        'input-base-sm-error-focused-borderTopLeftRadius': '0',
        'input-base-sm-error-focused-borderTopRightRadius': '0',
        'input-base-sm-error-focused-borderTopWidth': '0',
        'input-base-sm-error-focused-height': '3rem',
        'input-base-sm-error-focused-paddingLeft': '0.5rem',
        'input-base-sm-error-focused-paddingRight': '0.5rem',
        'input-base-sm-error-hover-background': 'rgb(193, 199, 204)',
        'input-base-sm-error-hover-borderBottomLeftRadius': '0',
        'input-base-sm-error-hover-borderBottomRightRadius': '0',
        'input-base-sm-error-hover-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-hover-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-hover-borderLeftWidth': '0',
        'input-base-sm-error-hover-borderRightWidth': '0',
        'input-base-sm-error-hover-borderStyle': 'solid',
        'input-base-sm-error-hover-borderTopLeftRadius': '0',
        'input-base-sm-error-hover-borderTopRightRadius': '0',
        'input-base-sm-error-hover-borderTopWidth': '0',
        'input-base-sm-error-hover-height': '3rem',
        'input-base-sm-error-hover-paddingLeft': '0.5rem',
        'input-base-sm-error-hover-paddingRight': '0.5rem',
        'input-base-sm-error-initial-background': 'rgb(224, 226, 229)',
        'input-base-sm-error-initial-borderBottomLeftRadius': '0',
        'input-base-sm-error-initial-borderBottomRightRadius': '0',
        'input-base-sm-error-initial-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-initial-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-initial-borderLeftWidth': '0',
        'input-base-sm-error-initial-borderRightWidth': '0',
        'input-base-sm-error-initial-borderStyle': 'solid',
        'input-base-sm-error-initial-borderTopLeftRadius': '0',
        'input-base-sm-error-initial-borderTopRightRadius': '0',
        'input-base-sm-error-initial-borderTopWidth': '0',
        'input-base-sm-error-initial-disabled-background': 'rgb(224, 226, 229)',
        'input-base-sm-error-initial-disabled-borderBottomLeftRadius': '0',
        'input-base-sm-error-initial-disabled-borderBottomRightRadius': '0',
        'input-base-sm-error-initial-disabled-borderBottomWidth': '0.0625rem',
        'input-base-sm-error-initial-disabled-borderColor': 'rgb(237, 0, 7)',
        'input-base-sm-error-initial-disabled-borderLeftWidth': '0',
        'input-base-sm-error-initial-disabled-borderRightWidth': '0',
        'input-base-sm-error-initial-disabled-borderStyle': 'solid',
        'input-base-sm-error-initial-disabled-borderTopLeftRadius': '0',
        'input-base-sm-error-initial-disabled-borderTopRightRadius': '0',
        'input-base-sm-error-initial-disabled-borderTopWidth': '0',
        'input-base-sm-error-initial-disabled-height': '3rem',
        'input-base-sm-error-initial-disabled-paddingLeft': '0.5rem',
        'input-base-sm-error-initial-disabled-paddingRight': '0.5rem',
        'input-base-sm-error-initial-height': '3rem',
        'input-base-sm-error-initial-paddingLeft': '0.5rem',
        'input-base-sm-error-initial-paddingRight': '0.5rem',
        'input-base-sm-idle-filled-background': 'rgb(224, 226, 229)',
        'input-base-sm-idle-filled-borderBottomLeftRadius': '0',
        'input-base-sm-idle-filled-borderBottomRightRadius': '0',
        'input-base-sm-idle-filled-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-filled-borderColor': 'rgb(0, 0, 0)',
        'input-base-sm-idle-filled-borderLeftWidth': '0',
        'input-base-sm-idle-filled-borderRightWidth': '0',
        'input-base-sm-idle-filled-borderStyle': 'solid',
        'input-base-sm-idle-filled-borderTopLeftRadius': '0',
        'input-base-sm-idle-filled-borderTopRightRadius': '0',
        'input-base-sm-idle-filled-borderTopWidth': '0',
        'input-base-sm-idle-filled-disabled-background': 'rgb(224, 226, 229)',
        'input-base-sm-idle-filled-disabled-borderBottomLeftRadius': '0',
        'input-base-sm-idle-filled-disabled-borderBottomRightRadius': '0',
        'input-base-sm-idle-filled-disabled-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-filled-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'input-base-sm-idle-filled-disabled-borderLeftWidth': '0',
        'input-base-sm-idle-filled-disabled-borderRightWidth': '0',
        'input-base-sm-idle-filled-disabled-borderStyle': 'solid',
        'input-base-sm-idle-filled-disabled-borderTopLeftRadius': '0',
        'input-base-sm-idle-filled-disabled-borderTopRightRadius': '0',
        'input-base-sm-idle-filled-disabled-borderTopWidth': '0',
        'input-base-sm-idle-filled-disabled-height': '3rem',
        'input-base-sm-idle-filled-disabled-paddingLeft': '0.5rem',
        'input-base-sm-idle-filled-disabled-paddingRight': '0.5rem',
        'input-base-sm-idle-filled-height': '3rem',
        'input-base-sm-idle-filled-paddingLeft': '0.5rem',
        'input-base-sm-idle-filled-paddingRight': '0.5rem',
        'input-base-sm-idle-focused-background': 'rgb(209, 228, 255)',
        'input-base-sm-idle-focused-borderBottomLeftRadius': '0',
        'input-base-sm-idle-focused-borderBottomRightRadius': '0',
        'input-base-sm-idle-focused-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-focused-borderColor': 'rgb(0, 0, 0)',
        'input-base-sm-idle-focused-borderLeftWidth': '0',
        'input-base-sm-idle-focused-borderRightWidth': '0',
        'input-base-sm-idle-focused-borderStyle': 'solid',
        'input-base-sm-idle-focused-borderTopLeftRadius': '0',
        'input-base-sm-idle-focused-borderTopRightRadius': '0',
        'input-base-sm-idle-focused-borderTopWidth': '0',
        'input-base-sm-idle-focused-height': '3rem',
        'input-base-sm-idle-focused-paddingLeft': '0.5rem',
        'input-base-sm-idle-focused-paddingRight': '0.5rem',
        'input-base-sm-idle-hover-background': 'rgb(193, 199, 204)',
        'input-base-sm-idle-hover-borderBottomLeftRadius': '0',
        'input-base-sm-idle-hover-borderBottomRightRadius': '0',
        'input-base-sm-idle-hover-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-hover-borderColor': 'rgb(0, 0, 0)',
        'input-base-sm-idle-hover-borderLeftWidth': '0',
        'input-base-sm-idle-hover-borderRightWidth': '0',
        'input-base-sm-idle-hover-borderStyle': 'solid',
        'input-base-sm-idle-hover-borderTopLeftRadius': '0',
        'input-base-sm-idle-hover-borderTopRightRadius': '0',
        'input-base-sm-idle-hover-borderTopWidth': '0',
        'input-base-sm-idle-hover-height': '3rem',
        'input-base-sm-idle-hover-paddingLeft': '0.5rem',
        'input-base-sm-idle-hover-paddingRight': '0.5rem',
        'input-base-sm-idle-initial-background': 'rgb(224, 226, 229)',
        'input-base-sm-idle-initial-borderBottomLeftRadius': '0',
        'input-base-sm-idle-initial-borderBottomRightRadius': '0',
        'input-base-sm-idle-initial-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-initial-borderColor': 'rgb(0, 0, 0)',
        'input-base-sm-idle-initial-borderLeftWidth': '0',
        'input-base-sm-idle-initial-borderRightWidth': '0',
        'input-base-sm-idle-initial-borderStyle': 'solid',
        'input-base-sm-idle-initial-borderTopLeftRadius': '0',
        'input-base-sm-idle-initial-borderTopRightRadius': '0',
        'input-base-sm-idle-initial-borderTopWidth': '0',
        'input-base-sm-idle-initial-disabled-background': 'rgb(224, 226, 229)',
        'input-base-sm-idle-initial-disabled-borderBottomLeftRadius': '0',
        'input-base-sm-idle-initial-disabled-borderBottomRightRadius': '0',
        'input-base-sm-idle-initial-disabled-borderBottomWidth': '0.0625rem',
        'input-base-sm-idle-initial-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'input-base-sm-idle-initial-disabled-borderLeftWidth': '0',
        'input-base-sm-idle-initial-disabled-borderRightWidth': '0',
        'input-base-sm-idle-initial-disabled-borderStyle': 'solid',
        'input-base-sm-idle-initial-disabled-borderTopLeftRadius': '0',
        'input-base-sm-idle-initial-disabled-borderTopRightRadius': '0',
        'input-base-sm-idle-initial-disabled-borderTopWidth': '0',
        'input-base-sm-idle-initial-disabled-height': '3rem',
        'input-base-sm-idle-initial-disabled-paddingLeft': '0.5rem',
        'input-base-sm-idle-initial-disabled-paddingRight': '0.5rem',
        'input-base-sm-idle-initial-height': '3rem',
        'input-base-sm-idle-initial-paddingLeft': '0.5rem',
        'input-base-sm-idle-initial-paddingRight': '0.5rem',
        'input-content-base-default-gap': '0',
        'input-content-base-default-paddingLeft': '0.5rem',
        'input-content-base-default-paddingRight': '0.5rem',
        'input-content-base-reduced-gap': '0',
        'input-content-base-reduced-paddingLeft': '0.5rem',
        'input-content-base-reduced-paddingRight': '0.5rem',
        'input-content-input-filled-color': 'rgb(0, 0, 0)',
        'input-content-input-filled-disabled-color': 'rgb(0, 0, 0)',
        'input-content-input-filled-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-input-filled-disabled-fontSize': '1rem',
        'input-content-input-filled-disabled-fontWeight': 'normal',
        'input-content-input-filled-disabled-letterSpacing': '0em',
        'input-content-input-filled-disabled-lineHeight': '1.5rem',
        'input-content-input-filled-disabled-opacity': 0.4,
        'input-content-input-filled-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-input-filled-fontSize': '1rem',
        'input-content-input-filled-fontWeight': 'normal',
        'input-content-input-filled-letterSpacing': '0em',
        'input-content-input-filled-lineHeight': '1.5rem',
        'input-content-input-filled-opacity': 0.8,
        'input-content-input-focused-color': 'rgb(0, 0, 0)',
        'input-content-input-focused-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-input-focused-fontSize': '1rem',
        'input-content-input-focused-fontWeight': 'normal',
        'input-content-input-focused-letterSpacing': '0em',
        'input-content-input-focused-lineHeight': '1.5rem',
        'input-content-input-focused-opacity': 0.8,
        'input-content-label-filled-color': 'rgb(0, 0, 0)',
        'input-content-label-filled-disabled-color': 'rgb(0, 0, 0)',
        'input-content-label-filled-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-filled-disabled-fontSize': '0.75rem',
        'input-content-label-filled-disabled-fontWeight': 'normal',
        'input-content-label-filled-disabled-letterSpacing': '0em',
        'input-content-label-filled-disabled-lineHeight': '1rem',
        'input-content-label-filled-disabled-opacity': 0.4,
        'input-content-label-filled-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-filled-fontSize': '0.75rem',
        'input-content-label-filled-fontWeight': 'normal',
        'input-content-label-filled-letterSpacing': '0em',
        'input-content-label-filled-lineHeight': '1rem',
        'input-content-label-filled-opacity': 0.8,
        'input-content-label-focused-color': 'rgb(0, 0, 0)',
        'input-content-label-focused-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-focused-fontSize': '0.75rem',
        'input-content-label-focused-fontWeight': 'normal',
        'input-content-label-focused-letterSpacing': '0em',
        'input-content-label-focused-lineHeight': '1rem',
        'input-content-label-focused-opacity': 0.8,
        'input-content-label-hover-color': 'rgb(0, 0, 0)',
        'input-content-label-hover-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-hover-fontSize': '1rem',
        'input-content-label-hover-fontWeight': 'normal',
        'input-content-label-hover-letterSpacing': '0em',
        'input-content-label-hover-lineHeight': '1.5rem',
        'input-content-label-hover-opacity': 0.65,
        'input-content-label-initial-color': 'rgb(0, 0, 0)',
        'input-content-label-initial-disabled-color': 'rgb(0, 0, 0)',
        'input-content-label-initial-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-initial-disabled-fontSize': '1rem',
        'input-content-label-initial-disabled-fontWeight': 'normal',
        'input-content-label-initial-disabled-letterSpacing': '0em',
        'input-content-label-initial-disabled-lineHeight': '1.5rem',
        'input-content-label-initial-disabled-opacity': 0.4,
        'input-content-label-initial-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-label-initial-fontSize': '1rem',
        'input-content-label-initial-fontWeight': 'normal',
        'input-content-label-initial-letterSpacing': '0em',
        'input-content-label-initial-lineHeight': '1.5rem',
        'input-content-label-initial-opacity': 0.65,
        'input-content-placeholder-color': 'rgb(0, 0, 0)',
        'input-content-placeholder-fontFamily': 'Bosch Sans, sans-serif',
        'input-content-placeholder-fontSize': '1rem',
        'input-content-placeholder-fontWeight': 'normal',
        'input-content-placeholder-letterSpacing': '0em',
        'input-content-placeholder-lineHeight': '1.5rem',
        'input-content-placeholder-opacity': 0.4,
        'input-indicator-action-base-disabled-paddingLeft': '0.5rem',
        'input-indicator-action-base-disabled-paddingRight': '0.5rem',
        'input-indicator-action-base-focused-paddingLeft': '0.5rem',
        'input-indicator-action-base-focused-paddingRight': '0.5rem',
        'input-indicator-action-base-hover-paddingLeft': '0.5rem',
        'input-indicator-action-base-hover-paddingRight': '0.5rem',
        'input-indicator-action-base-initial-paddingLeft': '0.5rem',
        'input-indicator-action-base-initial-paddingRight': '0.5rem',
        'input-indicator-action-base-pressed-paddingLeft': '0.5rem',
        'input-indicator-action-base-pressed-paddingRight': '0.5rem',
        'input-indicator-action-icon-disabled-background': 'rgb(0, 0, 0)',
        'input-indicator-action-icon-disabled-opacity': 0.65,
        'input-indicator-action-icon-focused-background': 'rgb(0, 98, 154)',
        'input-indicator-action-icon-focused-opacity': 1,
        'input-indicator-action-icon-hover-background': 'rgb(0, 98, 154)',
        'input-indicator-action-icon-hover-opacity': 0.8,
        'input-indicator-action-icon-initial-background': 'rgb(0, 123, 192)',
        'input-indicator-action-icon-initial-opacity': 1,
        'input-indicator-action-icon-pressed-background': 'rgb(0, 73, 117)',
        'input-indicator-action-icon-pressed-opacity': 0.65,
        'input-indicator-countrySelector-base-gap': '0.5rem',
        'input-indicator-countrySelector-base-paddingLeft': '0.5rem',
        'input-indicator-countrySelector-base-paddingRight': '0.5rem',
        'input-indicator-countrySelector-divider-disabled-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-divider-disabled-height': '0.75rem',
        'input-indicator-countrySelector-divider-disabled-opacity': 0.4,
        'input-indicator-countrySelector-divider-disabled-width': '0.0625rem',
        'input-indicator-countrySelector-divider-focused-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-divider-focused-height': '0.75rem',
        'input-indicator-countrySelector-divider-focused-opacity': 1,
        'input-indicator-countrySelector-divider-focused-width': '0.0625rem',
        'input-indicator-countrySelector-divider-hover-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-divider-hover-height': '0.75rem',
        'input-indicator-countrySelector-divider-hover-opacity': 1,
        'input-indicator-countrySelector-divider-hover-width': '0.0625rem',
        'input-indicator-countrySelector-divider-initial-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-divider-initial-height': '0.75rem',
        'input-indicator-countrySelector-divider-initial-opacity': 0.8,
        'input-indicator-countrySelector-divider-initial-width': '0.0625rem',
        'input-indicator-countrySelector-divider-pressed-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-divider-pressed-height': '0.75rem',
        'input-indicator-countrySelector-divider-pressed-opacity': 0.65,
        'input-indicator-countrySelector-divider-pressed-width': '0.0625rem',
        'input-indicator-countrySelector-flag-disabled-opacity': 0.4,
        'input-indicator-countrySelector-flag-focused-opacity': 1,
        'input-indicator-countrySelector-flag-hover-opacity': 1,
        'input-indicator-countrySelector-flag-initial-opacity': 0.8,
        'input-indicator-countrySelector-flag-pressed-opacity': 0.65,
        'input-indicator-countrySelector-icon-disabled-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-icon-disabled-opacity': 0.4,
        'input-indicator-countrySelector-icon-focused-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-icon-focused-opacity': 1,
        'input-indicator-countrySelector-icon-hover-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-icon-hover-opacity': 1,
        'input-indicator-countrySelector-icon-initial-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-icon-initial-opacity': 0.8,
        'input-indicator-countrySelector-icon-pressed-background': 'rgb(0, 0, 0)',
        'input-indicator-countrySelector-icon-pressed-opacity': 0.65,
        'input-indicator-creditCardProvider-base-paddingLeft': '0.5rem',
        'input-indicator-creditCardProvider-base-paddingRight': '0.5rem',
        'input-indicator-helper-base-paddingLeft': '0.5rem',
        'input-indicator-helper-base-paddingRight': '0.5rem',
        'input-indicator-helper-icon-error-filled-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-filled-disabled-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-filled-disabled-opacity': 0.4,
        'input-indicator-helper-icon-error-filled-opacity': 0.8,
        'input-indicator-helper-icon-error-focused-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-focused-opacity': 0.8,
        'input-indicator-helper-icon-error-hover-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-hover-opacity': 1,
        'input-indicator-helper-icon-error-initial-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-initial-disabled-background': 'rgb(237, 0, 7)',
        'input-indicator-helper-icon-error-initial-disabled-opacity': 0.4,
        'input-indicator-helper-icon-error-initial-opacity': 1,
        'input-indicator-helper-icon-idle-filled-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-filled-disabled-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-filled-disabled-opacity': 0.4,
        'input-indicator-helper-icon-idle-filled-opacity': 0.8,
        'input-indicator-helper-icon-idle-focused-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-focused-opacity': 0.8,
        'input-indicator-helper-icon-idle-hover-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-hover-opacity': 0.65,
        'input-indicator-helper-icon-idle-initial-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-initial-disabled-background': 'rgb(0, 0, 0)',
        'input-indicator-helper-icon-idle-initial-disabled-opacity': 0.4,
        'input-indicator-helper-icon-idle-initial-opacity': 0.65,
        'interaction-hover-brightness': 'brightness(0.96)',
        'interaction-hover-contrast': 'contrast(1)',
        'interaction-hover-duration': '600ms',
        'interaction-hover-timing': 'cubic-bezier(0.25, 0.1, 0, 1)',
        'interaction-pressed-brightness': 'brightness(0.94)',
        'interaction-pressed-contrast': 'contrast(1)',
        'interaction-pressed-duration': '600ms',
        'interaction-pressed-timing': 'cubic-bezier(0.25, 0.1, 0, 1)',
        'keyBenefit-link-lg-paddingRight': '0.5rem',
        'keyBenefit-link-sm-paddingRight': '0.25rem',
        'keyBenefit-text-default-lg-color': 'rgb(0, 0, 0)',
        'keyBenefit-text-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'keyBenefit-text-default-lg-fontSize': '1rem',
        'keyBenefit-text-default-lg-fontWeight': 'normal',
        'keyBenefit-text-default-lg-letterSpacing': '0em',
        'keyBenefit-text-default-lg-lineHeight': '1.5rem',
        'keyBenefit-text-default-lg-opacity': 1,
        'keyBenefit-text-default-sm-color': 'rgb(0, 0, 0)',
        'keyBenefit-text-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'keyBenefit-text-default-sm-fontSize': '0.875rem',
        'keyBenefit-text-default-sm-fontWeight': 'normal',
        'keyBenefit-text-default-sm-letterSpacing': '0em',
        'keyBenefit-text-default-sm-lineHeight': '1.25rem',
        'keyBenefit-text-default-sm-opacity': 1,
        'keyBenefit-text-highlighted-lg-color': 'rgb(0, 0, 0)',
        'keyBenefit-text-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'keyBenefit-text-highlighted-lg-fontSize': '1rem',
        'keyBenefit-text-highlighted-lg-fontWeight': 'normal',
        'keyBenefit-text-highlighted-lg-letterSpacing': '0em',
        'keyBenefit-text-highlighted-lg-lineHeight': '1.5rem',
        'keyBenefit-text-highlighted-lg-opacity': 1,
        'keyBenefit-text-highlighted-sm-color': 'rgb(0, 0, 0)',
        'keyBenefit-text-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'keyBenefit-text-highlighted-sm-fontSize': '0.875rem',
        'keyBenefit-text-highlighted-sm-fontWeight': 'normal',
        'keyBenefit-text-highlighted-sm-letterSpacing': '0em',
        'keyBenefit-text-highlighted-sm-lineHeight': '1.25rem',
        'keyBenefit-text-highlighted-sm-opacity': 1,
        'labeltext-large-fontFamily': 'Bosch Sans, sans-serif',
        'labeltext-large-fontSize': '1rem',
        'labeltext-large-fontWeight': 'bold',
        'labeltext-large-letterSpacing': '0em',
        'labeltext-large-lineHeight': '1.5rem',
        'labeltext-medium-fontFamily': 'Bosch Sans, sans-serif',
        'labeltext-medium-fontSize': '0.875rem',
        'labeltext-medium-fontWeight': 'bold',
        'labeltext-medium-letterSpacing': '0em',
        'labeltext-medium-lineHeight': '1.25rem',
        'labeltext-small-fontFamily': 'Bosch Sans, sans-serif',
        'labeltext-small-fontSize': '0.75rem',
        'labeltext-small-fontWeight': 'bold',
        'labeltext-small-letterSpacing': '0em',
        'labeltext-small-lineHeight': '1rem',
        'lane-default-lg-gap': '3rem',
        'lane-default-md-gap': '2rem',
        'lane-default-sm-gap': '1.5rem',
        'lane-stack-lg-gap': '1.5rem',
        'lane-stack-sm-gap': '1rem',
        'link-base-lg-disabled-gap': '0.5rem',
        'link-base-lg-focused-gap': '0.5rem',
        'link-base-lg-hover-gap': '0.5rem',
        'link-base-lg-initial-gap': '0.5rem',
        'link-base-lg-pressed-gap': '0.5rem',
        'link-base-md-disabled-gap': '0.5rem',
        'link-base-md-focused-gap': '0.5rem',
        'link-base-md-hover-gap': '0.5rem',
        'link-base-md-initial-gap': '0.5rem',
        'link-base-md-pressed-gap': '0.5rem',
        'link-base-sm-disabled-gap': '0.25rem',
        'link-base-sm-focused-gap': '0.25rem',
        'link-base-sm-hover-gap': '0.25rem',
        'link-base-sm-initial-gap': '0.25rem',
        'link-base-sm-pressed-gap': '0.25rem',
        'link-base-xs-disabled-gap': '0.25rem',
        'link-base-xs-focused-gap': '0.25rem',
        'link-base-xs-hover-gap': '0.25rem',
        'link-base-xs-initial-gap': '0.25rem',
        'link-base-xs-pressed-gap': '0.25rem',
        'link-icon-neutral-disabled-background': 'rgb(0, 0, 0)',
        'link-icon-neutral-disabled-opacity': 0.4,
        'link-icon-neutral-focused-background': 'rgb(0, 98, 154)',
        'link-icon-neutral-focused-opacity': 1,
        'link-icon-neutral-hover-background': 'rgb(0, 98, 154)',
        'link-icon-neutral-hover-opacity': 0.8,
        'link-icon-neutral-initial-background': 'rgb(0, 0, 0)',
        'link-icon-neutral-initial-opacity': 0.65,
        'link-icon-neutral-pressed-background': 'rgb(0, 73, 117)',
        'link-icon-neutral-pressed-opacity': 0.65,
        'link-icon-prominent-disabled-background': 'rgb(0, 0, 0)',
        'link-icon-prominent-disabled-opacity': 0.4,
        'link-icon-prominent-focused-background': 'rgb(0, 98, 154)',
        'link-icon-prominent-focused-opacity': 1,
        'link-icon-prominent-hover-background': 'rgb(0, 98, 154)',
        'link-icon-prominent-hover-opacity': 0.8,
        'link-icon-prominent-initial-background': 'rgb(0, 123, 192)',
        'link-icon-prominent-initial-opacity': 1,
        'link-icon-prominent-pressed-background': 'rgb(0, 73, 117)',
        'link-icon-prominent-pressed-opacity': 0.65,
        'link-label-neutral-lg-disabled-color': 'rgb(0, 0, 0)',
        'link-label-neutral-lg-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-lg-disabled-fontSize': '1rem',
        'link-label-neutral-lg-disabled-fontWeight': 'normal',
        'link-label-neutral-lg-disabled-letterSpacing': '0em',
        'link-label-neutral-lg-disabled-lineHeight': '1.5rem',
        'link-label-neutral-lg-disabled-opacity': 0.4,
        'link-label-neutral-lg-disabled-textDecoration': 'none',
        'link-label-neutral-lg-focused-color': 'rgb(0, 98, 154)',
        'link-label-neutral-lg-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-lg-focused-fontSize': '1rem',
        'link-label-neutral-lg-focused-fontWeight': 'normal',
        'link-label-neutral-lg-focused-letterSpacing': '0em',
        'link-label-neutral-lg-focused-lineHeight': '1.5rem',
        'link-label-neutral-lg-focused-opacity': 0.8,
        'link-label-neutral-lg-focused-textDecoration': 'underline',
        'link-label-neutral-lg-hover-color': 'rgb(0, 98, 154)',
        'link-label-neutral-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-lg-hover-fontSize': '1rem',
        'link-label-neutral-lg-hover-fontWeight': 'normal',
        'link-label-neutral-lg-hover-letterSpacing': '0em',
        'link-label-neutral-lg-hover-lineHeight': '1.5rem',
        'link-label-neutral-lg-hover-opacity': 0.8,
        'link-label-neutral-lg-hover-textDecoration': 'underline',
        'link-label-neutral-lg-initial-color': 'rgb(0, 0, 0)',
        'link-label-neutral-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-lg-initial-fontSize': '1rem',
        'link-label-neutral-lg-initial-fontWeight': 'normal',
        'link-label-neutral-lg-initial-letterSpacing': '0em',
        'link-label-neutral-lg-initial-lineHeight': '1.5rem',
        'link-label-neutral-lg-initial-opacity': 0.65,
        'link-label-neutral-lg-initial-textDecoration': 'none',
        'link-label-neutral-lg-pressed-color': 'rgb(0, 73, 117)',
        'link-label-neutral-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-lg-pressed-fontSize': '1rem',
        'link-label-neutral-lg-pressed-fontWeight': 'normal',
        'link-label-neutral-lg-pressed-letterSpacing': '0em',
        'link-label-neutral-lg-pressed-lineHeight': '1.5rem',
        'link-label-neutral-lg-pressed-opacity': 0.65,
        'link-label-neutral-lg-pressed-textDecoration': 'underline',
        'link-label-neutral-md-disabled-color': 'rgb(0, 0, 0)',
        'link-label-neutral-md-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-md-disabled-fontSize': '0.875rem',
        'link-label-neutral-md-disabled-fontWeight': 'normal',
        'link-label-neutral-md-disabled-letterSpacing': '0em',
        'link-label-neutral-md-disabled-lineHeight': '1.25rem',
        'link-label-neutral-md-disabled-opacity': 0.4,
        'link-label-neutral-md-disabled-textDecoration': 'none',
        'link-label-neutral-md-focused-color': 'rgb(0, 98, 154)',
        'link-label-neutral-md-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-md-focused-fontSize': '0.875rem',
        'link-label-neutral-md-focused-fontWeight': 'normal',
        'link-label-neutral-md-focused-letterSpacing': '0em',
        'link-label-neutral-md-focused-lineHeight': '1.25rem',
        'link-label-neutral-md-focused-opacity': 0.8,
        'link-label-neutral-md-focused-textDecoration': 'underline',
        'link-label-neutral-md-hover-color': 'rgb(0, 98, 154)',
        'link-label-neutral-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-md-hover-fontSize': '0.875rem',
        'link-label-neutral-md-hover-fontWeight': 'normal',
        'link-label-neutral-md-hover-letterSpacing': '0em',
        'link-label-neutral-md-hover-lineHeight': '1.25rem',
        'link-label-neutral-md-hover-opacity': 0.8,
        'link-label-neutral-md-hover-textDecoration': 'underline',
        'link-label-neutral-md-initial-color': 'rgb(0, 0, 0)',
        'link-label-neutral-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-md-initial-fontSize': '0.875rem',
        'link-label-neutral-md-initial-fontWeight': 'normal',
        'link-label-neutral-md-initial-letterSpacing': '0em',
        'link-label-neutral-md-initial-lineHeight': '1.25rem',
        'link-label-neutral-md-initial-opacity': 0.65,
        'link-label-neutral-md-initial-textDecoration': 'none',
        'link-label-neutral-md-pressed-color': 'rgb(0, 73, 117)',
        'link-label-neutral-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-md-pressed-fontSize': '0.875rem',
        'link-label-neutral-md-pressed-fontWeight': 'normal',
        'link-label-neutral-md-pressed-letterSpacing': '0em',
        'link-label-neutral-md-pressed-lineHeight': '1.25rem',
        'link-label-neutral-md-pressed-opacity': 0.65,
        'link-label-neutral-md-pressed-textDecoration': 'underline',
        'link-label-neutral-sm-disabled-color': 'rgb(0, 0, 0)',
        'link-label-neutral-sm-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-sm-disabled-fontSize': '0.75rem',
        'link-label-neutral-sm-disabled-fontWeight': 'normal',
        'link-label-neutral-sm-disabled-letterSpacing': '0em',
        'link-label-neutral-sm-disabled-lineHeight': '1rem',
        'link-label-neutral-sm-disabled-opacity': 0.4,
        'link-label-neutral-sm-disabled-textDecoration': 'none',
        'link-label-neutral-sm-focused-color': 'rgb(0, 98, 154)',
        'link-label-neutral-sm-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-sm-focused-fontSize': '0.75rem',
        'link-label-neutral-sm-focused-fontWeight': 'normal',
        'link-label-neutral-sm-focused-letterSpacing': '0em',
        'link-label-neutral-sm-focused-lineHeight': '1rem',
        'link-label-neutral-sm-focused-opacity': 0.8,
        'link-label-neutral-sm-focused-textDecoration': 'underline',
        'link-label-neutral-sm-hover-color': 'rgb(0, 98, 154)',
        'link-label-neutral-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-sm-hover-fontSize': '0.75rem',
        'link-label-neutral-sm-hover-fontWeight': 'normal',
        'link-label-neutral-sm-hover-letterSpacing': '0em',
        'link-label-neutral-sm-hover-lineHeight': '1rem',
        'link-label-neutral-sm-hover-opacity': 0.8,
        'link-label-neutral-sm-hover-textDecoration': 'underline',
        'link-label-neutral-sm-initial-color': 'rgb(0, 0, 0)',
        'link-label-neutral-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-sm-initial-fontSize': '0.75rem',
        'link-label-neutral-sm-initial-fontWeight': 'normal',
        'link-label-neutral-sm-initial-letterSpacing': '0em',
        'link-label-neutral-sm-initial-lineHeight': '1rem',
        'link-label-neutral-sm-initial-opacity': 0.65,
        'link-label-neutral-sm-initial-textDecoration': 'none',
        'link-label-neutral-sm-pressed-color': 'rgb(0, 73, 117)',
        'link-label-neutral-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-sm-pressed-fontSize': '0.75rem',
        'link-label-neutral-sm-pressed-fontWeight': 'normal',
        'link-label-neutral-sm-pressed-letterSpacing': '0em',
        'link-label-neutral-sm-pressed-lineHeight': '1rem',
        'link-label-neutral-sm-pressed-opacity': 0.65,
        'link-label-neutral-sm-pressed-textDecoration': 'underline',
        'link-label-neutral-xs-disabled-color': 'rgb(0, 0, 0)',
        'link-label-neutral-xs-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-xs-disabled-fontSize': '0.625rem',
        'link-label-neutral-xs-disabled-fontWeight': 'normal',
        'link-label-neutral-xs-disabled-letterSpacing': '0em',
        'link-label-neutral-xs-disabled-lineHeight': '0.75rem',
        'link-label-neutral-xs-disabled-opacity': 0.4,
        'link-label-neutral-xs-disabled-textDecoration': 'none',
        'link-label-neutral-xs-focused-color': 'rgb(0, 98, 154)',
        'link-label-neutral-xs-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-xs-focused-fontSize': '0.625rem',
        'link-label-neutral-xs-focused-fontWeight': 'normal',
        'link-label-neutral-xs-focused-letterSpacing': '0em',
        'link-label-neutral-xs-focused-lineHeight': '0.75rem',
        'link-label-neutral-xs-focused-opacity': 0.8,
        'link-label-neutral-xs-focused-textDecoration': 'underline',
        'link-label-neutral-xs-hover-color': 'rgb(0, 98, 154)',
        'link-label-neutral-xs-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-xs-hover-fontSize': '0.625rem',
        'link-label-neutral-xs-hover-fontWeight': 'normal',
        'link-label-neutral-xs-hover-letterSpacing': '0em',
        'link-label-neutral-xs-hover-lineHeight': '0.75rem',
        'link-label-neutral-xs-hover-opacity': 0.8,
        'link-label-neutral-xs-hover-textDecoration': 'underline',
        'link-label-neutral-xs-initial-color': 'rgb(0, 0, 0)',
        'link-label-neutral-xs-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-xs-initial-fontSize': '0.625rem',
        'link-label-neutral-xs-initial-fontWeight': 'normal',
        'link-label-neutral-xs-initial-letterSpacing': '0em',
        'link-label-neutral-xs-initial-lineHeight': '0.75rem',
        'link-label-neutral-xs-initial-opacity': 0.65,
        'link-label-neutral-xs-initial-textDecoration': 'none',
        'link-label-neutral-xs-pressed-color': 'rgb(0, 73, 117)',
        'link-label-neutral-xs-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-neutral-xs-pressed-fontSize': '0.625rem',
        'link-label-neutral-xs-pressed-fontWeight': 'normal',
        'link-label-neutral-xs-pressed-letterSpacing': '0em',
        'link-label-neutral-xs-pressed-lineHeight': '0.75rem',
        'link-label-neutral-xs-pressed-opacity': 0.65,
        'link-label-neutral-xs-pressed-textDecoration': 'underline',
        'link-label-prominent-lg-disabled-color': 'rgb(0, 0, 0)',
        'link-label-prominent-lg-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-lg-disabled-fontSize': '1rem',
        'link-label-prominent-lg-disabled-fontWeight': 'normal',
        'link-label-prominent-lg-disabled-letterSpacing': '0em',
        'link-label-prominent-lg-disabled-lineHeight': '1.5rem',
        'link-label-prominent-lg-disabled-opacity': 0.4,
        'link-label-prominent-lg-disabled-textDecoration': 'none',
        'link-label-prominent-lg-focused-color': 'rgb(0, 98, 154)',
        'link-label-prominent-lg-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-lg-focused-fontSize': '1rem',
        'link-label-prominent-lg-focused-fontWeight': 'normal',
        'link-label-prominent-lg-focused-letterSpacing': '0em',
        'link-label-prominent-lg-focused-lineHeight': '1.5rem',
        'link-label-prominent-lg-focused-opacity': 1,
        'link-label-prominent-lg-focused-textDecoration': 'underline',
        'link-label-prominent-lg-hover-color': 'rgb(0, 98, 154)',
        'link-label-prominent-lg-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-lg-hover-fontSize': '1rem',
        'link-label-prominent-lg-hover-fontWeight': 'normal',
        'link-label-prominent-lg-hover-letterSpacing': '0em',
        'link-label-prominent-lg-hover-lineHeight': '1.5rem',
        'link-label-prominent-lg-hover-opacity': 0.8,
        'link-label-prominent-lg-hover-textDecoration': 'underline',
        'link-label-prominent-lg-initial-color': 'rgb(0, 123, 192)',
        'link-label-prominent-lg-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-lg-initial-fontSize': '1rem',
        'link-label-prominent-lg-initial-fontWeight': 'normal',
        'link-label-prominent-lg-initial-letterSpacing': '0em',
        'link-label-prominent-lg-initial-lineHeight': '1.5rem',
        'link-label-prominent-lg-initial-opacity': 1,
        'link-label-prominent-lg-initial-textDecoration': 'none',
        'link-label-prominent-lg-pressed-color': 'rgb(0, 73, 117)',
        'link-label-prominent-lg-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-lg-pressed-fontSize': '1rem',
        'link-label-prominent-lg-pressed-fontWeight': 'normal',
        'link-label-prominent-lg-pressed-letterSpacing': '0em',
        'link-label-prominent-lg-pressed-lineHeight': '1.5rem',
        'link-label-prominent-lg-pressed-opacity': 0.65,
        'link-label-prominent-lg-pressed-textDecoration': 'underline',
        'link-label-prominent-md-disabled-color': 'rgb(0, 0, 0)',
        'link-label-prominent-md-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-md-disabled-fontSize': '0.875rem',
        'link-label-prominent-md-disabled-fontWeight': 'normal',
        'link-label-prominent-md-disabled-letterSpacing': '0em',
        'link-label-prominent-md-disabled-lineHeight': '1.25rem',
        'link-label-prominent-md-disabled-opacity': 0.4,
        'link-label-prominent-md-disabled-textDecoration': 'none',
        'link-label-prominent-md-focused-color': 'rgb(0, 98, 154)',
        'link-label-prominent-md-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-md-focused-fontSize': '0.875rem',
        'link-label-prominent-md-focused-fontWeight': 'normal',
        'link-label-prominent-md-focused-letterSpacing': '0em',
        'link-label-prominent-md-focused-lineHeight': '1.25rem',
        'link-label-prominent-md-focused-opacity': 1,
        'link-label-prominent-md-focused-textDecoration': 'underline',
        'link-label-prominent-md-hover-color': 'rgb(0, 98, 154)',
        'link-label-prominent-md-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-md-hover-fontSize': '0.875rem',
        'link-label-prominent-md-hover-fontWeight': 'normal',
        'link-label-prominent-md-hover-letterSpacing': '0em',
        'link-label-prominent-md-hover-lineHeight': '1.25rem',
        'link-label-prominent-md-hover-opacity': 0.8,
        'link-label-prominent-md-hover-textDecoration': 'underline',
        'link-label-prominent-md-initial-color': 'rgb(0, 123, 192)',
        'link-label-prominent-md-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-md-initial-fontSize': '0.875rem',
        'link-label-prominent-md-initial-fontWeight': 'normal',
        'link-label-prominent-md-initial-letterSpacing': '0em',
        'link-label-prominent-md-initial-lineHeight': '1.25rem',
        'link-label-prominent-md-initial-opacity': 1,
        'link-label-prominent-md-initial-textDecoration': 'none',
        'link-label-prominent-md-pressed-color': 'rgb(0, 73, 117)',
        'link-label-prominent-md-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-md-pressed-fontSize': '0.875rem',
        'link-label-prominent-md-pressed-fontWeight': 'normal',
        'link-label-prominent-md-pressed-letterSpacing': '0em',
        'link-label-prominent-md-pressed-lineHeight': '1.25rem',
        'link-label-prominent-md-pressed-opacity': 0.65,
        'link-label-prominent-md-pressed-textDecoration': 'underline',
        'link-label-prominent-sm-disabled-color': 'rgb(0, 0, 0)',
        'link-label-prominent-sm-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-sm-disabled-fontSize': '0.75rem',
        'link-label-prominent-sm-disabled-fontWeight': 'normal',
        'link-label-prominent-sm-disabled-letterSpacing': '0em',
        'link-label-prominent-sm-disabled-lineHeight': '1rem',
        'link-label-prominent-sm-disabled-opacity': 0.4,
        'link-label-prominent-sm-disabled-textDecoration': 'none',
        'link-label-prominent-sm-focused-color': 'rgb(0, 98, 154)',
        'link-label-prominent-sm-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-sm-focused-fontSize': '0.75rem',
        'link-label-prominent-sm-focused-fontWeight': 'normal',
        'link-label-prominent-sm-focused-letterSpacing': '0em',
        'link-label-prominent-sm-focused-lineHeight': '1rem',
        'link-label-prominent-sm-focused-opacity': 1,
        'link-label-prominent-sm-focused-textDecoration': 'underline',
        'link-label-prominent-sm-hover-color': 'rgb(0, 98, 154)',
        'link-label-prominent-sm-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-sm-hover-fontSize': '0.75rem',
        'link-label-prominent-sm-hover-fontWeight': 'normal',
        'link-label-prominent-sm-hover-letterSpacing': '0em',
        'link-label-prominent-sm-hover-lineHeight': '1rem',
        'link-label-prominent-sm-hover-opacity': 0.8,
        'link-label-prominent-sm-hover-textDecoration': 'underline',
        'link-label-prominent-sm-initial-color': 'rgb(0, 123, 192)',
        'link-label-prominent-sm-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-sm-initial-fontSize': '0.75rem',
        'link-label-prominent-sm-initial-fontWeight': 'normal',
        'link-label-prominent-sm-initial-letterSpacing': '0em',
        'link-label-prominent-sm-initial-lineHeight': '1rem',
        'link-label-prominent-sm-initial-opacity': 1,
        'link-label-prominent-sm-initial-textDecoration': 'none',
        'link-label-prominent-sm-pressed-color': 'rgb(0, 73, 117)',
        'link-label-prominent-sm-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-sm-pressed-fontSize': '0.75rem',
        'link-label-prominent-sm-pressed-fontWeight': 'normal',
        'link-label-prominent-sm-pressed-letterSpacing': '0em',
        'link-label-prominent-sm-pressed-lineHeight': '1rem',
        'link-label-prominent-sm-pressed-opacity': 0.65,
        'link-label-prominent-sm-pressed-textDecoration': 'underline',
        'link-label-prominent-xs-disabled-color': 'rgb(0, 0, 0)',
        'link-label-prominent-xs-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-xs-disabled-fontSize': '0.625rem',
        'link-label-prominent-xs-disabled-fontWeight': 'normal',
        'link-label-prominent-xs-disabled-letterSpacing': '0em',
        'link-label-prominent-xs-disabled-lineHeight': '0.75rem',
        'link-label-prominent-xs-disabled-opacity': 0.4,
        'link-label-prominent-xs-disabled-textDecoration': 'none',
        'link-label-prominent-xs-focused-color': 'rgb(0, 98, 154)',
        'link-label-prominent-xs-focused-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-xs-focused-fontSize': '0.625rem',
        'link-label-prominent-xs-focused-fontWeight': 'normal',
        'link-label-prominent-xs-focused-letterSpacing': '0em',
        'link-label-prominent-xs-focused-lineHeight': '0.75rem',
        'link-label-prominent-xs-focused-opacity': 1,
        'link-label-prominent-xs-focused-textDecoration': 'underline',
        'link-label-prominent-xs-hover-color': 'rgb(0, 98, 154)',
        'link-label-prominent-xs-hover-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-xs-hover-fontSize': '0.625rem',
        'link-label-prominent-xs-hover-fontWeight': 'normal',
        'link-label-prominent-xs-hover-letterSpacing': '0em',
        'link-label-prominent-xs-hover-lineHeight': '0.75rem',
        'link-label-prominent-xs-hover-opacity': 0.8,
        'link-label-prominent-xs-hover-textDecoration': 'underline',
        'link-label-prominent-xs-initial-color': 'rgb(0, 123, 192)',
        'link-label-prominent-xs-initial-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-xs-initial-fontSize': '0.625rem',
        'link-label-prominent-xs-initial-fontWeight': 'normal',
        'link-label-prominent-xs-initial-letterSpacing': '0em',
        'link-label-prominent-xs-initial-lineHeight': '0.75rem',
        'link-label-prominent-xs-initial-opacity': 1,
        'link-label-prominent-xs-initial-textDecoration': 'none',
        'link-label-prominent-xs-pressed-color': 'rgb(0, 73, 117)',
        'link-label-prominent-xs-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'link-label-prominent-xs-pressed-fontSize': '0.625rem',
        'link-label-prominent-xs-pressed-fontWeight': 'normal',
        'link-label-prominent-xs-pressed-letterSpacing': '0em',
        'link-label-prominent-xs-pressed-lineHeight': '0.75rem',
        'link-label-prominent-xs-pressed-opacity': 0.65,
        'link-label-prominent-xs-pressed-textDecoration': 'underline',
        'linkTile-base-lg-default-background': 'rgb(255, 255, 255)',
        'linkTile-base-lg-default-borderColor': 'rgb(239, 241, 242)',
        'linkTile-base-lg-default-borderRadius': '0',
        'linkTile-base-lg-default-borderStyle': 'solid',
        'linkTile-base-lg-default-paddingBlock': '1rem',
        'linkTile-base-lg-default-paddingLeft': '1.5rem',
        'linkTile-base-lg-default-paddingRight': '0.5rem',
        'linkTile-base-lg-highlighted-background': 'rgb(239, 241, 242)',
        'linkTile-base-lg-highlighted-borderColor': 'rgb(239, 241, 242)',
        'linkTile-base-lg-highlighted-borderRadius': '0',
        'linkTile-base-lg-highlighted-borderStyle': 'solid',
        'linkTile-base-lg-highlighted-paddingBlock': '1rem',
        'linkTile-base-lg-highlighted-paddingLeft': '1.5rem',
        'linkTile-base-lg-highlighted-paddingRight': '0.5rem',
        'linkTile-base-sm-default-background': 'rgb(255, 255, 255)',
        'linkTile-base-sm-default-borderColor': 'rgb(239, 241, 242)',
        'linkTile-base-sm-default-borderRadius': '0',
        'linkTile-base-sm-default-borderStyle': 'solid',
        'linkTile-base-sm-default-paddingBlock': '1rem',
        'linkTile-base-sm-default-paddingLeft': '1rem',
        'linkTile-base-sm-default-paddingRight': '0.5rem',
        'linkTile-base-sm-highlighted-background': 'rgb(239, 241, 242)',
        'linkTile-base-sm-highlighted-borderColor': 'rgb(239, 241, 242)',
        'linkTile-base-sm-highlighted-borderRadius': '0',
        'linkTile-base-sm-highlighted-borderStyle': 'solid',
        'linkTile-base-sm-highlighted-paddingBlock': '1rem',
        'linkTile-base-sm-highlighted-paddingLeft': '1rem',
        'linkTile-base-sm-highlighted-paddingRight': '0.5rem',
        'linkTile-content-base-lg-default-gap': '1rem',
        'linkTile-content-base-lg-highlighted-gap': '1rem',
        'linkTile-content-base-sm-default-gap': '0.75rem',
        'linkTile-content-base-sm-highlighted-gap': '0.75rem',
        'linkTile-content-icon-default-background': 'rgb(0, 0, 0)',
        'linkTile-content-icon-highlighted-background': 'rgb(0, 0, 0)',
        'linkTile-content-retailerLogo-lg-paddingLeft': '3rem',
        'linkTile-content-retailerLogo-sm-paddingLeft': '2rem',
        'linkTile-content-retailerReview-base-lg-default-gap': '0.75rem',
        'linkTile-content-retailerReview-base-lg-highlighted-gap': '0.75rem',
        'linkTile-content-retailerReview-base-sm-default-gap': '0.5rem',
        'linkTile-content-retailerReview-base-sm-highlighted-gap': '0.5rem',
        'linkTile-content-retailerReview-divider-default-background': 'rgb(239, 241, 242)',
        'linkTile-content-retailerReview-divider-default-height': '2rem',
        'linkTile-content-retailerReview-divider-highlighted-background': 'rgb(224, 226, 229)',
        'linkTile-content-retailerReview-divider-highlighted-height': '2rem',
        'linkTile-content-retailerReview-logo-default-gap': '0.25rem',
        'linkTile-content-retailerReview-logo-highlighted-gap': '0.25rem',
        'linkTile-content-title-base-lg-default-gap': '0.25rem',
        'linkTile-content-title-base-lg-highlighted-gap': '0.25rem',
        'linkTile-content-title-base-sm-default-gap': '0.25rem',
        'linkTile-content-title-base-sm-highlighted-gap': '0.25rem',
        'linkTile-content-title-description-lg-default-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-description-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-description-lg-default-fontSize': '0.875rem',
        'linkTile-content-title-description-lg-default-fontWeight': 'normal',
        'linkTile-content-title-description-lg-default-letterSpacing': '0em',
        'linkTile-content-title-description-lg-default-lineHeight': '1.25rem',
        'linkTile-content-title-description-lg-default-opacity': 0.8,
        'linkTile-content-title-description-lg-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-description-lg-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-description-lg-highlighted-fontSize': '0.875rem',
        'linkTile-content-title-description-lg-highlighted-fontWeight': 'normal',
        'linkTile-content-title-description-lg-highlighted-letterSpacing': '0em',
        'linkTile-content-title-description-lg-highlighted-lineHeight': '1.25rem',
        'linkTile-content-title-description-lg-highlighted-opacity': 0.8,
        'linkTile-content-title-description-sm-default-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-description-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-description-sm-default-fontSize': '0.75rem',
        'linkTile-content-title-description-sm-default-fontWeight': 'normal',
        'linkTile-content-title-description-sm-default-letterSpacing': '0em',
        'linkTile-content-title-description-sm-default-lineHeight': '1rem',
        'linkTile-content-title-description-sm-default-opacity': 0.8,
        'linkTile-content-title-description-sm-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-description-sm-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-description-sm-highlighted-fontSize': '0.75rem',
        'linkTile-content-title-description-sm-highlighted-fontWeight': 'normal',
        'linkTile-content-title-description-sm-highlighted-letterSpacing': '0em',
        'linkTile-content-title-description-sm-highlighted-lineHeight': '1rem',
        'linkTile-content-title-description-sm-highlighted-opacity': 0.8,
        'linkTile-content-title-headline-lg-default-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-headline-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-headline-lg-default-fontSize': '1rem',
        'linkTile-content-title-headline-lg-default-fontWeight': 'bold',
        'linkTile-content-title-headline-lg-default-letterSpacing': '0em',
        'linkTile-content-title-headline-lg-default-lineHeight': '1.5rem',
        'linkTile-content-title-headline-lg-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-headline-lg-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-headline-lg-highlighted-fontSize': '1rem',
        'linkTile-content-title-headline-lg-highlighted-fontWeight': 'bold',
        'linkTile-content-title-headline-lg-highlighted-letterSpacing': '0em',
        'linkTile-content-title-headline-lg-highlighted-lineHeight': '1.5rem',
        'linkTile-content-title-headline-sm-default-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-headline-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-headline-sm-default-fontSize': '0.75rem',
        'linkTile-content-title-headline-sm-default-fontWeight': 'bold',
        'linkTile-content-title-headline-sm-default-letterSpacing': '0em',
        'linkTile-content-title-headline-sm-default-lineHeight': '1rem',
        'linkTile-content-title-headline-sm-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-content-title-headline-sm-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-content-title-headline-sm-highlighted-fontSize': '0.75rem',
        'linkTile-content-title-headline-sm-highlighted-fontWeight': 'bold',
        'linkTile-content-title-headline-sm-highlighted-letterSpacing': '0em',
        'linkTile-content-title-headline-sm-highlighted-lineHeight': '1rem',
        'linkTile-logo-base-lg-default-gap': '0.25rem',
        'linkTile-logo-base-lg-highlighted-gap': '0.25rem',
        'linkTile-logo-base-sm-default-gap': '0.25rem',
        'linkTile-logo-base-sm-highlighted-gap': '0.25rem',
        'linkTile-logo-description-lg-default-color': 'rgb(0, 0, 0)',
        'linkTile-logo-description-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-logo-description-lg-default-fontSize': '0.875rem',
        'linkTile-logo-description-lg-default-fontWeight': 'normal',
        'linkTile-logo-description-lg-default-letterSpacing': '0em',
        'linkTile-logo-description-lg-default-lineHeight': '1.25rem',
        'linkTile-logo-description-lg-default-opacity': 0.8,
        'linkTile-logo-description-lg-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-logo-description-lg-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-logo-description-lg-highlighted-fontSize': '0.875rem',
        'linkTile-logo-description-lg-highlighted-fontWeight': 'normal',
        'linkTile-logo-description-lg-highlighted-letterSpacing': '0em',
        'linkTile-logo-description-lg-highlighted-lineHeight': '1.25rem',
        'linkTile-logo-description-lg-highlighted-opacity': 0.8,
        'linkTile-logo-description-sm-default-color': 'rgb(0, 0, 0)',
        'linkTile-logo-description-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-logo-description-sm-default-fontSize': '0.75rem',
        'linkTile-logo-description-sm-default-fontWeight': 'normal',
        'linkTile-logo-description-sm-default-letterSpacing': '0em',
        'linkTile-logo-description-sm-default-lineHeight': '1rem',
        'linkTile-logo-description-sm-default-opacity': 0.8,
        'linkTile-logo-description-sm-highlighted-color': 'rgb(0, 0, 0)',
        'linkTile-logo-description-sm-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'linkTile-logo-description-sm-highlighted-fontSize': '0.75rem',
        'linkTile-logo-description-sm-highlighted-fontWeight': 'normal',
        'linkTile-logo-description-sm-highlighted-letterSpacing': '0em',
        'linkTile-logo-description-sm-highlighted-lineHeight': '1rem',
        'linkTile-logo-description-sm-highlighted-opacity': 0.8,
        'linkTile-logo-image-lg-height': '2rem',
        'linkTile-logo-image-sm-height': '1.5rem',
        'loadMore-base-lg-gap': '3rem',
        'loadMore-base-lg-width': '26rem',
        'loadMore-base-md-gap': '2rem',
        'loadMore-base-md-width': '23.5rem',
        'loadMore-base-sm-gap': '1.5rem',
        'loadMore-description-lg-color': 'rgb(0, 0, 0)',
        'loadMore-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'loadMore-description-lg-fontSize': '0.875rem',
        'loadMore-description-lg-fontWeight': 'normal',
        'loadMore-description-lg-letterSpacing': '0em',
        'loadMore-description-lg-lineHeight': '1.25rem',
        'loadMore-description-lg-opacity': 0.8,
        'loadMore-description-sm-color': 'rgb(0, 0, 0)',
        'loadMore-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'loadMore-description-sm-fontSize': '0.75rem',
        'loadMore-description-sm-fontWeight': 'normal',
        'loadMore-description-sm-letterSpacing': '0em',
        'loadMore-description-sm-lineHeight': '1rem',
        'loadMore-description-sm-opacity': 0.8,
        'loadMore-progress-lg-gap': '1.5rem',
        'loadMore-progress-md-gap': '1rem',
        'loadMore-progress-sm-gap': '0.75rem',
        'logo-height-lg': '2.5rem',
        'logo-height-md': '2rem',
        'logo-height-sm': '1.5rem',
        'logo-width-lg': '11.1875rem',
        'logo-width-md': '8.8125rem',
        'logo-width-sm': '6.5rem',
        'logoContainer-background': 'rgb(255, 255, 255)',
        'logoContainer-borderColor': 'rgb(224, 226, 229)',
        'logoContainer-borderRadius': '0',
        'logoContainer-borderStyle': 'solid',
        'logoContainer-borderWidth': '0.0625rem',
        'logoContainer-height': '2rem',
        'logoContainer-paddingLeft': '0',
        'logoContainer-paddingRight': '0',
        'message-base-default-lg-background': 'rgb(239, 241, 242)',
        'message-base-default-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-default-lg-borderRadius': '0',
        'message-base-default-lg-borderStyle': 'solid',
        'message-base-default-lg-borderWidth': '0.0625rem',
        'message-base-default-lg-gap': '1.5rem',
        'message-base-default-lg-paddingBottom': '2rem',
        'message-base-default-lg-paddingLeft': '1.5rem',
        'message-base-default-lg-paddingRight': '1.5rem',
        'message-base-default-lg-paddingTop': '2rem',
        'message-base-default-md-background': 'rgb(239, 241, 242)',
        'message-base-default-md-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-default-md-borderRadius': '0',
        'message-base-default-md-borderStyle': 'solid',
        'message-base-default-md-borderWidth': '0.0625rem',
        'message-base-default-md-gap': '1.5rem',
        'message-base-default-md-paddingBottom': '1.5rem',
        'message-base-default-md-paddingLeft': '1rem',
        'message-base-default-md-paddingRight': '1rem',
        'message-base-default-md-paddingTop': '1.5rem',
        'message-base-default-sm-background': 'rgb(239, 241, 242)',
        'message-base-default-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-default-sm-borderRadius': '0',
        'message-base-default-sm-borderStyle': 'solid',
        'message-base-default-sm-borderWidth': '0.0625rem',
        'message-base-default-sm-gap': '1rem',
        'message-base-default-sm-paddingBottom': '1.5rem',
        'message-base-default-sm-paddingLeft': '1rem',
        'message-base-default-sm-paddingRight': '1rem',
        'message-base-default-sm-paddingTop': '1.5rem',
        'message-base-floating-lg-background': 'rgb(239, 241, 242)',
        'message-base-floating-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-floating-lg-borderRadius': '0',
        'message-base-floating-lg-borderStyle': 'solid',
        'message-base-floating-lg-borderWidth': '0.0625rem',
        'message-base-floating-lg-gap': '1.5rem',
        'message-base-floating-lg-paddingBottom': '2rem',
        'message-base-floating-lg-paddingLeft': '1.5rem',
        'message-base-floating-lg-paddingRight': '1.5rem',
        'message-base-floating-lg-paddingTop': '2rem',
        'message-base-floating-md-background': 'rgb(239, 241, 242)',
        'message-base-floating-md-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-floating-md-borderRadius': '0',
        'message-base-floating-md-borderStyle': 'solid',
        'message-base-floating-md-borderWidth': '0.0625rem',
        'message-base-floating-md-gap': '1.5rem',
        'message-base-floating-md-paddingBottom': '1.5rem',
        'message-base-floating-md-paddingLeft': '1rem',
        'message-base-floating-md-paddingRight': '1rem',
        'message-base-floating-md-paddingTop': '1.5rem',
        'message-base-floating-sm-background': 'rgb(239, 241, 242)',
        'message-base-floating-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'message-base-floating-sm-borderRadius': '0',
        'message-base-floating-sm-borderStyle': 'solid',
        'message-base-floating-sm-borderWidth': '0.0625rem',
        'message-base-floating-sm-gap': '1rem',
        'message-base-floating-sm-paddingBottom': '1.5rem',
        'message-base-floating-sm-paddingLeft': '1rem',
        'message-base-floating-sm-paddingRight': '1rem',
        'message-base-floating-sm-paddingTop': '1.5rem',
        'message-title-base-lg-gap': '0.5rem',
        'message-title-base-md-gap': '0.25rem',
        'message-title-base-sm-gap': '0.25rem',
        'message-title-description-default-lg-color': 'rgb(0, 0, 0)',
        'message-title-description-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-description-default-lg-fontSize': '1rem',
        'message-title-description-default-lg-fontWeight': 'normal',
        'message-title-description-default-lg-letterSpacing': '0em',
        'message-title-description-default-lg-lineHeight': '1.5rem',
        'message-title-description-default-sm-color': 'rgb(0, 0, 0)',
        'message-title-description-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-description-default-sm-fontSize': '0.875rem',
        'message-title-description-default-sm-fontWeight': 'normal',
        'message-title-description-default-sm-letterSpacing': '0em',
        'message-title-description-default-sm-lineHeight': '1.25rem',
        'message-title-description-floating-lg-color': 'rgb(0, 0, 0)',
        'message-title-description-floating-lg-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-description-floating-lg-fontSize': '1rem',
        'message-title-description-floating-lg-fontWeight': 'normal',
        'message-title-description-floating-lg-letterSpacing': '0em',
        'message-title-description-floating-lg-lineHeight': '1.5rem',
        'message-title-description-floating-sm-color': 'rgb(0, 0, 0)',
        'message-title-description-floating-sm-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-description-floating-sm-fontSize': '0.875rem',
        'message-title-description-floating-sm-fontWeight': 'normal',
        'message-title-description-floating-sm-letterSpacing': '0em',
        'message-title-description-floating-sm-lineHeight': '1.25rem',
        'message-title-headline-default-lg-color': 'rgb(0, 0, 0)',
        'message-title-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-headline-default-lg-fontSize': '1.5rem',
        'message-title-headline-default-lg-fontWeight': 'bold',
        'message-title-headline-default-lg-letterSpacing': '0em',
        'message-title-headline-default-lg-lineHeight': '2rem',
        'message-title-headline-default-sm-color': 'rgb(0, 0, 0)',
        'message-title-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-headline-default-sm-fontSize': '1.25rem',
        'message-title-headline-default-sm-fontWeight': 'bold',
        'message-title-headline-default-sm-letterSpacing': '0em',
        'message-title-headline-default-sm-lineHeight': '1.75rem',
        'message-title-headline-floating-lg-color': 'rgb(0, 0, 0)',
        'message-title-headline-floating-lg-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-headline-floating-lg-fontSize': '1.5rem',
        'message-title-headline-floating-lg-fontWeight': 'bold',
        'message-title-headline-floating-lg-letterSpacing': '0em',
        'message-title-headline-floating-lg-lineHeight': '2rem',
        'message-title-headline-floating-sm-color': 'rgb(0, 0, 0)',
        'message-title-headline-floating-sm-fontFamily': 'Bosch Sans, sans-serif',
        'message-title-headline-floating-sm-fontSize': '1.25rem',
        'message-title-headline-floating-sm-fontWeight': 'bold',
        'message-title-headline-floating-sm-letterSpacing': '0em',
        'message-title-headline-floating-sm-lineHeight': '1.75rem',
        'modal-default-lg-width': '60rem',
        'modal-default-md-width': '50rem',
        'modal-default-sm-width': '42rem',
        'navigation-bar-actions-base-lg-gap': '1.5rem',
        'navigation-bar-actions-base-sm-gap': '1rem',
        'navigation-bar-actions-primary-base-lg-gap': '1.5rem',
        'navigation-bar-actions-primary-base-sm-gap': '1rem',
        'navigation-bar-actions-primary-divider-solid-background': 'rgba(0, 0, 0, 0.4)',
        'navigation-bar-actions-primary-divider-solid-borderRadius': '624.9375rem',
        'navigation-bar-actions-primary-divider-solid-width': '0.0625rem',
        'navigation-bar-actions-primary-divider-transparent-background': 'rgba(255, 255, 255, 0.4)',
        'navigation-bar-actions-primary-divider-transparent-borderRadius': '624.9375rem',
        'navigation-bar-actions-primary-divider-transparent-width': '0.0625rem',
        'navigation-bar-actions-primary-navigationList-base-gap': '2rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-hover-opacity': 0.65,
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-initial-opacity': 1,
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-active-pressed-opacity': 0.4,
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-hover-opacity': 0.65,
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-initial-opacity': 0.8,
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-solid-inactive-pressed-opacity': 0.4,
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-hover-opacity': 0.65,
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-initial-opacity': 1,
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-active-pressed-opacity': 0.4,
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-hover-opacity': 0.65,
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-initial-opacity': 0.8,
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-color': 'rgb(255, 255, 255)',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-fontSize': '1rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-fontWeight': 'normal',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-letterSpacing': '0em',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-lineHeight': '1.5rem',
        'navigation-bar-actions-primary-navigationList-item-transparent-inactive-pressed-opacity': 0.4,
        'navigation-bar-actions-secondary-base-lg-gap': '1rem',
        'navigation-bar-actions-secondary-base-sm-gap': '1rem',
        'navigation-bar-base-solid-lg-condensed-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-lg-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-lg-condensed-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-lg-condensed-borderStyle': 'solid',
        'navigation-bar-base-solid-lg-condensed-paddingBottom': '1.5rem',
        'navigation-bar-base-solid-lg-condensed-paddingLeft': '3rem',
        'navigation-bar-base-solid-lg-condensed-paddingRight': '2rem',
        'navigation-bar-base-solid-lg-condensed-paddingTop': '1.5rem',
        'navigation-bar-base-solid-lg-default-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-lg-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-lg-default-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-lg-default-borderStyle': 'solid',
        'navigation-bar-base-solid-lg-default-gap': '1rem',
        'navigation-bar-base-solid-lg-default-paddingBottom': '1.5rem',
        'navigation-bar-base-solid-lg-default-paddingLeft': '3rem',
        'navigation-bar-base-solid-lg-default-paddingRight': '2rem',
        'navigation-bar-base-solid-lg-default-paddingTop': '2.5rem',
        'navigation-bar-base-solid-lg-progress-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-lg-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-lg-progress-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-lg-progress-borderStyle': 'solid',
        'navigation-bar-base-solid-lg-progress-gap': '1.5rem',
        'navigation-bar-base-solid-lg-progress-paddingBottom': '1.5rem',
        'navigation-bar-base-solid-lg-progress-paddingLeft': '3rem',
        'navigation-bar-base-solid-lg-progress-paddingRight': '2rem',
        'navigation-bar-base-solid-lg-progress-paddingTop': '2.5rem',
        'navigation-bar-base-solid-md-condensed-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-md-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-md-condensed-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-md-condensed-borderStyle': 'solid',
        'navigation-bar-base-solid-md-condensed-gap': '2rem',
        'navigation-bar-base-solid-md-condensed-paddingBottom': '1.5rem',
        'navigation-bar-base-solid-md-condensed-paddingLeft': '2rem',
        'navigation-bar-base-solid-md-condensed-paddingRight': '1rem',
        'navigation-bar-base-solid-md-condensed-paddingTop': '1.5rem',
        'navigation-bar-base-solid-md-default-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-md-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-md-default-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-md-default-borderStyle': 'solid',
        'navigation-bar-base-solid-md-default-gap': '0.75rem',
        'navigation-bar-base-solid-md-default-paddingBottom': '1rem',
        'navigation-bar-base-solid-md-default-paddingLeft': '2rem',
        'navigation-bar-base-solid-md-default-paddingRight': '1rem',
        'navigation-bar-base-solid-md-default-paddingTop': '2rem',
        'navigation-bar-base-solid-md-progress-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-md-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-md-progress-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-md-progress-borderStyle': 'solid',
        'navigation-bar-base-solid-md-progress-gap': '1rem',
        'navigation-bar-base-solid-md-progress-paddingBottom': '1.5rem',
        'navigation-bar-base-solid-md-progress-paddingLeft': '2rem',
        'navigation-bar-base-solid-md-progress-paddingRight': '1rem',
        'navigation-bar-base-solid-md-progress-paddingTop': '2rem',
        'navigation-bar-base-solid-sm-condensed-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-sm-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-sm-condensed-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-sm-condensed-borderStyle': 'solid',
        'navigation-bar-base-solid-sm-condensed-paddingBottom': '1rem',
        'navigation-bar-base-solid-sm-condensed-paddingLeft': '1rem',
        'navigation-bar-base-solid-sm-condensed-paddingRight': '1rem',
        'navigation-bar-base-solid-sm-condensed-paddingTop': '1rem',
        'navigation-bar-base-solid-sm-default-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-sm-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-sm-default-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-sm-default-borderStyle': 'solid',
        'navigation-bar-base-solid-sm-default-gap': '0.5rem',
        'navigation-bar-base-solid-sm-default-paddingBottom': '1rem',
        'navigation-bar-base-solid-sm-default-paddingLeft': '1rem',
        'navigation-bar-base-solid-sm-default-paddingRight': '1rem',
        'navigation-bar-base-solid-sm-default-paddingTop': '1rem',
        'navigation-bar-base-solid-sm-progress-background': 'rgb(255, 255, 255)',
        'navigation-bar-base-solid-sm-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-solid-sm-progress-borderColor': 'rgb(193, 199, 204)',
        'navigation-bar-base-solid-sm-progress-borderStyle': 'solid',
        'navigation-bar-base-solid-sm-progress-gap': '0.75rem',
        'navigation-bar-base-solid-sm-progress-paddingBottom': '1rem',
        'navigation-bar-base-solid-sm-progress-paddingLeft': '1rem',
        'navigation-bar-base-solid-sm-progress-paddingRight': '1rem',
        'navigation-bar-base-solid-sm-progress-paddingTop': '1rem',
        'navigation-bar-base-transparent-lg-condensed-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-lg-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-lg-condensed-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-lg-condensed-borderStyle': 'solid',
        'navigation-bar-base-transparent-lg-condensed-paddingBottom': '1.5rem',
        'navigation-bar-base-transparent-lg-condensed-paddingLeft': '3rem',
        'navigation-bar-base-transparent-lg-condensed-paddingRight': '2rem',
        'navigation-bar-base-transparent-lg-condensed-paddingTop': '1.5rem',
        'navigation-bar-base-transparent-lg-default-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-lg-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-lg-default-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-lg-default-borderStyle': 'solid',
        'navigation-bar-base-transparent-lg-default-gap': '1rem',
        'navigation-bar-base-transparent-lg-default-paddingBottom': '1.5rem',
        'navigation-bar-base-transparent-lg-default-paddingLeft': '3rem',
        'navigation-bar-base-transparent-lg-default-paddingRight': '2rem',
        'navigation-bar-base-transparent-lg-default-paddingTop': '2.5rem',
        'navigation-bar-base-transparent-lg-progress-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-lg-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-lg-progress-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-lg-progress-borderStyle': 'solid',
        'navigation-bar-base-transparent-lg-progress-gap': '1.5rem',
        'navigation-bar-base-transparent-lg-progress-paddingBottom': '1.5rem',
        'navigation-bar-base-transparent-lg-progress-paddingLeft': '3rem',
        'navigation-bar-base-transparent-lg-progress-paddingRight': '2rem',
        'navigation-bar-base-transparent-lg-progress-paddingTop': '2.5rem',
        'navigation-bar-base-transparent-md-condensed-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-md-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-md-condensed-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-md-condensed-borderStyle': 'solid',
        'navigation-bar-base-transparent-md-condensed-gap': '1rem',
        'navigation-bar-base-transparent-md-condensed-paddingBottom': '1.5rem',
        'navigation-bar-base-transparent-md-condensed-paddingLeft': '2rem',
        'navigation-bar-base-transparent-md-condensed-paddingRight': '1rem',
        'navigation-bar-base-transparent-md-condensed-paddingTop': '1.5rem',
        'navigation-bar-base-transparent-md-default-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-md-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-md-default-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-md-default-borderStyle': 'solid',
        'navigation-bar-base-transparent-md-default-gap': '0.75rem',
        'navigation-bar-base-transparent-md-default-paddingBottom': '1rem',
        'navigation-bar-base-transparent-md-default-paddingLeft': '2rem',
        'navigation-bar-base-transparent-md-default-paddingRight': '1rem',
        'navigation-bar-base-transparent-md-default-paddingTop': '2rem',
        'navigation-bar-base-transparent-md-progress-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-md-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-md-progress-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-md-progress-borderStyle': 'solid',
        'navigation-bar-base-transparent-md-progress-gap': '1rem',
        'navigation-bar-base-transparent-md-progress-paddingBottom': '1.5rem',
        'navigation-bar-base-transparent-md-progress-paddingLeft': '2rem',
        'navigation-bar-base-transparent-md-progress-paddingRight': '1rem',
        'navigation-bar-base-transparent-md-progress-paddingTop': '2rem',
        'navigation-bar-base-transparent-sm-condensed-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-sm-condensed-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-sm-condensed-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-sm-condensed-borderStyle': 'solid',
        'navigation-bar-base-transparent-sm-condensed-paddingBottom': '1rem',
        'navigation-bar-base-transparent-sm-condensed-paddingLeft': '1rem',
        'navigation-bar-base-transparent-sm-condensed-paddingRight': '1rem',
        'navigation-bar-base-transparent-sm-condensed-paddingTop': '1rem',
        'navigation-bar-base-transparent-sm-default-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-sm-default-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-sm-default-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-sm-default-borderStyle': 'solid',
        'navigation-bar-base-transparent-sm-default-gap': '0.5rem',
        'navigation-bar-base-transparent-sm-default-paddingBottom': '1rem',
        'navigation-bar-base-transparent-sm-default-paddingLeft': '1rem',
        'navigation-bar-base-transparent-sm-default-paddingRight': '1rem',
        'navigation-bar-base-transparent-sm-default-paddingTop': '1rem',
        'navigation-bar-base-transparent-sm-progress-background': 'linear-gradient(180deg, #00000099 0%, #00000099 20%, #0000000d 100%);',
        'navigation-bar-base-transparent-sm-progress-borderBottomWidth': '0.0625rem',
        'navigation-bar-base-transparent-sm-progress-borderColor': 'rgba(0, 0, 0, 0)',
        'navigation-bar-base-transparent-sm-progress-borderStyle': 'solid',
        'navigation-bar-base-transparent-sm-progress-gap': '0.75rem',
        'navigation-bar-base-transparent-sm-progress-paddingBottom': '1rem',
        'navigation-bar-base-transparent-sm-progress-paddingLeft': '1rem',
        'navigation-bar-base-transparent-sm-progress-paddingRight': '1rem',
        'navigation-bar-base-transparent-sm-progress-paddingTop': '1rem',
        'navigation-bar-brandArea-base-lg-paddingRight': '1rem',
        'navigation-bar-brandArea-base-sm-paddingRight': '0',
        'navigation-bar-menuButton-base-solid-lg-hover-background': 'rgb(232, 241, 255)',
        'navigation-bar-menuButton-base-solid-lg-hover-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-lg-hover-height': '3rem',
        'navigation-bar-menuButton-base-solid-lg-hover-width': '3rem',
        'navigation-bar-menuButton-base-solid-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'navigation-bar-menuButton-base-solid-lg-initial-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-lg-initial-height': '3rem',
        'navigation-bar-menuButton-base-solid-lg-initial-width': '3rem',
        'navigation-bar-menuButton-base-solid-lg-pressed-background': 'rgb(209, 228, 255)',
        'navigation-bar-menuButton-base-solid-lg-pressed-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-lg-pressed-height': '3rem',
        'navigation-bar-menuButton-base-solid-lg-pressed-width': '3rem',
        'navigation-bar-menuButton-base-solid-sm-hover-background': 'rgb(232, 241, 255)',
        'navigation-bar-menuButton-base-solid-sm-hover-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-sm-hover-height': '2rem',
        'navigation-bar-menuButton-base-solid-sm-hover-width': '2rem',
        'navigation-bar-menuButton-base-solid-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'navigation-bar-menuButton-base-solid-sm-initial-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-sm-initial-height': '2rem',
        'navigation-bar-menuButton-base-solid-sm-initial-width': '2rem',
        'navigation-bar-menuButton-base-solid-sm-pressed-background': 'rgb(209, 228, 255)',
        'navigation-bar-menuButton-base-solid-sm-pressed-borderRadius': '0',
        'navigation-bar-menuButton-base-solid-sm-pressed-height': '2rem',
        'navigation-bar-menuButton-base-solid-sm-pressed-width': '2rem',
        'navigation-bar-menuButton-base-transparent-lg-hover-background': 'rgba(0, 0, 0, 0.1)',
        'navigation-bar-menuButton-base-transparent-lg-hover-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-lg-hover-height': '3rem',
        'navigation-bar-menuButton-base-transparent-lg-hover-width': '3rem',
        'navigation-bar-menuButton-base-transparent-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'navigation-bar-menuButton-base-transparent-lg-initial-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-lg-initial-height': '3rem',
        'navigation-bar-menuButton-base-transparent-lg-initial-width': '3rem',
        'navigation-bar-menuButton-base-transparent-lg-pressed-background': 'rgba(0, 0, 0, 0.1)',
        'navigation-bar-menuButton-base-transparent-lg-pressed-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-lg-pressed-height': '3rem',
        'navigation-bar-menuButton-base-transparent-lg-pressed-width': '3rem',
        'navigation-bar-menuButton-base-transparent-sm-hover-background': 'rgba(0, 0, 0, 0.1)',
        'navigation-bar-menuButton-base-transparent-sm-hover-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-sm-hover-height': '2rem',
        'navigation-bar-menuButton-base-transparent-sm-hover-width': '2rem',
        'navigation-bar-menuButton-base-transparent-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'navigation-bar-menuButton-base-transparent-sm-initial-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-sm-initial-height': '2rem',
        'navigation-bar-menuButton-base-transparent-sm-initial-width': '2rem',
        'navigation-bar-menuButton-base-transparent-sm-pressed-background': 'rgba(0, 0, 0, 0.1)',
        'navigation-bar-menuButton-base-transparent-sm-pressed-borderRadius': '0',
        'navigation-bar-menuButton-base-transparent-sm-pressed-height': '2rem',
        'navigation-bar-menuButton-base-transparent-sm-pressed-width': '2rem',
        'navigation-bar-menuButton-solid-hover-background': 'rgb(0, 98, 154)',
        'navigation-bar-menuButton-solid-hover-opacity': 0.8,
        'navigation-bar-menuButton-solid-initial-background': 'rgb(0, 0, 0)',
        'navigation-bar-menuButton-solid-initial-opacity': 1,
        'navigation-bar-menuButton-solid-pressed-background': 'rgb(0, 73, 117)',
        'navigation-bar-menuButton-solid-pressed-opacity': 0.65,
        'navigation-bar-menuButton-transparent-hover-background': 'rgb(255, 255, 255)',
        'navigation-bar-menuButton-transparent-hover-opacity': 0.8,
        'navigation-bar-menuButton-transparent-initial-background': 'rgb(255, 255, 255)',
        'navigation-bar-menuButton-transparent-initial-opacity': 1,
        'navigation-bar-menuButton-transparent-pressed-background': 'rgb(255, 255, 255)',
        'navigation-bar-menuButton-transparent-pressed-opacity': 0.65,
        'navigation-bar-tagline-solid-lg-color': 'rgb(0, 0, 0)',
        'navigation-bar-tagline-solid-lg-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-tagline-solid-lg-fontSize': '1rem',
        'navigation-bar-tagline-solid-lg-fontWeight': 'bold',
        'navigation-bar-tagline-solid-lg-letterSpacing': '0em',
        'navigation-bar-tagline-solid-lg-lineHeight': '1.5rem',
        'navigation-bar-tagline-solid-sm-color': 'rgb(0, 0, 0)',
        'navigation-bar-tagline-solid-sm-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-tagline-solid-sm-fontSize': '0.75rem',
        'navigation-bar-tagline-solid-sm-fontWeight': 'bold',
        'navigation-bar-tagline-solid-sm-letterSpacing': '0em',
        'navigation-bar-tagline-solid-sm-lineHeight': '1rem',
        'navigation-bar-tagline-transparent-lg-color': 'rgb(255, 255, 255)',
        'navigation-bar-tagline-transparent-lg-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-tagline-transparent-lg-fontSize': '1rem',
        'navigation-bar-tagline-transparent-lg-fontWeight': 'bold',
        'navigation-bar-tagline-transparent-lg-letterSpacing': '0em',
        'navigation-bar-tagline-transparent-lg-lineHeight': '1.5rem',
        'navigation-bar-tagline-transparent-sm-color': 'rgb(255, 255, 255)',
        'navigation-bar-tagline-transparent-sm-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-bar-tagline-transparent-sm-fontSize': '0.75rem',
        'navigation-bar-tagline-transparent-sm-fontWeight': 'bold',
        'navigation-bar-tagline-transparent-sm-letterSpacing': '0em',
        'navigation-bar-tagline-transparent-sm-lineHeight': '1rem',
        'navigation-buttonAction-base-solid-default-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-solid-default-focused': 'rgb(209, 228, 255)',
        'navigation-buttonAction-base-solid-default-hover': 'rgb(209, 228, 255)',
        'navigation-buttonAction-base-solid-default-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-solid-default-pressed': 'rgb(157, 201, 255)',
        'navigation-buttonAction-base-solid-subtle-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-solid-subtle-focused': 'rgb(232, 241, 255)',
        'navigation-buttonAction-base-solid-subtle-hover': 'rgb(232, 241, 255)',
        'navigation-buttonAction-base-solid-subtle-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-solid-subtle-pressed': 'rgb(209, 228, 255)',
        'navigation-buttonAction-base-transparent-default-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-transparent-default-focused': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-base-transparent-default-hover': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-base-transparent-default-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-transparent-default-pressed': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-base-transparent-subtle-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-transparent-subtle-focused': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-base-transparent-subtle-hover': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-base-transparent-subtle-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-base-transparent-subtle-pressed': 'rgba(0, 0, 0, 0.1)',
        'navigation-buttonAction-borderColor-solid-default-disabled': 'rgb(113, 118, 124)',
        'navigation-buttonAction-borderColor-solid-default-focused': 'rgb(0, 98, 154)',
        'navigation-buttonAction-borderColor-solid-default-hover': 'rgb(0, 98, 154)',
        'navigation-buttonAction-borderColor-solid-default-initial': 'rgb(193, 199, 204)',
        'navigation-buttonAction-borderColor-solid-default-pressed': 'rgb(0, 73, 117)',
        'navigation-buttonAction-borderColor-solid-subtle-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-solid-subtle-focused': 'rgb(0, 98, 154)',
        'navigation-buttonAction-borderColor-solid-subtle-hover': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-solid-subtle-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-solid-subtle-pressed': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-transparent-default-disabled': 'rgba(255, 255, 255, 0.45)',
        'navigation-buttonAction-borderColor-transparent-default-focused': 'rgb(255, 255, 255)',
        'navigation-buttonAction-borderColor-transparent-default-hover': 'rgb(255, 255, 255)',
        'navigation-buttonAction-borderColor-transparent-default-initial': 'rgb(255, 255, 255)',
        'navigation-buttonAction-borderColor-transparent-default-pressed': 'rgb(255, 255, 255)',
        'navigation-buttonAction-borderColor-transparent-subtle-disabled': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-transparent-subtle-focused': 'rgb(255, 255, 255)',
        'navigation-buttonAction-borderColor-transparent-subtle-hover': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-transparent-subtle-initial': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-borderColor-transparent-subtle-pressed': 'rgba(0, 0, 0, 0)',
        'navigation-buttonAction-onBase-solid-default-disabled': 'rgb(0, 0, 0)',
        'navigation-buttonAction-onBase-solid-default-focused': 'rgb(0, 98, 154)',
        'navigation-buttonAction-onBase-solid-default-hover': 'rgb(0, 98, 154)',
        'navigation-buttonAction-onBase-solid-default-initial': 'rgb(0, 0, 0)',
        'navigation-buttonAction-onBase-solid-default-pressed': 'rgb(0, 73, 117)',
        'navigation-buttonAction-onBase-solid-subtle-disabled': 'rgb(0, 0, 0)',
        'navigation-buttonAction-onBase-solid-subtle-focused': 'rgb(0, 98, 154)',
        'navigation-buttonAction-onBase-solid-subtle-hover': 'rgb(0, 98, 154)',
        'navigation-buttonAction-onBase-solid-subtle-initial': 'rgb(0, 0, 0)',
        'navigation-buttonAction-onBase-solid-subtle-pressed': 'rgb(0, 73, 117)',
        'navigation-buttonAction-onBase-transparent-default-disabled': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-default-focused': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-default-hover': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-default-initial': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-default-pressed': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-subtle-disabled': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-subtle-focused': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-subtle-hover': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-subtle-initial': 'rgb(255, 255, 255)',
        'navigation-buttonAction-onBase-transparent-subtle-pressed': 'rgb(255, 255, 255)',
        'navigation-infobar-base-lg-background': 'rgb(239, 241, 242)',
        'navigation-infobar-base-lg-paddingBottom': '1rem',
        'navigation-infobar-base-lg-paddingLeft': '3rem',
        'navigation-infobar-base-lg-paddingRight': '3rem',
        'navigation-infobar-base-lg-paddingTop': '1rem',
        'navigation-infobar-base-md-background': 'rgb(239, 241, 242)',
        'navigation-infobar-base-md-paddingBottom': '0.75rem',
        'navigation-infobar-base-md-paddingLeft': '2rem',
        'navigation-infobar-base-md-paddingRight': '2rem',
        'navigation-infobar-base-md-paddingTop': '0.75rem',
        'navigation-infobar-base-sm-background': 'rgb(239, 241, 242)',
        'navigation-infobar-base-sm-paddingBottom': '0.75rem',
        'navigation-infobar-base-sm-paddingLeft': '1rem',
        'navigation-infobar-base-sm-paddingRight': '1rem',
        'navigation-infobar-base-sm-paddingTop': '0.75rem',
        'navigation-infobar-content-base-gap': '1rem',
        'navigation-infobar-content-countdown-base-gap': '0.5rem',
        'navigation-infobar-content-countdown-item-base-gap': '0.125rem',
        'navigation-infobar-content-countdown-item-label-color': 'rgb(0, 0, 0)',
        'navigation-infobar-content-countdown-item-label-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-infobar-content-countdown-item-label-fontSize': '0.875rem',
        'navigation-infobar-content-countdown-item-label-fontWeight': 'normal',
        'navigation-infobar-content-countdown-item-label-letterSpacing': '0em',
        'navigation-infobar-content-countdown-item-label-lineHeight': '1.25rem',
        'navigation-infobar-content-countdown-item-label-opacity': 1,
        'navigation-infobar-content-countdown-item-number-color': 'rgb(0, 0, 0)',
        'navigation-infobar-content-countdown-item-number-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-infobar-content-countdown-item-number-fontSize': '0.875rem',
        'navigation-infobar-content-countdown-item-number-fontWeight': 'bold',
        'navigation-infobar-content-countdown-item-number-letterSpacing': '0em',
        'navigation-infobar-content-countdown-item-number-lineHeight': '1.25rem',
        'navigation-infobar-content-countdown-item-number-width': '1.125rem',
        'navigation-infobar-content-label-color': 'rgb(0, 0, 0)',
        'navigation-infobar-content-label-fontFamily': 'Bosch Sans, sans-serif',
        'navigation-infobar-content-label-fontSize': '0.875rem',
        'navigation-infobar-content-label-fontWeight': 'normal',
        'navigation-infobar-content-label-letterSpacing': '0em',
        'navigation-infobar-content-label-lineHeight': '1.25rem',
        'navigation-infobar-content-link-iconColor-default': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-iconColor-disabled': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-iconColor-hover': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-iconColor-pressed': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-textColor-default': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-textColor-disabled': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-textColor-hover': 'rgb(0, 0, 0)',
        'navigation-infobar-content-link-textColor-pressed': 'rgb(0, 0, 0)',
        'navigation-progressSteps-base-lg-maxWidth': '72.5rem',
        'navigation-progressSteps-base-lg-paddingBottom': '0.5rem',
        'navigation-progressSteps-base-lg-paddingTop': '0.5rem',
        'navigation-progressSteps-base-sm-paddingBottom': '0.25rem',
        'navigation-progressSteps-base-sm-paddingTop': '0.25rem',
        'navigationButton-base-primary-lg-active-hover-background': 'rgb(224, 226, 229)',
        'navigationButton-base-primary-lg-active-hover-borderRadius': '0',
        'navigationButton-base-primary-lg-active-hover-gap': '0.75rem',
        'navigationButton-base-primary-lg-active-hover-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-active-hover-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-active-hover-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-active-hover-paddingTop': '1rem',
        'navigationButton-base-primary-lg-active-initial-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-lg-active-initial-borderRadius': '0',
        'navigationButton-base-primary-lg-active-initial-gap': '0.75rem',
        'navigationButton-base-primary-lg-active-initial-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-active-initial-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-active-initial-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-active-initial-paddingTop': '1rem',
        'navigationButton-base-primary-lg-active-pressed-background': 'rgb(224, 226, 229)',
        'navigationButton-base-primary-lg-active-pressed-borderRadius': '0',
        'navigationButton-base-primary-lg-active-pressed-gap': '0.75rem',
        'navigationButton-base-primary-lg-active-pressed-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-active-pressed-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-active-pressed-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-active-pressed-paddingTop': '1rem',
        'navigationButton-base-primary-lg-inactive-hover-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-lg-inactive-hover-borderRadius': '0',
        'navigationButton-base-primary-lg-inactive-hover-gap': '0.75rem',
        'navigationButton-base-primary-lg-inactive-hover-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-inactive-hover-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-inactive-hover-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-inactive-hover-paddingTop': '1rem',
        'navigationButton-base-primary-lg-inactive-initial-background': 'rgb(255, 255, 255)',
        'navigationButton-base-primary-lg-inactive-initial-borderRadius': '0',
        'navigationButton-base-primary-lg-inactive-initial-gap': '0.75rem',
        'navigationButton-base-primary-lg-inactive-initial-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-inactive-initial-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-inactive-initial-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-inactive-initial-paddingTop': '1rem',
        'navigationButton-base-primary-lg-inactive-pressed-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-lg-inactive-pressed-borderRadius': '0',
        'navigationButton-base-primary-lg-inactive-pressed-gap': '0.75rem',
        'navigationButton-base-primary-lg-inactive-pressed-paddingBottom': '1rem',
        'navigationButton-base-primary-lg-inactive-pressed-paddingLeft': '1.5rem',
        'navigationButton-base-primary-lg-inactive-pressed-paddingRight': '1.5rem',
        'navigationButton-base-primary-lg-inactive-pressed-paddingTop': '1rem',
        'navigationButton-base-primary-sm-active-hover-background': 'rgb(224, 226, 229)',
        'navigationButton-base-primary-sm-active-hover-borderRadius': '0',
        'navigationButton-base-primary-sm-active-hover-gap': '0.5rem',
        'navigationButton-base-primary-sm-active-hover-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-active-hover-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-active-hover-paddingRight': '1rem',
        'navigationButton-base-primary-sm-active-hover-paddingTop': '0.75rem',
        'navigationButton-base-primary-sm-active-initial-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-sm-active-initial-borderRadius': '0',
        'navigationButton-base-primary-sm-active-initial-gap': '0.5rem',
        'navigationButton-base-primary-sm-active-initial-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-active-initial-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-active-initial-paddingRight': '1rem',
        'navigationButton-base-primary-sm-active-initial-paddingTop': '0.75rem',
        'navigationButton-base-primary-sm-active-pressed-background': 'rgb(224, 226, 229)',
        'navigationButton-base-primary-sm-active-pressed-borderRadius': '0',
        'navigationButton-base-primary-sm-active-pressed-gap': '0.5rem',
        'navigationButton-base-primary-sm-active-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-active-pressed-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-active-pressed-paddingRight': '1rem',
        'navigationButton-base-primary-sm-active-pressed-paddingTop': '0.75rem',
        'navigationButton-base-primary-sm-inactive-hover-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-sm-inactive-hover-borderRadius': '0',
        'navigationButton-base-primary-sm-inactive-hover-gap': '0.5rem',
        'navigationButton-base-primary-sm-inactive-hover-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-inactive-hover-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-inactive-hover-paddingRight': '1rem',
        'navigationButton-base-primary-sm-inactive-hover-paddingTop': '0.75rem',
        'navigationButton-base-primary-sm-inactive-initial-background': 'rgb(255, 255, 255)',
        'navigationButton-base-primary-sm-inactive-initial-borderRadius': '0',
        'navigationButton-base-primary-sm-inactive-initial-gap': '0.5rem',
        'navigationButton-base-primary-sm-inactive-initial-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-inactive-initial-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-inactive-initial-paddingRight': '1rem',
        'navigationButton-base-primary-sm-inactive-initial-paddingTop': '0.75rem',
        'navigationButton-base-primary-sm-inactive-pressed-background': 'rgb(239, 241, 242)',
        'navigationButton-base-primary-sm-inactive-pressed-borderRadius': '0',
        'navigationButton-base-primary-sm-inactive-pressed-gap': '0.5rem',
        'navigationButton-base-primary-sm-inactive-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-primary-sm-inactive-pressed-paddingLeft': '1rem',
        'navigationButton-base-primary-sm-inactive-pressed-paddingRight': '1rem',
        'navigationButton-base-primary-sm-inactive-pressed-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-active-hover-background': 'rgb(224, 226, 229)',
        'navigationButton-base-secondary-lg-active-hover-borderRadius': '0',
        'navigationButton-base-secondary-lg-active-hover-gap': '0.5rem',
        'navigationButton-base-secondary-lg-active-hover-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-active-hover-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-active-hover-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-active-hover-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-active-initial-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-lg-active-initial-borderRadius': '0',
        'navigationButton-base-secondary-lg-active-initial-gap': '0.5rem',
        'navigationButton-base-secondary-lg-active-initial-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-active-initial-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-active-initial-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-active-initial-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-active-pressed-background': 'rgb(224, 226, 229)',
        'navigationButton-base-secondary-lg-active-pressed-borderRadius': '0',
        'navigationButton-base-secondary-lg-active-pressed-gap': '0.5rem',
        'navigationButton-base-secondary-lg-active-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-active-pressed-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-active-pressed-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-active-pressed-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-hover-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-lg-inactive-hover-borderRadius': '0',
        'navigationButton-base-secondary-lg-inactive-hover-gap': '0.5rem',
        'navigationButton-base-secondary-lg-inactive-hover-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-hover-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-hover-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-hover-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-initial-background': 'rgb(255, 255, 255)',
        'navigationButton-base-secondary-lg-inactive-initial-borderRadius': '0',
        'navigationButton-base-secondary-lg-inactive-initial-gap': '0.5rem',
        'navigationButton-base-secondary-lg-inactive-initial-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-initial-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-initial-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-initial-paddingTop': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-pressed-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-lg-inactive-pressed-borderRadius': '0',
        'navigationButton-base-secondary-lg-inactive-pressed-gap': '0.5rem',
        'navigationButton-base-secondary-lg-inactive-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-lg-inactive-pressed-paddingLeft': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-pressed-paddingRight': '1.5rem',
        'navigationButton-base-secondary-lg-inactive-pressed-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-active-hover-background': 'rgb(224, 226, 229)',
        'navigationButton-base-secondary-sm-active-hover-borderRadius': '0',
        'navigationButton-base-secondary-sm-active-hover-gap': '0.5rem',
        'navigationButton-base-secondary-sm-active-hover-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-active-hover-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-active-hover-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-active-hover-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-active-initial-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-sm-active-initial-borderRadius': '0',
        'navigationButton-base-secondary-sm-active-initial-gap': '0.5rem',
        'navigationButton-base-secondary-sm-active-initial-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-active-initial-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-active-initial-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-active-initial-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-active-pressed-background': 'rgb(224, 226, 229)',
        'navigationButton-base-secondary-sm-active-pressed-borderRadius': '0',
        'navigationButton-base-secondary-sm-active-pressed-gap': '0.5rem',
        'navigationButton-base-secondary-sm-active-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-active-pressed-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-active-pressed-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-active-pressed-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-hover-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-sm-inactive-hover-borderRadius': '0',
        'navigationButton-base-secondary-sm-inactive-hover-gap': '0.5rem',
        'navigationButton-base-secondary-sm-inactive-hover-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-hover-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-inactive-hover-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-inactive-hover-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-initial-background': 'rgb(255, 255, 255)',
        'navigationButton-base-secondary-sm-inactive-initial-borderRadius': '0',
        'navigationButton-base-secondary-sm-inactive-initial-gap': '0.5rem',
        'navigationButton-base-secondary-sm-inactive-initial-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-initial-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-inactive-initial-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-inactive-initial-paddingTop': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-pressed-background': 'rgb(239, 241, 242)',
        'navigationButton-base-secondary-sm-inactive-pressed-borderRadius': '0',
        'navigationButton-base-secondary-sm-inactive-pressed-gap': '0.5rem',
        'navigationButton-base-secondary-sm-inactive-pressed-paddingBottom': '0.75rem',
        'navigationButton-base-secondary-sm-inactive-pressed-paddingLeft': '1rem',
        'navigationButton-base-secondary-sm-inactive-pressed-paddingRight': '1rem',
        'navigationButton-base-secondary-sm-inactive-pressed-paddingTop': '0.75rem',
        'navigationButton-helper-active-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-active-hover-fontSize': '0.875rem',
        'navigationButton-helper-active-hover-fontWeight': 'normal',
        'navigationButton-helper-active-hover-letterSpacing': '0em',
        'navigationButton-helper-active-hover-lineHeight': '1.25rem',
        'navigationButton-helper-active-hover-opacity': 1,
        'navigationButton-helper-active-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-active-initial-fontSize': '0.875rem',
        'navigationButton-helper-active-initial-fontWeight': 'normal',
        'navigationButton-helper-active-initial-letterSpacing': '0em',
        'navigationButton-helper-active-initial-lineHeight': '1.25rem',
        'navigationButton-helper-active-initial-opacity': 0.8,
        'navigationButton-helper-active-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-active-pressed-fontSize': '0.875rem',
        'navigationButton-helper-active-pressed-fontWeight': 'normal',
        'navigationButton-helper-active-pressed-letterSpacing': '0em',
        'navigationButton-helper-active-pressed-lineHeight': '1.25rem',
        'navigationButton-helper-active-pressed-opacity': 0.65,
        'navigationButton-helper-base-lg-initial-height': 'auto',
        'navigationButton-helper-base-lg-sticky-height': '26rem',
        'navigationButton-helper-base-sm-initial-height': 'auto',
        'navigationButton-helper-base-sm-sticky-height': '26rem',
        'navigationButton-helper-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-inactive-hover-fontSize': '0.875rem',
        'navigationButton-helper-inactive-hover-fontWeight': 'normal',
        'navigationButton-helper-inactive-hover-letterSpacing': '0em',
        'navigationButton-helper-inactive-hover-lineHeight': '1.25rem',
        'navigationButton-helper-inactive-hover-opacity': 1,
        'navigationButton-helper-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-inactive-initial-fontSize': '0.875rem',
        'navigationButton-helper-inactive-initial-fontWeight': 'normal',
        'navigationButton-helper-inactive-initial-letterSpacing': '0em',
        'navigationButton-helper-inactive-initial-lineHeight': '1.25rem',
        'navigationButton-helper-inactive-initial-opacity': 0.8,
        'navigationButton-helper-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-helper-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-helper-inactive-pressed-fontSize': '0.875rem',
        'navigationButton-helper-inactive-pressed-fontWeight': 'normal',
        'navigationButton-helper-inactive-pressed-letterSpacing': '0em',
        'navigationButton-helper-inactive-pressed-lineHeight': '1.25rem',
        'navigationButton-helper-inactive-pressed-opacity': 0.65,
        'navigationButton-icon-primary-lg-active-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-lg-active-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-lg-active-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-lg-inactive-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-lg-inactive-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-lg-inactive-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-active-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-active-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-active-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-inactive-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-inactive-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-primary-sm-inactive-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-active-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-active-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-active-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-inactive-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-inactive-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-lg-inactive-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-active-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-active-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-active-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-inactive-hover-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-inactive-initial-background': 'rgb(0, 0, 0)',
        'navigationButton-icon-secondary-sm-inactive-pressed-background': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-active-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-active-hover-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-active-hover-fontWeight': 'bold',
        'navigationButton-label-primary-lg-active-hover-letterSpacing': '0em',
        'navigationButton-label-primary-lg-active-hover-lineHeight': '2rem',
        'navigationButton-label-primary-lg-active-hover-opacity': 1,
        'navigationButton-label-primary-lg-active-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-active-initial-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-active-initial-fontWeight': 'bold',
        'navigationButton-label-primary-lg-active-initial-letterSpacing': '0em',
        'navigationButton-label-primary-lg-active-initial-lineHeight': '2rem',
        'navigationButton-label-primary-lg-active-initial-opacity': 0.8,
        'navigationButton-label-primary-lg-active-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-active-pressed-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-active-pressed-fontWeight': 'bold',
        'navigationButton-label-primary-lg-active-pressed-letterSpacing': '0em',
        'navigationButton-label-primary-lg-active-pressed-lineHeight': '2rem',
        'navigationButton-label-primary-lg-active-pressed-opacity': 0.65,
        'navigationButton-label-primary-lg-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-inactive-hover-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-inactive-hover-fontWeight': 'bold',
        'navigationButton-label-primary-lg-inactive-hover-letterSpacing': '0em',
        'navigationButton-label-primary-lg-inactive-hover-lineHeight': '2rem',
        'navigationButton-label-primary-lg-inactive-hover-opacity': 1,
        'navigationButton-label-primary-lg-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-inactive-initial-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-inactive-initial-fontWeight': 'bold',
        'navigationButton-label-primary-lg-inactive-initial-letterSpacing': '0em',
        'navigationButton-label-primary-lg-inactive-initial-lineHeight': '2rem',
        'navigationButton-label-primary-lg-inactive-initial-opacity': 0.8,
        'navigationButton-label-primary-lg-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-lg-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-lg-inactive-pressed-fontSize': '1.5rem',
        'navigationButton-label-primary-lg-inactive-pressed-fontWeight': 'bold',
        'navigationButton-label-primary-lg-inactive-pressed-letterSpacing': '0em',
        'navigationButton-label-primary-lg-inactive-pressed-lineHeight': '2rem',
        'navigationButton-label-primary-lg-inactive-pressed-opacity': 0.65,
        'navigationButton-label-primary-sm-active-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-active-hover-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-active-hover-fontWeight': 'bold',
        'navigationButton-label-primary-sm-active-hover-letterSpacing': '0em',
        'navigationButton-label-primary-sm-active-hover-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-active-hover-opacity': 1,
        'navigationButton-label-primary-sm-active-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-active-initial-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-active-initial-fontWeight': 'bold',
        'navigationButton-label-primary-sm-active-initial-letterSpacing': '0em',
        'navigationButton-label-primary-sm-active-initial-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-active-initial-opacity': 0.8,
        'navigationButton-label-primary-sm-active-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-active-pressed-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-active-pressed-fontWeight': 'bold',
        'navigationButton-label-primary-sm-active-pressed-letterSpacing': '0em',
        'navigationButton-label-primary-sm-active-pressed-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-active-pressed-opacity': 0.65,
        'navigationButton-label-primary-sm-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-inactive-hover-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-inactive-hover-fontWeight': 'bold',
        'navigationButton-label-primary-sm-inactive-hover-letterSpacing': '0em',
        'navigationButton-label-primary-sm-inactive-hover-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-inactive-hover-opacity': 1,
        'navigationButton-label-primary-sm-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-inactive-initial-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-inactive-initial-fontWeight': 'bold',
        'navigationButton-label-primary-sm-inactive-initial-letterSpacing': '0em',
        'navigationButton-label-primary-sm-inactive-initial-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-inactive-initial-opacity': 0.8,
        'navigationButton-label-primary-sm-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-primary-sm-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-primary-sm-inactive-pressed-fontSize': '1.25rem',
        'navigationButton-label-primary-sm-inactive-pressed-fontWeight': 'bold',
        'navigationButton-label-primary-sm-inactive-pressed-letterSpacing': '0em',
        'navigationButton-label-primary-sm-inactive-pressed-lineHeight': '1.75rem',
        'navigationButton-label-primary-sm-inactive-pressed-opacity': 0.65,
        'navigationButton-label-secondary-lg-active-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-active-hover-fontSize': '1rem',
        'navigationButton-label-secondary-lg-active-hover-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-active-hover-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-active-hover-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-active-hover-opacity': 1,
        'navigationButton-label-secondary-lg-active-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-active-initial-fontSize': '1rem',
        'navigationButton-label-secondary-lg-active-initial-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-active-initial-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-active-initial-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-active-initial-opacity': 0.8,
        'navigationButton-label-secondary-lg-active-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-active-pressed-fontSize': '1rem',
        'navigationButton-label-secondary-lg-active-pressed-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-active-pressed-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-active-pressed-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-active-pressed-opacity': 0.65,
        'navigationButton-label-secondary-lg-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-inactive-hover-fontSize': '1rem',
        'navigationButton-label-secondary-lg-inactive-hover-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-inactive-hover-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-inactive-hover-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-inactive-hover-opacity': 1,
        'navigationButton-label-secondary-lg-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-inactive-initial-fontSize': '1rem',
        'navigationButton-label-secondary-lg-inactive-initial-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-inactive-initial-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-inactive-initial-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-inactive-initial-opacity': 0.8,
        'navigationButton-label-secondary-lg-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-lg-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-lg-inactive-pressed-fontSize': '1rem',
        'navigationButton-label-secondary-lg-inactive-pressed-fontWeight': 'bold',
        'navigationButton-label-secondary-lg-inactive-pressed-letterSpacing': '0em',
        'navigationButton-label-secondary-lg-inactive-pressed-lineHeight': '1.5rem',
        'navigationButton-label-secondary-lg-inactive-pressed-opacity': 0.65,
        'navigationButton-label-secondary-sm-active-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-active-hover-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-active-hover-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-active-hover-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-active-hover-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-active-hover-opacity': 1,
        'navigationButton-label-secondary-sm-active-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-active-initial-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-active-initial-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-active-initial-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-active-initial-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-active-initial-opacity': 0.8,
        'navigationButton-label-secondary-sm-active-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-active-pressed-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-active-pressed-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-active-pressed-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-active-pressed-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-active-pressed-opacity': 0.65,
        'navigationButton-label-secondary-sm-inactive-hover-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-inactive-hover-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-inactive-hover-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-inactive-hover-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-inactive-hover-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-inactive-hover-opacity': 1,
        'navigationButton-label-secondary-sm-inactive-initial-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-inactive-initial-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-inactive-initial-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-inactive-initial-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-inactive-initial-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-inactive-initial-opacity': 0.8,
        'navigationButton-label-secondary-sm-inactive-pressed-color': 'rgb(0, 0, 0)',
        'navigationButton-label-secondary-sm-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'navigationButton-label-secondary-sm-inactive-pressed-fontSize': '0.875rem',
        'navigationButton-label-secondary-sm-inactive-pressed-fontWeight': 'bold',
        'navigationButton-label-secondary-sm-inactive-pressed-letterSpacing': '0em',
        'navigationButton-label-secondary-sm-inactive-pressed-lineHeight': '1.25rem',
        'navigationButton-label-secondary-sm-inactive-pressed-opacity': 0.65,
        'orderSummary-base-lg-default-background': 'rgb(255, 255, 255)',
        'orderSummary-base-lg-default-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-base-lg-default-borderRadius': '0',
        'orderSummary-base-lg-default-borderStyle': 'solid',
        'orderSummary-base-lg-default-borderWidth': '0.0625rem',
        'orderSummary-base-lg-default-paddingTop': '2rem',
        'orderSummary-base-lg-floating-collapsed-gap': '0',
        'orderSummary-base-lg-floating-collapsed-paddingTop': '0',
        'orderSummary-base-lg-floating-expanded-gap': '0',
        'orderSummary-base-lg-floating-expanded-paddingTop': '0',
        'orderSummary-base-sm-default-background': 'rgb(255, 255, 255)',
        'orderSummary-base-sm-default-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-base-sm-default-borderRadius': '0',
        'orderSummary-base-sm-default-borderStyle': 'solid',
        'orderSummary-base-sm-default-borderWidth': '0.0625rem',
        'orderSummary-base-sm-default-paddingTop': '1.5rem',
        'orderSummary-base-sm-floating-collapsed-gap': '0',
        'orderSummary-base-sm-floating-collapsed-paddingTop': '0',
        'orderSummary-base-sm-floating-expanded-gap': '0',
        'orderSummary-base-sm-floating-expanded-paddingTop': '0',
        'orderSummary-content-base-default-lg-gap': '1.5rem',
        'orderSummary-content-base-default-lg-paddingBottom': '0.5rem',
        'orderSummary-content-base-default-lg-paddingLeft': '1.5rem',
        'orderSummary-content-base-default-lg-paddingRight': '1.5rem',
        'orderSummary-content-base-default-lg-paddingTop': '0',
        'orderSummary-content-base-default-sm-gap': '1rem',
        'orderSummary-content-base-default-sm-paddingBottom': '0.5rem',
        'orderSummary-content-base-default-sm-paddingLeft': '1rem',
        'orderSummary-content-base-default-sm-paddingRight': '1rem',
        'orderSummary-content-base-default-sm-paddingTop': '0',
        'orderSummary-content-base-floating-lg-gap': '1.5rem',
        'orderSummary-content-base-floating-lg-paddingBottom': '1rem',
        'orderSummary-content-base-floating-lg-paddingLeft': '1.5rem',
        'orderSummary-content-base-floating-lg-paddingRight': '1.5rem',
        'orderSummary-content-base-floating-lg-paddingTop': '1rem',
        'orderSummary-content-base-floating-sm-gap': '1rem',
        'orderSummary-content-base-floating-sm-paddingBottom': '1rem',
        'orderSummary-content-base-floating-sm-paddingLeft': '1rem',
        'orderSummary-content-base-floating-sm-paddingRight': '1rem',
        'orderSummary-content-base-floating-sm-paddingTop': '1rem',
        'orderSummary-content-detailList-base-lg-gap': '1.5rem',
        'orderSummary-content-detailList-base-sm-gap': '1rem',
        'orderSummary-content-detailList-item-base-lg-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-content-detailList-item-base-lg-borderRadius': '0',
        'orderSummary-content-detailList-item-base-lg-borderStyle': 'solid',
        'orderSummary-content-detailList-item-base-lg-borderWidth': '0.0625rem',
        'orderSummary-content-detailList-item-base-lg-gap': '1rem',
        'orderSummary-content-detailList-item-base-lg-paddingBottom': '1.5rem',
        'orderSummary-content-detailList-item-base-lg-paddingLeft': '1.5rem',
        'orderSummary-content-detailList-item-base-lg-paddingRight': '1.5rem',
        'orderSummary-content-detailList-item-base-lg-paddingTop': '1.5rem',
        'orderSummary-content-detailList-item-base-sm-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-content-detailList-item-base-sm-borderRadius': '0',
        'orderSummary-content-detailList-item-base-sm-borderStyle': 'solid',
        'orderSummary-content-detailList-item-base-sm-borderWidth': '0.0625rem',
        'orderSummary-content-detailList-item-base-sm-gap': '0.75rem',
        'orderSummary-content-detailList-item-base-sm-paddingBottom': '1rem',
        'orderSummary-content-detailList-item-base-sm-paddingLeft': '1rem',
        'orderSummary-content-detailList-item-base-sm-paddingRight': '1rem',
        'orderSummary-content-detailList-item-base-sm-paddingTop': '1rem',
        'orderSummary-content-detailList-item-priceLine-base-lg-gap': '1.5rem',
        'orderSummary-content-detailList-item-priceLine-base-sm-gap': '1rem',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-fontSize': '0.875rem',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-fontWeight': 'bold',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-label-default-lg-lineHeight': '1.25rem',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-fontSize': '0.75rem',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-fontWeight': 'bold',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-label-default-sm-lineHeight': '1rem',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-fontSize': '0.875rem',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-label-subtle-lg-lineHeight': '1.25rem',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-fontSize': '0.75rem',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-label-subtle-sm-lineHeight': '1rem',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-color': 'rgb(158, 40, 150)',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-fontSize': '0.875rem',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-benefit-lg-lineHeight': '1.25rem',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-color': 'rgb(158, 40, 150)',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-fontSize': '0.75rem',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-benefit-sm-lineHeight': '1rem',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-fontSize': '0.875rem',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-fontWeight': 'bold',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-default-lg-lineHeight': '1.25rem',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-fontSize': '0.75rem',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-fontWeight': 'bold',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-default-sm-lineHeight': '1rem',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-fontSize': '0.875rem',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-subtle-lg-lineHeight': '1.25rem',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-fontSize': '0.75rem',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-fontWeight': 'normal',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-letterSpacing': '0em',
        'orderSummary-content-detailList-item-priceLine-price-subtle-sm-lineHeight': '1rem',
        'orderSummary-content-header-base-lg-gap': '0.75rem',
        'orderSummary-content-header-base-sm-gap': '0.5rem',
        'orderSummary-content-header-headline-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-content-header-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-header-headline-lg-fontSize': '1rem',
        'orderSummary-content-header-headline-lg-fontWeight': 'bold',
        'orderSummary-content-header-headline-lg-letterSpacing': '0em',
        'orderSummary-content-header-headline-lg-lineHeight': '1.5rem',
        'orderSummary-content-header-headline-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-content-header-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-content-header-headline-sm-fontSize': '0.875rem',
        'orderSummary-content-header-headline-sm-fontWeight': 'bold',
        'orderSummary-content-header-headline-sm-letterSpacing': '0em',
        'orderSummary-content-header-headline-sm-lineHeight': '1.25rem',
        'orderSummary-content-productTeaserList-base-lg-gap': '1.5rem',
        'orderSummary-content-productTeaserList-base-sm-gap': '1rem',
        'orderSummary-content-subtotal-base-lg-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-content-subtotal-base-lg-borderRadius': '0',
        'orderSummary-content-subtotal-base-lg-borderStyle': 'solid',
        'orderSummary-content-subtotal-base-lg-borderWidth': '0.0625rem',
        'orderSummary-content-subtotal-base-lg-gap': '1rem',
        'orderSummary-content-subtotal-base-lg-paddingBottom': '1.5rem',
        'orderSummary-content-subtotal-base-lg-paddingLeft': '1.5rem',
        'orderSummary-content-subtotal-base-lg-paddingRight': '1.5rem',
        'orderSummary-content-subtotal-base-lg-paddingTop': '1.5rem',
        'orderSummary-content-subtotal-base-sm-borderColor': 'rgb(239, 241, 242)',
        'orderSummary-content-subtotal-base-sm-borderRadius': '0',
        'orderSummary-content-subtotal-base-sm-borderStyle': 'solid',
        'orderSummary-content-subtotal-base-sm-borderWidth': '0.0625rem',
        'orderSummary-content-subtotal-base-sm-gap': '0.75rem',
        'orderSummary-content-subtotal-base-sm-paddingBottom': '1rem',
        'orderSummary-content-subtotal-base-sm-paddingLeft': '1rem',
        'orderSummary-content-subtotal-base-sm-paddingRight': '1rem',
        'orderSummary-content-subtotal-base-sm-paddingTop': '1rem',
        'orderSummary-expandButton-initial-background': 'rgba(0, 0, 0, 0)',
        'orderSummary-expandButton-initial-borderBottomWidth': '0.0625rem',
        'orderSummary-expandButton-initial-borderColor': 'rgb(224, 226, 229)',
        'orderSummary-expandButton-initial-borderStyle': 'solid',
        'orderSummary-expandButton-initial-boxShadow': {
            'box-shadow': 'none',
            'drop-shadow': 'none',
        },
        'orderSummary-expandButton-initial-paddingBottom': '0.25rem',
        'orderSummary-expandButton-initial-paddingTop': '0.25rem',
        'orderSummary-expandButton-sticky-background': 'rgb(255, 255, 255)',
        'orderSummary-expandButton-sticky-borderBottomWidth': '0.0625rem',
        'orderSummary-expandButton-sticky-borderColor': 'rgba(0, 0, 0, 0)',
        'orderSummary-expandButton-sticky-borderStyle': 'solid',
        'orderSummary-expandButton-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'orderSummary-expandButton-sticky-paddingBottom': '0.25rem',
        'orderSummary-expandButton-sticky-paddingTop': '0.25rem',
        'orderSummary-footer-base-lg-default-background': 'rgba(0, 0, 0, 0)',
        'orderSummary-footer-base-lg-default-boxShadow': {
            'box-shadow': 'none',
            'drop-shadow': 'none',
        },
        'orderSummary-footer-base-lg-default-gap': '1.5rem',
        'orderSummary-footer-base-lg-default-paddingBottom': '2rem',
        'orderSummary-footer-base-lg-default-paddingLeft': '1.5rem',
        'orderSummary-footer-base-lg-default-paddingRight': '1.5rem',
        'orderSummary-footer-base-lg-default-paddingTop': '1.5rem',
        'orderSummary-footer-base-lg-sticky-background': 'rgb(255, 255, 255)',
        'orderSummary-footer-base-lg-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04))',
        },
        'orderSummary-footer-base-lg-sticky-gap': '1.5rem',
        'orderSummary-footer-base-lg-sticky-paddingBottom': '2rem',
        'orderSummary-footer-base-lg-sticky-paddingLeft': '1.5rem',
        'orderSummary-footer-base-lg-sticky-paddingRight': '1.5rem',
        'orderSummary-footer-base-lg-sticky-paddingTop': '1.5rem',
        'orderSummary-footer-base-sm-default-background': 'rgba(0, 0, 0, 0)',
        'orderSummary-footer-base-sm-default-boxShadow': {
            'box-shadow': 'none',
            'drop-shadow': 'none',
        },
        'orderSummary-footer-base-sm-default-gap': '1rem',
        'orderSummary-footer-base-sm-default-paddingBottom': '2rem',
        'orderSummary-footer-base-sm-default-paddingLeft': '1rem',
        'orderSummary-footer-base-sm-default-paddingRight': '1rem',
        'orderSummary-footer-base-sm-default-paddingTop': '1rem',
        'orderSummary-footer-base-sm-sticky-background': 'rgb(255, 255, 255)',
        'orderSummary-footer-base-sm-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px -2px 4px 0px rgba(0, 0, 0, 0.04), 0px -4px 8px 0px rgba(0, 0, 0, 0.04), 0px -8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px -2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px -4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px -8px 16px rgba(0, 0, 0, 0.04))',
        },
        'orderSummary-footer-base-sm-sticky-gap': '1rem',
        'orderSummary-footer-base-sm-sticky-paddingBottom': '2rem',
        'orderSummary-footer-base-sm-sticky-paddingLeft': '1rem',
        'orderSummary-footer-base-sm-sticky-paddingRight': '1rem',
        'orderSummary-footer-base-sm-sticky-paddingTop': '1rem',
        'orderSummary-footer-summaryList-base-lg-gap': '0.5rem',
        'orderSummary-footer-summaryList-base-sm-gap': '0.5rem',
        'orderSummary-footer-summaryList-legal-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-legal-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-legal-lg-fontSize': '0.875rem',
        'orderSummary-footer-summaryList-legal-lg-fontWeight': 'normal',
        'orderSummary-footer-summaryList-legal-lg-letterSpacing': '0em',
        'orderSummary-footer-summaryList-legal-lg-lineHeight': '1.25rem',
        'orderSummary-footer-summaryList-legal-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-legal-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-legal-sm-fontSize': '0.75rem',
        'orderSummary-footer-summaryList-legal-sm-fontWeight': 'normal',
        'orderSummary-footer-summaryList-legal-sm-letterSpacing': '0em',
        'orderSummary-footer-summaryList-legal-sm-lineHeight': '1rem',
        'orderSummary-footer-summaryList-priceLine-base-lg-gap': '1.5rem',
        'orderSummary-footer-summaryList-priceLine-base-sm-gap': '1rem',
        'orderSummary-footer-summaryList-priceLine-label-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-priceLine-label-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-priceLine-label-lg-fontSize': '1rem',
        'orderSummary-footer-summaryList-priceLine-label-lg-fontWeight': 'bold',
        'orderSummary-footer-summaryList-priceLine-label-lg-letterSpacing': '0em',
        'orderSummary-footer-summaryList-priceLine-label-lg-lineHeight': '1.5rem',
        'orderSummary-footer-summaryList-priceLine-label-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-priceLine-label-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-priceLine-label-sm-fontSize': '0.875rem',
        'orderSummary-footer-summaryList-priceLine-label-sm-fontWeight': 'bold',
        'orderSummary-footer-summaryList-priceLine-label-sm-letterSpacing': '0em',
        'orderSummary-footer-summaryList-priceLine-label-sm-lineHeight': '1.25rem',
        'orderSummary-footer-summaryList-priceLine-price-lg-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-priceLine-price-lg-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-priceLine-price-lg-fontSize': '1rem',
        'orderSummary-footer-summaryList-priceLine-price-lg-fontWeight': 'bold',
        'orderSummary-footer-summaryList-priceLine-price-lg-letterSpacing': '0em',
        'orderSummary-footer-summaryList-priceLine-price-lg-lineHeight': '1.5rem',
        'orderSummary-footer-summaryList-priceLine-price-sm-color': 'rgb(0, 0, 0)',
        'orderSummary-footer-summaryList-priceLine-price-sm-fontFamily': 'Bosch Sans, sans-serif',
        'orderSummary-footer-summaryList-priceLine-price-sm-fontSize': '0.875rem',
        'orderSummary-footer-summaryList-priceLine-price-sm-fontWeight': 'bold',
        'orderSummary-footer-summaryList-priceLine-price-sm-letterSpacing': '0em',
        'orderSummary-footer-summaryList-priceLine-price-sm-lineHeight': '1.25rem',
        'orderSummary-summaryList-base-lg-gap': '0.5rem',
        'orderSummary-summaryList-base-sm-gap': '0.5rem',
        'overlay-high-background': 'rgba(0, 0, 0, 0.4)',
        'overlay-high-filter': 'blur(24px)',
        'overlay-low-background': 'rgba(0, 0, 0, 0.2)',
        'overlay-low-filter': 'blur(2px)',
        'overlay-medium-background': 'rgba(0, 0, 0, 0.3)',
        'overlay-medium-filter': 'blur(16px)',
        'overlay-subtle-background': 'rgba(0, 0, 0, 0.1)',
        'overlay-subtle-filter': 'none',
        'overlayCard-base-lg-background': 'rgb(255, 255, 255)',
        'overlayCard-base-sm-background': 'rgb(255, 255, 255)',
        'overlayCard-footer-base-initial-lg-background': 'rgba(0, 0, 0, 0)',
        'overlayCard-footer-base-initial-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'overlayCard-footer-base-initial-lg-borderStyle': 'solid',
        'overlayCard-footer-base-initial-lg-borderTopWidth': '0',
        'overlayCard-footer-base-initial-lg-gap': '1rem',
        'overlayCard-footer-base-initial-lg-paddingBottom': '2rem',
        'overlayCard-footer-base-initial-lg-paddingLeft': '3rem',
        'overlayCard-footer-base-initial-lg-paddingRight': '3rem',
        'overlayCard-footer-base-initial-lg-paddingTop': '0',
        'overlayCard-footer-base-initial-sm-background': 'rgba(0, 0, 0, 0)',
        'overlayCard-footer-base-initial-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'overlayCard-footer-base-initial-sm-borderStyle': 'solid',
        'overlayCard-footer-base-initial-sm-borderTopWidth': '0',
        'overlayCard-footer-base-initial-sm-gap': '1rem',
        'overlayCard-footer-base-initial-sm-paddingBottom': '2rem',
        'overlayCard-footer-base-initial-sm-paddingLeft': '2rem',
        'overlayCard-footer-base-initial-sm-paddingRight': '2rem',
        'overlayCard-footer-base-initial-sm-paddingTop': '0',
        'overlayCard-footer-base-sticky-lg-background': 'rgb(255, 255, 255)',
        'overlayCard-footer-base-sticky-lg-borderColor': 'rgb(239, 241, 242)',
        'overlayCard-footer-base-sticky-lg-borderStyle': 'solid',
        'overlayCard-footer-base-sticky-lg-borderTopWidth': '0.0625rem',
        'overlayCard-footer-base-sticky-lg-gap': '1rem',
        'overlayCard-footer-base-sticky-lg-paddingBottom': '2rem',
        'overlayCard-footer-base-sticky-lg-paddingLeft': '3rem',
        'overlayCard-footer-base-sticky-lg-paddingRight': '3rem',
        'overlayCard-footer-base-sticky-lg-paddingTop': '1rem',
        'overlayCard-footer-base-sticky-sm-background': 'rgb(255, 255, 255)',
        'overlayCard-footer-base-sticky-sm-borderColor': 'rgb(239, 241, 242)',
        'overlayCard-footer-base-sticky-sm-borderStyle': 'solid',
        'overlayCard-footer-base-sticky-sm-borderTopWidth': '0.0625rem',
        'overlayCard-footer-base-sticky-sm-gap': '1rem',
        'overlayCard-footer-base-sticky-sm-paddingBottom': '2rem',
        'overlayCard-footer-base-sticky-sm-paddingLeft': '2rem',
        'overlayCard-footer-base-sticky-sm-paddingRight': '2rem',
        'overlayCard-footer-base-sticky-sm-paddingTop': '1rem',
        'overlayCard-header-base-lg-gap': '1rem',
        'overlayCard-header-base-lg-paddingLeft': '1.5rem',
        'overlayCard-header-base-lg-paddingRight': '1.5rem',
        'overlayCard-header-base-lg-paddingTop': '2rem',
        'overlayCard-header-base-sm-gap': '1rem',
        'overlayCard-header-base-sm-paddingLeft': '1rem',
        'overlayCard-header-base-sm-paddingRight': '0.75rem',
        'overlayCard-header-base-sm-paddingTop': '2rem',
        'overlayCard-header-headline-lg-color': 'rgb(0, 0, 0)',
        'overlayCard-header-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'overlayCard-header-headline-lg-fontSize': '1.5rem',
        'overlayCard-header-headline-lg-fontWeight': 'bold',
        'overlayCard-header-headline-lg-letterSpacing': '0em',
        'overlayCard-header-headline-lg-lineHeight': '2rem',
        'overlayCard-header-headline-sm-color': 'rgb(0, 0, 0)',
        'overlayCard-header-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'overlayCard-header-headline-sm-fontSize': '1.25rem',
        'overlayCard-header-headline-sm-fontWeight': 'bold',
        'overlayCard-header-headline-sm-letterSpacing': '0em',
        'overlayCard-header-headline-sm-lineHeight': '1.75rem',
        'page-default-base': 'rgb(255, 255, 255)',
        'page-default-onBase': 'rgb(0, 0, 0)',
        'page-default-onDefault-base': 'rgb(239, 241, 242)',
        'page-default-onDefault-onBase': 'rgb(0, 0, 0)',
        'page-highlighted-base': 'rgb(239, 241, 242)',
        'page-highlighted-onBase': 'rgb(0, 0, 0)',
        'page-highlighted-onHighlighted-base': 'rgb(224, 226, 229)',
        'page-highlighted-onHighlighted-onBase': 'rgb(0, 0, 0)',
        'page-margin-lg': '3rem',
        'page-margin-md': '2rem',
        'page-margin-sm': '1rem',
        'page-wrapper-lg': '87.5rem',
        'page-wrapper-md': '72.5rem',
        'page-wrapper-sm': '60rem',
        'pagination-base-gap': '1rem',
        'pagination-highlighted-active-background': 'rgb(0, 123, 192)',
        'pagination-highlighted-active-borderRadius': '624.9375rem',
        'pagination-highlighted-active-height': '0.75rem',
        'pagination-highlighted-active-opacity': 1,
        'pagination-highlighted-active-width': '0.75rem',
        'pagination-highlighted-inactive-background': 'rgb(138, 144, 151)',
        'pagination-highlighted-inactive-borderRadius': '624.9375rem',
        'pagination-highlighted-inactive-height': '0.5rem',
        'pagination-highlighted-inactive-opacity': 1,
        'pagination-highlighted-inactive-width': '0.5rem',
        'pagination-highlighted-truncated-background': 'rgb(138, 144, 151)',
        'pagination-highlighted-truncated-borderRadius': '624.9375rem',
        'pagination-highlighted-truncated-height': '0.25rem',
        'pagination-highlighted-truncated-opacity': 1,
        'pagination-highlighted-truncated-width': '0.25rem',
        'pagination-image-active-background': 'rgb(255, 255, 255)',
        'pagination-image-active-borderRadius': '624.9375rem',
        'pagination-image-active-height': '0.75rem',
        'pagination-image-active-opacity': 1,
        'pagination-image-active-width': '0.75rem',
        'pagination-image-inactive-background': 'rgb(255, 255, 255)',
        'pagination-image-inactive-borderRadius': '624.9375rem',
        'pagination-image-inactive-height': '0.5rem',
        'pagination-image-inactive-opacity': 1,
        'pagination-image-inactive-width': '0.5rem',
        'pagination-image-truncated-background': 'rgb(255, 255, 255)',
        'pagination-image-truncated-borderRadius': '624.9375rem',
        'pagination-image-truncated-height': '0.25rem',
        'pagination-image-truncated-opacity': 1,
        'pagination-image-truncated-width': '0.25rem',
        'pagination-page-active-background': 'rgb(0, 123, 192)',
        'pagination-page-active-borderRadius': '624.9375rem',
        'pagination-page-active-height': '0.75rem',
        'pagination-page-active-opacity': 1,
        'pagination-page-active-width': '0.75rem',
        'pagination-page-inactive-background': 'rgb(138, 144, 151)',
        'pagination-page-inactive-borderRadius': '624.9375rem',
        'pagination-page-inactive-height': '0.5rem',
        'pagination-page-inactive-opacity': 1,
        'pagination-page-inactive-width': '0.5rem',
        'pagination-page-truncated-background': 'rgb(138, 144, 151)',
        'pagination-page-truncated-borderRadius': '624.9375rem',
        'pagination-page-truncated-height': '0.25rem',
        'pagination-page-truncated-opacity': 1,
        'pagination-page-truncated-width': '0.25rem',
        'paymentList-base-gap': '1rem',
        'paymentList-logoContainer-image-height': '2rem',
        'paymentList-logoContainer-image-width': '3rem',
        'popover-backgroundColor': 'rgb(255, 255, 255)',
        'popover-borderColor': 'rgb(239, 241, 242)',
        'popover-textColor': 'rgb(0, 0, 0)',
        'post-base-lg-background': 'rgb(255, 255, 255)',
        'post-base-lg-borderColor': 'rgb(239, 241, 242)',
        'post-base-lg-borderRadius': '0',
        'post-base-lg-borderStyle': 'solid',
        'post-base-lg-borderWidth': '0.0625rem',
        'post-base-lg-gap': '1rem',
        'post-base-lg-paddingBlock': '1.5rem',
        'post-base-lg-paddingInline': '1.5rem',
        'post-base-md-background': 'rgb(255, 255, 255)',
        'post-base-md-borderColor': 'rgb(239, 241, 242)',
        'post-base-md-borderRadius': '0',
        'post-base-md-borderStyle': 'solid',
        'post-base-md-borderWidth': '0.0625rem',
        'post-base-md-gap': '1rem',
        'post-base-md-paddingBlock': '1.5rem',
        'post-base-md-paddingInline': '1rem',
        'post-base-sm-background': 'rgb(255, 255, 255)',
        'post-base-sm-borderColor': 'rgb(239, 241, 242)',
        'post-base-sm-borderRadius': '0',
        'post-base-sm-borderStyle': 'solid',
        'post-base-sm-borderWidth': '0.0625rem',
        'post-base-sm-gap': '1rem',
        'post-base-sm-paddingBlock': '1rem',
        'post-base-sm-paddingInline': '1rem',
        'post-content-lg-gap': '0.75rem',
        'post-content-question-lg-color': 'rgb(0, 0, 0)',
        'post-content-question-lg-fontFamily': 'Bosch Sans, sans-serif',
        'post-content-question-lg-fontSize': '1rem',
        'post-content-question-lg-fontWeight': 'normal',
        'post-content-question-lg-letterSpacing': '0em',
        'post-content-question-lg-lineHeight': '1.5rem',
        'post-content-question-lg-opacity': 0.8,
        'post-content-question-sm-color': 'rgb(0, 0, 0)',
        'post-content-question-sm-fontFamily': 'Bosch Sans, sans-serif',
        'post-content-question-sm-fontSize': '0.875rem',
        'post-content-question-sm-fontWeight': 'normal',
        'post-content-question-sm-letterSpacing': '0em',
        'post-content-question-sm-lineHeight': '1.25rem',
        'post-content-question-sm-opacity': 0.8,
        'post-content-sm-gap': '0.5rem',
        'post-content-translateLink-base-color': 'rgb(0, 0, 0)',
        'post-content-translateLink-base-fontFamily': 'Bosch Sans, sans-serif',
        'post-content-translateLink-base-fontSize': '0.75rem',
        'post-content-translateLink-base-fontWeight': 'normal',
        'post-content-translateLink-base-letterSpacing': '0em',
        'post-content-translateLink-base-lineHeight': '1rem',
        'post-content-translateLink-base-opacity': 0.65,
        'post-header-author-base-gap': '0.25rem',
        'post-header-author-demographic-base-color': 'rgb(0, 0, 0)',
        'post-header-author-demographic-base-fontFamily': 'Bosch Sans, sans-serif',
        'post-header-author-demographic-base-fontSize': '0.75rem',
        'post-header-author-demographic-base-fontWeight': 'normal',
        'post-header-author-demographic-base-letterSpacing': '0em',
        'post-header-author-demographic-base-lineHeight': '1rem',
        'post-header-author-demographic-base-opacity': 0.65,
        'post-header-author-icon-base-background': 'rgb(0, 0, 0)',
        'post-header-author-name-base-color': 'rgb(0, 0, 0)',
        'post-header-author-name-base-fontFamily': 'Bosch Sans, sans-serif',
        'post-header-author-name-base-fontSize': '0.75rem',
        'post-header-author-name-base-fontWeight': 'bold',
        'post-header-author-name-base-letterSpacing': '0em',
        'post-header-author-name-base-lineHeight': '1rem',
        'post-header-author-name-base-opacity': 0.65,
        'post-header-base-gap': '0.5rem',
        'post-header-date-base-color': 'rgb(0, 0, 0)',
        'post-header-date-base-fontFamily': 'Bosch Sans, sans-serif',
        'post-header-date-base-fontSize': '0.75rem',
        'post-header-date-base-fontWeight': 'normal',
        'post-header-date-base-letterSpacing': '0em',
        'post-header-date-base-lineHeight': '1rem',
        'post-header-date-base-opacity': 0.65,
        'price-mainPrice-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'price-mainPrice-2xs-fontSize': '0.75rem',
        'price-mainPrice-2xs-fontWeight': 'bold',
        'price-mainPrice-2xs-letterSpacing': '0em',
        'price-mainPrice-2xs-lineHeight': '1rem',
        'price-mainPrice-lg-fontFamily': 'Bosch Sans, sans-serif',
        'price-mainPrice-lg-fontSize': '1.5rem',
        'price-mainPrice-lg-fontWeight': 'bold',
        'price-mainPrice-lg-letterSpacing': '0em',
        'price-mainPrice-lg-lineHeight': '2rem',
        'price-mainPrice-md-fontFamily': 'Bosch Sans, sans-serif',
        'price-mainPrice-md-fontSize': '1.25rem',
        'price-mainPrice-md-fontWeight': 'bold',
        'price-mainPrice-md-letterSpacing': '0em',
        'price-mainPrice-md-lineHeight': '1.75rem',
        'price-mainPrice-sm-fontFamily': 'Bosch Sans, sans-serif',
        'price-mainPrice-sm-fontSize': '1rem',
        'price-mainPrice-sm-fontWeight': 'bold',
        'price-mainPrice-sm-letterSpacing': '0em',
        'price-mainPrice-sm-lineHeight': '1.5rem',
        'price-mainPrice-xs-fontFamily': 'Bosch Sans, sans-serif',
        'price-mainPrice-xs-fontSize': '0.875rem',
        'price-mainPrice-xs-fontWeight': 'bold',
        'price-mainPrice-xs-letterSpacing': '0em',
        'price-mainPrice-xs-lineHeight': '1.25rem',
        'price-offerline-color': 'rgb(158, 40, 150)',
        'price-offerline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'price-offerline-sm-fontSize': '0.75rem',
        'price-offerline-sm-fontWeight': 'bold',
        'price-offerline-sm-letterSpacing': '0em',
        'price-offerline-sm-lineHeight': '1rem',
        'price-offerline-xs-fontFamily': 'Bosch Sans, sans-serif',
        'price-offerline-xs-fontSize': '0.625rem',
        'price-offerline-xs-fontWeight': 'bold',
        'price-offerline-xs-letterSpacing': '0em',
        'price-offerline-xs-lineHeight': '0.75rem',
        'price-strikePrice-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'price-strikePrice-2xs-fontSize': '0.75rem',
        'price-strikePrice-2xs-fontWeight': 'normal',
        'price-strikePrice-2xs-letterSpacing': '0em',
        'price-strikePrice-2xs-lineHeight': '1rem',
        'price-strikePrice-lg-fontFamily': 'Bosch Sans, sans-serif',
        'price-strikePrice-lg-fontSize': '1.5rem',
        'price-strikePrice-lg-fontWeight': 'normal',
        'price-strikePrice-lg-letterSpacing': '0em',
        'price-strikePrice-lg-lineHeight': '2rem',
        'price-strikePrice-md-fontFamily': 'Bosch Sans, sans-serif',
        'price-strikePrice-md-fontSize': '1.25rem',
        'price-strikePrice-md-fontWeight': 'normal',
        'price-strikePrice-md-letterSpacing': '0em',
        'price-strikePrice-md-lineHeight': '1.75rem',
        'price-strikePrice-sm-fontFamily': 'Bosch Sans, sans-serif',
        'price-strikePrice-sm-fontSize': '1rem',
        'price-strikePrice-sm-fontWeight': 'normal',
        'price-strikePrice-sm-letterSpacing': '0em',
        'price-strikePrice-sm-lineHeight': '1.5rem',
        'price-strikePrice-xs-fontFamily': 'Bosch Sans, sans-serif',
        'price-strikePrice-xs-fontSize': '0.875rem',
        'price-strikePrice-xs-fontWeight': 'normal',
        'price-strikePrice-xs-letterSpacing': '0em',
        'price-strikePrice-xs-lineHeight': '1.25rem',
        'productGridTeaser-badgeList-base-lg-gap': '1rem',
        'productGridTeaser-badgeList-base-sm-gap': '1rem',
        'productGridTeaser-base-lg-default-background': 'rgb(255, 255, 255)',
        'productGridTeaser-base-lg-default-borderColor': 'rgb(239, 241, 242)',
        'productGridTeaser-base-lg-default-borderRadius': '0',
        'productGridTeaser-base-lg-default-borderStyle': 'solid',
        'productGridTeaser-base-lg-default-borderWidth': '0.0625rem',
        'productGridTeaser-base-lg-default-gap': '1.5rem',
        'productGridTeaser-base-lg-default-paddingBottom': '1.5rem',
        'productGridTeaser-base-lg-default-paddingLeft': '1.5rem',
        'productGridTeaser-base-lg-default-paddingRight': '1.5rem',
        'productGridTeaser-base-lg-default-paddingTop': '1.5rem',
        'productGridTeaser-base-lg-highlighted-background': 'rgb(239, 241, 242)',
        'productGridTeaser-base-lg-highlighted-borderColor': 'rgba(0, 0, 0, 0)',
        'productGridTeaser-base-lg-highlighted-borderRadius': '0',
        'productGridTeaser-base-lg-highlighted-borderStyle': 'solid',
        'productGridTeaser-base-lg-highlighted-borderWidth': '0.0625rem',
        'productGridTeaser-base-lg-highlighted-gap': '1.5rem',
        'productGridTeaser-base-lg-highlighted-paddingBottom': '1.5rem',
        'productGridTeaser-base-lg-highlighted-paddingLeft': '1.5rem',
        'productGridTeaser-base-lg-highlighted-paddingRight': '1.5rem',
        'productGridTeaser-base-lg-highlighted-paddingTop': '1.5rem',
        'productGridTeaser-base-sm-default-background': 'rgb(255, 255, 255)',
        'productGridTeaser-base-sm-default-borderColor': 'rgb(239, 241, 242)',
        'productGridTeaser-base-sm-default-borderRadius': '0',
        'productGridTeaser-base-sm-default-borderStyle': 'solid',
        'productGridTeaser-base-sm-default-borderWidth': '0.0625rem',
        'productGridTeaser-base-sm-default-gap': '1rem',
        'productGridTeaser-base-sm-default-paddingBottom': '1rem',
        'productGridTeaser-base-sm-default-paddingLeft': '1rem',
        'productGridTeaser-base-sm-default-paddingRight': '1rem',
        'productGridTeaser-base-sm-default-paddingTop': '1.5rem',
        'productGridTeaser-base-sm-highlighted-background': 'rgb(239, 241, 242)',
        'productGridTeaser-base-sm-highlighted-borderColor': 'rgba(0, 0, 0, 0)',
        'productGridTeaser-base-sm-highlighted-borderRadius': '0',
        'productGridTeaser-base-sm-highlighted-borderStyle': 'solid',
        'productGridTeaser-base-sm-highlighted-borderWidth': '0.0625rem',
        'productGridTeaser-base-sm-highlighted-gap': '1rem',
        'productGridTeaser-base-sm-highlighted-paddingBottom': '1rem',
        'productGridTeaser-base-sm-highlighted-paddingLeft': '1rem',
        'productGridTeaser-base-sm-highlighted-paddingRight': '1rem',
        'productGridTeaser-base-sm-highlighted-paddingTop': '1.5rem',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-filter': 'brightness(0.96) contrast(1)',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-hover-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-filter': 'none',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-initial-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-filter': 'brightness(0.94) contrast(1)',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-lg-pressed-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-filter': 'brightness(0.96) contrast(1)',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-hover-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-filter': 'none',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-initial-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-background': 'rgb(239, 241, 242)',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-filter': 'brightness(0.94) contrast(1)',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-default-sm-pressed-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-filter': 'brightness(0.96) contrast(1)',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-hover-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-filter': 'none',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-initial-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-filter': 'brightness(0.94) contrast(1)',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-paddingLeft': '1rem',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-lg-pressed-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-filter': 'brightness(0.96) contrast(1)',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-hover-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-filter': 'none',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-initial-paddingTop': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-background': 'rgb(224, 226, 229)',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-borderRadius': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-filter': 'brightness(0.94) contrast(1)',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-paddingBottom': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-paddingLeft': '0.75rem',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-paddingRight': '0',
        'productGridTeaser-content-detailsButton-base-highlighted-sm-pressed-paddingTop': '0',
        'productGridTeaser-content-detailsButton-content-base-hover-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-content-base-hover-opacity': 0.8,
        'productGridTeaser-content-detailsButton-content-base-initial-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-content-base-initial-opacity': 1,
        'productGridTeaser-content-detailsButton-content-base-pressed-gap': '0.25rem',
        'productGridTeaser-content-detailsButton-content-base-pressed-opacity': 0.65,
        'productGridTeaser-content-detailsButton-content-description-default-color': 'rgb(0, 0, 0)',
        'productGridTeaser-content-detailsButton-content-description-default-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-content-detailsButton-content-description-default-fontSize': '0.75rem',
        'productGridTeaser-content-detailsButton-content-description-default-fontWeight': 'normal',
        'productGridTeaser-content-detailsButton-content-description-default-letterSpacing': '0em',
        'productGridTeaser-content-detailsButton-content-description-default-lineHeight': '1rem',
        'productGridTeaser-content-detailsButton-content-description-default-opacity': 0.8,
        'productGridTeaser-content-detailsButton-content-description-highlighted-color': 'rgb(0, 0, 0)',
        'productGridTeaser-content-detailsButton-content-description-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-content-detailsButton-content-description-highlighted-fontSize': '0.75rem',
        'productGridTeaser-content-detailsButton-content-description-highlighted-fontWeight': 'normal',
        'productGridTeaser-content-detailsButton-content-description-highlighted-letterSpacing': '0em',
        'productGridTeaser-content-detailsButton-content-description-highlighted-lineHeight': '1rem',
        'productGridTeaser-content-detailsButton-content-description-highlighted-opacity': 0.8,
        'productGridTeaser-content-detailsButton-content-label-default-color': 'rgb(0, 0, 0)',
        'productGridTeaser-content-detailsButton-content-label-default-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-content-detailsButton-content-label-default-fontSize': '0.75rem',
        'productGridTeaser-content-detailsButton-content-label-default-fontWeight': 'bold',
        'productGridTeaser-content-detailsButton-content-label-default-letterSpacing': '0em',
        'productGridTeaser-content-detailsButton-content-label-default-lineHeight': '1rem',
        'productGridTeaser-content-detailsButton-content-label-default-opacity': 0.8,
        'productGridTeaser-content-detailsButton-content-label-highlighted-color': 'rgb(0, 0, 0)',
        'productGridTeaser-content-detailsButton-content-label-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-content-detailsButton-content-label-highlighted-fontSize': '0.75rem',
        'productGridTeaser-content-detailsButton-content-label-highlighted-fontWeight': 'bold',
        'productGridTeaser-content-detailsButton-content-label-highlighted-letterSpacing': '0em',
        'productGridTeaser-content-detailsButton-content-label-highlighted-lineHeight': '1rem',
        'productGridTeaser-content-detailsButton-content-label-highlighted-opacity': 0.8,
        'productGridTeaser-details-base-lg-paddingBottom': '4rem',
        'productGridTeaser-details-base-sm-paddingBottom': '3rem',
        'productGridTeaser-details-modal-base-default-background': 'rgb(255, 255, 255)',
        'productGridTeaser-details-modal-base-default-borderBottomLeftRadius': '0',
        'productGridTeaser-details-modal-base-default-borderBottomRightRadius': '0',
        'productGridTeaser-details-modal-base-default-borderColor': 'rgba(0, 0, 0, 0)',
        'productGridTeaser-details-modal-base-default-borderStyle': 'solid',
        'productGridTeaser-details-modal-base-default-borderTopLeftRadius': '0',
        'productGridTeaser-details-modal-base-default-borderTopRightRadius': '0',
        'productGridTeaser-details-modal-base-default-borderWidth': '0',
        'productGridTeaser-details-modal-base-default-maxHeight': '28rem',
        'productGridTeaser-details-modal-base-highlighted-background': 'rgb(239, 241, 242)',
        'productGridTeaser-details-modal-base-highlighted-borderBottomLeftRadius': '0',
        'productGridTeaser-details-modal-base-highlighted-borderBottomRightRadius': '0',
        'productGridTeaser-details-modal-base-highlighted-borderColor': 'rgba(0, 0, 0, 0)',
        'productGridTeaser-details-modal-base-highlighted-borderStyle': 'solid',
        'productGridTeaser-details-modal-base-highlighted-borderTopLeftRadius': '0',
        'productGridTeaser-details-modal-base-highlighted-borderTopRightRadius': '0',
        'productGridTeaser-details-modal-base-highlighted-borderWidth': '0',
        'productGridTeaser-details-modal-base-highlighted-maxHeight': '28rem',
        'productGridTeaser-details-modal-content-awardList-base-gap': '0.75rem',
        'productGridTeaser-details-modal-content-awardList-base-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-awardList-base-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-content-base-gap': '2rem',
        'productGridTeaser-details-modal-content-base-paddingBottom': '2rem',
        'productGridTeaser-details-modal-content-base-paddingTop': '1.5rem',
        'productGridTeaser-details-modal-content-button-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-button-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-base-gap': '1rem',
        'productGridTeaser-details-modal-content-featureList-divider-default-background': 'rgb(239, 241, 242)',
        'productGridTeaser-details-modal-content-featureList-divider-default-borderRadius': '624.9375rem',
        'productGridTeaser-details-modal-content-featureList-divider-default-height': '0.0625rem',
        'productGridTeaser-details-modal-content-featureList-divider-highlighted-background': 'rgb(224, 226, 229)',
        'productGridTeaser-details-modal-content-featureList-divider-highlighted-borderRadius': '624.9375rem',
        'productGridTeaser-details-modal-content-featureList-divider-highlighted-height': '0.0625rem',
        'productGridTeaser-details-modal-content-featureList-headline-base-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-headline-base-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-icon-base-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-icon-base-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-label-base-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-featureList-label-base-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-content-information-base-paddingLeft': '1.5rem',
        'productGridTeaser-details-modal-content-information-base-paddingRight': '1.5rem',
        'productGridTeaser-details-modal-gradient-default-background': 'linear-gradient(180deg, #ffffff00 0%, #ffffff 100%)',
        'productGridTeaser-details-modal-gradient-default-height': '4rem',
        'productGridTeaser-details-modal-gradient-highlighted-background': 'linear-gradient(180deg, #eff1f200 0%, #eff1f2 100%)',
        'productGridTeaser-details-modal-gradient-highlighted-height': '4rem',
        'productGridTeaser-details-modal-header-default-initial-background': 'rgb(255, 255, 255)',
        'productGridTeaser-details-modal-header-default-initial-boxShadow': {
            'box-shadow': 'none',
            'drop-shadow': 'none',
        },
        'productGridTeaser-details-modal-header-default-initial-paddingBottom': '0.75rem',
        'productGridTeaser-details-modal-header-default-initial-paddingLeft': '3rem',
        'productGridTeaser-details-modal-header-default-initial-paddingRight': '1rem',
        'productGridTeaser-details-modal-header-default-initial-paddingTop': '0.75rem',
        'productGridTeaser-details-modal-header-default-sticky-background': 'rgb(255, 255, 255)',
        'productGridTeaser-details-modal-header-default-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'productGridTeaser-details-modal-header-default-sticky-paddingBottom': '0.75rem',
        'productGridTeaser-details-modal-header-default-sticky-paddingLeft': '3rem',
        'productGridTeaser-details-modal-header-default-sticky-paddingRight': '1rem',
        'productGridTeaser-details-modal-header-default-sticky-paddingTop': '0.75rem',
        'productGridTeaser-details-modal-header-headline-default-color': 'rgb(0, 0, 0)',
        'productGridTeaser-details-modal-header-headline-default-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-details-modal-header-headline-default-fontSize': '0.875rem',
        'productGridTeaser-details-modal-header-headline-default-fontWeight': 'bold',
        'productGridTeaser-details-modal-header-headline-default-letterSpacing': '0em',
        'productGridTeaser-details-modal-header-headline-default-lineHeight': '1.25rem',
        'productGridTeaser-details-modal-header-headline-default-opacity': 1,
        'productGridTeaser-details-modal-header-headline-highlighted-color': 'rgb(0, 0, 0)',
        'productGridTeaser-details-modal-header-headline-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-details-modal-header-headline-highlighted-fontSize': '0.875rem',
        'productGridTeaser-details-modal-header-headline-highlighted-fontWeight': 'bold',
        'productGridTeaser-details-modal-header-headline-highlighted-letterSpacing': '0em',
        'productGridTeaser-details-modal-header-headline-highlighted-lineHeight': '1.25rem',
        'productGridTeaser-details-modal-header-headline-highlighted-opacity': 1,
        'productGridTeaser-details-modal-header-highlighted-initial-background': 'rgb(239, 241, 242)',
        'productGridTeaser-details-modal-header-highlighted-initial-boxShadow': {
            'box-shadow': 'none',
            'drop-shadow': 'none',
        },
        'productGridTeaser-details-modal-header-highlighted-initial-paddingBottom': '0.75rem',
        'productGridTeaser-details-modal-header-highlighted-initial-paddingLeft': '3rem',
        'productGridTeaser-details-modal-header-highlighted-initial-paddingRight': '1rem',
        'productGridTeaser-details-modal-header-highlighted-initial-paddingTop': '0.75rem',
        'productGridTeaser-details-modal-header-highlighted-sticky-background': 'rgb(239, 241, 242)',
        'productGridTeaser-details-modal-header-highlighted-sticky-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'productGridTeaser-details-modal-header-highlighted-sticky-paddingBottom': '0.75rem',
        'productGridTeaser-details-modal-header-highlighted-sticky-paddingLeft': '3rem',
        'productGridTeaser-details-modal-header-highlighted-sticky-paddingRight': '1rem',
        'productGridTeaser-details-modal-header-highlighted-sticky-paddingTop': '0.75rem',
        'productGridTeaser-expandArea-content-information-colorSelector-thumbnail-borderRadius': '0',
        'productGridTeaser-expandArea-content-information-colorSelector-thumbnail-height': '2rem',
        'productGridTeaser-expandArea-content-information-colorSelector-thumbnail-width': '2rem',
        'productGridTeaser-footer-base-gap': '1rem',
        'productGridTeaser-footer-buttonList-gap': '1rem',
        'productGridTeaser-header-base-lg-gap': '1rem',
        'productGridTeaser-header-base-sm-gap': '0.75rem',
        'productGridTeaser-header-productList-base-gap': '1rem',
        'productGridTeaser-header-productList-item-awardList-base-gap': '0.5rem',
        'productGridTeaser-header-productList-item-base-paddingBottom': '1rem',
        'productGridTeaser-header-productList-item-base-paddingTop': '1rem',
        'productGridTeaser-image-productDivider-divider-background': 'rgb(224, 226, 229)',
        'productGridTeaser-image-productDivider-illustration-base-background': 'rgb(255, 255, 255)',
        'productGridTeaser-image-productDivider-illustration-base-borderColor': 'rgb(224, 226, 229)',
        'productGridTeaser-image-productDivider-illustration-base-borderRadius': '624.9375rem',
        'productGridTeaser-image-productDivider-illustration-base-borderStyle': 'solid',
        'productGridTeaser-image-productDivider-illustration-base-borderWidth': '0.0625rem',
        'productGridTeaser-image-productDivider-illustration-icon-background': 'rgb(0, 0, 0)',
        'productGridTeaser-information-base-lg-gap': '1.5rem',
        'productGridTeaser-information-base-sm-gap': '1.5rem',
        'productGridTeaser-information-buyInformation-base-gap': '1rem',
        'productGridTeaser-information-meta-base-gap': '1rem',
        'productGridTeaser-information-variantOverview-base-gap': '1rem',
        'productGridTeaser-information-variantOverview-colorSelector-base-gap': '0.5rem',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-color': 'rgb(0, 0, 0)',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-fontSize': '0.75rem',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-fontWeight': 'normal',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-letterSpacing': '0em',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-lineHeight': '1rem',
        'productGridTeaser-information-variantOverview-colorSelector-label-default-opacity': 0.8,
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-color': 'rgb(0, 0, 0)',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-fontSize': '0.75rem',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-fontWeight': 'normal',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-letterSpacing': '0em',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-lineHeight': '1rem',
        'productGridTeaser-information-variantOverview-colorSelector-label-highlighted-opacity': 0.8,
        'productGridTeaser-information-variantOverview-label-default-color': 'rgb(0, 0, 0)',
        'productGridTeaser-information-variantOverview-label-default-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-information-variantOverview-label-default-fontSize': '0.75rem',
        'productGridTeaser-information-variantOverview-label-default-fontWeight': 'normal',
        'productGridTeaser-information-variantOverview-label-default-letterSpacing': '0em',
        'productGridTeaser-information-variantOverview-label-default-lineHeight': '1rem',
        'productGridTeaser-information-variantOverview-label-default-opacity': 0.8,
        'productGridTeaser-information-variantOverview-label-highlighted-color': 'rgb(0, 0, 0)',
        'productGridTeaser-information-variantOverview-label-highlighted-fontFamily': 'Bosch Sans, sans-serif',
        'productGridTeaser-information-variantOverview-label-highlighted-fontSize': '0.75rem',
        'productGridTeaser-information-variantOverview-label-highlighted-fontWeight': 'normal',
        'productGridTeaser-information-variantOverview-label-highlighted-letterSpacing': '0em',
        'productGridTeaser-information-variantOverview-label-highlighted-lineHeight': '1rem',
        'productGridTeaser-information-variantOverview-label-highlighted-opacity': 0.8,
        'productImage-lg-paddingBottom': '1.5rem',
        'productImage-lg-paddingLeft': '1.5rem',
        'productImage-lg-paddingRight': '1.5rem',
        'productImage-lg-paddingTop': '1.5rem',
        'productImage-md-paddingBottom': '1rem',
        'productImage-md-paddingLeft': '1rem',
        'productImage-md-paddingRight': '1rem',
        'productImage-md-paddingTop': '1rem',
        'productImage-sm-paddingBottom': '0.5rem',
        'productImage-sm-paddingLeft': '0.5rem',
        'productImage-sm-paddingRight': '0.5rem',
        'productImage-sm-paddingTop': '0.5rem',
        'productImage-xl-paddingBottom': '2rem',
        'productImage-xl-paddingLeft': '2rem',
        'productImage-xl-paddingRight': '2rem',
        'productImage-xl-paddingTop': '2rem',
        'productListTeaser-badgeList-lg-gap': '1rem',
        'productListTeaser-badgeList-md-gap': '0.75rem',
        'productListTeaser-badgeList-sm-gap': '0.5rem',
        'productListTeaser-base-lg-background': 'rgb(255, 255, 255)',
        'productListTeaser-base-lg-borderColor': 'rgb(239, 241, 242)',
        'productListTeaser-base-lg-borderRadius': '0',
        'productListTeaser-base-lg-borderStyle': 'solid',
        'productListTeaser-base-lg-borderWidth': '0.0625rem',
        'productListTeaser-base-lg-gap': '1.5rem',
        'productListTeaser-base-lg-paddingBottom': '2rem',
        'productListTeaser-base-lg-paddingTop': '2rem',
        'productListTeaser-base-md-background': 'rgb(255, 255, 255)',
        'productListTeaser-base-md-borderColor': 'rgb(239, 241, 242)',
        'productListTeaser-base-md-borderRadius': '0',
        'productListTeaser-base-md-borderStyle': 'solid',
        'productListTeaser-base-md-borderWidth': '0.0625rem',
        'productListTeaser-base-md-gap': '1rem',
        'productListTeaser-base-md-paddingBottom': '1.5rem',
        'productListTeaser-base-md-paddingTop': '1.5rem',
        'productListTeaser-base-sm-background': 'rgb(255, 255, 255)',
        'productListTeaser-base-sm-borderColor': 'rgb(239, 241, 242)',
        'productListTeaser-base-sm-borderRadius': '0',
        'productListTeaser-base-sm-borderStyle': 'solid',
        'productListTeaser-base-sm-borderWidth': '0.0625rem',
        'productListTeaser-base-sm-gap': '1rem',
        'productListTeaser-base-sm-paddingBottom': '1.5rem',
        'productListTeaser-base-sm-paddingTop': '1.5rem',
        'productListTeaser-details-checkout-base-lg-gap': '0.5rem',
        'productListTeaser-details-checkout-base-lg-paddingLeft': '1.5rem',
        'productListTeaser-details-checkout-base-lg-paddingRight': '1.5rem',
        'productListTeaser-details-checkout-base-md-gap': '0.25rem',
        'productListTeaser-details-checkout-base-md-paddingLeft': '1rem',
        'productListTeaser-details-checkout-base-md-paddingRight': '1rem',
        'productListTeaser-details-checkout-base-sm-gap': '0.25rem',
        'productListTeaser-details-checkout-base-sm-paddingLeft': '1rem',
        'productListTeaser-details-checkout-base-sm-paddingRight': '1rem',
        'productListTeaser-details-checkout-item-selectService-lg-paddingTop': '0.75rem',
        'productListTeaser-details-checkout-item-selectService-md-paddingTop': '0.5rem',
        'productListTeaser-details-checkout-item-selectService-sm-paddingTop': '0.5rem',
        'productListTeaser-product-base-lg-gap': '1.5rem',
        'productListTeaser-product-base-lg-minHeight': '15rem',
        'productListTeaser-product-base-lg-paddingLeft': '1.5rem',
        'productListTeaser-product-base-lg-paddingRight': '1.5rem',
        'productListTeaser-product-base-md-gap': '1rem',
        'productListTeaser-product-base-md-minHeight': '11rem',
        'productListTeaser-product-base-md-paddingLeft': '1rem',
        'productListTeaser-product-base-md-paddingRight': '1rem',
        'productListTeaser-product-base-sm-gap': '1rem',
        'productListTeaser-product-base-sm-minHeight': '9rem',
        'productListTeaser-product-base-sm-paddingLeft': '1rem',
        'productListTeaser-product-base-sm-paddingRight': '1rem',
        'productListTeaser-product-imageList-horizontal-gap': '1.5rem',
        'productListTeaser-product-imageList-vertical-gap': '1.5rem',
        'productListTeaser-product-information-base-lg-gap': '2rem',
        'productListTeaser-product-information-base-md-gap': '1.5rem',
        'productListTeaser-product-information-base-sm-gap': '1rem',
        'productListTeaser-product-information-details-amount-gap': '1rem',
        'productListTeaser-product-information-details-base-lg-gap': '1.5rem',
        'productListTeaser-product-information-details-base-md-gap': '1rem',
        'productListTeaser-product-information-details-base-sm-gap': '0.75rem',
        'productTeaserMini-base-lg-default-background': 'rgb(255, 255, 255)',
        'productTeaserMini-base-lg-default-borderColor': 'rgb(239, 241, 242)',
        'productTeaserMini-base-lg-default-borderRadius': '0',
        'productTeaserMini-base-lg-default-borderStyle': 'solid',
        'productTeaserMini-base-lg-default-borderWidth': '0.0625rem',
        'productTeaserMini-base-lg-default-gap': '1.5rem',
        'productTeaserMini-base-lg-default-paddingBottom': '1.5rem',
        'productTeaserMini-base-lg-default-paddingLeft': '1.5rem',
        'productTeaserMini-base-lg-default-paddingRight': '1.5rem',
        'productTeaserMini-base-lg-default-paddingTop': '1.5rem',
        'productTeaserMini-base-lg-subtle-background': 'rgb(255, 255, 255)',
        'productTeaserMini-base-lg-subtle-borderColor': 'rgba(0, 0, 0, 0)',
        'productTeaserMini-base-lg-subtle-borderStyle': 'solid',
        'productTeaserMini-base-lg-subtle-borderWidth': '0.0625rem',
        'productTeaserMini-base-lg-subtle-gap': '1rem',
        'productTeaserMini-base-lg-subtle-paddingBottom': '1.5rem',
        'productTeaserMini-base-lg-subtle-paddingLeft': '1.5rem',
        'productTeaserMini-base-lg-subtle-paddingRight': '1.5rem',
        'productTeaserMini-base-lg-subtle-paddingTop': '1.5rem',
        'productTeaserMini-base-sm-default-background': 'rgb(255, 255, 255)',
        'productTeaserMini-base-sm-default-borderColor': 'rgb(239, 241, 242)',
        'productTeaserMini-base-sm-default-borderRadius': '0',
        'productTeaserMini-base-sm-default-borderStyle': 'solid',
        'productTeaserMini-base-sm-default-borderWidth': '0.0625rem',
        'productTeaserMini-base-sm-default-gap': '1rem',
        'productTeaserMini-base-sm-default-paddingBottom': '1rem',
        'productTeaserMini-base-sm-default-paddingLeft': '1rem',
        'productTeaserMini-base-sm-default-paddingRight': '1rem',
        'productTeaserMini-base-sm-default-paddingTop': '1rem',
        'productTeaserMini-base-sm-subtle-background': 'rgb(255, 255, 255)',
        'productTeaserMini-base-sm-subtle-borderColor': 'rgba(0, 0, 0, 0)',
        'productTeaserMini-base-sm-subtle-borderRadius': '0',
        'productTeaserMini-base-sm-subtle-borderStyle': 'solid',
        'productTeaserMini-base-sm-subtle-borderWidth': '0.0625rem',
        'productTeaserMini-base-sm-subtle-gap': '1rem',
        'productTeaserMini-base-sm-subtle-paddingBottom': '1rem',
        'productTeaserMini-base-sm-subtle-paddingLeft': '1rem',
        'productTeaserMini-base-sm-subtle-paddingRight': '1rem',
        'productTeaserMini-base-sm-subtle-paddingTop': '1rem',
        'productTeaserMini-content-base-lg-gap': '1.5rem',
        'productTeaserMini-content-base-sm-gap': '1rem',
        'productTeaserMini-content-product-base-lg-gap': '1rem',
        'productTeaserMini-content-product-base-sm-gap': '0.75rem',
        'productTeaserMini-content-productImage-lg-width': '4rem',
        'productTeaserMini-content-productImage-sm-width': '3rem',
        'productTeaserMini-services-base-lg-gap': '1rem',
        'productTeaserMini-services-base-sm-gap': '0.75rem',
        'productTeaserMini-services-divider-background': 'rgb(224, 226, 229)',
        'productTeaserMini-services-divider-borderRadius': '624.9375rem',
        'productTeaserMini-services-divider-borderWidth': '0.0625rem',
        'productTeaserMini-services-item-base-lg-gap': '1rem',
        'productTeaserMini-services-item-base-sm-gap': '0.75rem',
        'productTeaserMini-services-item-description-lg-color': 'rgb(0, 0, 0)',
        'productTeaserMini-services-item-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-description-lg-fontSize': '0.875rem',
        'productTeaserMini-services-item-description-lg-fontWeight': 'normal',
        'productTeaserMini-services-item-description-lg-letterSpacing': '0em',
        'productTeaserMini-services-item-description-lg-lineHeight': '1.25rem',
        'productTeaserMini-services-item-description-sm-color': 'rgb(0, 0, 0)',
        'productTeaserMini-services-item-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-description-sm-fontSize': '0.75rem',
        'productTeaserMini-services-item-description-sm-fontWeight': 'normal',
        'productTeaserMini-services-item-description-sm-letterSpacing': '0em',
        'productTeaserMini-services-item-description-sm-lineHeight': '1rem',
        'productTeaserMini-services-item-price-lg-benefit-color': 'rgb(158, 40, 150)',
        'productTeaserMini-services-item-price-lg-benefit-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-price-lg-benefit-fontSize': '0.875rem',
        'productTeaserMini-services-item-price-lg-benefit-fontWeight': 'normal',
        'productTeaserMini-services-item-price-lg-benefit-letterSpacing': '0em',
        'productTeaserMini-services-item-price-lg-benefit-lineHeight': '1.25rem',
        'productTeaserMini-services-item-price-lg-default-color': 'rgb(0, 0, 0)',
        'productTeaserMini-services-item-price-lg-default-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-price-lg-default-fontSize': '0.875rem',
        'productTeaserMini-services-item-price-lg-default-fontWeight': 'normal',
        'productTeaserMini-services-item-price-lg-default-letterSpacing': '0em',
        'productTeaserMini-services-item-price-lg-default-lineHeight': '1.25rem',
        'productTeaserMini-services-item-price-sm-benefit-color': 'rgb(158, 40, 150)',
        'productTeaserMini-services-item-price-sm-benefit-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-price-sm-benefit-fontSize': '0.75rem',
        'productTeaserMini-services-item-price-sm-benefit-fontWeight': 'normal',
        'productTeaserMini-services-item-price-sm-benefit-letterSpacing': '0em',
        'productTeaserMini-services-item-price-sm-benefit-lineHeight': '1rem',
        'productTeaserMini-services-item-price-sm-default-color': 'rgb(0, 0, 0)',
        'productTeaserMini-services-item-price-sm-default-fontFamily': 'Bosch Sans, sans-serif',
        'productTeaserMini-services-item-price-sm-default-fontSize': '0.75rem',
        'productTeaserMini-services-item-price-sm-default-fontWeight': 'normal',
        'productTeaserMini-services-item-price-sm-default-letterSpacing': '0em',
        'productTeaserMini-services-item-price-sm-default-lineHeight': '1rem',
        'productTitle-headline-base-default-2xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-default-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-default-2xs-fontSize': '0.875rem',
        'productTitle-headline-base-default-2xs-fontWeight': 'normal',
        'productTitle-headline-base-default-2xs-letterSpacing': '0em',
        'productTitle-headline-base-default-2xs-lineHeight': '1.25rem',
        'productTitle-headline-base-default-lg-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-default-lg-fontSize': '1.75rem',
        'productTitle-headline-base-default-lg-fontWeight': 'normal',
        'productTitle-headline-base-default-lg-letterSpacing': '0em',
        'productTitle-headline-base-default-lg-lineHeight': '2.25rem',
        'productTitle-headline-base-default-md-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-default-md-fontSize': '1.5rem',
        'productTitle-headline-base-default-md-fontWeight': 'normal',
        'productTitle-headline-base-default-md-letterSpacing': '0em',
        'productTitle-headline-base-default-md-lineHeight': '2rem',
        'productTitle-headline-base-default-sm-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-default-sm-fontSize': '1.25rem',
        'productTitle-headline-base-default-sm-fontWeight': 'normal',
        'productTitle-headline-base-default-sm-letterSpacing': '0em',
        'productTitle-headline-base-default-sm-lineHeight': '1.75rem',
        'productTitle-headline-base-default-xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-default-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-default-xs-fontSize': '1rem',
        'productTitle-headline-base-default-xs-fontWeight': 'normal',
        'productTitle-headline-base-default-xs-letterSpacing': '0em',
        'productTitle-headline-base-default-xs-lineHeight': '1.5rem',
        'productTitle-headline-base-highlighted-2xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-highlighted-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-highlighted-2xs-fontSize': '0.875rem',
        'productTitle-headline-base-highlighted-2xs-fontWeight': 'normal',
        'productTitle-headline-base-highlighted-2xs-letterSpacing': '0em',
        'productTitle-headline-base-highlighted-2xs-lineHeight': '1.25rem',
        'productTitle-headline-base-highlighted-lg-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-highlighted-lg-fontSize': '1.75rem',
        'productTitle-headline-base-highlighted-lg-fontWeight': 'normal',
        'productTitle-headline-base-highlighted-lg-letterSpacing': '0em',
        'productTitle-headline-base-highlighted-lg-lineHeight': '2.25rem',
        'productTitle-headline-base-highlighted-md-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-highlighted-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-highlighted-md-fontSize': '1.5rem',
        'productTitle-headline-base-highlighted-md-fontWeight': 'normal',
        'productTitle-headline-base-highlighted-md-letterSpacing': '0em',
        'productTitle-headline-base-highlighted-md-lineHeight': '2rem',
        'productTitle-headline-base-highlighted-sm-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-highlighted-sm-fontSize': '1.25rem',
        'productTitle-headline-base-highlighted-sm-fontWeight': 'normal',
        'productTitle-headline-base-highlighted-sm-letterSpacing': '0em',
        'productTitle-headline-base-highlighted-sm-lineHeight': '1.75rem',
        'productTitle-headline-base-highlighted-xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-base-highlighted-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-base-highlighted-xs-fontSize': '1rem',
        'productTitle-headline-base-highlighted-xs-fontWeight': 'normal',
        'productTitle-headline-base-highlighted-xs-letterSpacing': '0em',
        'productTitle-headline-base-highlighted-xs-lineHeight': '1.5rem',
        'productTitle-headline-valueClass-base-default-2xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-default-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-default-2xs-fontSize': '0.875rem',
        'productTitle-headline-valueClass-base-default-2xs-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-default-2xs-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-default-2xs-lineHeight': '1.25rem',
        'productTitle-headline-valueClass-base-default-lg-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-default-lg-fontSize': '1.75rem',
        'productTitle-headline-valueClass-base-default-lg-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-default-lg-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-default-lg-lineHeight': '2.25rem',
        'productTitle-headline-valueClass-base-default-md-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-default-md-fontSize': '1.5rem',
        'productTitle-headline-valueClass-base-default-md-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-default-md-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-default-md-lineHeight': '2rem',
        'productTitle-headline-valueClass-base-default-sm-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-default-sm-fontSize': '1.25rem',
        'productTitle-headline-valueClass-base-default-sm-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-default-sm-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-default-sm-lineHeight': '1.75rem',
        'productTitle-headline-valueClass-base-default-xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-default-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-default-xs-fontSize': '1rem',
        'productTitle-headline-valueClass-base-default-xs-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-default-xs-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-default-xs-lineHeight': '1.5rem',
        'productTitle-headline-valueClass-base-highlighted-2xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-highlighted-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-highlighted-2xs-fontSize': '0.875rem',
        'productTitle-headline-valueClass-base-highlighted-2xs-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-highlighted-2xs-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-highlighted-2xs-lineHeight': '1.25rem',
        'productTitle-headline-valueClass-base-highlighted-lg-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-highlighted-lg-fontSize': '1.75rem',
        'productTitle-headline-valueClass-base-highlighted-lg-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-highlighted-lg-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-highlighted-lg-lineHeight': '2.25rem',
        'productTitle-headline-valueClass-base-highlighted-md-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-highlighted-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-highlighted-md-fontSize': '1.5rem',
        'productTitle-headline-valueClass-base-highlighted-md-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-highlighted-md-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-highlighted-md-lineHeight': '2rem',
        'productTitle-headline-valueClass-base-highlighted-sm-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-highlighted-sm-fontSize': '1.25rem',
        'productTitle-headline-valueClass-base-highlighted-sm-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-highlighted-sm-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-highlighted-sm-lineHeight': '1.75rem',
        'productTitle-headline-valueClass-base-highlighted-xs-color': 'rgb(0, 0, 0)',
        'productTitle-headline-valueClass-base-highlighted-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-headline-valueClass-base-highlighted-xs-fontSize': '1rem',
        'productTitle-headline-valueClass-base-highlighted-xs-fontWeight': 'bold',
        'productTitle-headline-valueClass-base-highlighted-xs-letterSpacing': '0em',
        'productTitle-headline-valueClass-base-highlighted-xs-lineHeight': '1.5rem',
        'productTitle-subline-base-default-lg-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-default-lg-fontSize': '1rem',
        'productTitle-subline-base-default-lg-fontWeight': 'normal',
        'productTitle-subline-base-default-lg-letterSpacing': '0em',
        'productTitle-subline-base-default-lg-lineHeight': '1.5rem',
        'productTitle-subline-base-default-lg-opacity': 0.65,
        'productTitle-subline-base-default-md-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-default-md-fontSize': '0.875rem',
        'productTitle-subline-base-default-md-fontWeight': 'normal',
        'productTitle-subline-base-default-md-letterSpacing': '0em',
        'productTitle-subline-base-default-md-lineHeight': '1.25rem',
        'productTitle-subline-base-default-md-opacity': 0.65,
        'productTitle-subline-base-default-sm-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-default-sm-fontSize': '0.75rem',
        'productTitle-subline-base-default-sm-fontWeight': 'normal',
        'productTitle-subline-base-default-sm-letterSpacing': '0em',
        'productTitle-subline-base-default-sm-lineHeight': '1rem',
        'productTitle-subline-base-default-sm-opacity': 0.65,
        'productTitle-subline-base-default-xs-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-default-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-default-xs-fontSize': '0.625rem',
        'productTitle-subline-base-default-xs-fontWeight': 'normal',
        'productTitle-subline-base-default-xs-letterSpacing': '0em',
        'productTitle-subline-base-default-xs-lineHeight': '0.75rem',
        'productTitle-subline-base-default-xs-opacity': 0.65,
        'productTitle-subline-base-highlighted-lg-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-highlighted-lg-fontSize': '1rem',
        'productTitle-subline-base-highlighted-lg-fontWeight': 'normal',
        'productTitle-subline-base-highlighted-lg-letterSpacing': '0em',
        'productTitle-subline-base-highlighted-lg-lineHeight': '1.5rem',
        'productTitle-subline-base-highlighted-lg-opacity': 0.65,
        'productTitle-subline-base-highlighted-md-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-highlighted-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-highlighted-md-fontSize': '0.875rem',
        'productTitle-subline-base-highlighted-md-fontWeight': 'normal',
        'productTitle-subline-base-highlighted-md-letterSpacing': '0em',
        'productTitle-subline-base-highlighted-md-lineHeight': '1.25rem',
        'productTitle-subline-base-highlighted-md-opacity': 0.65,
        'productTitle-subline-base-highlighted-sm-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-highlighted-sm-fontSize': '0.75rem',
        'productTitle-subline-base-highlighted-sm-fontWeight': 'normal',
        'productTitle-subline-base-highlighted-sm-letterSpacing': '0em',
        'productTitle-subline-base-highlighted-sm-lineHeight': '1rem',
        'productTitle-subline-base-highlighted-sm-opacity': 0.65,
        'productTitle-subline-base-highlighted-xs-color': 'rgb(0, 0, 0)',
        'productTitle-subline-base-highlighted-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitle-subline-base-highlighted-xs-fontSize': '0.625rem',
        'productTitle-subline-base-highlighted-xs-fontWeight': 'normal',
        'productTitle-subline-base-highlighted-xs-letterSpacing': '0em',
        'productTitle-subline-base-highlighted-xs-lineHeight': '0.75rem',
        'productTitle-subline-base-highlighted-xs-opacity': 0.65,
        'productTitleHeadline-2xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitleHeadline-2xs-fontSize': '0.875rem',
        'productTitleHeadline-2xs-fontWeight': 'normal',
        'productTitleHeadline-2xs-letterSpacing': '0em',
        'productTitleHeadline-2xs-lineHeight': '1.25rem',
        'productTitleHeadline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'productTitleHeadline-lg-fontSize': '1.75rem',
        'productTitleHeadline-lg-fontWeight': 'normal',
        'productTitleHeadline-lg-letterSpacing': '0em',
        'productTitleHeadline-lg-lineHeight': '2.25rem',
        'productTitleHeadline-md-fontFamily': 'Bosch Sans, sans-serif',
        'productTitleHeadline-md-fontSize': '1.5rem',
        'productTitleHeadline-md-fontWeight': 'normal',
        'productTitleHeadline-md-letterSpacing': '0em',
        'productTitleHeadline-md-lineHeight': '2rem',
        'productTitleHeadline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'productTitleHeadline-sm-fontSize': '1.25rem',
        'productTitleHeadline-sm-fontWeight': 'normal',
        'productTitleHeadline-sm-letterSpacing': '0em',
        'productTitleHeadline-sm-lineHeight': '1.75rem',
        'productTitleHeadline-xs-fontFamily': 'Bosch Sans, sans-serif',
        'productTitleHeadline-xs-fontSize': '1rem',
        'productTitleHeadline-xs-fontWeight': 'normal',
        'productTitleHeadline-xs-letterSpacing': '0em',
        'productTitleHeadline-xs-lineHeight': '1.5rem',
        'progressSteps-base-gap': '1rem',
        'progressSteps-progressBar-active-background': 'rgb(0, 123, 192)',
        'progressSteps-progressBar-active-borderRadius': '624.9375rem',
        'progressSteps-progressBar-base-height': '0.25rem',
        'progressSteps-stepList-step-base-gap': '0.75rem',
        'progressSteps-stepList-step-indicator-base-active-hover-background': 'rgb(0, 98, 154)',
        'progressSteps-stepList-step-indicator-base-active-hover-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-active-hover-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-active-hover-width': '1.5rem',
        'progressSteps-stepList-step-indicator-base-active-initial-background': 'rgb(0, 123, 192)',
        'progressSteps-stepList-step-indicator-base-active-initial-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-active-initial-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-active-initial-width': '1.5rem',
        'progressSteps-stepList-step-indicator-base-active-pressed-background': 'rgb(0, 73, 117)',
        'progressSteps-stepList-step-indicator-base-active-pressed-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-active-pressed-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-active-pressed-width': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-hover-background': 'rgb(46, 48, 51)',
        'progressSteps-stepList-step-indicator-base-inactive-hover-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-inactive-hover-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-hover-opacity': 0.8,
        'progressSteps-stepList-step-indicator-base-inactive-hover-width': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-initial-background': 'rgb(67, 70, 74)',
        'progressSteps-stepList-step-indicator-base-inactive-initial-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-inactive-initial-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-initial-opacity': 0.65,
        'progressSteps-stepList-step-indicator-base-inactive-initial-width': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-pressed-background': 'rgb(26, 28, 29)',
        'progressSteps-stepList-step-indicator-base-inactive-pressed-borderRadius': '624.9375rem',
        'progressSteps-stepList-step-indicator-base-inactive-pressed-height': '1.5rem',
        'progressSteps-stepList-step-indicator-base-inactive-pressed-opacity': 0.65,
        'progressSteps-stepList-step-indicator-base-inactive-pressed-width': '1.5rem',
        'progressSteps-stepList-step-indicator-icon-active-hover-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-active-hover-opacity': 0.8,
        'progressSteps-stepList-step-indicator-icon-active-initial-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-active-initial-opacity': 1,
        'progressSteps-stepList-step-indicator-icon-active-pressed-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-active-pressed-opacity': 0.65,
        'progressSteps-stepList-step-indicator-icon-inactive-hover-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-inactive-hover-opacity': 1,
        'progressSteps-stepList-step-indicator-icon-inactive-initial-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-inactive-initial-opacity': 1,
        'progressSteps-stepList-step-indicator-icon-inactive-pressed-background': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-icon-inactive-pressed-opacity': 0.8,
        'progressSteps-stepList-step-indicator-label-active-hover-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-active-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-active-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-active-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-active-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-active-hover-opacity': 0.8,
        'progressSteps-stepList-step-indicator-label-active-initial-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-active-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-active-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-active-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-active-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-active-initial-opacity': 1,
        'progressSteps-stepList-step-indicator-label-active-pressed-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-active-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-active-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-active-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-active-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-active-pressed-opacity': 0.65,
        'progressSteps-stepList-step-indicator-label-inactive-hover-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-inactive-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-inactive-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-inactive-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-inactive-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-inactive-hover-opacity': 0.8,
        'progressSteps-stepList-step-indicator-label-inactive-initial-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-inactive-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-inactive-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-inactive-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-inactive-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-inactive-initial-opacity': 1,
        'progressSteps-stepList-step-indicator-label-inactive-pressed-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-indicator-label-inactive-pressed-opacity': 0.65,
        'progressSteps-stepList-step-label-default-active-hover-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-active-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-active-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-active-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-active-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-active-hover-opacity': 0.8,
        'progressSteps-stepList-step-label-default-active-initial-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-active-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-active-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-active-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-active-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-active-initial-opacity': 1,
        'progressSteps-stepList-step-label-default-active-pressed-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-active-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-active-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-active-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-active-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-active-pressed-opacity': 0.65,
        'progressSteps-stepList-step-label-default-inactive-hover-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-inactive-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-inactive-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-inactive-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-inactive-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-inactive-hover-opacity': 0.8,
        'progressSteps-stepList-step-label-default-inactive-initial-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-inactive-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-inactive-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-inactive-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-inactive-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-inactive-initial-opacity': 0.65,
        'progressSteps-stepList-step-label-default-inactive-pressed-color': 'rgb(0, 0, 0)',
        'progressSteps-stepList-step-label-default-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-default-inactive-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-default-inactive-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-label-default-inactive-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-label-default-inactive-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-default-inactive-pressed-opacity': 0.65,
        'progressSteps-stepList-step-label-image-active-hover-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-active-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-active-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-active-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-active-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-active-hover-opacity': 0.8,
        'progressSteps-stepList-step-label-image-active-initial-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-active-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-active-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-active-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-active-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-active-initial-opacity': 1,
        'progressSteps-stepList-step-label-image-active-pressed-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-active-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-active-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-active-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-active-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-active-pressed-opacity': 0.65,
        'progressSteps-stepList-step-label-image-inactive-hover-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-inactive-hover-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-inactive-hover-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-inactive-hover-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-inactive-hover-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-inactive-hover-opacity': 0.8,
        'progressSteps-stepList-step-label-image-inactive-initial-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-inactive-initial-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-inactive-initial-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-inactive-initial-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-inactive-initial-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-inactive-initial-opacity': 0.65,
        'progressSteps-stepList-step-label-image-inactive-pressed-color': 'rgb(255, 255, 255)',
        'progressSteps-stepList-step-label-image-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'progressSteps-stepList-step-label-image-inactive-pressed-fontSize': '0.875rem',
        'progressSteps-stepList-step-label-image-inactive-pressed-fontWeight': 'bold',
        'progressSteps-stepList-step-label-image-inactive-pressed-letterSpacing': '0em',
        'progressSteps-stepList-step-label-image-inactive-pressed-lineHeight': '1.25rem',
        'progressSteps-stepList-step-label-image-inactive-pressed-opacity': 0.65,
        'questionSummary-base-lg-background': 'rgb(239, 241, 242)',
        'questionSummary-base-lg-borderRadius': '0',
        'questionSummary-base-lg-gap': '2rem',
        'questionSummary-base-lg-paddingBlock': '2rem',
        'questionSummary-base-lg-paddingInline': '2rem',
        'questionSummary-base-sm-background': 'rgb(239, 241, 242)',
        'questionSummary-base-sm-borderRadius': '0',
        'questionSummary-base-sm-gap': '1.5rem',
        'questionSummary-base-sm-paddingBlock': '1rem',
        'questionSummary-base-sm-paddingInline': '1rem',
        'questionSummary-content-base-lg-gap': '1.5rem',
        'questionSummary-content-base-sm-gap': '1rem',
        'questionSummary-content-headline-lg-color': 'rgb(0, 0, 0)',
        'questionSummary-content-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-content-headline-lg-fontSize': '1.25rem',
        'questionSummary-content-headline-lg-fontWeight': 'bold',
        'questionSummary-content-headline-lg-letterSpacing': '0em',
        'questionSummary-content-headline-lg-lineHeight': '1.75rem',
        'questionSummary-content-headline-sm-color': 'rgb(0, 0, 0)',
        'questionSummary-content-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-content-headline-sm-fontSize': '1rem',
        'questionSummary-content-headline-sm-fontWeight': 'bold',
        'questionSummary-content-headline-sm-letterSpacing': '0em',
        'questionSummary-content-headline-sm-lineHeight': '1.5rem',
        'questionSummary-footer-gap': '1rem',
        'questionSummary-grid-tile-base-lg-gap': '0',
        'questionSummary-grid-tile-base-sm-gap': '0',
        'questionSummary-grid-tile-description-lg-color': 'rgb(0, 0, 0)',
        'questionSummary-grid-tile-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-grid-tile-description-lg-fontSize': '1.25rem',
        'questionSummary-grid-tile-description-lg-fontWeight': 'normal',
        'questionSummary-grid-tile-description-lg-letterSpacing': '0em',
        'questionSummary-grid-tile-description-lg-lineHeight': '1.75rem',
        'questionSummary-grid-tile-description-lg-opacity': 0.8,
        'questionSummary-grid-tile-description-sm-color': 'rgb(0, 0, 0)',
        'questionSummary-grid-tile-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-grid-tile-description-sm-fontSize': '1rem',
        'questionSummary-grid-tile-description-sm-fontWeight': 'normal',
        'questionSummary-grid-tile-description-sm-letterSpacing': '0em',
        'questionSummary-grid-tile-description-sm-lineHeight': '1.5rem',
        'questionSummary-grid-tile-description-sm-opacity': 0.8,
        'questionSummary-grid-tile-number-lg-color': 'rgb(0, 0, 0)',
        'questionSummary-grid-tile-number-lg-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-grid-tile-number-lg-fontSize': '2.625rem',
        'questionSummary-grid-tile-number-lg-fontWeight': 'bold',
        'questionSummary-grid-tile-number-lg-letterSpacing': '0em',
        'questionSummary-grid-tile-number-lg-lineHeight': '3.5rem',
        'questionSummary-grid-tile-number-sm-color': 'rgb(0, 0, 0)',
        'questionSummary-grid-tile-number-sm-fontFamily': 'Bosch Sans, sans-serif',
        'questionSummary-grid-tile-number-sm-fontSize': '2.25rem',
        'questionSummary-grid-tile-number-sm-fontWeight': 'bold',
        'questionSummary-grid-tile-number-sm-letterSpacing': '0em',
        'questionSummary-grid-tile-number-sm-lineHeight': '2.75rem',
        'radio-base-selected-disabled-background': 'rgb(193, 199, 204)',
        'radio-base-selected-disabled-borderColor': 'rgb(0, 0, 0)',
        'radio-base-selected-disabled-borderRadius': '624.9375rem',
        'radio-base-selected-disabled-borderStyle': 'solid',
        'radio-base-selected-disabled-borderWidth': '0',
        'radio-base-selected-disabled-height': '1.5rem',
        'radio-base-selected-disabled-opacity': 0.4,
        'radio-base-selected-disabled-width': '1.5rem',
        'radio-base-selected-hover-background': 'rgb(0, 98, 154)',
        'radio-base-selected-hover-borderColor': 'rgb(0, 0, 0)',
        'radio-base-selected-hover-borderRadius': '624.9375rem',
        'radio-base-selected-hover-borderStyle': 'solid',
        'radio-base-selected-hover-borderWidth': '0',
        'radio-base-selected-hover-height': '1.5rem',
        'radio-base-selected-hover-opacity': 1,
        'radio-base-selected-hover-width': '1.5rem',
        'radio-base-selected-initial-background': 'rgb(0, 123, 192)',
        'radio-base-selected-initial-borderColor': 'rgb(0, 0, 0)',
        'radio-base-selected-initial-borderRadius': '624.9375rem',
        'radio-base-selected-initial-borderStyle': 'solid',
        'radio-base-selected-initial-borderWidth': '0',
        'radio-base-selected-initial-height': '1.5rem',
        'radio-base-selected-initial-opacity': 1,
        'radio-base-selected-initial-width': '1.5rem',
        'radio-base-selected-pressed-background': 'rgb(0, 73, 117)',
        'radio-base-selected-pressed-borderColor': 'rgb(0, 0, 0)',
        'radio-base-selected-pressed-borderRadius': '624.9375rem',
        'radio-base-selected-pressed-borderStyle': 'solid',
        'radio-base-selected-pressed-borderWidth': '0',
        'radio-base-selected-pressed-height': '1.5rem',
        'radio-base-selected-pressed-opacity': 1,
        'radio-base-selected-pressed-width': '1.5rem',
        'radio-base-unselected-disabled-background': 'rgb(193, 199, 204)',
        'radio-base-unselected-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'radio-base-unselected-disabled-borderRadius': '624.9375rem',
        'radio-base-unselected-disabled-borderStyle': 'solid',
        'radio-base-unselected-disabled-borderWidth': '0',
        'radio-base-unselected-disabled-height': '1.5rem',
        'radio-base-unselected-disabled-opacity': 1,
        'radio-base-unselected-disabled-width': '1.5rem',
        'radio-base-unselected-hover-background': 'rgb(113, 118, 124)',
        'radio-base-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'radio-base-unselected-hover-borderRadius': '624.9375rem',
        'radio-base-unselected-hover-borderStyle': 'solid',
        'radio-base-unselected-hover-borderWidth': '0',
        'radio-base-unselected-hover-height': '1.5rem',
        'radio-base-unselected-hover-opacity': 1,
        'radio-base-unselected-hover-width': '1.5rem',
        'radio-base-unselected-initial-background': 'rgb(138, 144, 151)',
        'radio-base-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'radio-base-unselected-initial-borderRadius': '624.9375rem',
        'radio-base-unselected-initial-borderStyle': 'solid',
        'radio-base-unselected-initial-borderWidth': '0',
        'radio-base-unselected-initial-height': '1.5rem',
        'radio-base-unselected-initial-opacity': 1,
        'radio-base-unselected-initial-width': '1.5rem',
        'radio-base-unselected-pressed-background': 'rgb(89, 94, 98)',
        'radio-base-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'radio-base-unselected-pressed-borderRadius': '624.9375rem',
        'radio-base-unselected-pressed-borderStyle': 'solid',
        'radio-base-unselected-pressed-borderWidth': '0',
        'radio-base-unselected-pressed-height': '1.5rem',
        'radio-base-unselected-pressed-opacity': 1,
        'radio-base-unselected-pressed-width': '1.5rem',
        'radio-icon-selected-disabled-background': 'rgb(67, 70, 74)',
        'radio-icon-selected-hover-background': 'rgb(255, 255, 255)',
        'radio-icon-selected-initial-background': 'rgb(255, 255, 255)',
        'radio-icon-selected-pressed-background': 'rgb(255, 255, 255)',
        'rating-iconColor-prominent-default': 'rgb(0, 123, 192)',
        'rating-iconColor-prominent-disabled': 'rgb(0, 123, 192)',
        'rating-iconColor-prominent-hover': 'rgb(0, 98, 154)',
        'rating-iconColor-prominent-pressed': 'rgb(0, 73, 117)',
        'rating-textColor-prominent-default': 'rgb(0, 123, 192)',
        'rating-textColor-prominent-disabled': 'rgb(0, 123, 192)',
        'rating-textColor-prominent-hover': 'rgb(0, 98, 154)',
        'rating-textColor-prominent-pressed': 'rgb(0, 73, 117)',
        'ratingSummary-base-lg-background': 'rgb(255, 255, 255)',
        'ratingSummary-base-lg-borderColor': 'rgb(239, 241, 242)',
        'ratingSummary-base-lg-borderRadius': '0',
        'ratingSummary-base-lg-borderStyle': 'solid',
        'ratingSummary-base-lg-borderWidth': '0.0625rem',
        'ratingSummary-base-lg-gap': '2rem',
        'ratingSummary-base-lg-paddingBlock': '1.5rem',
        'ratingSummary-base-lg-paddingInline': '1.5rem',
        'ratingSummary-base-sm-background': 'rgb(255, 255, 255)',
        'ratingSummary-base-sm-borderColor': 'rgb(239, 241, 242)',
        'ratingSummary-base-sm-borderRadius': '0',
        'ratingSummary-base-sm-borderStyle': 'solid',
        'ratingSummary-base-sm-borderWidth': '0.0625rem',
        'ratingSummary-base-sm-gap': '2rem',
        'ratingSummary-base-sm-paddingBlock': '1rem',
        'ratingSummary-base-sm-paddingInline': '1rem',
        'ratingSummary-contentList-base-gap': '1rem',
        'ratingSummary-contentList-item-base-gap': '1rem',
        'ratingSummary-contentList-item-content-featureList-base-gap': '1rem',
        'ratingSummary-contentList-item-content-featureList-row-base-gap': '0.75rem',
        'ratingSummary-contentList-item-content-productList-base-lg-gap': '1rem',
        'ratingSummary-contentList-item-content-productList-base-sm-gap': '1rem',
        'ratingSummary-contentList-item-content-productList-item-base-lg-gap': '0.75rem',
        'ratingSummary-contentList-item-content-productList-item-base-sm-gap': '0.75rem',
        'ratingSummary-contentList-item-content-productList-item-productImage-lg-width': '3rem',
        'ratingSummary-contentList-item-content-productList-item-productImage-sm-width': '2rem',
        'ratingSummary-contentList-item-content-ratingList-base-gap': '1rem',
        'ratingSummary-contentList-item-title-base-color': 'rgb(0, 0, 0)',
        'ratingSummary-contentList-item-title-base-fontFamily': 'Bosch Sans, sans-serif',
        'ratingSummary-contentList-item-title-base-fontSize': '0.875rem',
        'ratingSummary-contentList-item-title-base-fontWeight': 'bold',
        'ratingSummary-contentList-item-title-base-letterSpacing': '0em',
        'ratingSummary-contentList-item-title-base-lineHeight': '1.25rem',
        'ratingSummary-footer-gap': '1rem',
        'ratingSummary-rating-base-gap': '0.5rem',
        'ratingSummary-rating-label-color': 'rgb(0, 0, 0)',
        'ratingSummary-rating-label-fontFamily': 'Bosch Sans, sans-serif',
        'ratingSummary-rating-label-fontSize': '2.25rem',
        'ratingSummary-rating-label-fontWeight': 'bold',
        'ratingSummary-rating-label-letterSpacing': '0em',
        'ratingSummary-rating-label-lineHeight': '2.75rem',
        'ratingSummary-rating-label-opacity': 1,
        'repairIndex-lg-width': '5rem',
        'repairIndex-md-width': '4.0625rem',
        'repairIndex-sm-width': '3.1875rem',
        'reply-base-lg-background': 'rgb(239, 241, 242)',
        'reply-base-lg-borderColor': 'rgba(0, 0, 0, 0)',
        'reply-base-lg-borderRadius': '0',
        'reply-base-lg-borderStyle': 'solid',
        'reply-base-lg-borderWidth': '0.0625rem',
        'reply-base-lg-gap': '1rem',
        'reply-base-lg-paddingBlock': '1.5rem',
        'reply-base-lg-paddingInline': '1.5rem',
        'reply-base-md-background': 'rgb(239, 241, 242)',
        'reply-base-md-borderColor': 'rgba(0, 0, 0, 0)',
        'reply-base-md-borderRadius': '0',
        'reply-base-md-borderStyle': 'solid',
        'reply-base-md-borderWidth': '0.0625rem',
        'reply-base-md-gap': '1rem',
        'reply-base-md-paddingBlock': '1.5rem',
        'reply-base-md-paddingInline': '1rem',
        'reply-base-sm-background': 'rgb(239, 241, 242)',
        'reply-base-sm-borderColor': 'rgba(0, 0, 0, 0)',
        'reply-base-sm-borderRadius': '0',
        'reply-base-sm-borderStyle': 'solid',
        'reply-base-sm-borderWidth': '0.0625rem',
        'reply-base-sm-gap': '1rem',
        'reply-base-sm-paddingBlock': '1rem',
        'reply-base-sm-paddingInline': '1rem',
        'reply-content-answer-lg-color': 'rgb(0, 0, 0)',
        'reply-content-answer-lg-fontFamily': 'Bosch Sans, sans-serif',
        'reply-content-answer-lg-fontSize': '1rem',
        'reply-content-answer-lg-fontWeight': 'normal',
        'reply-content-answer-lg-letterSpacing': '0em',
        'reply-content-answer-lg-lineHeight': '1.5rem',
        'reply-content-answer-lg-opacity': 0.8,
        'reply-content-answer-sm-color': 'rgb(0, 0, 0)',
        'reply-content-answer-sm-fontFamily': 'Bosch Sans, sans-serif',
        'reply-content-answer-sm-fontSize': '0.875rem',
        'reply-content-answer-sm-fontWeight': 'normal',
        'reply-content-answer-sm-letterSpacing': '0em',
        'reply-content-answer-sm-lineHeight': '1.25rem',
        'reply-content-answer-sm-opacity': 0.8,
        'reply-content-base-lg-gap': '0.75rem',
        'reply-content-base-sm-gap': '0.5rem',
        'reply-footer-action-base-gap': '1rem',
        'reply-footer-action-headline-color': 'rgb(0, 0, 0)',
        'reply-footer-action-headline-fontFamily': 'Bosch Sans, sans-serif',
        'reply-footer-action-headline-fontSize': '0.75rem',
        'reply-footer-action-headline-fontWeight': 'normal',
        'reply-footer-action-headline-letterSpacing': '0em',
        'reply-footer-action-headline-lineHeight': '1rem',
        'reply-footer-action-headline-opacity': 0.8,
        'reply-footer-base-gap': '1rem',
        'reply-footer-feedback-base-gap': '0.25rem',
        'reply-footer-feedback-headline-base-color': 'rgb(0, 136, 74)',
        'reply-footer-feedback-headline-base-fontFamily': 'Bosch Sans, sans-serif',
        'reply-footer-feedback-headline-base-fontSize': '0.75rem',
        'reply-footer-feedback-headline-base-fontWeight': 'normal',
        'reply-footer-feedback-headline-base-letterSpacing': '0em',
        'reply-footer-feedback-headline-base-lineHeight': '1rem',
        'reply-footer-feedback-icon-base-background': 'rgb(0, 136, 74)',
        'reply-header-author-base-gap': '0.25rem',
        'reply-header-author-icon-background': 'rgb(0, 0, 0)',
        'reply-header-author-icon-opacity': 0.4,
        'reply-header-author-name-color': 'rgb(0, 0, 0)',
        'reply-header-author-name-fontFamily': 'Bosch Sans, sans-serif',
        'reply-header-author-name-fontSize': '0.75rem',
        'reply-header-author-name-fontWeight': 'bold',
        'reply-header-author-name-letterSpacing': '0em',
        'reply-header-author-name-lineHeight': '1rem',
        'reply-header-author-name-opacity': 0.65,
        'reply-header-base-gap': '0.5rem',
        'reply-header-date-color': 'rgb(0, 0, 0)',
        'reply-header-date-fontFamily': 'Bosch Sans, sans-serif',
        'reply-header-date-fontSize': '0.75rem',
        'reply-header-date-fontWeight': 'normal',
        'reply-header-date-letterSpacing': '0em',
        'reply-header-date-lineHeight': '1rem',
        'reply-header-date-opacity': 0.65,
        'retailerReview-base-lg-background': 'rgb(239, 241, 242)',
        'retailerReview-base-lg-borderColor': 'rgb(239, 241, 242)',
        'retailerReview-base-lg-borderRadius': '0',
        'retailerReview-base-lg-borderStyle': 'solid',
        'retailerReview-base-lg-borderWidth': '0.0625rem',
        'retailerReview-base-lg-gap': '1.5rem',
        'retailerReview-base-lg-paddingBlock': '1.5rem',
        'retailerReview-base-lg-paddingInline': '1.5rem',
        'retailerReview-base-sm-background': 'rgb(239, 241, 242)',
        'retailerReview-base-sm-borderColor': 'rgb(239, 241, 242)',
        'retailerReview-base-sm-borderRadius': '0',
        'retailerReview-base-sm-borderStyle': 'solid',
        'retailerReview-base-sm-borderWidth': '0.0625rem',
        'retailerReview-base-sm-gap': '1rem',
        'retailerReview-base-sm-paddingBlock': '1rem',
        'retailerReview-base-sm-paddingInline': '1rem',
        'retailerReview-content-lg-gap': '0.75rem',
        'retailerReview-content-linkTileRow-lg-gap': '0.75rem',
        'retailerReview-content-linkTileRow-sm-gap': '0.5rem',
        'retailerReview-content-sm-gap': '0.5rem',
        'retailerReview-description-base-color': 'rgb(0, 0, 0)',
        'retailerReview-description-base-fontFamily': 'Bosch Sans, sans-serif',
        'retailerReview-description-base-fontSize': '0.625rem',
        'retailerReview-description-base-fontWeight': 'normal',
        'retailerReview-description-base-letterSpacing': '0em',
        'retailerReview-description-base-lineHeight': '0.75rem',
        'retailerReview-description-base-opacity': 0.65,
        'retailerReview-title-lg-color': 'rgb(0, 0, 0)',
        'retailerReview-title-lg-fontFamily': 'Bosch Sans, sans-serif',
        'retailerReview-title-lg-fontSize': '1rem',
        'retailerReview-title-lg-fontWeight': 'bold',
        'retailerReview-title-lg-letterSpacing': '0em',
        'retailerReview-title-lg-lineHeight': '1.5rem',
        'retailerReview-title-sm-color': 'rgb(0, 0, 0)',
        'retailerReview-title-sm-fontFamily': 'Bosch Sans, sans-serif',
        'retailerReview-title-sm-fontSize': '0.875rem',
        'retailerReview-title-sm-fontWeight': 'bold',
        'retailerReview-title-sm-letterSpacing': '0em',
        'retailerReview-title-sm-lineHeight': '1.25rem',
        'scrollToTop-base-hover-background': 'rgb(239, 241, 242)',
        'scrollToTop-base-hover-borderRadius': '624.9375rem',
        'scrollToTop-base-hover-height': '3rem',
        'scrollToTop-base-hover-width': '3rem',
        'scrollToTop-base-initial-background': 'rgb(239, 241, 242)',
        'scrollToTop-base-initial-borderRadius': '624.9375rem',
        'scrollToTop-base-initial-height': '3rem',
        'scrollToTop-base-initial-width': '3rem',
        'scrollToTop-base-pressed-background': 'rgb(239, 241, 242)',
        'scrollToTop-base-pressed-borderRadius': '624.9375rem',
        'scrollToTop-base-pressed-height': '3rem',
        'scrollToTop-base-pressed-width': '3rem',
        'scrollToTop-icon-hover-background': 'rgb(0, 0, 0)',
        'scrollToTop-icon-hover-opacity': 0.8,
        'scrollToTop-icon-initial-background': 'rgb(0, 0, 0)',
        'scrollToTop-icon-initial-opacity': 0.65,
        'scrollToTop-icon-pressed-background': 'rgb(0, 0, 0)',
        'scrollToTop-icon-pressed-opacity': 0.4,
        'section-header-headline-default-lg-color': 'rgb(0, 0, 0)',
        'section-header-headline-default-lg-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-default-lg-fontSize': '2rem',
        'section-header-headline-default-lg-fontWeight': 'bold',
        'section-header-headline-default-lg-letterSpacing': '0em',
        'section-header-headline-default-lg-lineHeight': '2.5rem',
        'section-header-headline-default-md-color': 'rgb(0, 0, 0)',
        'section-header-headline-default-md-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-default-md-fontSize': '1.75rem',
        'section-header-headline-default-md-fontWeight': 'bold',
        'section-header-headline-default-md-letterSpacing': '0em',
        'section-header-headline-default-md-lineHeight': '2.25rem',
        'section-header-headline-default-sm-color': 'rgb(0, 0, 0)',
        'section-header-headline-default-sm-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-default-sm-fontSize': '1.5rem',
        'section-header-headline-default-sm-fontWeight': 'bold',
        'section-header-headline-default-sm-letterSpacing': '0em',
        'section-header-headline-default-sm-lineHeight': '2rem',
        'section-header-headline-default-xs-color': 'rgb(0, 0, 0)',
        'section-header-headline-default-xs-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-default-xs-fontSize': '1.25rem',
        'section-header-headline-default-xs-fontWeight': 'bold',
        'section-header-headline-default-xs-letterSpacing': '0em',
        'section-header-headline-default-xs-lineHeight': '1.75rem',
        'section-header-headline-highlighted-lg-color': 'rgb(0, 0, 0)',
        'section-header-headline-highlighted-lg-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-highlighted-lg-fontSize': '2rem',
        'section-header-headline-highlighted-lg-fontWeight': 'bold',
        'section-header-headline-highlighted-lg-letterSpacing': '0em',
        'section-header-headline-highlighted-lg-lineHeight': '2.5rem',
        'section-header-headline-highlighted-md-color': 'rgb(0, 0, 0)',
        'section-header-headline-highlighted-md-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-highlighted-md-fontSize': '1.75rem',
        'section-header-headline-highlighted-md-fontWeight': 'bold',
        'section-header-headline-highlighted-md-letterSpacing': '0em',
        'section-header-headline-highlighted-md-lineHeight': '2.25rem',
        'section-header-headline-highlighted-sm-color': 'rgb(0, 0, 0)',
        'section-header-headline-highlighted-sm-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-highlighted-sm-fontSize': '1.5rem',
        'section-header-headline-highlighted-sm-fontWeight': 'bold',
        'section-header-headline-highlighted-sm-letterSpacing': '0em',
        'section-header-headline-highlighted-sm-lineHeight': '2rem',
        'section-header-headline-highlighted-xs-color': 'rgb(0, 0, 0)',
        'section-header-headline-highlighted-xs-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-highlighted-xs-fontSize': '1.25rem',
        'section-header-headline-highlighted-xs-fontWeight': 'bold',
        'section-header-headline-highlighted-xs-letterSpacing': '0em',
        'section-header-headline-highlighted-xs-lineHeight': '1.75rem',
        'section-header-headline-image-lg-color': 'rgb(255, 255, 255)',
        'section-header-headline-image-lg-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-image-lg-fontSize': '2rem',
        'section-header-headline-image-lg-fontWeight': 'bold',
        'section-header-headline-image-lg-letterSpacing': '0em',
        'section-header-headline-image-lg-lineHeight': '2.5rem',
        'section-header-headline-image-md-color': 'rgb(255, 255, 255)',
        'section-header-headline-image-md-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-image-md-fontSize': '1.75rem',
        'section-header-headline-image-md-fontWeight': 'bold',
        'section-header-headline-image-md-letterSpacing': '0em',
        'section-header-headline-image-md-lineHeight': '2.25rem',
        'section-header-headline-image-sm-color': 'rgb(255, 255, 255)',
        'section-header-headline-image-sm-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-image-sm-fontSize': '1.5rem',
        'section-header-headline-image-sm-fontWeight': 'bold',
        'section-header-headline-image-sm-letterSpacing': '0em',
        'section-header-headline-image-sm-lineHeight': '2rem',
        'section-header-headline-image-xs-color': 'rgb(255, 255, 255)',
        'section-header-headline-image-xs-fontFamily': 'Bosch Sans, sans-serif',
        'section-header-headline-image-xs-fontSize': '1.25rem',
        'section-header-headline-image-xs-fontWeight': 'bold',
        'section-header-headline-image-xs-letterSpacing': '0em',
        'section-header-headline-image-xs-lineHeight': '1.75rem',
        'section-header-navigation-buttonAction-image-borderColor-disabled': 'rgb(255, 255, 255)',
        'section-header-navigation-buttonAction-image-borderColor-initial': 'rgb(255, 255, 255)',
        'section-header-navigation-buttonAction-image-onBackground-disabled': 'rgb(255, 255, 255)',
        'section-header-navigation-buttonAction-image-onBackground-initial': 'rgb(255, 255, 255)',
        'segmentControl-base-lg-background': 'rgb(255, 255, 255)',
        'segmentControl-base-lg-borderRadius': '0',
        'segmentControl-base-lg-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'segmentControl-base-lg-paddingBottom': '0.5rem',
        'segmentControl-base-lg-paddingTop': '0.5rem',
        'segmentControl-base-md-background': 'rgb(255, 255, 255)',
        'segmentControl-base-md-borderRadius': '0',
        'segmentControl-base-md-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'segmentControl-base-md-paddingBottom': '0.5rem',
        'segmentControl-base-md-paddingTop': '0.5rem',
        'segmentControl-base-sm-background': 'rgb(255, 255, 255)',
        'segmentControl-base-sm-borderRadius': '0',
        'segmentControl-base-sm-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04))',
        },
        'segmentControl-base-sm-paddingBottom': '0.5rem',
        'segmentControl-base-sm-paddingTop': '0.5rem',
        'segmentControl-button-base-left-lg-hover-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-lg-hover-filter': 'brightness(0.96)',
        'segmentControl-button-base-left-lg-hover-paddingLeft': '0.75rem',
        'segmentControl-button-base-left-lg-hover-paddingRight': '2rem',
        'segmentControl-button-base-left-lg-initial-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-lg-initial-paddingLeft': '0.75rem',
        'segmentControl-button-base-left-lg-initial-paddingRight': '2rem',
        'segmentControl-button-base-left-lg-pressed-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-lg-pressed-filter': 'brightness(0.94)',
        'segmentControl-button-base-left-lg-pressed-paddingLeft': '0.75rem',
        'segmentControl-button-base-left-lg-pressed-paddingRight': '2rem',
        'segmentControl-button-base-left-sm-hover-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-sm-hover-filter': 'brightness(0.96)',
        'segmentControl-button-base-left-sm-hover-paddingLeft': '0.5rem',
        'segmentControl-button-base-left-sm-hover-paddingRight': '1.5rem',
        'segmentControl-button-base-left-sm-initial-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-sm-initial-paddingLeft': '0.5rem',
        'segmentControl-button-base-left-sm-initial-paddingRight': '1.5rem',
        'segmentControl-button-base-left-sm-pressed-background': 'linear-gradient(270deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-left-sm-pressed-filter': 'brightness(0.94)',
        'segmentControl-button-base-left-sm-pressed-paddingLeft': '0.5rem',
        'segmentControl-button-base-left-sm-pressed-paddingRight': '1.5rem',
        'segmentControl-button-base-right-lg-hover-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-lg-hover-filter': 'brightness(0.96)',
        'segmentControl-button-base-right-lg-hover-paddingLeft': '2rem',
        'segmentControl-button-base-right-lg-hover-paddingRight': '0.75rem',
        'segmentControl-button-base-right-lg-initial-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-lg-initial-paddingLeft': '2rem',
        'segmentControl-button-base-right-lg-initial-paddingRight': '0.75rem',
        'segmentControl-button-base-right-lg-pressed-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-lg-pressed-filter': 'brightness(0.94)',
        'segmentControl-button-base-right-lg-pressed-paddingLeft': '2rem',
        'segmentControl-button-base-right-lg-pressed-paddingRight': '0.75rem',
        'segmentControl-button-base-right-sm-hover-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-sm-hover-filter': 'brightness(0.96)',
        'segmentControl-button-base-right-sm-hover-paddingLeft': '1.5rem',
        'segmentControl-button-base-right-sm-hover-paddingRight': '0.5rem',
        'segmentControl-button-base-right-sm-initial-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-sm-initial-paddingLeft': '1.5rem',
        'segmentControl-button-base-right-sm-initial-paddingRight': '0.5rem',
        'segmentControl-button-base-right-sm-pressed-background': 'linear-gradient(90deg, #ffffff00 0%, #ffffff 65%)',
        'segmentControl-button-base-right-sm-pressed-filter': 'brightness(0.94)',
        'segmentControl-button-base-right-sm-pressed-paddingLeft': '1.5rem',
        'segmentControl-button-base-right-sm-pressed-paddingRight': '0.5rem',
        'segmentControl-button-icon-hover-background': 'rgb(0, 0, 0)',
        'segmentControl-button-icon-hover-filter': 'brightness(0.96)',
        'segmentControl-button-icon-hover-opacity': 0.8,
        'segmentControl-button-icon-initial-background': 'rgb(0, 0, 0)',
        'segmentControl-button-icon-initial-opacity': 0.65,
        'segmentControl-button-icon-pressed-background': 'rgb(0, 0, 0)',
        'segmentControl-button-icon-pressed-filter': 'brightness(0.94)',
        'segmentControl-button-icon-pressed-opacity': 0.4,
        'segmentControl-tab-base-lg-selected-hover-background': 'rgb(224, 226, 229)',
        'segmentControl-tab-base-lg-selected-hover-borderRadius': '0',
        'segmentControl-tab-base-lg-selected-hover-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-selected-hover-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-selected-hover-paddingRight': '1rem',
        'segmentControl-tab-base-lg-selected-hover-paddingTop': '0.75rem',
        'segmentControl-tab-base-lg-selected-initial-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-lg-selected-initial-borderRadius': '0',
        'segmentControl-tab-base-lg-selected-initial-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-selected-initial-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-selected-initial-paddingRight': '1rem',
        'segmentControl-tab-base-lg-selected-initial-paddingTop': '0.75rem',
        'segmentControl-tab-base-lg-selected-pressed-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-lg-selected-pressed-borderRadius': '0',
        'segmentControl-tab-base-lg-selected-pressed-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-selected-pressed-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-selected-pressed-paddingRight': '1rem',
        'segmentControl-tab-base-lg-selected-pressed-paddingTop': '0.75rem',
        'segmentControl-tab-base-lg-unselected-hover-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-lg-unselected-hover-borderRadius': '0',
        'segmentControl-tab-base-lg-unselected-hover-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-unselected-hover-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-unselected-hover-paddingRight': '1rem',
        'segmentControl-tab-base-lg-unselected-hover-paddingTop': '0.75rem',
        'segmentControl-tab-base-lg-unselected-initial-background': 'rgb(255, 255, 255)',
        'segmentControl-tab-base-lg-unselected-initial-borderRadius': '0',
        'segmentControl-tab-base-lg-unselected-initial-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-unselected-initial-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-unselected-initial-paddingRight': '1rem',
        'segmentControl-tab-base-lg-unselected-initial-paddingTop': '0.75rem',
        'segmentControl-tab-base-lg-unselected-pressed-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-lg-unselected-pressed-borderRadius': '0',
        'segmentControl-tab-base-lg-unselected-pressed-paddingBottom': '0.75rem',
        'segmentControl-tab-base-lg-unselected-pressed-paddingLeft': '1rem',
        'segmentControl-tab-base-lg-unselected-pressed-paddingRight': '1rem',
        'segmentControl-tab-base-lg-unselected-pressed-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-selected-hover-background': 'rgb(224, 226, 229)',
        'segmentControl-tab-base-sm-selected-hover-borderRadius': '0',
        'segmentControl-tab-base-sm-selected-hover-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-selected-hover-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-selected-hover-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-selected-hover-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-selected-initial-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-sm-selected-initial-borderRadius': '0',
        'segmentControl-tab-base-sm-selected-initial-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-selected-initial-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-selected-initial-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-selected-initial-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-selected-pressed-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-sm-selected-pressed-borderRadius': '0',
        'segmentControl-tab-base-sm-selected-pressed-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-selected-pressed-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-selected-pressed-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-selected-pressed-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-unselected-hover-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-sm-unselected-hover-borderRadius': '0',
        'segmentControl-tab-base-sm-unselected-hover-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-unselected-hover-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-unselected-hover-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-unselected-hover-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-unselected-initial-background': 'rgb(255, 255, 255)',
        'segmentControl-tab-base-sm-unselected-initial-borderRadius': '0',
        'segmentControl-tab-base-sm-unselected-initial-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-unselected-initial-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-unselected-initial-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-unselected-initial-paddingTop': '0.75rem',
        'segmentControl-tab-base-sm-unselected-pressed-background': 'rgb(239, 241, 242)',
        'segmentControl-tab-base-sm-unselected-pressed-borderRadius': '0',
        'segmentControl-tab-base-sm-unselected-pressed-paddingBottom': '0.75rem',
        'segmentControl-tab-base-sm-unselected-pressed-paddingLeft': '0.75rem',
        'segmentControl-tab-base-sm-unselected-pressed-paddingRight': '0.75rem',
        'segmentControl-tab-base-sm-unselected-pressed-paddingTop': '0.75rem',
        'segmentControl-tab-label-lg-selected-hover-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-selected-hover-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-selected-hover-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-selected-hover-fontWeight': 'bold',
        'segmentControl-tab-label-lg-selected-hover-letterSpacing': '0em',
        'segmentControl-tab-label-lg-selected-hover-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-selected-hover-opacity': 1,
        'segmentControl-tab-label-lg-selected-initial-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-selected-initial-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-selected-initial-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-selected-initial-fontWeight': 'bold',
        'segmentControl-tab-label-lg-selected-initial-letterSpacing': '0em',
        'segmentControl-tab-label-lg-selected-initial-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-selected-initial-opacity': 0.8,
        'segmentControl-tab-label-lg-selected-pressed-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-selected-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-selected-pressed-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-selected-pressed-fontWeight': 'bold',
        'segmentControl-tab-label-lg-selected-pressed-letterSpacing': '0em',
        'segmentControl-tab-label-lg-selected-pressed-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-selected-pressed-opacity': 0.65,
        'segmentControl-tab-label-lg-unselected-hover-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-unselected-hover-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-unselected-hover-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-unselected-hover-fontWeight': 'bold',
        'segmentControl-tab-label-lg-unselected-hover-letterSpacing': '0em',
        'segmentControl-tab-label-lg-unselected-hover-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-unselected-hover-opacity': 0.8,
        'segmentControl-tab-label-lg-unselected-initial-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-unselected-initial-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-unselected-initial-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-unselected-initial-fontWeight': 'bold',
        'segmentControl-tab-label-lg-unselected-initial-letterSpacing': '0em',
        'segmentControl-tab-label-lg-unselected-initial-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-unselected-initial-opacity': 0.65,
        'segmentControl-tab-label-lg-unselected-pressed-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-lg-unselected-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-lg-unselected-pressed-fontSize': '0.875rem',
        'segmentControl-tab-label-lg-unselected-pressed-fontWeight': 'bold',
        'segmentControl-tab-label-lg-unselected-pressed-letterSpacing': '0em',
        'segmentControl-tab-label-lg-unselected-pressed-lineHeight': '1.25rem',
        'segmentControl-tab-label-lg-unselected-pressed-opacity': 0.4,
        'segmentControl-tab-label-sm-selected-hover-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-selected-hover-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-selected-hover-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-selected-hover-fontWeight': 'bold',
        'segmentControl-tab-label-sm-selected-hover-letterSpacing': '0em',
        'segmentControl-tab-label-sm-selected-hover-lineHeight': '1rem',
        'segmentControl-tab-label-sm-selected-hover-opacity': 1,
        'segmentControl-tab-label-sm-selected-initial-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-selected-initial-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-selected-initial-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-selected-initial-fontWeight': 'bold',
        'segmentControl-tab-label-sm-selected-initial-letterSpacing': '0em',
        'segmentControl-tab-label-sm-selected-initial-lineHeight': '1rem',
        'segmentControl-tab-label-sm-selected-initial-opacity': 0.8,
        'segmentControl-tab-label-sm-selected-pressed-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-selected-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-selected-pressed-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-selected-pressed-fontWeight': 'bold',
        'segmentControl-tab-label-sm-selected-pressed-letterSpacing': '0em',
        'segmentControl-tab-label-sm-selected-pressed-lineHeight': '1rem',
        'segmentControl-tab-label-sm-selected-pressed-opacity': 0.65,
        'segmentControl-tab-label-sm-unselected-hover-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-unselected-hover-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-unselected-hover-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-unselected-hover-fontWeight': 'bold',
        'segmentControl-tab-label-sm-unselected-hover-letterSpacing': '0em',
        'segmentControl-tab-label-sm-unselected-hover-lineHeight': '1rem',
        'segmentControl-tab-label-sm-unselected-hover-opacity': 0.8,
        'segmentControl-tab-label-sm-unselected-initial-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-unselected-initial-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-unselected-initial-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-unselected-initial-fontWeight': 'bold',
        'segmentControl-tab-label-sm-unselected-initial-letterSpacing': '0em',
        'segmentControl-tab-label-sm-unselected-initial-lineHeight': '1rem',
        'segmentControl-tab-label-sm-unselected-initial-opacity': 0.65,
        'segmentControl-tab-label-sm-unselected-pressed-color': 'rgb(0, 0, 0)',
        'segmentControl-tab-label-sm-unselected-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'segmentControl-tab-label-sm-unselected-pressed-fontSize': '0.75rem',
        'segmentControl-tab-label-sm-unselected-pressed-fontWeight': 'bold',
        'segmentControl-tab-label-sm-unselected-pressed-letterSpacing': '0em',
        'segmentControl-tab-label-sm-unselected-pressed-lineHeight': '1rem',
        'segmentControl-tab-label-sm-unselected-pressed-opacity': 0.4,
        'segmentControl-tabList-base-lg-gap': '0.5rem',
        'segmentControl-tabList-base-lg-paddingLeft': '0.5rem',
        'segmentControl-tabList-base-lg-paddingRight': '0.5rem',
        'segmentControl-tabList-base-md-gap': '0.5rem',
        'segmentControl-tabList-base-md-paddingLeft': '0.5rem',
        'segmentControl-tabList-base-md-paddingRight': '0.5rem',
        'segmentControl-tabList-base-sm-gap': '0.5rem',
        'segmentControl-tabList-base-sm-paddingLeft': '0.25rem',
        'segmentControl-tabList-base-sm-paddingRight': '0.25rem',
        'select-backgroundColor-default-default': 'rgb(255, 255, 255)',
        'select-backgroundColor-selected-default': 'rgb(255, 255, 255)',
        'select-borderColor-default-default': 'rgb(224, 226, 229)',
        'select-borderColor-selected-default': 'rgb(0, 123, 192)',
        'select-borderColor-selected-disabled': 'rgb(193, 199, 204)',
        'select-borderColor-selected-hover': 'rgb(0, 98, 154)',
        'select-borderColor-selected-pressed': 'rgb(0, 73, 117)',
        'select-textColor-default-default': 'rgb(0, 0, 0)',
        'select-textColor-selected-default': 'rgb(0, 0, 0)',
        'selectAddress-content-base-lg-gap': '1rem',
        'selectAddress-content-base-lg-paddingBottom': '1rem',
        'selectAddress-content-base-lg-paddingTop': '1rem',
        'selectAddress-content-base-sm-gap': '0.75rem',
        'selectAddress-content-base-sm-paddingBottom': '1rem',
        'selectAddress-content-base-sm-paddingTop': '1rem',
        'selectAddress-content-footer-base-lg-borderColor': 'rgb(239, 241, 242)',
        'selectAddress-content-footer-base-lg-borderStyle': 'solid',
        'selectAddress-content-footer-base-lg-borderTopWidth': '0.0625rem',
        'selectAddress-content-footer-base-lg-paddingLeft': '1.5rem',
        'selectAddress-content-footer-base-lg-paddingRight': '1.5rem',
        'selectAddress-content-footer-base-lg-paddingTop': '1rem',
        'selectAddress-content-footer-base-sm-borderColor': 'rgb(239, 241, 242)',
        'selectAddress-content-footer-base-sm-borderStyle': 'solid',
        'selectAddress-content-footer-base-sm-borderTopWidth': '0.0625rem',
        'selectAddress-content-footer-base-sm-paddingLeft': '1rem',
        'selectAddress-content-footer-base-sm-paddingRight': '1rem',
        'selectAddress-content-footer-base-sm-paddingTop': '1rem',
        'selectAddress-content-header-base-lg-borderBottomWidth': '0.0625rem',
        'selectAddress-content-header-base-lg-borderColor': 'rgb(239, 241, 242)',
        'selectAddress-content-header-base-lg-borderStyle': 'solid',
        'selectAddress-content-header-base-lg-paddingBottom': '1rem',
        'selectAddress-content-header-base-lg-paddingLeft': '1.5rem',
        'selectAddress-content-header-base-lg-paddingRight': '1.5rem',
        'selectAddress-content-header-base-sm-borderBottomWidth': '0.0625rem',
        'selectAddress-content-header-base-sm-borderColor': 'rgb(239, 241, 242)',
        'selectAddress-content-header-base-sm-borderStyle': 'solid',
        'selectAddress-content-header-base-sm-paddingBottom': '1rem',
        'selectAddress-content-header-base-sm-paddingLeft': '1rem',
        'selectAddress-content-header-base-sm-paddingRight': '1rem',
        'selectAddress-content-header-headline-color': 'rgb(0, 0, 0)',
        'selectAddress-content-header-headline-fontFamily': 'Bosch Sans, sans-serif',
        'selectAddress-content-header-headline-fontSize': '0.875rem',
        'selectAddress-content-header-headline-fontWeight': 'normal',
        'selectAddress-content-header-headline-letterSpacing': '0em',
        'selectAddress-content-header-headline-lineHeight': '1.25rem',
        'selectAddress-content-header-headline-opacity': 0.65,
        'selectAddress-content-resultList-result-base-lg-hover-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-lg-hover-filter': 'brightness(0.96) contrast(1)',
        'selectAddress-content-resultList-result-base-lg-hover-gap': '1rem',
        'selectAddress-content-resultList-result-base-lg-hover-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-lg-hover-paddingLeft': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-hover-paddingRight': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-hover-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-base-lg-initial-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-lg-initial-filter': 'none',
        'selectAddress-content-resultList-result-base-lg-initial-gap': '1rem',
        'selectAddress-content-resultList-result-base-lg-initial-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-lg-initial-paddingLeft': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-initial-paddingRight': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-initial-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-base-lg-pressed-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-lg-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectAddress-content-resultList-result-base-lg-pressed-gap': '1rem',
        'selectAddress-content-resultList-result-base-lg-pressed-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-lg-pressed-paddingLeft': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-pressed-paddingRight': '1.5rem',
        'selectAddress-content-resultList-result-base-lg-pressed-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-hover-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-sm-hover-filter': 'brightness(0.96) contrast(1)',
        'selectAddress-content-resultList-result-base-sm-hover-gap': '0.75rem',
        'selectAddress-content-resultList-result-base-sm-hover-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-hover-paddingLeft': '1rem',
        'selectAddress-content-resultList-result-base-sm-hover-paddingRight': '1rem',
        'selectAddress-content-resultList-result-base-sm-hover-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-initial-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-sm-initial-filter': 'none',
        'selectAddress-content-resultList-result-base-sm-initial-gap': '0.75rem',
        'selectAddress-content-resultList-result-base-sm-initial-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-initial-paddingLeft': '1rem',
        'selectAddress-content-resultList-result-base-sm-initial-paddingRight': '1rem',
        'selectAddress-content-resultList-result-base-sm-initial-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-pressed-background': 'rgb(255, 255, 255)',
        'selectAddress-content-resultList-result-base-sm-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectAddress-content-resultList-result-base-sm-pressed-gap': '0.75rem',
        'selectAddress-content-resultList-result-base-sm-pressed-paddingBottom': '0.5rem',
        'selectAddress-content-resultList-result-base-sm-pressed-paddingLeft': '1rem',
        'selectAddress-content-resultList-result-base-sm-pressed-paddingRight': '1rem',
        'selectAddress-content-resultList-result-base-sm-pressed-paddingTop': '0.5rem',
        'selectAddress-content-resultList-result-description-color': 'rgb(0, 0, 0)',
        'selectAddress-content-resultList-result-description-fontFamily': 'Bosch Sans, sans-serif',
        'selectAddress-content-resultList-result-description-fontSize': '0.875rem',
        'selectAddress-content-resultList-result-description-fontWeight': 'normal',
        'selectAddress-content-resultList-result-description-letterSpacing': '0em',
        'selectAddress-content-resultList-result-description-lineHeight': '1.25rem',
        'selectAddress-content-resultList-result-description-opacity': 0.8,
        'selectAddress-content-resultList-result-icon-background': 'rgb(0, 0, 0)',
        'selectAddress-content-resultList-result-icon-opacity': 0.8,
        'selectBox-badgeList-base-lg-gap': '1rem',
        'selectBox-badgeList-base-lg-paddingLeft': '1.5rem',
        'selectBox-badgeList-base-lg-paddingRight': '1.5rem',
        'selectBox-badgeList-base-sm-gap': '1rem',
        'selectBox-badgeList-base-sm-paddingLeft': '1rem',
        'selectBox-badgeList-base-sm-paddingRight': '1rem',
        'selectBox-base-center-lg-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-lg-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-disabled-borderStyle': 'solid',
        'selectBox-base-center-lg-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-lg-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-disabled-filter': 'none',
        'selectBox-base-center-lg-resting-disabled-opacity': 0.4,
        'selectBox-base-center-lg-resting-disabled-paddingBlock': '2rem',
        'selectBox-base-center-lg-resting-disabled-paddingInline': '1.5rem',
        'selectBox-base-center-lg-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-focused-borderStyle': 'solid',
        'selectBox-base-center-lg-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-center-lg-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-resting-focused-opacity': 1,
        'selectBox-base-center-lg-resting-focused-paddingBlock': '2rem',
        'selectBox-base-center-lg-resting-focused-paddingInline': '1.5rem',
        'selectBox-base-center-lg-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-hover-borderStyle': 'solid',
        'selectBox-base-center-lg-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-center-lg-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-resting-hover-opacity': 0.8,
        'selectBox-base-center-lg-resting-hover-paddingBlock': '2rem',
        'selectBox-base-center-lg-resting-hover-paddingInline': '1.5rem',
        'selectBox-base-center-lg-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-lg-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-initial-borderStyle': 'solid',
        'selectBox-base-center-lg-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-center-lg-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-initial-filter': 'none',
        'selectBox-base-center-lg-resting-initial-opacity': 1,
        'selectBox-base-center-lg-resting-initial-paddingBlock': '2rem',
        'selectBox-base-center-lg-resting-initial-paddingInline': '1.5rem',
        'selectBox-base-center-lg-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-lg-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-pressed-borderStyle': 'solid',
        'selectBox-base-center-lg-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-lg-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-lg-resting-pressed-opacity': 0.65,
        'selectBox-base-center-lg-resting-pressed-paddingBlock': '2rem',
        'selectBox-base-center-lg-resting-pressed-paddingInline': '1.5rem',
        'selectBox-base-center-lg-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-center-lg-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-disabled-borderStyle': 'solid',
        'selectBox-base-center-lg-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-lg-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-disabled-filter': 'none',
        'selectBox-base-center-lg-selected-disabled-opacity': 0.4,
        'selectBox-base-center-lg-selected-disabled-paddingBlock': '2rem',
        'selectBox-base-center-lg-selected-disabled-paddingInline': '1.5rem',
        'selectBox-base-center-lg-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-focused-borderStyle': 'solid',
        'selectBox-base-center-lg-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-center-lg-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-selected-focused-opacity': 1,
        'selectBox-base-center-lg-selected-focused-paddingBlock': '2rem',
        'selectBox-base-center-lg-selected-focused-paddingInline': '1.5rem',
        'selectBox-base-center-lg-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-hover-borderStyle': 'solid',
        'selectBox-base-center-lg-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-center-lg-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-selected-hover-opacity': 0.8,
        'selectBox-base-center-lg-selected-hover-paddingBlock': '2rem',
        'selectBox-base-center-lg-selected-hover-paddingInline': '1.5rem',
        'selectBox-base-center-lg-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-center-lg-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-initial-borderStyle': 'solid',
        'selectBox-base-center-lg-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-center-lg-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-initial-filter': 'none',
        'selectBox-base-center-lg-selected-initial-opacity': 1,
        'selectBox-base-center-lg-selected-initial-paddingBlock': '2rem',
        'selectBox-base-center-lg-selected-initial-paddingInline': '1.5rem',
        'selectBox-base-center-lg-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-lg-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-pressed-borderStyle': 'solid',
        'selectBox-base-center-lg-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-lg-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-lg-selected-pressed-opacity': 0.65,
        'selectBox-base-center-lg-selected-pressed-paddingBlock': '2rem',
        'selectBox-base-center-lg-selected-pressed-paddingInline': '1.5rem',
        'selectBox-base-center-lg-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-lg-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-center-lg-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-lg-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-disabled-filter': 'none',
        'selectBox-base-center-lg-unselected-disabled-opacity': 0.4,
        'selectBox-base-center-lg-unselected-disabled-paddingBlock': '2rem',
        'selectBox-base-center-lg-unselected-disabled-paddingInline': '1.5rem',
        'selectBox-base-center-lg-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-focused-borderStyle': 'solid',
        'selectBox-base-center-lg-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-center-lg-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-unselected-focused-opacity': 0.8,
        'selectBox-base-center-lg-unselected-focused-paddingBlock': '2rem',
        'selectBox-base-center-lg-unselected-focused-paddingInline': '1.5rem',
        'selectBox-base-center-lg-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-lg-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-hover-borderStyle': 'solid',
        'selectBox-base-center-lg-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-center-lg-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-lg-unselected-hover-opacity': 0.8,
        'selectBox-base-center-lg-unselected-hover-paddingBlock': '2rem',
        'selectBox-base-center-lg-unselected-hover-paddingInline': '1.5rem',
        'selectBox-base-center-lg-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-lg-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-initial-borderStyle': 'solid',
        'selectBox-base-center-lg-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-center-lg-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-initial-filter': 'none',
        'selectBox-base-center-lg-unselected-initial-opacity': 0.65,
        'selectBox-base-center-lg-unselected-initial-paddingBlock': '2rem',
        'selectBox-base-center-lg-unselected-initial-paddingInline': '1.5rem',
        'selectBox-base-center-lg-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-lg-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-lg-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-lg-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-lg-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-center-lg-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-lg-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-lg-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-lg-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-lg-unselected-pressed-opacity': 0.65,
        'selectBox-base-center-lg-unselected-pressed-paddingBlock': '2rem',
        'selectBox-base-center-lg-unselected-pressed-paddingInline': '1.5rem',
        'selectBox-base-center-sm-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-sm-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-disabled-borderStyle': 'solid',
        'selectBox-base-center-sm-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-sm-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-disabled-filter': 'none',
        'selectBox-base-center-sm-resting-disabled-opacity': 0.4,
        'selectBox-base-center-sm-resting-disabled-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-resting-disabled-paddingInline': '1rem',
        'selectBox-base-center-sm-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-focused-borderStyle': 'solid',
        'selectBox-base-center-sm-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-center-sm-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-resting-focused-opacity': 1,
        'selectBox-base-center-sm-resting-focused-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-resting-focused-paddingInline': '1rem',
        'selectBox-base-center-sm-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-hover-borderStyle': 'solid',
        'selectBox-base-center-sm-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-center-sm-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-resting-hover-opacity': 0.8,
        'selectBox-base-center-sm-resting-hover-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-resting-hover-paddingInline': '1rem',
        'selectBox-base-center-sm-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-sm-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-initial-borderStyle': 'solid',
        'selectBox-base-center-sm-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-center-sm-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-initial-filter': 'none',
        'selectBox-base-center-sm-resting-initial-opacity': 1,
        'selectBox-base-center-sm-resting-initial-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-resting-initial-paddingInline': '1rem',
        'selectBox-base-center-sm-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-sm-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-pressed-borderStyle': 'solid',
        'selectBox-base-center-sm-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-sm-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-sm-resting-pressed-opacity': 0.65,
        'selectBox-base-center-sm-resting-pressed-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-resting-pressed-paddingInline': '1rem',
        'selectBox-base-center-sm-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-center-sm-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-disabled-borderStyle': 'solid',
        'selectBox-base-center-sm-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-sm-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-disabled-filter': 'none',
        'selectBox-base-center-sm-selected-disabled-opacity': 0.4,
        'selectBox-base-center-sm-selected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-selected-disabled-paddingInline': '1rem',
        'selectBox-base-center-sm-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-focused-borderStyle': 'solid',
        'selectBox-base-center-sm-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-center-sm-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-selected-focused-opacity': 1,
        'selectBox-base-center-sm-selected-focused-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-selected-focused-paddingInline': '1rem',
        'selectBox-base-center-sm-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-hover-borderStyle': 'solid',
        'selectBox-base-center-sm-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-center-sm-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-selected-hover-opacity': 0.8,
        'selectBox-base-center-sm-selected-hover-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-selected-hover-paddingInline': '1rem',
        'selectBox-base-center-sm-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-center-sm-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-initial-borderStyle': 'solid',
        'selectBox-base-center-sm-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-center-sm-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-initial-filter': 'none',
        'selectBox-base-center-sm-selected-initial-opacity': 1,
        'selectBox-base-center-sm-selected-initial-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-selected-initial-paddingInline': '1rem',
        'selectBox-base-center-sm-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-sm-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-pressed-borderStyle': 'solid',
        'selectBox-base-center-sm-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-sm-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-sm-selected-pressed-opacity': 0.65,
        'selectBox-base-center-sm-selected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-selected-pressed-paddingInline': '1rem',
        'selectBox-base-center-sm-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-sm-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-center-sm-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-center-sm-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-disabled-filter': 'none',
        'selectBox-base-center-sm-unselected-disabled-opacity': 0.4,
        'selectBox-base-center-sm-unselected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-unselected-disabled-paddingInline': '1rem',
        'selectBox-base-center-sm-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-focused-borderStyle': 'solid',
        'selectBox-base-center-sm-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-center-sm-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-unselected-focused-opacity': 0.8,
        'selectBox-base-center-sm-unselected-focused-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-unselected-focused-paddingInline': '1rem',
        'selectBox-base-center-sm-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-center-sm-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-hover-borderStyle': 'solid',
        'selectBox-base-center-sm-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-center-sm-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-center-sm-unselected-hover-opacity': 0.8,
        'selectBox-base-center-sm-unselected-hover-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-unselected-hover-paddingInline': '1rem',
        'selectBox-base-center-sm-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-center-sm-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-initial-borderStyle': 'solid',
        'selectBox-base-center-sm-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-center-sm-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-initial-filter': 'none',
        'selectBox-base-center-sm-unselected-initial-opacity': 0.65,
        'selectBox-base-center-sm-unselected-initial-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-unselected-initial-paddingInline': '1rem',
        'selectBox-base-center-sm-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-center-sm-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-center-sm-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-center-sm-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-center-sm-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-center-sm-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-center-sm-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-center-sm-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-center-sm-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-center-sm-unselected-pressed-opacity': 0.65,
        'selectBox-base-center-sm-unselected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-center-sm-unselected-pressed-paddingInline': '1rem',
        'selectBox-base-first-lg-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-resting-disabled-borderBottomWidth': '0',
        'selectBox-base-first-lg-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-lg-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-disabled-borderStyle': 'solid',
        'selectBox-base-first-lg-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-lg-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-disabled-filter': 'none',
        'selectBox-base-first-lg-resting-disabled-opacity': 0.4,
        'selectBox-base-first-lg-resting-disabled-paddingBlock': '2rem',
        'selectBox-base-first-lg-resting-disabled-paddingInline': '1.5rem',
        'selectBox-base-first-lg-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-resting-focused-borderBottomWidth': '0',
        'selectBox-base-first-lg-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-focused-borderStyle': 'solid',
        'selectBox-base-first-lg-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-first-lg-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-resting-focused-opacity': 1,
        'selectBox-base-first-lg-resting-focused-paddingBlock': '2rem',
        'selectBox-base-first-lg-resting-focused-paddingInline': '1.5rem',
        'selectBox-base-first-lg-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-resting-hover-borderBottomWidth': '0',
        'selectBox-base-first-lg-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-hover-borderStyle': 'solid',
        'selectBox-base-first-lg-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-first-lg-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-resting-hover-opacity': 0.8,
        'selectBox-base-first-lg-resting-hover-paddingBlock': '2rem',
        'selectBox-base-first-lg-resting-hover-paddingInline': '1.5rem',
        'selectBox-base-first-lg-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-resting-initial-borderBottomWidth': '0',
        'selectBox-base-first-lg-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-lg-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-initial-borderStyle': 'solid',
        'selectBox-base-first-lg-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-first-lg-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-initial-filter': 'none',
        'selectBox-base-first-lg-resting-initial-opacity': 1,
        'selectBox-base-first-lg-resting-initial-paddingBlock': '2rem',
        'selectBox-base-first-lg-resting-initial-paddingInline': '1.5rem',
        'selectBox-base-first-lg-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-resting-pressed-borderBottomWidth': '0',
        'selectBox-base-first-lg-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-lg-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-pressed-borderStyle': 'solid',
        'selectBox-base-first-lg-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-lg-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-lg-resting-pressed-opacity': 0.65,
        'selectBox-base-first-lg-resting-pressed-paddingBlock': '2rem',
        'selectBox-base-first-lg-resting-pressed-paddingInline': '1.5rem',
        'selectBox-base-first-lg-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-first-lg-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-disabled-borderStyle': 'solid',
        'selectBox-base-first-lg-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-lg-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-disabled-filter': 'none',
        'selectBox-base-first-lg-selected-disabled-opacity': 0.4,
        'selectBox-base-first-lg-selected-disabled-paddingBlock': '2rem',
        'selectBox-base-first-lg-selected-disabled-paddingInline': '1.5rem',
        'selectBox-base-first-lg-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-focused-borderStyle': 'solid',
        'selectBox-base-first-lg-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-first-lg-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-selected-focused-opacity': 1,
        'selectBox-base-first-lg-selected-focused-paddingBlock': '2rem',
        'selectBox-base-first-lg-selected-focused-paddingInline': '1.5rem',
        'selectBox-base-first-lg-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-hover-borderStyle': 'solid',
        'selectBox-base-first-lg-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-first-lg-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-selected-hover-opacity': 0.8,
        'selectBox-base-first-lg-selected-hover-paddingBlock': '2rem',
        'selectBox-base-first-lg-selected-hover-paddingInline': '1.5rem',
        'selectBox-base-first-lg-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-first-lg-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-initial-borderStyle': 'solid',
        'selectBox-base-first-lg-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-first-lg-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-initial-filter': 'none',
        'selectBox-base-first-lg-selected-initial-opacity': 1,
        'selectBox-base-first-lg-selected-initial-paddingBlock': '2rem',
        'selectBox-base-first-lg-selected-initial-paddingInline': '1.5rem',
        'selectBox-base-first-lg-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-lg-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-pressed-borderStyle': 'solid',
        'selectBox-base-first-lg-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-lg-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-lg-selected-pressed-opacity': 0.65,
        'selectBox-base-first-lg-selected-pressed-paddingBlock': '2rem',
        'selectBox-base-first-lg-selected-pressed-paddingInline': '1.5rem',
        'selectBox-base-first-lg-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-unselected-disabled-borderBottomWidth': '0',
        'selectBox-base-first-lg-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-lg-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-first-lg-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-lg-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-disabled-filter': 'none',
        'selectBox-base-first-lg-unselected-disabled-opacity': 0.4,
        'selectBox-base-first-lg-unselected-disabled-paddingBlock': '2rem',
        'selectBox-base-first-lg-unselected-disabled-paddingInline': '1.5rem',
        'selectBox-base-first-lg-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-unselected-focused-borderBottomWidth': '0',
        'selectBox-base-first-lg-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-focused-borderStyle': 'solid',
        'selectBox-base-first-lg-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-first-lg-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-unselected-focused-opacity': 0.8,
        'selectBox-base-first-lg-unselected-focused-paddingBlock': '2rem',
        'selectBox-base-first-lg-unselected-focused-paddingInline': '1.5rem',
        'selectBox-base-first-lg-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-unselected-hover-borderBottomWidth': '0',
        'selectBox-base-first-lg-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-lg-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-hover-borderStyle': 'solid',
        'selectBox-base-first-lg-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-first-lg-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-lg-unselected-hover-opacity': 0.8,
        'selectBox-base-first-lg-unselected-hover-paddingBlock': '2rem',
        'selectBox-base-first-lg-unselected-hover-paddingInline': '1.5rem',
        'selectBox-base-first-lg-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-unselected-initial-borderBottomWidth': '0',
        'selectBox-base-first-lg-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-lg-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-initial-borderStyle': 'solid',
        'selectBox-base-first-lg-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-first-lg-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-initial-filter': 'none',
        'selectBox-base-first-lg-unselected-initial-opacity': 0.65,
        'selectBox-base-first-lg-unselected-initial-paddingBlock': '2rem',
        'selectBox-base-first-lg-unselected-initial-paddingInline': '1.5rem',
        'selectBox-base-first-lg-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-lg-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-lg-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-lg-unselected-pressed-borderBottomWidth': '0',
        'selectBox-base-first-lg-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-lg-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-first-lg-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-lg-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-lg-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-lg-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-lg-unselected-pressed-opacity': 0.65,
        'selectBox-base-first-lg-unselected-pressed-paddingBlock': '2rem',
        'selectBox-base-first-lg-unselected-pressed-paddingInline': '1.5rem',
        'selectBox-base-first-sm-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-resting-disabled-borderBottomWidth': '0',
        'selectBox-base-first-sm-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-sm-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-disabled-borderStyle': 'solid',
        'selectBox-base-first-sm-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-sm-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-disabled-filter': 'none',
        'selectBox-base-first-sm-resting-disabled-opacity': 0.4,
        'selectBox-base-first-sm-resting-disabled-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-resting-disabled-paddingInline': '1rem',
        'selectBox-base-first-sm-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-resting-focused-borderBottomWidth': '0',
        'selectBox-base-first-sm-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-focused-borderStyle': 'solid',
        'selectBox-base-first-sm-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-first-sm-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-resting-focused-opacity': 1,
        'selectBox-base-first-sm-resting-focused-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-resting-focused-paddingInline': '1rem',
        'selectBox-base-first-sm-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-resting-hover-borderBottomWidth': '0',
        'selectBox-base-first-sm-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-hover-borderStyle': 'solid',
        'selectBox-base-first-sm-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-first-sm-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-resting-hover-opacity': 0.8,
        'selectBox-base-first-sm-resting-hover-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-resting-hover-paddingInline': '1rem',
        'selectBox-base-first-sm-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-resting-initial-borderBottomWidth': '0',
        'selectBox-base-first-sm-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-sm-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-initial-borderStyle': 'solid',
        'selectBox-base-first-sm-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-first-sm-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-initial-filter': 'none',
        'selectBox-base-first-sm-resting-initial-opacity': 1,
        'selectBox-base-first-sm-resting-initial-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-resting-initial-paddingInline': '1rem',
        'selectBox-base-first-sm-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-resting-pressed-borderBottomWidth': '0',
        'selectBox-base-first-sm-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-sm-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-pressed-borderStyle': 'solid',
        'selectBox-base-first-sm-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-sm-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-sm-resting-pressed-opacity': 0.65,
        'selectBox-base-first-sm-resting-pressed-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-resting-pressed-paddingInline': '1rem',
        'selectBox-base-first-sm-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-first-sm-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-disabled-borderStyle': 'solid',
        'selectBox-base-first-sm-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-sm-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-disabled-filter': 'none',
        'selectBox-base-first-sm-selected-disabled-opacity': 0.4,
        'selectBox-base-first-sm-selected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-selected-disabled-paddingInline': '1rem',
        'selectBox-base-first-sm-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-focused-borderStyle': 'solid',
        'selectBox-base-first-sm-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-first-sm-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-selected-focused-opacity': 1,
        'selectBox-base-first-sm-selected-focused-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-selected-focused-paddingInline': '1rem',
        'selectBox-base-first-sm-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-hover-borderStyle': 'solid',
        'selectBox-base-first-sm-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-first-sm-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-selected-hover-opacity': 0.8,
        'selectBox-base-first-sm-selected-hover-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-selected-hover-paddingInline': '1rem',
        'selectBox-base-first-sm-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-first-sm-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-initial-borderStyle': 'solid',
        'selectBox-base-first-sm-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-first-sm-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-initial-filter': 'none',
        'selectBox-base-first-sm-selected-initial-opacity': 1,
        'selectBox-base-first-sm-selected-initial-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-selected-initial-paddingInline': '1rem',
        'selectBox-base-first-sm-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-sm-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-pressed-borderStyle': 'solid',
        'selectBox-base-first-sm-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-sm-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-sm-selected-pressed-opacity': 0.65,
        'selectBox-base-first-sm-selected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-selected-pressed-paddingInline': '1rem',
        'selectBox-base-first-sm-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-unselected-disabled-borderBottomWidth': '0',
        'selectBox-base-first-sm-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-sm-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-first-sm-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-first-sm-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-disabled-filter': 'none',
        'selectBox-base-first-sm-unselected-disabled-opacity': 0.4,
        'selectBox-base-first-sm-unselected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-unselected-disabled-paddingInline': '1rem',
        'selectBox-base-first-sm-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-unselected-focused-borderBottomWidth': '0',
        'selectBox-base-first-sm-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-focused-borderStyle': 'solid',
        'selectBox-base-first-sm-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-first-sm-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-unselected-focused-opacity': 0.8,
        'selectBox-base-first-sm-unselected-focused-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-unselected-focused-paddingInline': '1rem',
        'selectBox-base-first-sm-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-unselected-hover-borderBottomWidth': '0',
        'selectBox-base-first-sm-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-first-sm-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-hover-borderStyle': 'solid',
        'selectBox-base-first-sm-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-first-sm-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-first-sm-unselected-hover-opacity': 0.8,
        'selectBox-base-first-sm-unselected-hover-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-unselected-hover-paddingInline': '1rem',
        'selectBox-base-first-sm-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-unselected-initial-borderBottomWidth': '0',
        'selectBox-base-first-sm-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-first-sm-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-initial-borderStyle': 'solid',
        'selectBox-base-first-sm-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-first-sm-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-initial-filter': 'none',
        'selectBox-base-first-sm-unselected-initial-opacity': 0.65,
        'selectBox-base-first-sm-unselected-initial-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-unselected-initial-paddingInline': '1rem',
        'selectBox-base-first-sm-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-first-sm-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-first-sm-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-first-sm-unselected-pressed-borderBottomWidth': '0',
        'selectBox-base-first-sm-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-first-sm-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-first-sm-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-first-sm-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-first-sm-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-first-sm-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-first-sm-unselected-pressed-opacity': 0.65,
        'selectBox-base-first-sm-unselected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-first-sm-unselected-pressed-paddingInline': '1rem',
        'selectBox-base-last-lg-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-lg-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-disabled-borderStyle': 'solid',
        'selectBox-base-last-lg-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-lg-resting-disabled-borderTopWidth': '0',
        'selectBox-base-last-lg-resting-disabled-filter': 'none',
        'selectBox-base-last-lg-resting-disabled-opacity': 0.4,
        'selectBox-base-last-lg-resting-disabled-paddingBlock': '2rem',
        'selectBox-base-last-lg-resting-disabled-paddingInline': '1.5rem',
        'selectBox-base-last-lg-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-focused-borderStyle': 'solid',
        'selectBox-base-last-lg-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-last-lg-resting-focused-borderTopWidth': '0',
        'selectBox-base-last-lg-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-resting-focused-opacity': 1,
        'selectBox-base-last-lg-resting-focused-paddingBlock': '2rem',
        'selectBox-base-last-lg-resting-focused-paddingInline': '1.5rem',
        'selectBox-base-last-lg-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-hover-borderStyle': 'solid',
        'selectBox-base-last-lg-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-last-lg-resting-hover-borderTopWidth': '0',
        'selectBox-base-last-lg-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-resting-hover-opacity': 0.8,
        'selectBox-base-last-lg-resting-hover-paddingBlock': '2rem',
        'selectBox-base-last-lg-resting-hover-paddingInline': '1.5rem',
        'selectBox-base-last-lg-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-lg-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-initial-borderStyle': 'solid',
        'selectBox-base-last-lg-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-last-lg-resting-initial-borderTopWidth': '0',
        'selectBox-base-last-lg-resting-initial-filter': 'none',
        'selectBox-base-last-lg-resting-initial-opacity': 1,
        'selectBox-base-last-lg-resting-initial-paddingBlock': '2rem',
        'selectBox-base-last-lg-resting-initial-paddingInline': '1.5rem',
        'selectBox-base-last-lg-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-lg-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-resting-pressed-borderStyle': 'solid',
        'selectBox-base-last-lg-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-lg-resting-pressed-borderTopWidth': '0',
        'selectBox-base-last-lg-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-lg-resting-pressed-opacity': 0.65,
        'selectBox-base-last-lg-resting-pressed-paddingBlock': '2rem',
        'selectBox-base-last-lg-resting-pressed-paddingInline': '1.5rem',
        'selectBox-base-last-lg-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-last-lg-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-disabled-borderStyle': 'solid',
        'selectBox-base-last-lg-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-lg-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-disabled-filter': 'none',
        'selectBox-base-last-lg-selected-disabled-opacity': 0.4,
        'selectBox-base-last-lg-selected-disabled-paddingBlock': '2rem',
        'selectBox-base-last-lg-selected-disabled-paddingInline': '1.5rem',
        'selectBox-base-last-lg-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-focused-borderStyle': 'solid',
        'selectBox-base-last-lg-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-last-lg-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-selected-focused-opacity': 1,
        'selectBox-base-last-lg-selected-focused-paddingBlock': '2rem',
        'selectBox-base-last-lg-selected-focused-paddingInline': '1.5rem',
        'selectBox-base-last-lg-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-hover-borderStyle': 'solid',
        'selectBox-base-last-lg-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-last-lg-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-selected-hover-opacity': 0.8,
        'selectBox-base-last-lg-selected-hover-paddingBlock': '2rem',
        'selectBox-base-last-lg-selected-hover-paddingInline': '1.5rem',
        'selectBox-base-last-lg-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-last-lg-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-initial-borderStyle': 'solid',
        'selectBox-base-last-lg-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-last-lg-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-initial-filter': 'none',
        'selectBox-base-last-lg-selected-initial-opacity': 1,
        'selectBox-base-last-lg-selected-initial-paddingBlock': '2rem',
        'selectBox-base-last-lg-selected-initial-paddingInline': '1.5rem',
        'selectBox-base-last-lg-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-lg-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-pressed-borderStyle': 'solid',
        'selectBox-base-last-lg-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-lg-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-last-lg-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-lg-selected-pressed-opacity': 0.65,
        'selectBox-base-last-lg-selected-pressed-paddingBlock': '2rem',
        'selectBox-base-last-lg-selected-pressed-paddingInline': '1.5rem',
        'selectBox-base-last-lg-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-lg-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-last-lg-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-lg-unselected-disabled-borderTopWidth': '0',
        'selectBox-base-last-lg-unselected-disabled-filter': 'none',
        'selectBox-base-last-lg-unselected-disabled-opacity': 0.4,
        'selectBox-base-last-lg-unselected-disabled-paddingBlock': '2rem',
        'selectBox-base-last-lg-unselected-disabled-paddingInline': '1.5rem',
        'selectBox-base-last-lg-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-focused-borderStyle': 'solid',
        'selectBox-base-last-lg-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-last-lg-unselected-focused-borderTopWidth': '0',
        'selectBox-base-last-lg-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-unselected-focused-opacity': 0.8,
        'selectBox-base-last-lg-unselected-focused-paddingBlock': '2rem',
        'selectBox-base-last-lg-unselected-focused-paddingInline': '1.5rem',
        'selectBox-base-last-lg-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-lg-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-hover-borderStyle': 'solid',
        'selectBox-base-last-lg-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-last-lg-unselected-hover-borderTopWidth': '0',
        'selectBox-base-last-lg-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-lg-unselected-hover-opacity': 0.8,
        'selectBox-base-last-lg-unselected-hover-paddingBlock': '2rem',
        'selectBox-base-last-lg-unselected-hover-paddingInline': '1.5rem',
        'selectBox-base-last-lg-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-lg-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-initial-borderStyle': 'solid',
        'selectBox-base-last-lg-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-last-lg-unselected-initial-borderTopWidth': '0',
        'selectBox-base-last-lg-unselected-initial-filter': 'none',
        'selectBox-base-last-lg-unselected-initial-opacity': 0.65,
        'selectBox-base-last-lg-unselected-initial-paddingBlock': '2rem',
        'selectBox-base-last-lg-unselected-initial-paddingInline': '1.5rem',
        'selectBox-base-last-lg-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-lg-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-lg-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-lg-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-lg-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-lg-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-last-lg-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-lg-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-lg-unselected-pressed-borderTopWidth': '0',
        'selectBox-base-last-lg-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-lg-unselected-pressed-opacity': 0.65,
        'selectBox-base-last-lg-unselected-pressed-paddingBlock': '2rem',
        'selectBox-base-last-lg-unselected-pressed-paddingInline': '1.5rem',
        'selectBox-base-last-sm-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-sm-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-disabled-borderStyle': 'solid',
        'selectBox-base-last-sm-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-sm-resting-disabled-borderTopWidth': '0',
        'selectBox-base-last-sm-resting-disabled-filter': 'none',
        'selectBox-base-last-sm-resting-disabled-opacity': 0.4,
        'selectBox-base-last-sm-resting-disabled-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-resting-disabled-paddingInline': '1rem',
        'selectBox-base-last-sm-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-focused-borderStyle': 'solid',
        'selectBox-base-last-sm-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-last-sm-resting-focused-borderTopWidth': '0',
        'selectBox-base-last-sm-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-resting-focused-opacity': 1,
        'selectBox-base-last-sm-resting-focused-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-resting-focused-paddingInline': '1rem',
        'selectBox-base-last-sm-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-hover-borderStyle': 'solid',
        'selectBox-base-last-sm-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-last-sm-resting-hover-borderTopWidth': '0',
        'selectBox-base-last-sm-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-resting-hover-opacity': 0.8,
        'selectBox-base-last-sm-resting-hover-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-resting-hover-paddingInline': '1rem',
        'selectBox-base-last-sm-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-sm-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-initial-borderStyle': 'solid',
        'selectBox-base-last-sm-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-last-sm-resting-initial-borderTopWidth': '0',
        'selectBox-base-last-sm-resting-initial-filter': 'none',
        'selectBox-base-last-sm-resting-initial-opacity': 1,
        'selectBox-base-last-sm-resting-initial-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-resting-initial-paddingInline': '1rem',
        'selectBox-base-last-sm-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-sm-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-resting-pressed-borderStyle': 'solid',
        'selectBox-base-last-sm-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-sm-resting-pressed-borderTopWidth': '0',
        'selectBox-base-last-sm-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-sm-resting-pressed-opacity': 0.65,
        'selectBox-base-last-sm-resting-pressed-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-resting-pressed-paddingInline': '1rem',
        'selectBox-base-last-sm-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-last-sm-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-disabled-borderStyle': 'solid',
        'selectBox-base-last-sm-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-sm-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-disabled-filter': 'none',
        'selectBox-base-last-sm-selected-disabled-opacity': 0.4,
        'selectBox-base-last-sm-selected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-selected-disabled-paddingInline': '1rem',
        'selectBox-base-last-sm-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-focused-borderStyle': 'solid',
        'selectBox-base-last-sm-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-last-sm-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-selected-focused-opacity': 1,
        'selectBox-base-last-sm-selected-focused-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-selected-focused-paddingInline': '1rem',
        'selectBox-base-last-sm-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-hover-borderStyle': 'solid',
        'selectBox-base-last-sm-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-last-sm-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-selected-hover-opacity': 0.8,
        'selectBox-base-last-sm-selected-hover-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-selected-hover-paddingInline': '1rem',
        'selectBox-base-last-sm-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-last-sm-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-initial-borderStyle': 'solid',
        'selectBox-base-last-sm-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-last-sm-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-initial-filter': 'none',
        'selectBox-base-last-sm-selected-initial-opacity': 1,
        'selectBox-base-last-sm-selected-initial-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-selected-initial-paddingInline': '1rem',
        'selectBox-base-last-sm-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-sm-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-pressed-borderStyle': 'solid',
        'selectBox-base-last-sm-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-sm-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-last-sm-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-sm-selected-pressed-opacity': 0.65,
        'selectBox-base-last-sm-selected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-selected-pressed-paddingInline': '1rem',
        'selectBox-base-last-sm-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-sm-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-last-sm-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-last-sm-unselected-disabled-borderTopWidth': '0',
        'selectBox-base-last-sm-unselected-disabled-filter': 'none',
        'selectBox-base-last-sm-unselected-disabled-opacity': 0.4,
        'selectBox-base-last-sm-unselected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-unselected-disabled-paddingInline': '1rem',
        'selectBox-base-last-sm-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-focused-borderStyle': 'solid',
        'selectBox-base-last-sm-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-last-sm-unselected-focused-borderTopWidth': '0',
        'selectBox-base-last-sm-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-unselected-focused-opacity': 0.8,
        'selectBox-base-last-sm-unselected-focused-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-unselected-focused-paddingInline': '1rem',
        'selectBox-base-last-sm-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-last-sm-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-hover-borderStyle': 'solid',
        'selectBox-base-last-sm-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-last-sm-unselected-hover-borderTopWidth': '0',
        'selectBox-base-last-sm-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-last-sm-unselected-hover-opacity': 0.8,
        'selectBox-base-last-sm-unselected-hover-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-unselected-hover-paddingInline': '1rem',
        'selectBox-base-last-sm-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-last-sm-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-initial-borderStyle': 'solid',
        'selectBox-base-last-sm-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-last-sm-unselected-initial-borderTopWidth': '0',
        'selectBox-base-last-sm-unselected-initial-filter': 'none',
        'selectBox-base-last-sm-unselected-initial-opacity': 0.65,
        'selectBox-base-last-sm-unselected-initial-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-unselected-initial-paddingInline': '1rem',
        'selectBox-base-last-sm-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-last-sm-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-last-sm-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-last-sm-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-last-sm-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-last-sm-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-last-sm-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-last-sm-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-last-sm-unselected-pressed-borderTopWidth': '0',
        'selectBox-base-last-sm-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-last-sm-unselected-pressed-opacity': 0.65,
        'selectBox-base-last-sm-unselected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-last-sm-unselected-pressed-paddingInline': '1rem',
        'selectBox-base-standalone-lg-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-lg-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-lg-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-disabled-filter': 'none',
        'selectBox-base-standalone-lg-resting-disabled-opacity': 0.4,
        'selectBox-base-standalone-lg-resting-disabled-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-resting-disabled-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-focused-borderStyle': 'solid',
        'selectBox-base-standalone-lg-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-resting-focused-opacity': 1,
        'selectBox-base-standalone-lg-resting-focused-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-resting-focused-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-hover-borderStyle': 'solid',
        'selectBox-base-standalone-lg-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-resting-hover-opacity': 0.8,
        'selectBox-base-standalone-lg-resting-hover-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-resting-hover-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-lg-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-initial-borderStyle': 'solid',
        'selectBox-base-standalone-lg-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-initial-filter': 'none',
        'selectBox-base-standalone-lg-resting-initial-opacity': 1,
        'selectBox-base-standalone-lg-resting-initial-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-resting-initial-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-lg-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-lg-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-lg-resting-pressed-opacity': 0.65,
        'selectBox-base-standalone-lg-resting-pressed-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-resting-pressed-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-standalone-lg-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-lg-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-disabled-filter': 'none',
        'selectBox-base-standalone-lg-selected-disabled-opacity': 0.4,
        'selectBox-base-standalone-lg-selected-disabled-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-selected-disabled-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-focused-borderStyle': 'solid',
        'selectBox-base-standalone-lg-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-selected-focused-opacity': 1,
        'selectBox-base-standalone-lg-selected-focused-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-selected-focused-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-hover-borderStyle': 'solid',
        'selectBox-base-standalone-lg-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-selected-hover-opacity': 0.8,
        'selectBox-base-standalone-lg-selected-hover-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-selected-hover-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-standalone-lg-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-initial-borderStyle': 'solid',
        'selectBox-base-standalone-lg-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-initial-filter': 'none',
        'selectBox-base-standalone-lg-selected-initial-opacity': 1,
        'selectBox-base-standalone-lg-selected-initial-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-selected-initial-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-lg-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-lg-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-lg-selected-pressed-opacity': 0.65,
        'selectBox-base-standalone-lg-selected-pressed-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-selected-pressed-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-lg-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-lg-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-disabled-filter': 'none',
        'selectBox-base-standalone-lg-unselected-disabled-opacity': 0.4,
        'selectBox-base-standalone-lg-unselected-disabled-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-unselected-disabled-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-focused-borderStyle': 'solid',
        'selectBox-base-standalone-lg-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-unselected-focused-opacity': 0.8,
        'selectBox-base-standalone-lg-unselected-focused-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-unselected-focused-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-lg-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-hover-borderStyle': 'solid',
        'selectBox-base-standalone-lg-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-lg-unselected-hover-opacity': 0.8,
        'selectBox-base-standalone-lg-unselected-hover-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-unselected-hover-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-lg-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-initial-borderStyle': 'solid',
        'selectBox-base-standalone-lg-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-initial-filter': 'none',
        'selectBox-base-standalone-lg-unselected-initial-opacity': 0.65,
        'selectBox-base-standalone-lg-unselected-initial-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-unselected-initial-paddingInline': '1.5rem',
        'selectBox-base-standalone-lg-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-lg-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-lg-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-lg-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-lg-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-lg-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-lg-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-lg-unselected-pressed-opacity': 0.65,
        'selectBox-base-standalone-lg-unselected-pressed-paddingBlock': '2rem',
        'selectBox-base-standalone-lg-unselected-pressed-paddingInline': '1.5rem',
        'selectBox-base-standalone-sm-resting-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-resting-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-resting-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-sm-resting-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-sm-resting-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-resting-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-disabled-filter': 'none',
        'selectBox-base-standalone-sm-resting-disabled-opacity': 0.4,
        'selectBox-base-standalone-sm-resting-disabled-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-resting-disabled-paddingInline': '1rem',
        'selectBox-base-standalone-sm-resting-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-resting-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-resting-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-resting-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-focused-borderStyle': 'solid',
        'selectBox-base-standalone-sm-resting-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-resting-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-resting-focused-opacity': 1,
        'selectBox-base-standalone-sm-resting-focused-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-resting-focused-paddingInline': '1rem',
        'selectBox-base-standalone-sm-resting-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-resting-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-resting-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-resting-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-hover-borderStyle': 'solid',
        'selectBox-base-standalone-sm-resting-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-resting-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-resting-hover-opacity': 0.8,
        'selectBox-base-standalone-sm-resting-hover-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-resting-hover-paddingInline': '1rem',
        'selectBox-base-standalone-sm-resting-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-resting-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-resting-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-sm-resting-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-initial-borderStyle': 'solid',
        'selectBox-base-standalone-sm-resting-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-resting-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-initial-filter': 'none',
        'selectBox-base-standalone-sm-resting-initial-opacity': 1,
        'selectBox-base-standalone-sm-resting-initial-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-resting-initial-paddingInline': '1rem',
        'selectBox-base-standalone-sm-resting-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-resting-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-resting-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-sm-resting-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-sm-resting-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-resting-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-resting-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-resting-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-sm-resting-pressed-opacity': 0.65,
        'selectBox-base-standalone-sm-resting-pressed-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-resting-pressed-paddingInline': '1rem',
        'selectBox-base-standalone-sm-selected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-selected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-selected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectBox-base-standalone-sm-selected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-sm-selected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-selected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-disabled-filter': 'none',
        'selectBox-base-standalone-sm-selected-disabled-opacity': 0.4,
        'selectBox-base-standalone-sm-selected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-selected-disabled-paddingInline': '1rem',
        'selectBox-base-standalone-sm-selected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-selected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-selected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-selected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-focused-borderStyle': 'solid',
        'selectBox-base-standalone-sm-selected-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-selected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-selected-focused-opacity': 1,
        'selectBox-base-standalone-sm-selected-focused-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-selected-focused-paddingInline': '1rem',
        'selectBox-base-standalone-sm-selected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-selected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-selected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-selected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-hover-borderStyle': 'solid',
        'selectBox-base-standalone-sm-selected-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-selected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-selected-hover-opacity': 0.8,
        'selectBox-base-standalone-sm-selected-hover-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-selected-hover-paddingInline': '1rem',
        'selectBox-base-standalone-sm-selected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-selected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-selected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectBox-base-standalone-sm-selected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-initial-borderStyle': 'solid',
        'selectBox-base-standalone-sm-selected-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-selected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-initial-filter': 'none',
        'selectBox-base-standalone-sm-selected-initial-opacity': 1,
        'selectBox-base-standalone-sm-selected-initial-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-selected-initial-paddingInline': '1rem',
        'selectBox-base-standalone-sm-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-selected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-selected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-sm-selected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-sm-selected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-selected-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-selected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-selected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-sm-selected-pressed-opacity': 0.65,
        'selectBox-base-standalone-sm-selected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-selected-pressed-paddingInline': '1rem',
        'selectBox-base-standalone-sm-unselected-disabled-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-unselected-disabled-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-disabled-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-disabled-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-sm-unselected-disabled-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-disabled-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-disabled-borderStyle': 'solid',
        'selectBox-base-standalone-sm-unselected-disabled-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-disabled-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-disabled-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-disabled-filter': 'none',
        'selectBox-base-standalone-sm-unselected-disabled-opacity': 0.4,
        'selectBox-base-standalone-sm-unselected-disabled-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-unselected-disabled-paddingInline': '1rem',
        'selectBox-base-standalone-sm-unselected-focused-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-unselected-focused-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-focused-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-focused-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-focused-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-unselected-focused-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-focused-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-focused-borderStyle': 'solid',
        'selectBox-base-standalone-sm-unselected-focused-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-focused-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-focused-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-focused-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-unselected-focused-opacity': 0.8,
        'selectBox-base-standalone-sm-unselected-focused-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-unselected-focused-paddingInline': '1rem',
        'selectBox-base-standalone-sm-unselected-hover-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-unselected-hover-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-hover-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-hover-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectBox-base-standalone-sm-unselected-hover-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-hover-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-hover-borderStyle': 'solid',
        'selectBox-base-standalone-sm-unselected-hover-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-hover-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-hover-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-hover-filter': 'brightness(0.96) contrast(1)',
        'selectBox-base-standalone-sm-unselected-hover-opacity': 0.8,
        'selectBox-base-standalone-sm-unselected-hover-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-unselected-hover-paddingInline': '1rem',
        'selectBox-base-standalone-sm-unselected-initial-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-unselected-initial-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-initial-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-initial-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectBox-base-standalone-sm-unselected-initial-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-initial-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-initial-borderStyle': 'solid',
        'selectBox-base-standalone-sm-unselected-initial-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-initial-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-initial-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-initial-filter': 'none',
        'selectBox-base-standalone-sm-unselected-initial-opacity': 0.65,
        'selectBox-base-standalone-sm-unselected-initial-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-unselected-initial-paddingInline': '1rem',
        'selectBox-base-standalone-sm-unselected-pressed-background': 'rgb(255, 255, 255)',
        'selectBox-base-standalone-sm-unselected-pressed-borderBottomLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-pressed-borderBottomRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-pressed-borderBottomWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectBox-base-standalone-sm-unselected-pressed-borderLeftWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-pressed-borderRightWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-pressed-borderStyle': 'solid',
        'selectBox-base-standalone-sm-unselected-pressed-borderTopLeftRadius': '0',
        'selectBox-base-standalone-sm-unselected-pressed-borderTopRightRadius': '0',
        'selectBox-base-standalone-sm-unselected-pressed-borderTopWidth': '0.0625rem',
        'selectBox-base-standalone-sm-unselected-pressed-filter': 'brightness(0.94) contrast(1)',
        'selectBox-base-standalone-sm-unselected-pressed-opacity': 0.65,
        'selectBox-base-standalone-sm-unselected-pressed-paddingBlock': '1.5rem',
        'selectBox-base-standalone-sm-unselected-pressed-paddingInline': '1rem',
        'selectBox-content-base-lg-gap': '1rem',
        'selectBox-content-base-sm-gap': '0.75rem',
        'selectBox-content-footer-base-lg-gap': '1rem',
        'selectBox-content-footer-base-sm-gap': '0.75rem',
        'selectBox-content-header-base-lg-gap': '1rem',
        'selectBox-content-header-base-sm-gap': '0.75rem',
        'selectBox-content-header-icon-background': 'rgb(0, 0, 0)',
        'selectBox-content-header-title-headline-lg-gap': '0.75rem',
        'selectBox-content-header-title-headline-sm-gap': '0.75rem',
        'selectBox-content-header-title-subline-lg-color': 'rgb(0, 0, 0)',
        'selectBox-content-header-title-subline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'selectBox-content-header-title-subline-lg-fontSize': '0.875rem',
        'selectBox-content-header-title-subline-lg-fontWeight': 'normal',
        'selectBox-content-header-title-subline-lg-letterSpacing': '0em',
        'selectBox-content-header-title-subline-lg-lineHeight': '1.25rem',
        'selectBox-content-header-title-subline-lg-opacity': 0.65,
        'selectBox-content-header-title-subline-sm-color': 'rgb(0, 0, 0)',
        'selectBox-content-header-title-subline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'selectBox-content-header-title-subline-sm-fontSize': '0.75rem',
        'selectBox-content-header-title-subline-sm-fontWeight': 'normal',
        'selectBox-content-header-title-subline-sm-letterSpacing': '0em',
        'selectBox-content-header-title-subline-sm-lineHeight': '1rem',
        'selectBox-content-header-title-subline-sm-opacity': 0.65,
        'selectBox-content-header-title-title-lg-gap': '0.25rem',
        'selectBox-content-header-title-title-sm-gap': '0.25rem',
        'selectBoxList-multi-base-lg-gap': '1.5rem',
        'selectBoxList-multi-base-sm-gap': '1rem',
        'selectBoxList-single-base-lg-gap': '0',
        'selectBoxList-single-base-sm-gap': '0',
        'selectButton-base-selected-disabled-background': 'rgb(193, 199, 204)',
        'selectButton-base-selected-disabled-borderColor': 'rgb(0, 0, 0)',
        'selectButton-base-selected-disabled-borderRadius': '0',
        'selectButton-base-selected-disabled-borderStyle': 'solid',
        'selectButton-base-selected-disabled-borderWidth': '0',
        'selectButton-base-selected-disabled-height': '2rem',
        'selectButton-base-selected-disabled-opacity': 1,
        'selectButton-base-selected-disabled-width': '2rem',
        'selectButton-base-selected-hover-background': 'rgb(0, 98, 154)',
        'selectButton-base-selected-hover-borderColor': 'rgb(0, 0, 0)',
        'selectButton-base-selected-hover-borderRadius': '0',
        'selectButton-base-selected-hover-borderStyle': 'solid',
        'selectButton-base-selected-hover-borderWidth': '0',
        'selectButton-base-selected-hover-height': '2rem',
        'selectButton-base-selected-hover-opacity': 1,
        'selectButton-base-selected-hover-width': '2rem',
        'selectButton-base-selected-initial-background': 'rgb(0, 123, 192)',
        'selectButton-base-selected-initial-borderColor': 'rgb(0, 0, 0)',
        'selectButton-base-selected-initial-borderRadius': '0',
        'selectButton-base-selected-initial-borderStyle': 'solid',
        'selectButton-base-selected-initial-borderWidth': '0',
        'selectButton-base-selected-initial-height': '2rem',
        'selectButton-base-selected-initial-opacity': 1,
        'selectButton-base-selected-initial-width': '2rem',
        'selectButton-base-selected-pressed-background': 'rgb(0, 73, 117)',
        'selectButton-base-selected-pressed-borderColor': 'rgb(0, 0, 0)',
        'selectButton-base-selected-pressed-borderRadius': '0',
        'selectButton-base-selected-pressed-borderStyle': 'solid',
        'selectButton-base-selected-pressed-borderWidth': '0',
        'selectButton-base-selected-pressed-height': '2rem',
        'selectButton-base-selected-pressed-opacity': 1,
        'selectButton-base-selected-pressed-width': '2rem',
        'selectButton-base-unselected-disabled-background': 'rgb(193, 199, 204)',
        'selectButton-base-unselected-disabled-borderColor': 'rgba(0, 0, 0, 0)',
        'selectButton-base-unselected-disabled-borderRadius': '0',
        'selectButton-base-unselected-disabled-borderStyle': 'solid',
        'selectButton-base-unselected-disabled-borderWidth': '0',
        'selectButton-base-unselected-disabled-height': '2rem',
        'selectButton-base-unselected-disabled-opacity': 1,
        'selectButton-base-unselected-disabled-width': '2rem',
        'selectButton-base-unselected-hover-background': 'rgb(113, 118, 124)',
        'selectButton-base-unselected-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'selectButton-base-unselected-hover-borderRadius': '0',
        'selectButton-base-unselected-hover-borderStyle': 'solid',
        'selectButton-base-unselected-hover-borderWidth': '0',
        'selectButton-base-unselected-hover-height': '2rem',
        'selectButton-base-unselected-hover-opacity': 1,
        'selectButton-base-unselected-hover-width': '2rem',
        'selectButton-base-unselected-initial-background': 'rgb(138, 144, 151)',
        'selectButton-base-unselected-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'selectButton-base-unselected-initial-borderRadius': '0',
        'selectButton-base-unselected-initial-borderStyle': 'solid',
        'selectButton-base-unselected-initial-borderWidth': '0',
        'selectButton-base-unselected-initial-height': '2rem',
        'selectButton-base-unselected-initial-opacity': 1,
        'selectButton-base-unselected-initial-width': '2rem',
        'selectButton-base-unselected-pressed-background': 'rgb(89, 94, 98)',
        'selectButton-base-unselected-pressed-borderColor': 'rgba(0, 0, 0, 0)',
        'selectButton-base-unselected-pressed-borderRadius': '0',
        'selectButton-base-unselected-pressed-borderStyle': 'solid',
        'selectButton-base-unselected-pressed-borderWidth': '0',
        'selectButton-base-unselected-pressed-height': '2rem',
        'selectButton-base-unselected-pressed-opacity': 1,
        'selectButton-base-unselected-pressed-width': '2rem',
        'selectButton-icon-selected-disabled-background': 'rgb(67, 70, 74)',
        'selectButton-icon-selected-disabled-opacity': 1,
        'selectButton-icon-selected-hover-background': 'rgb(255, 255, 255)',
        'selectButton-icon-selected-hover-opacity': 1,
        'selectButton-icon-selected-initial-background': 'rgb(255, 255, 255)',
        'selectButton-icon-selected-initial-opacity': 1,
        'selectButton-icon-selected-pressed-background': 'rgb(255, 255, 255)',
        'selectButton-icon-selected-pressed-opacity': 1,
        'selectButton-icon-unselected-disabled-background': 'rgb(0, 0, 0)',
        'selectButton-icon-unselected-disabled-opacity': 0.65,
        'selectButton-icon-unselected-hover-background': 'rgb(0, 0, 0)',
        'selectButton-icon-unselected-hover-opacity': 0.8,
        'selectButton-icon-unselected-initial-background': 'rgb(0, 0, 0)',
        'selectButton-icon-unselected-initial-opacity': 0.65,
        'selectButton-icon-unselected-pressed-background': 'rgb(0, 0, 0)',
        'selectButton-icon-unselected-pressed-opacity': 0.4,
        'selectColor-selected-disabled-borderColor': 'rgb(193, 199, 204)',
        'selectColor-selected-disabled-borderRadius': '624.9375rem',
        'selectColor-selected-disabled-borderStyle': 'solid',
        'selectColor-selected-disabled-borderWidth': '0.125rem',
        'selectColor-selected-disabled-height': '2rem',
        'selectColor-selected-disabled-opacity': 0.8,
        'selectColor-selected-disabled-paddingBlock': '0.25rem',
        'selectColor-selected-disabled-paddingInline': '0.25rem',
        'selectColor-selected-disabled-width': '2rem',
        'selectColor-selected-hover-borderColor': 'rgb(0, 98, 154)',
        'selectColor-selected-hover-borderRadius': '624.9375rem',
        'selectColor-selected-hover-borderStyle': 'solid',
        'selectColor-selected-hover-borderWidth': '0.125rem',
        'selectColor-selected-hover-height': '2rem',
        'selectColor-selected-hover-opacity': 0.8,
        'selectColor-selected-hover-paddingBlock': '0.25rem',
        'selectColor-selected-hover-paddingInline': '0.25rem',
        'selectColor-selected-hover-width': '2rem',
        'selectColor-selected-initial-borderColor': 'rgb(0, 123, 192)',
        'selectColor-selected-initial-borderRadius': '624.9375rem',
        'selectColor-selected-initial-borderStyle': 'solid',
        'selectColor-selected-initial-borderWidth': '0.125rem',
        'selectColor-selected-initial-height': '2rem',
        'selectColor-selected-initial-opacity': 1,
        'selectColor-selected-initial-paddingBlock': '0.25rem',
        'selectColor-selected-initial-paddingInline': '0.25rem',
        'selectColor-selected-initial-width': '2rem',
        'selectColor-selected-pressed-borderColor': 'rgb(0, 73, 117)',
        'selectColor-selected-pressed-borderRadius': '624.9375rem',
        'selectColor-selected-pressed-borderStyle': 'solid',
        'selectColor-selected-pressed-borderWidth': '0.125rem',
        'selectColor-selected-pressed-height': '2rem',
        'selectColor-selected-pressed-opacity': 0.65,
        'selectColor-selected-pressed-paddingBlock': '0.25rem',
        'selectColor-selected-pressed-paddingInline': '0.25rem',
        'selectColor-selected-pressed-width': '2rem',
        'selectColor-unselected-disabled-borderColor': 'rgb(224, 226, 229)',
        'selectColor-unselected-disabled-borderRadius': '624.9375rem',
        'selectColor-unselected-disabled-borderStyle': 'solid',
        'selectColor-unselected-disabled-borderWidth': '0.125rem',
        'selectColor-unselected-disabled-height': '2rem',
        'selectColor-unselected-disabled-opacity': 0.4,
        'selectColor-unselected-disabled-paddingBlock': '0',
        'selectColor-unselected-disabled-paddingInline': '0',
        'selectColor-unselected-disabled-width': '2rem',
        'selectColor-unselected-hover-borderColor': 'rgb(0, 0, 0)',
        'selectColor-unselected-hover-borderRadius': '624.9375rem',
        'selectColor-unselected-hover-borderStyle': 'solid',
        'selectColor-unselected-hover-borderWidth': '0.125rem',
        'selectColor-unselected-hover-height': '2rem',
        'selectColor-unselected-hover-opacity': 0.8,
        'selectColor-unselected-hover-paddingBlock': '0',
        'selectColor-unselected-hover-paddingInline': '0',
        'selectColor-unselected-hover-width': '2rem',
        'selectColor-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'selectColor-unselected-initial-borderRadius': '624.9375rem',
        'selectColor-unselected-initial-borderStyle': 'solid',
        'selectColor-unselected-initial-borderWidth': '0.125rem',
        'selectColor-unselected-initial-height': '2rem',
        'selectColor-unselected-initial-opacity': 1,
        'selectColor-unselected-initial-paddingBlock': '0',
        'selectColor-unselected-initial-paddingInline': '0',
        'selectColor-unselected-initial-width': '2rem',
        'selectColor-unselected-pressed-borderColor': 'rgb(0, 0, 0)',
        'selectColor-unselected-pressed-borderRadius': '624.9375rem',
        'selectColor-unselected-pressed-borderStyle': 'solid',
        'selectColor-unselected-pressed-borderWidth': '0.125rem',
        'selectColor-unselected-pressed-height': '2rem',
        'selectColor-unselected-pressed-opacity': 0.65,
        'selectColor-unselected-pressed-paddingBlock': '0',
        'selectColor-unselected-pressed-paddingInline': '0',
        'selectColor-unselected-pressed-width': '2rem',
        'selectService-base-lg-gap': '1rem',
        'selectService-base-sm-gap': '0.75rem',
        'selectService-divider-background': 'rgb(224, 226, 229)',
        'selectService-divider-borderRadius': '624.9375rem',
        'selectService-divider-height': '0.0625rem',
        'selectService-item-base-lg-gap': '1rem',
        'selectService-item-base-sm-gap': '0.75rem',
        'selectService-item-description-lg-color': 'rgb(0, 0, 0)',
        'selectService-item-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'selectService-item-description-lg-fontSize': '0.875rem',
        'selectService-item-description-lg-fontWeight': 'normal',
        'selectService-item-description-lg-letterSpacing': '0em',
        'selectService-item-description-lg-lineHeight': '1.25rem',
        'selectService-item-description-sm-color': 'rgb(0, 0, 0)',
        'selectService-item-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'selectService-item-description-sm-fontSize': '0.75rem',
        'selectService-item-description-sm-fontWeight': 'normal',
        'selectService-item-description-sm-letterSpacing': '0em',
        'selectService-item-description-sm-lineHeight': '1rem',
        'selectService-item-title-base-horizontal-lg-gap': '1rem',
        'selectService-item-title-base-horizontal-sm-gap': '1rem',
        'selectService-item-title-base-vertical-lg-gap': '0.25rem',
        'selectService-item-title-base-vertical-sm-gap': '0.25rem',
        'selectService-item-title-headline-base-lg-gap': '0.25rem',
        'selectService-item-title-headline-base-sm-gap': '0.25rem',
        'selectService-item-title-headline-icon-background': 'rgb(0, 0, 0)',
        'selectService-item-title-headline-label-lg-color': 'rgb(0, 0, 0)',
        'selectService-item-title-headline-label-lg-fontFamily': 'Bosch Sans, sans-serif',
        'selectService-item-title-headline-label-lg-fontSize': '1rem',
        'selectService-item-title-headline-label-lg-fontWeight': 'normal',
        'selectService-item-title-headline-label-lg-letterSpacing': '0em',
        'selectService-item-title-headline-label-lg-lineHeight': '1.5rem',
        'selectService-item-title-headline-label-sm-color': 'rgb(0, 0, 0)',
        'selectService-item-title-headline-label-sm-fontFamily': 'Bosch Sans, sans-serif',
        'selectService-item-title-headline-label-sm-fontSize': '0.875rem',
        'selectService-item-title-headline-label-sm-fontWeight': 'normal',
        'selectService-item-title-headline-label-sm-letterSpacing': '0em',
        'selectService-item-title-headline-label-sm-lineHeight': '1.25rem',
        'skeleton-backgroundColor': 'rgb(239, 241, 242)',
        'skeleton-height-bodytext-large': '1.75rem',
        'skeleton-height-bodytext-medium': '1.5rem',
        'skeleton-height-bodytext-nano': '0.75rem',
        'skeleton-height-bodytext-small': '1.25rem',
        'skeleton-height-bodytext-tiny': '1rem',
        'skeleton-height-buttontext-large': '4rem',
        'skeleton-height-buttontext-medium': '3rem',
        'skeleton-height-buttontext-small': '2rem',
        'skeleton-height-headline-large-level1': '3.5rem',
        'skeleton-height-headline-large-level2': '2.75rem',
        'skeleton-height-headline-large-level3': '2.5rem',
        'skeleton-height-headline-large-level4': '2.25rem',
        'skeleton-height-headline-large-level5': '2rem',
        'skeleton-height-headline-large-level6': '1.75rem',
        'skeleton-height-headline-large-level7': '1.5rem',
        'skeleton-height-headline-small-level1': '2.75rem',
        'skeleton-height-headline-small-level2': '2.5rem',
        'skeleton-height-headline-small-level3': '2.25rem',
        'skeleton-height-headline-small-level4': '2rem',
        'skeleton-height-headline-small-level5': '1.75rem',
        'skeleton-height-headline-small-level6': '1.5rem',
        'skeleton-height-headline-small-level7': '1.25rem',
        'skeleton-height-labeltext-large': '1.5rem',
        'skeleton-height-labeltext-medium': '1.25rem',
        'skeleton-height-labeltext-small': '1rem',
        'state-action-default-background-disabled': 'rgba(0, 0, 0, 0)',
        'state-action-default-background-focused': 'rgb(209, 228, 255)',
        'state-action-default-background-hover': 'rgb(209, 228, 255)',
        'state-action-default-background-initial': 'rgba(0, 0, 0, 0)',
        'state-action-default-background-pressed': 'rgb(157, 201, 255)',
        'state-action-default-borderColor-disabled': 'rgb(113, 118, 124)',
        'state-action-default-borderColor-focused': 'rgb(0, 98, 154)',
        'state-action-default-borderColor-hover': 'rgb(0, 98, 154)',
        'state-action-default-borderColor-initial': 'rgb(0, 123, 192)',
        'state-action-default-borderColor-pressed': 'rgb(0, 73, 117)',
        'state-action-default-onBackground-disabled': 'rgb(0, 0, 0)',
        'state-action-default-onBackground-focused': 'rgb(0, 98, 154)',
        'state-action-default-onBackground-hover': 'rgb(0, 98, 154)',
        'state-action-default-onBackground-initial': 'rgb(0, 123, 192)',
        'state-action-default-onBackground-pressed': 'rgb(0, 73, 117)',
        'state-action-prominent-background-disabled': 'rgb(193, 199, 204)',
        'state-action-prominent-background-focused': 'rgb(0, 98, 154)',
        'state-action-prominent-background-hover': 'rgb(0, 98, 154)',
        'state-action-prominent-background-initial': 'rgb(0, 123, 192)',
        'state-action-prominent-background-pressed': 'rgb(0, 73, 117)',
        'state-action-prominent-borderColor-disabled': 'rgba(0, 0, 0, 0)',
        'state-action-prominent-borderColor-focused': 'rgb(0, 18, 34)',
        'state-action-prominent-borderColor-hover': 'rgba(0, 0, 0, 0)',
        'state-action-prominent-borderColor-initial': 'rgba(0, 0, 0, 0)',
        'state-action-prominent-borderColor-pressed': 'rgba(0, 0, 0, 0)',
        'state-action-prominent-onBackground-disabled': 'rgb(0, 0, 0)',
        'state-action-prominent-onBackground-focused': 'rgb(255, 255, 255)',
        'state-action-prominent-onBackground-hover': 'rgb(255, 255, 255)',
        'state-action-prominent-onBackground-initial': 'rgb(255, 255, 255)',
        'state-action-prominent-onBackground-pressed': 'rgb(255, 255, 255)',
        'state-action-subtle-background-disabled': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-background-focused': 'rgb(232, 241, 255)',
        'state-action-subtle-background-hover': 'rgb(232, 241, 255)',
        'state-action-subtle-background-initial': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-background-pressed': 'rgb(209, 228, 255)',
        'state-action-subtle-borderColor-disabled': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-borderColor-focused': 'rgb(0, 98, 154)',
        'state-action-subtle-borderColor-hover': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-borderColor-initial': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-borderColor-pressed': 'rgba(0, 0, 0, 0)',
        'state-action-subtle-onBackground-disabled': 'rgb(0, 0, 0)',
        'state-action-subtle-onBackground-focused': 'rgb(0, 98, 154)',
        'state-action-subtle-onBackground-hover': 'rgb(0, 98, 154)',
        'state-action-subtle-onBackground-initial': 'rgb(0, 123, 192)',
        'state-action-subtle-onBackground-pressed': 'rgb(0, 73, 117)',
        'state-link-neutral-disabled': 'rgb(0, 0, 0)',
        'state-link-neutral-focused': 'rgb(0, 98, 154)',
        'state-link-neutral-hover': 'rgb(0, 98, 154)',
        'state-link-neutral-initial': 'rgb(0, 0, 0)',
        'state-link-neutral-pressed': 'rgb(0, 73, 117)',
        'state-link-prominent-disabled': 'rgb(0, 0, 0)',
        'state-link-prominent-focused': 'rgb(0, 98, 154)',
        'state-link-prominent-hover': 'rgb(0, 98, 154)',
        'state-link-prominent-initial': 'rgb(0, 123, 192)',
        'state-link-prominent-pressed': 'rgb(0, 73, 117)',
        'stickyBar-base-lg-background': 'rgb(255, 255, 255)',
        'stickyBar-base-lg-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'stickyBar-base-lg-gap': '2rem',
        'stickyBar-base-lg-paddingBottom': '1rem',
        'stickyBar-base-lg-paddingLeft': '2rem',
        'stickyBar-base-lg-paddingRight': '2rem',
        'stickyBar-base-lg-paddingTop': '1rem',
        'stickyBar-base-sm-background': 'rgb(255, 255, 255)',
        'stickyBar-base-sm-boxShadow': {
            'box-shadow': '0px 0px 2px 0px rgba(0, 0, 0, 0.04), 0px 2px 4px 0px rgba(0, 0, 0, 0.04), 0px 4px 8px 0px rgba(0, 0, 0, 0.04), 0px 8px 16px 0px rgba(0, 0, 0, 0.04), 0px 16px 32px 0px rgba(0, 0, 0, 0.04)',
            'drop-shadow': 'drop-shadow(0px 0px 2px rgba(0, 0, 0, 0.04)) drop-shadow(0px 2px 4px rgba(0, 0, 0, 0.04)) drop-shadow(0px 4px 8px rgba(0, 0, 0, 0.04)) drop-shadow(0px 8px 16px rgba(0, 0, 0, 0.04)) drop-shadow(0px 16px 32px rgba(0, 0, 0, 0.04))',
        },
        'stickyBar-base-sm-gap': '1rem',
        'stickyBar-base-sm-paddingBottom': '0.75rem',
        'stickyBar-base-sm-paddingLeft': '1rem',
        'stickyBar-base-sm-paddingRight': '1rem',
        'stickyBar-base-sm-paddingTop': '0.75rem',
        'tabBar-base-default-lg-background': 'rgb(255, 255, 255)',
        'tabBar-base-default-lg-borderBottomWidth': '0.125rem',
        'tabBar-base-default-lg-borderColor': 'rgb(239, 241, 242)',
        'tabBar-base-default-lg-borderStyle': 'solid',
        'tabBar-base-default-lg-height': '4rem',
        'tabBar-base-default-sm-background': 'rgb(255, 255, 255)',
        'tabBar-base-default-sm-borderBottomWidth': '0.125rem',
        'tabBar-base-default-sm-borderColor': 'rgb(239, 241, 242)',
        'tabBar-base-default-sm-borderStyle': 'solid',
        'tabBar-base-default-sm-height': '3rem',
        'tabBar-base-highlighted-lg-background': 'rgb(239, 241, 242)',
        'tabBar-base-highlighted-lg-borderBottomWidth': '0.125rem',
        'tabBar-base-highlighted-lg-borderColor': 'rgb(224, 226, 229)',
        'tabBar-base-highlighted-lg-borderStyle': 'solid',
        'tabBar-base-highlighted-lg-height': '4rem',
        'tabBar-base-highlighted-sm-background': 'rgb(239, 241, 242)',
        'tabBar-base-highlighted-sm-borderBottomWidth': '0.125rem',
        'tabBar-base-highlighted-sm-borderColor': 'rgb(224, 226, 229)',
        'tabBar-base-highlighted-sm-borderStyle': 'solid',
        'tabBar-base-highlighted-sm-height': '3rem',
        'tabBar-base-image-lg-borderBottomWidth': '0.125rem',
        'tabBar-base-image-lg-borderColor': 'rgb(255, 255, 255)',
        'tabBar-base-image-lg-borderStyle': 'solid',
        'tabBar-base-image-lg-height': '4rem',
        'tabBar-base-image-sm-borderBottomWidth': '0.125rem',
        'tabBar-base-image-sm-borderColor': 'rgb(255, 255, 255)',
        'tabBar-base-image-sm-borderStyle': 'solid',
        'tabBar-base-image-sm-height': '3rem',
        'tabBar-button-base-default-lg-hover-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-lg-hover-height': '4rem',
        'tabBar-button-base-default-lg-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-default-lg-hover-paddingRight': '0.75rem',
        'tabBar-button-base-default-lg-initial-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-lg-initial-height': '4rem',
        'tabBar-button-base-default-lg-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-default-lg-initial-paddingRight': '0.75rem',
        'tabBar-button-base-default-lg-pressed-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-lg-pressed-height': '4rem',
        'tabBar-button-base-default-lg-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-default-lg-pressed-paddingRight': '0.75rem',
        'tabBar-button-base-default-sm-hover-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-sm-hover-height': '3rem',
        'tabBar-button-base-default-sm-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-default-sm-hover-paddingRight': '0.75rem',
        'tabBar-button-base-default-sm-initial-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-sm-initial-height': '3rem',
        'tabBar-button-base-default-sm-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-default-sm-initial-paddingRight': '0.75rem',
        'tabBar-button-base-default-sm-pressed-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-default-sm-pressed-height': '3rem',
        'tabBar-button-base-default-sm-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-default-sm-pressed-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-lg-hover-background': 'rgb(224, 226, 229)',
        'tabBar-button-base-highlighted-lg-hover-height': '4rem',
        'tabBar-button-base-highlighted-lg-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-lg-hover-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-lg-initial-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-highlighted-lg-initial-height': '4rem',
        'tabBar-button-base-highlighted-lg-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-lg-initial-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-lg-pressed-background': 'rgb(224, 226, 229)',
        'tabBar-button-base-highlighted-lg-pressed-height': '4rem',
        'tabBar-button-base-highlighted-lg-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-lg-pressed-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-sm-hover-background': 'rgb(224, 226, 229)',
        'tabBar-button-base-highlighted-sm-hover-height': '3rem',
        'tabBar-button-base-highlighted-sm-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-sm-hover-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-sm-initial-background': 'rgb(239, 241, 242)',
        'tabBar-button-base-highlighted-sm-initial-height': '3rem',
        'tabBar-button-base-highlighted-sm-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-sm-initial-paddingRight': '0.75rem',
        'tabBar-button-base-highlighted-sm-pressed-background': 'rgb(224, 226, 229)',
        'tabBar-button-base-highlighted-sm-pressed-height': '3rem',
        'tabBar-button-base-highlighted-sm-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-highlighted-sm-pressed-paddingRight': '0.75rem',
        'tabBar-button-base-image-lg-hover-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-lg-hover-height': '4rem',
        'tabBar-button-base-image-lg-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-image-lg-hover-paddingRight': '0.75rem',
        'tabBar-button-base-image-lg-initial-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-lg-initial-height': '4rem',
        'tabBar-button-base-image-lg-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-image-lg-initial-paddingRight': '0.75rem',
        'tabBar-button-base-image-lg-pressed-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-lg-pressed-height': '4rem',
        'tabBar-button-base-image-lg-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-image-lg-pressed-paddingRight': '0.75rem',
        'tabBar-button-base-image-sm-hover-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-sm-hover-height': '3rem',
        'tabBar-button-base-image-sm-hover-paddingLeft': '0.75rem',
        'tabBar-button-base-image-sm-hover-paddingRight': '0.75rem',
        'tabBar-button-base-image-sm-initial-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-sm-initial-height': '3rem',
        'tabBar-button-base-image-sm-initial-paddingLeft': '0.75rem',
        'tabBar-button-base-image-sm-initial-paddingRight': '0.75rem',
        'tabBar-button-base-image-sm-pressed-background': 'rgba(0, 0, 0, 0)',
        'tabBar-button-base-image-sm-pressed-height': '3rem',
        'tabBar-button-base-image-sm-pressed-paddingLeft': '0.75rem',
        'tabBar-button-base-image-sm-pressed-paddingRight': '0.75rem',
        'tabBar-button-icon-default-hover-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-default-hover-opacity': 1,
        'tabBar-button-icon-default-initial-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-default-initial-opacity': 0.8,
        'tabBar-button-icon-default-pressed-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-default-pressed-opacity': 0.65,
        'tabBar-button-icon-highlighted-hover-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-highlighted-hover-opacity': 1,
        'tabBar-button-icon-highlighted-initial-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-highlighted-initial-opacity': 0.8,
        'tabBar-button-icon-highlighted-pressed-background': 'rgb(0, 0, 0)',
        'tabBar-button-icon-highlighted-pressed-opacity': 0.65,
        'tabBar-button-icon-image-hover-background': 'rgb(255, 255, 255)',
        'tabBar-button-icon-image-hover-opacity': 1,
        'tabBar-button-icon-image-initial-background': 'rgb(255, 255, 255)',
        'tabBar-button-icon-image-initial-opacity': 0.8,
        'tabBar-button-icon-image-pressed-background': 'rgb(255, 255, 255)',
        'tabBar-button-icon-image-pressed-opacity': 0.65,
        'tabBar-tab-base-default-lg-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-lg-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-selected-hover-height': '4rem',
        'tabBar-tab-base-default-lg-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-lg-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-lg-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-selected-initial-height': '4rem',
        'tabBar-tab-base-default-lg-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-lg-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-lg-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-selected-pressed-height': '4rem',
        'tabBar-tab-base-default-lg-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-lg-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-unselected-hover-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-lg-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-unselected-hover-height': '4rem',
        'tabBar-tab-base-default-lg-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-lg-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-unselected-initial-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-lg-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-unselected-initial-height': '4rem',
        'tabBar-tab-base-default-lg-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-lg-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-lg-unselected-pressed-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-lg-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-default-lg-unselected-pressed-height': '4rem',
        'tabBar-tab-base-default-lg-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-sm-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-selected-hover-height': '3rem',
        'tabBar-tab-base-default-sm-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-sm-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-selected-initial-height': '3rem',
        'tabBar-tab-base-default-sm-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-default-sm-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-selected-pressed-height': '3rem',
        'tabBar-tab-base-default-sm-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-unselected-hover-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-sm-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-unselected-hover-height': '3rem',
        'tabBar-tab-base-default-sm-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-unselected-initial-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-sm-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-unselected-initial-height': '3rem',
        'tabBar-tab-base-default-sm-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-default-sm-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-default-sm-unselected-pressed-borderColor': 'rgb(239, 241, 242)',
        'tabBar-tab-base-default-sm-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-default-sm-unselected-pressed-height': '3rem',
        'tabBar-tab-base-default-sm-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-lg-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-selected-hover-height': '4rem',
        'tabBar-tab-base-highlighted-lg-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-lg-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-selected-initial-height': '4rem',
        'tabBar-tab-base-highlighted-lg-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-lg-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-selected-pressed-height': '4rem',
        'tabBar-tab-base-highlighted-lg-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-unselected-hover-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-lg-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-unselected-hover-height': '4rem',
        'tabBar-tab-base-highlighted-lg-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-lg-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-unselected-initial-height': '4rem',
        'tabBar-tab-base-highlighted-lg-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-lg-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-lg-unselected-pressed-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-lg-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-lg-unselected-pressed-height': '4rem',
        'tabBar-tab-base-highlighted-lg-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-sm-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-selected-hover-height': '3rem',
        'tabBar-tab-base-highlighted-sm-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-sm-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-selected-initial-height': '3rem',
        'tabBar-tab-base-highlighted-sm-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-highlighted-sm-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-selected-pressed-height': '3rem',
        'tabBar-tab-base-highlighted-sm-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-unselected-hover-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-sm-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-unselected-hover-height': '3rem',
        'tabBar-tab-base-highlighted-sm-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-unselected-initial-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-sm-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-unselected-initial-height': '3rem',
        'tabBar-tab-base-highlighted-sm-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-highlighted-sm-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-highlighted-sm-unselected-pressed-borderColor': 'rgb(224, 226, 229)',
        'tabBar-tab-base-highlighted-sm-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-highlighted-sm-unselected-pressed-height': '3rem',
        'tabBar-tab-base-highlighted-sm-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-lg-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-selected-hover-height': '4rem',
        'tabBar-tab-base-image-lg-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-lg-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-selected-initial-height': '4rem',
        'tabBar-tab-base-image-lg-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-lg-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-selected-pressed-height': '4rem',
        'tabBar-tab-base-image-lg-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-unselected-hover-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-lg-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-unselected-hover-height': '4rem',
        'tabBar-tab-base-image-lg-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-unselected-initial-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-lg-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-unselected-initial-height': '4rem',
        'tabBar-tab-base-image-lg-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-lg-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-lg-unselected-pressed-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-lg-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-image-lg-unselected-pressed-height': '4rem',
        'tabBar-tab-base-image-lg-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-selected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-selected-hover-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-sm-selected-hover-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-selected-hover-height': '3rem',
        'tabBar-tab-base-image-sm-selected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-selected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-selected-initial-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-sm-selected-initial-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-selected-initial-height': '3rem',
        'tabBar-tab-base-image-sm-selected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-selected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-selected-pressed-borderColor': 'rgb(0, 150, 232)',
        'tabBar-tab-base-image-sm-selected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-selected-pressed-height': '3rem',
        'tabBar-tab-base-image-sm-selected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-unselected-hover-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-unselected-hover-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-sm-unselected-hover-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-unselected-hover-height': '3rem',
        'tabBar-tab-base-image-sm-unselected-hover-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-unselected-initial-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-unselected-initial-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-sm-unselected-initial-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-unselected-initial-height': '3rem',
        'tabBar-tab-base-image-sm-unselected-initial-paddingBlock': '0.5rem',
        'tabBar-tab-base-image-sm-unselected-pressed-borderBottomWidth': '0.125rem',
        'tabBar-tab-base-image-sm-unselected-pressed-borderColor': 'rgb(255, 255, 255)',
        'tabBar-tab-base-image-sm-unselected-pressed-borderStyle': 'solid',
        'tabBar-tab-base-image-sm-unselected-pressed-height': '3rem',
        'tabBar-tab-base-image-sm-unselected-pressed-paddingBlock': '0.5rem',
        'tabBar-tab-label-default-lg-active-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-active-hover-fontSize': '1rem',
        'tabBar-tab-label-default-lg-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-active-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-active-hover-opacity': 1,
        'tabBar-tab-label-default-lg-active-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-active-initial-fontSize': '1rem',
        'tabBar-tab-label-default-lg-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-active-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-active-initial-opacity': 0.8,
        'tabBar-tab-label-default-lg-active-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-active-pressed-fontSize': '1rem',
        'tabBar-tab-label-default-lg-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-active-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-active-pressed-opacity': 0.65,
        'tabBar-tab-label-default-lg-inactive-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-inactive-hover-fontSize': '1rem',
        'tabBar-tab-label-default-lg-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-inactive-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-default-lg-inactive-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-inactive-initial-fontSize': '1rem',
        'tabBar-tab-label-default-lg-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-inactive-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-default-lg-inactive-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-lg-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-lg-inactive-pressed-fontSize': '1rem',
        'tabBar-tab-label-default-lg-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-default-lg-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-default-lg-inactive-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-default-lg-inactive-pressed-opacity': 0.4,
        'tabBar-tab-label-default-sm-active-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-active-hover-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-active-hover-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-active-hover-opacity': 1,
        'tabBar-tab-label-default-sm-active-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-active-initial-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-active-initial-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-active-initial-opacity': 0.8,
        'tabBar-tab-label-default-sm-active-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-active-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-active-pressed-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-active-pressed-opacity': 0.65,
        'tabBar-tab-label-default-sm-inactive-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-inactive-hover-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-inactive-hover-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-default-sm-inactive-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-inactive-initial-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-inactive-initial-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-default-sm-inactive-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-default-sm-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-default-sm-inactive-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-default-sm-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-default-sm-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-default-sm-inactive-pressed-lineHeight': '1rem',
        'tabBar-tab-label-default-sm-inactive-pressed-opacity': 0.4,
        'tabBar-tab-label-highlighted-lg-active-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-active-hover-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-active-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-active-hover-opacity': 1,
        'tabBar-tab-label-highlighted-lg-active-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-active-initial-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-active-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-active-initial-opacity': 0.8,
        'tabBar-tab-label-highlighted-lg-active-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-active-pressed-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-active-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-active-pressed-opacity': 0.65,
        'tabBar-tab-label-highlighted-lg-inactive-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-inactive-hover-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-inactive-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-highlighted-lg-inactive-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-inactive-initial-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-inactive-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-highlighted-lg-inactive-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-fontSize': '1rem',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-highlighted-lg-inactive-pressed-opacity': 0.4,
        'tabBar-tab-label-highlighted-sm-active-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-active-hover-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-active-hover-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-active-hover-opacity': 1,
        'tabBar-tab-label-highlighted-sm-active-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-active-initial-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-active-initial-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-active-initial-opacity': 0.8,
        'tabBar-tab-label-highlighted-sm-active-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-active-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-active-pressed-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-active-pressed-opacity': 0.65,
        'tabBar-tab-label-highlighted-sm-inactive-hover-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-inactive-hover-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-inactive-hover-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-highlighted-sm-inactive-initial-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-inactive-initial-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-inactive-initial-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-highlighted-sm-inactive-pressed-color': 'rgb(0, 0, 0)',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-lineHeight': '1rem',
        'tabBar-tab-label-highlighted-sm-inactive-pressed-opacity': 0.4,
        'tabBar-tab-label-image-lg-active-hover-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-active-hover-fontSize': '1rem',
        'tabBar-tab-label-image-lg-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-active-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-active-hover-opacity': 1,
        'tabBar-tab-label-image-lg-active-initial-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-active-initial-fontSize': '1rem',
        'tabBar-tab-label-image-lg-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-active-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-active-initial-opacity': 0.8,
        'tabBar-tab-label-image-lg-active-pressed-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-active-pressed-fontSize': '1rem',
        'tabBar-tab-label-image-lg-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-active-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-active-pressed-opacity': 0.65,
        'tabBar-tab-label-image-lg-inactive-hover-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-inactive-hover-fontSize': '1rem',
        'tabBar-tab-label-image-lg-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-inactive-hover-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-image-lg-inactive-initial-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-inactive-initial-fontSize': '1rem',
        'tabBar-tab-label-image-lg-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-inactive-initial-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-image-lg-inactive-pressed-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-lg-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-lg-inactive-pressed-fontSize': '1rem',
        'tabBar-tab-label-image-lg-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-image-lg-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-image-lg-inactive-pressed-lineHeight': '1.5rem',
        'tabBar-tab-label-image-lg-inactive-pressed-opacity': 0.4,
        'tabBar-tab-label-image-sm-active-hover-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-active-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-active-hover-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-active-hover-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-active-hover-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-active-hover-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-active-hover-opacity': 1,
        'tabBar-tab-label-image-sm-active-initial-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-active-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-active-initial-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-active-initial-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-active-initial-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-active-initial-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-active-initial-opacity': 0.8,
        'tabBar-tab-label-image-sm-active-pressed-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-active-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-active-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-active-pressed-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-active-pressed-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-active-pressed-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-active-pressed-opacity': 0.65,
        'tabBar-tab-label-image-sm-inactive-hover-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-inactive-hover-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-inactive-hover-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-inactive-hover-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-inactive-hover-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-inactive-hover-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-inactive-hover-opacity': 0.8,
        'tabBar-tab-label-image-sm-inactive-initial-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-inactive-initial-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-inactive-initial-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-inactive-initial-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-inactive-initial-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-inactive-initial-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-inactive-initial-opacity': 0.65,
        'tabBar-tab-label-image-sm-inactive-pressed-color': 'rgb(255, 255, 255)',
        'tabBar-tab-label-image-sm-inactive-pressed-fontFamily': 'Bosch Sans, sans-serif',
        'tabBar-tab-label-image-sm-inactive-pressed-fontSize': '0.75rem',
        'tabBar-tab-label-image-sm-inactive-pressed-fontWeight': 'bold',
        'tabBar-tab-label-image-sm-inactive-pressed-letterSpacing': '0em',
        'tabBar-tab-label-image-sm-inactive-pressed-lineHeight': '1rem',
        'tabBar-tab-label-image-sm-inactive-pressed-opacity': 0.4,
        'tabBar-tabList-base-lg-gap': '2rem',
        'tabBar-tabList-base-sm-gap': '1.5rem',
        'teaser-backgroundColor-image-default': 'rgb(255, 255, 255)',
        'technicalDetails-base-lg-gap': '4rem',
        'technicalDetails-base-sm-gap': '3rem',
        'technicalDetails-description-lg-color': 'rgb(0, 0, 0)',
        'technicalDetails-description-lg-fontFamily': 'Bosch Sans, sans-serif',
        'technicalDetails-description-lg-fontSize': '1rem',
        'technicalDetails-description-lg-fontWeight': 'normal',
        'technicalDetails-description-lg-letterSpacing': '0em',
        'technicalDetails-description-lg-lineHeight': '1.5rem',
        'technicalDetails-description-lg-opacity': 1,
        'technicalDetails-description-sm-color': 'rgb(0, 0, 0)',
        'technicalDetails-description-sm-fontFamily': 'Bosch Sans, sans-serif',
        'technicalDetails-description-sm-fontSize': '0.875rem',
        'technicalDetails-description-sm-fontWeight': 'normal',
        'technicalDetails-description-sm-letterSpacing': '0em',
        'technicalDetails-description-sm-lineHeight': '1.25rem',
        'technicalDetails-description-sm-opacity': 1,
        'technicalDetails-headline-lg-color': 'rgb(0, 0, 0)',
        'technicalDetails-headline-lg-fontFamily': 'Bosch Sans, sans-serif',
        'technicalDetails-headline-lg-fontSize': '1rem',
        'technicalDetails-headline-lg-fontWeight': 'bold',
        'technicalDetails-headline-lg-letterSpacing': '0em',
        'technicalDetails-headline-lg-lineHeight': '1.5rem',
        'technicalDetails-headline-lg-opacity': 0.8,
        'technicalDetails-headline-sm-color': 'rgb(0, 0, 0)',
        'technicalDetails-headline-sm-fontFamily': 'Bosch Sans, sans-serif',
        'technicalDetails-headline-sm-fontSize': '0.875rem',
        'technicalDetails-headline-sm-fontWeight': 'bold',
        'technicalDetails-headline-sm-letterSpacing': '0em',
        'technicalDetails-headline-sm-lineHeight': '1.25rem',
        'technicalDetails-headline-sm-opacity': 0.8,
        'textArea-base-error-filled-background': 'rgb(239, 241, 242)',
        'textArea-base-error-filled-borderBottomLeftRadius': '0',
        'textArea-base-error-filled-borderBottomRightRadius': '0',
        'textArea-base-error-filled-borderBottomWidth': '0.0625rem',
        'textArea-base-error-filled-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-filled-borderLeftWidth': '0.0625rem',
        'textArea-base-error-filled-borderRightWidth': '0.0625rem',
        'textArea-base-error-filled-borderStyle': 'solid',
        'textArea-base-error-filled-borderTopLeftRadius': '0',
        'textArea-base-error-filled-borderTopRightRadius': '0',
        'textArea-base-error-filled-borderTopWidth': '0.0625rem',
        'textArea-base-error-filled-disabled-background': 'rgba(0, 0, 0, 0)',
        'textArea-base-error-filled-disabled-borderBottomLeftRadius': '0',
        'textArea-base-error-filled-disabled-borderBottomRightRadius': '0',
        'textArea-base-error-filled-disabled-borderBottomWidth': '0.0625rem',
        'textArea-base-error-filled-disabled-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-filled-disabled-borderLeftWidth': '0.0625rem',
        'textArea-base-error-filled-disabled-borderRightWidth': '0.0625rem',
        'textArea-base-error-filled-disabled-borderStyle': 'solid',
        'textArea-base-error-filled-disabled-borderTopLeftRadius': '0',
        'textArea-base-error-filled-disabled-borderTopRightRadius': '0',
        'textArea-base-error-filled-disabled-borderTopWidth': '0.0625rem',
        'textArea-base-error-filled-disabled-minHeight': '6.5rem',
        'textArea-base-error-filled-disabled-paddingLeft': '0.75rem',
        'textArea-base-error-filled-disabled-paddingRight': '0.75rem',
        'textArea-base-error-filled-minHeight': '6.5rem',
        'textArea-base-error-filled-paddingLeft': '0.75rem',
        'textArea-base-error-filled-paddingRight': '0.75rem',
        'textArea-base-error-focused-background': 'rgb(224, 226, 229)',
        'textArea-base-error-focused-borderBottomLeftRadius': '0',
        'textArea-base-error-focused-borderBottomRightRadius': '0',
        'textArea-base-error-focused-borderBottomWidth': '0.0625rem',
        'textArea-base-error-focused-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-focused-borderLeftWidth': '0.0625rem',
        'textArea-base-error-focused-borderRightWidth': '0.0625rem',
        'textArea-base-error-focused-borderStyle': 'solid',
        'textArea-base-error-focused-borderTopLeftRadius': '0',
        'textArea-base-error-focused-borderTopRightRadius': '0',
        'textArea-base-error-focused-borderTopWidth': '0.0625rem',
        'textArea-base-error-focused-minHeight': '6.5rem',
        'textArea-base-error-focused-paddingLeft': '0.75rem',
        'textArea-base-error-focused-paddingRight': '0.75rem',
        'textArea-base-error-hover-background': 'rgb(224, 226, 229)',
        'textArea-base-error-hover-borderBottomLeftRadius': '0',
        'textArea-base-error-hover-borderBottomRightRadius': '0',
        'textArea-base-error-hover-borderBottomWidth': '0.0625rem',
        'textArea-base-error-hover-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-hover-borderLeftWidth': '0.0625rem',
        'textArea-base-error-hover-borderRightWidth': '0.0625rem',
        'textArea-base-error-hover-borderStyle': 'solid',
        'textArea-base-error-hover-borderTopLeftRadius': '0',
        'textArea-base-error-hover-borderTopRightRadius': '0',
        'textArea-base-error-hover-borderTopWidth': '0.0625rem',
        'textArea-base-error-hover-minHeight': '6.5rem',
        'textArea-base-error-hover-paddingLeft': '0.75rem',
        'textArea-base-error-hover-paddingRight': '0.75rem',
        'textArea-base-error-initial-background': 'rgb(239, 241, 242)',
        'textArea-base-error-initial-borderBottomLeftRadius': '0',
        'textArea-base-error-initial-borderBottomRightRadius': '0',
        'textArea-base-error-initial-borderBottomWidth': '0.0625rem',
        'textArea-base-error-initial-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-initial-borderLeftWidth': '0.0625rem',
        'textArea-base-error-initial-borderRightWidth': '0.0625rem',
        'textArea-base-error-initial-borderStyle': 'solid',
        'textArea-base-error-initial-borderTopLeftRadius': '0',
        'textArea-base-error-initial-borderTopRightRadius': '0',
        'textArea-base-error-initial-borderTopWidth': '0.0625rem',
        'textArea-base-error-initial-disabled-background': 'rgba(0, 0, 0, 0)',
        'textArea-base-error-initial-disabled-borderBottomLeftRadius': '0',
        'textArea-base-error-initial-disabled-borderBottomRightRadius': '0',
        'textArea-base-error-initial-disabled-borderBottomWidth': '0.0625rem',
        'textArea-base-error-initial-disabled-borderColor': 'rgb(237, 0, 7)',
        'textArea-base-error-initial-disabled-borderLeftWidth': '0.0625rem',
        'textArea-base-error-initial-disabled-borderRightWidth': '0.0625rem',
        'textArea-base-error-initial-disabled-borderStyle': 'solid',
        'textArea-base-error-initial-disabled-borderTopLeftRadius': '0',
        'textArea-base-error-initial-disabled-borderTopRightRadius': '0',
        'textArea-base-error-initial-disabled-borderTopWidth': '0.0625rem',
        'textArea-base-error-initial-disabled-minHeight': '6.5rem',
        'textArea-base-error-initial-disabled-paddingLeft': '0.75rem',
        'textArea-base-error-initial-disabled-paddingRight': '0.75rem',
        'textArea-base-error-initial-minHeight': '6.5rem',
        'textArea-base-error-initial-paddingLeft': '0.75rem',
        'textArea-base-error-initial-paddingRight': '0.75rem',
        'textArea-base-idle-filled-background': 'rgb(239, 241, 242)',
        'textArea-base-idle-filled-borderBottomLeftRadius': '0',
        'textArea-base-idle-filled-borderBottomRightRadius': '0',
        'textArea-base-idle-filled-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-filled-borderColor': 'rgba(0, 0, 0, 0)',
        'textArea-base-idle-filled-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-filled-borderRightWidth': '0.0625rem',
        'textArea-base-idle-filled-borderStyle': 'solid',
        'textArea-base-idle-filled-borderTopLeftRadius': '0',
        'textArea-base-idle-filled-borderTopRightRadius': '0',
        'textArea-base-idle-filled-borderTopWidth': '0.0625rem',
        'textArea-base-idle-filled-disabled-background': 'rgba(0, 0, 0, 0)',
        'textArea-base-idle-filled-disabled-borderBottomLeftRadius': '0',
        'textArea-base-idle-filled-disabled-borderBottomRightRadius': '0',
        'textArea-base-idle-filled-disabled-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-filled-disabled-borderColor': 'rgb(224, 226, 229)',
        'textArea-base-idle-filled-disabled-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-filled-disabled-borderRightWidth': '0.0625rem',
        'textArea-base-idle-filled-disabled-borderStyle': 'solid',
        'textArea-base-idle-filled-disabled-borderTopLeftRadius': '0',
        'textArea-base-idle-filled-disabled-borderTopRightRadius': '0',
        'textArea-base-idle-filled-disabled-borderTopWidth': '0.0625rem',
        'textArea-base-idle-filled-disabled-minHeight': '6.5rem',
        'textArea-base-idle-filled-disabled-paddingLeft': '0.75rem',
        'textArea-base-idle-filled-disabled-paddingRight': '0.75rem',
        'textArea-base-idle-filled-minHeight': '6.5rem',
        'textArea-base-idle-filled-paddingLeft': '0.75rem',
        'textArea-base-idle-filled-paddingRight': '0.75rem',
        'textArea-base-idle-focused-background': 'rgb(224, 226, 229)',
        'textArea-base-idle-focused-borderBottomLeftRadius': '0',
        'textArea-base-idle-focused-borderBottomRightRadius': '0',
        'textArea-base-idle-focused-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-focused-borderColor': 'rgb(0, 98, 154)',
        'textArea-base-idle-focused-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-focused-borderRightWidth': '0.0625rem',
        'textArea-base-idle-focused-borderStyle': 'solid',
        'textArea-base-idle-focused-borderTopLeftRadius': '0',
        'textArea-base-idle-focused-borderTopRightRadius': '0',
        'textArea-base-idle-focused-borderTopWidth': '0.0625rem',
        'textArea-base-idle-focused-minHeight': '6.5rem',
        'textArea-base-idle-focused-paddingLeft': '0.75rem',
        'textArea-base-idle-focused-paddingRight': '0.75rem',
        'textArea-base-idle-hover-background': 'rgb(224, 226, 229)',
        'textArea-base-idle-hover-borderBottomLeftRadius': '0',
        'textArea-base-idle-hover-borderBottomRightRadius': '0',
        'textArea-base-idle-hover-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-hover-borderColor': 'rgba(0, 0, 0, 0)',
        'textArea-base-idle-hover-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-hover-borderRightWidth': '0.0625rem',
        'textArea-base-idle-hover-borderStyle': 'solid',
        'textArea-base-idle-hover-borderTopLeftRadius': '0',
        'textArea-base-idle-hover-borderTopRightRadius': '0',
        'textArea-base-idle-hover-borderTopWidth': '0.0625rem',
        'textArea-base-idle-hover-minHeight': '6.5rem',
        'textArea-base-idle-hover-paddingLeft': '0.75rem',
        'textArea-base-idle-hover-paddingRight': '0.75rem',
        'textArea-base-idle-initial-background': 'rgb(239, 241, 242)',
        'textArea-base-idle-initial-borderBottomLeftRadius': '0',
        'textArea-base-idle-initial-borderBottomRightRadius': '0',
        'textArea-base-idle-initial-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-initial-borderColor': 'rgba(0, 0, 0, 0)',
        'textArea-base-idle-initial-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-initial-borderRightWidth': '0.0625rem',
        'textArea-base-idle-initial-borderStyle': 'solid',
        'textArea-base-idle-initial-borderTopLeftRadius': '0',
        'textArea-base-idle-initial-borderTopRightRadius': '0',
        'textArea-base-idle-initial-borderTopWidth': '0.0625rem',
        'textArea-base-idle-initial-disabled-background': 'rgba(0, 0, 0, 0)',
        'textArea-base-idle-initial-disabled-borderBottomLeftRadius': '0',
        'textArea-base-idle-initial-disabled-borderBottomRightRadius': '0',
        'textArea-base-idle-initial-disabled-borderBottomWidth': '0.0625rem',
        'textArea-base-idle-initial-disabled-borderColor': 'rgb(224, 226, 229)',
        'textArea-base-idle-initial-disabled-borderLeftWidth': '0.0625rem',
        'textArea-base-idle-initial-disabled-borderRightWidth': '0.0625rem',
        'textArea-base-idle-initial-disabled-borderStyle': 'solid',
        'textArea-base-idle-initial-disabled-borderTopLeftRadius': '0',
        'textArea-base-idle-initial-disabled-borderTopRightRadius': '0',
        'textArea-base-idle-initial-disabled-borderTopWidth': '0.0625rem',
        'textArea-base-idle-initial-disabled-minHeight': '6.5rem',
        'textArea-base-idle-initial-disabled-paddingLeft': '0.75rem',
        'textArea-base-idle-initial-disabled-paddingRight': '0.75rem',
        'textArea-base-idle-initial-minHeight': '6.5rem',
        'textArea-base-idle-initial-paddingLeft': '0.75rem',
        'textArea-base-idle-initial-paddingRight': '0.75rem',
        'textArea-content-base-gap': '0',
        'textArea-content-base-paddingInline': '0.5rem',
        'textArea-content-label-filled-color': 'rgb(0, 0, 0)',
        'textArea-content-label-filled-disabled-color': 'rgb(0, 0, 0)',
        'textArea-content-label-filled-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-filled-disabled-fontSize': '0.75rem',
        'textArea-content-label-filled-disabled-fontWeight': 'normal',
        'textArea-content-label-filled-disabled-letterSpacing': '0em',
        'textArea-content-label-filled-disabled-lineHeight': '1rem',
        'textArea-content-label-filled-disabled-opacity': 0.65,
        'textArea-content-label-filled-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-filled-fontSize': '0.75rem',
        'textArea-content-label-filled-fontWeight': 'normal',
        'textArea-content-label-filled-letterSpacing': '0em',
        'textArea-content-label-filled-lineHeight': '1rem',
        'textArea-content-label-filled-opacity': 0.8,
        'textArea-content-label-focused-color': 'rgb(0, 0, 0)',
        'textArea-content-label-focused-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-focused-fontSize': '0.75rem',
        'textArea-content-label-focused-fontWeight': 'normal',
        'textArea-content-label-focused-letterSpacing': '0em',
        'textArea-content-label-focused-lineHeight': '1rem',
        'textArea-content-label-focused-opacity': 0.8,
        'textArea-content-label-hover-color': 'rgb(0, 0, 0)',
        'textArea-content-label-hover-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-hover-fontSize': '0.75rem',
        'textArea-content-label-hover-fontWeight': 'normal',
        'textArea-content-label-hover-letterSpacing': '0em',
        'textArea-content-label-hover-lineHeight': '1rem',
        'textArea-content-label-hover-opacity': 1,
        'textArea-content-label-initial-color': 'rgb(0, 0, 0)',
        'textArea-content-label-initial-disabled-color': 'rgb(0, 0, 0)',
        'textArea-content-label-initial-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-initial-disabled-fontSize': '0.75rem',
        'textArea-content-label-initial-disabled-fontWeight': 'normal',
        'textArea-content-label-initial-disabled-letterSpacing': '0em',
        'textArea-content-label-initial-disabled-lineHeight': '1rem',
        'textArea-content-label-initial-disabled-opacity': 0.65,
        'textArea-content-label-initial-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-label-initial-fontSize': '0.75rem',
        'textArea-content-label-initial-fontWeight': 'normal',
        'textArea-content-label-initial-letterSpacing': '0em',
        'textArea-content-label-initial-lineHeight': '1rem',
        'textArea-content-label-initial-opacity': 0.8,
        'textArea-content-placeholder-focused-color': 'rgb(0, 0, 0)',
        'textArea-content-placeholder-focused-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-placeholder-focused-fontSize': '1rem',
        'textArea-content-placeholder-focused-fontWeight': 'normal',
        'textArea-content-placeholder-focused-letterSpacing': '0em',
        'textArea-content-placeholder-focused-lineHeight': '1.5rem',
        'textArea-content-placeholder-focused-opacity': 0.4,
        'textArea-content-placeholder-hover-color': 'rgb(0, 0, 0)',
        'textArea-content-placeholder-hover-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-placeholder-hover-fontSize': '1rem',
        'textArea-content-placeholder-hover-fontWeight': 'normal',
        'textArea-content-placeholder-hover-letterSpacing': '0em',
        'textArea-content-placeholder-hover-lineHeight': '1.5rem',
        'textArea-content-placeholder-hover-opacity': 0.4,
        'textArea-content-placeholder-initial-color': 'rgb(0, 0, 0)',
        'textArea-content-placeholder-initial-disabled-color': 'rgb(0, 0, 0)',
        'textArea-content-placeholder-initial-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-placeholder-initial-disabled-fontSize': '1rem',
        'textArea-content-placeholder-initial-disabled-fontWeight': 'normal',
        'textArea-content-placeholder-initial-disabled-letterSpacing': '0em',
        'textArea-content-placeholder-initial-disabled-lineHeight': '1.5rem',
        'textArea-content-placeholder-initial-disabled-opacity': 0.4,
        'textArea-content-placeholder-initial-fontFamily': 'Bosch Sans, sans-serif',
        'textArea-content-placeholder-initial-fontSize': '1rem',
        'textArea-content-placeholder-initial-fontWeight': 'normal',
        'textArea-content-placeholder-initial-letterSpacing': '0em',
        'textArea-content-placeholder-initial-lineHeight': '1.5rem',
        'textArea-content-placeholder-initial-opacity': 0.4,
        'textArea-dragIndicator-filled-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-filled-disabled-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-filled-disabled-opacity': 0.2,
        'textArea-dragIndicator-filled-opacity': 0.2,
        'textArea-dragIndicator-focused-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-focused-opacity': 0.2,
        'textArea-dragIndicator-hover-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-hover-opacity': 0.4,
        'textArea-dragIndicator-initial-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-initial-disabled-background': 'rgb(0, 0, 0)',
        'textArea-dragIndicator-initial-disabled-opacity': 0.2,
        'textArea-dragIndicator-initial-opacity': 0.2,
        'textField-base-error-filled-background': 'rgb(224, 226, 229)',
        'textField-base-error-filled-borderLeftWidth': '0',
        'textField-base-error-filled-borderRightWidth': '0',
        'textField-base-error-filled-borderTopWidth': '0',
        'textField-base-error-filled-disabled-background': 'rgb(224, 226, 229)',
        'textField-base-error-filled-disabled-borderLeftWidth': '0',
        'textField-base-error-filled-disabled-borderRightWidth': '0',
        'textField-base-error-filled-disabled-borderTopWidth': '0',
        'textField-base-error-focused-background': 'rgb(209, 228, 255)',
        'textField-base-error-focused-borderLeftWidth': '0',
        'textField-base-error-focused-borderRightWidth': '0',
        'textField-base-error-focused-borderTopWidth': '0',
        'textField-base-error-hover-background': 'rgb(193, 199, 204)',
        'textField-base-error-hover-borderLeftWidth': '0',
        'textField-base-error-hover-borderRightWidth': '0',
        'textField-base-error-hover-borderTopWidth': '0',
        'textField-base-error-initial-background': 'rgb(224, 226, 229)',
        'textField-base-error-initial-borderLeftWidth': '0',
        'textField-base-error-initial-borderRightWidth': '0',
        'textField-base-error-initial-borderTopWidth': '0',
        'textField-base-error-initial-disabled-background': 'rgb(224, 226, 229)',
        'textField-base-error-initial-disabled-borderLeftWidth': '0',
        'textField-base-error-initial-disabled-borderRightWidth': '0',
        'textField-base-error-initial-disabled-borderTopWidth': '0',
        'textField-base-idle-filled-background': 'rgb(224, 226, 229)',
        'textField-base-idle-filled-borderColor': 'rgb(0, 0, 0)',
        'textField-base-idle-filled-borderLeftWidth': '0',
        'textField-base-idle-filled-borderRightWidth': '0',
        'textField-base-idle-filled-borderStyle': 'solid',
        'textField-base-idle-filled-borderTopWidth': '0',
        'textField-base-idle-filled-disabled-background': 'rgb(224, 226, 229)',
        'textField-base-idle-filled-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'textField-base-idle-filled-disabled-borderLeftWidth': '0',
        'textField-base-idle-filled-disabled-borderRightWidth': '0',
        'textField-base-idle-filled-disabled-borderStyle': 'solid',
        'textField-base-idle-filled-disabled-borderTopWidth': '0',
        'textField-base-idle-focused-background': 'rgb(209, 228, 255)',
        'textField-base-idle-focused-borderColor': 'rgb(0, 0, 0)',
        'textField-base-idle-focused-borderLeftWidth': '0',
        'textField-base-idle-focused-borderRightWidth': '0',
        'textField-base-idle-focused-borderStyle': 'solid',
        'textField-base-idle-focused-borderTopWidth': '0',
        'textField-base-idle-hover-background': 'rgb(193, 199, 204)',
        'textField-base-idle-hover-borderColor': 'rgb(0, 0, 0)',
        'textField-base-idle-hover-borderLeftWidth': '0',
        'textField-base-idle-hover-borderRightWidth': '0',
        'textField-base-idle-hover-borderStyle': 'solid',
        'textField-base-idle-hover-borderTopWidth': '0',
        'textField-base-idle-initial-background': 'rgb(224, 226, 229)',
        'textField-base-idle-initial-borderColor': 'rgb(0, 0, 0)',
        'textField-base-idle-initial-borderLeftWidth': '0',
        'textField-base-idle-initial-borderRightWidth': '0',
        'textField-base-idle-initial-borderStyle': 'solid',
        'textField-base-idle-initial-borderTopWidth': '0',
        'textField-base-idle-initial-disabled-background': 'rgb(224, 226, 229)',
        'textField-base-idle-initial-disabled-borderColor': 'rgba(0, 0, 0, 0.3)',
        'textField-base-idle-initial-disabled-borderLeftWidth': '0',
        'textField-base-idle-initial-disabled-borderRightWidth': '0',
        'textField-base-idle-initial-disabled-borderStyle': 'solid',
        'textField-base-idle-initial-disabled-borderTopWidth': '0',
        'textField-content-input-filled-color': 'rgb(0, 0, 0)',
        'textField-content-input-filled-disabled-color': 'rgb(0, 0, 0)',
        'textField-content-input-filled-disabled-fontFamily': 'Bosch Sans, sans-serif',
        'textField-content-input-filled-disabled-fontSize': '1rem',
        'textField-content-input-filled-disabled-fontWeight': 'normal',
        'textField-content-input-filled-disabled-letterSpacing': '0em',
        'textField-content-input-filled-disabled-lineHeight': '1.5rem',
        'textField-content-input-filled-disabled-opacity': 0.65,
        'textField-content-input-filled-fontFamily': 'Bosch Sans, sans-serif',
        'textField-content-input-filled-fontSize': '1rem',
        'textField-content-input-filled-fontWeight': 'normal',
        'textField-content-input-filled-letterSpacing': '0em',
        'textField-content-input-filled-lineHeight': '1.5rem',
        'textField-content-input-filled-opacity': 0.8,
        'textField-content-input-focused-color': 'rgb(0, 0, 0)',
        'textField-content-input-focused-fontFamily': 'Bosch Sans, sans-serif',
        'textField-content-input-focused-fontSize': '1rem',
        'textField-content-input-focused-fontWeight': 'normal',
        'textField-content-input-focused-letterSpacing': '0em',
        'textField-content-input-focused-lineHeight': '1.5rem',
        'textField-content-input-focused-opacity': 0.8,
        'textField-content-label-filled-background': 'rgb(0, 0, 0)',
        'textField-content-label-filled-disabled-background': 'rgb(0, 0, 0)',
        'textField-content-label-filled-disabled-opacity': 0.4,
        'textField-content-label-focused-background': 'rgb(0, 0, 0)',
        'textField-content-label-hover-background': 'rgb(0, 0, 0)',
        'textField-content-label-hover-opacity': 0.65,
        'textField-content-label-initial-background': 'rgb(0, 0, 0)',
        'textField-content-label-initial-disabled-background': 'rgb(0, 0, 0)',
        'textField-content-label-initial-disabled-opacity': 0.4,
        'textField-content-label-initial-opacity': 0.65,
        'toggle-base-lg-active-default-background': 'rgb(0, 123, 192)',
        'toggle-base-lg-active-default-borderRadius': '624.9375rem',
        'toggle-base-lg-active-default-paddingBottom': '0.25rem',
        'toggle-base-lg-active-default-paddingLeft': '0.25rem',
        'toggle-base-lg-active-default-paddingRight': '0.25rem',
        'toggle-base-lg-active-default-paddingTop': '0.25rem',
        'toggle-base-lg-active-default-width': '4rem',
        'toggle-base-lg-active-hover-background': 'rgb(0, 98, 154)',
        'toggle-base-lg-active-hover-borderRadius': '624.9375rem',
        'toggle-base-lg-active-hover-paddingBottom': '0.25rem',
        'toggle-base-lg-active-hover-paddingLeft': '0.25rem',
        'toggle-base-lg-active-hover-paddingRight': '0.25rem',
        'toggle-base-lg-active-hover-paddingTop': '0.25rem',
        'toggle-base-lg-active-hover-width': '4rem',
        'toggle-base-lg-active-pressed-background': 'rgb(0, 73, 117)',
        'toggle-base-lg-active-pressed-borderRadius': '624.9375rem',
        'toggle-base-lg-active-pressed-paddingBottom': '0.25rem',
        'toggle-base-lg-active-pressed-paddingLeft': '0.25rem',
        'toggle-base-lg-active-pressed-paddingRight': '0.25rem',
        'toggle-base-lg-active-pressed-paddingTop': '0.25rem',
        'toggle-base-lg-active-pressed-width': '4rem',
        'toggle-base-lg-inactive-default-background': 'rgb(224, 226, 229)',
        'toggle-base-lg-inactive-default-borderRadius': '624.9375rem',
        'toggle-base-lg-inactive-default-paddingBottom': '0.25rem',
        'toggle-base-lg-inactive-default-paddingLeft': '0.25rem',
        'toggle-base-lg-inactive-default-paddingRight': '0.25rem',
        'toggle-base-lg-inactive-default-paddingTop': '0.25rem',
        'toggle-base-lg-inactive-default-width': '4rem',
        'toggle-base-lg-inactive-hover-background': 'rgb(224, 226, 229)',
        'toggle-base-lg-inactive-hover-borderRadius': '624.9375rem',
        'toggle-base-lg-inactive-hover-paddingBottom': '0.25rem',
        'toggle-base-lg-inactive-hover-paddingLeft': '0.25rem',
        'toggle-base-lg-inactive-hover-paddingRight': '0.25rem',
        'toggle-base-lg-inactive-hover-paddingTop': '0.25rem',
        'toggle-base-lg-inactive-hover-width': '4rem',
        'toggle-base-lg-inactive-pressed-background': 'rgb(224, 226, 229)',
        'toggle-base-lg-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-base-lg-inactive-pressed-paddingBottom': '0.25rem',
        'toggle-base-lg-inactive-pressed-paddingLeft': '0.25rem',
        'toggle-base-lg-inactive-pressed-paddingRight': '0.25rem',
        'toggle-base-lg-inactive-pressed-paddingTop': '0.25rem',
        'toggle-base-lg-inactive-pressed-width': '4rem',
        'toggle-base-md-active-default-background': 'rgb(0, 123, 192)',
        'toggle-base-md-active-default-borderRadius': '624.9375rem',
        'toggle-base-md-active-default-paddingBottom': '0.25rem',
        'toggle-base-md-active-default-paddingLeft': '0.25rem',
        'toggle-base-md-active-default-paddingRight': '0.25rem',
        'toggle-base-md-active-default-paddingTop': '0.25rem',
        'toggle-base-md-active-default-width': '3rem',
        'toggle-base-md-active-hover-background': 'rgb(0, 98, 154)',
        'toggle-base-md-active-hover-borderRadius': '624.9375rem',
        'toggle-base-md-active-hover-paddingBottom': '0.25rem',
        'toggle-base-md-active-hover-paddingLeft': '0.25rem',
        'toggle-base-md-active-hover-paddingRight': '0.25rem',
        'toggle-base-md-active-hover-paddingTop': '0.25rem',
        'toggle-base-md-active-hover-width': '3rem',
        'toggle-base-md-active-pressed-background': 'rgb(0, 73, 117)',
        'toggle-base-md-active-pressed-borderRadius': '624.9375rem',
        'toggle-base-md-active-pressed-paddingBottom': '0.25rem',
        'toggle-base-md-active-pressed-paddingLeft': '0.25rem',
        'toggle-base-md-active-pressed-paddingRight': '0.25rem',
        'toggle-base-md-active-pressed-paddingTop': '0.25rem',
        'toggle-base-md-active-pressed-width': '3rem',
        'toggle-base-md-inactive-default-background': 'rgb(224, 226, 229)',
        'toggle-base-md-inactive-default-borderRadius': '624.9375rem',
        'toggle-base-md-inactive-default-paddingBottom': '0.25rem',
        'toggle-base-md-inactive-default-paddingLeft': '0.25rem',
        'toggle-base-md-inactive-default-paddingRight': '0.25rem',
        'toggle-base-md-inactive-default-paddingTop': '0.25rem',
        'toggle-base-md-inactive-default-width': '3rem',
        'toggle-base-md-inactive-hover-background': 'rgb(224, 226, 229)',
        'toggle-base-md-inactive-hover-borderRadius': '624.9375rem',
        'toggle-base-md-inactive-hover-paddingBottom': '0.25rem',
        'toggle-base-md-inactive-hover-paddingLeft': '0.25rem',
        'toggle-base-md-inactive-hover-paddingRight': '0.25rem',
        'toggle-base-md-inactive-hover-paddingTop': '0.25rem',
        'toggle-base-md-inactive-hover-width': '3rem',
        'toggle-base-md-inactive-pressed-background': 'rgb(224, 226, 229)',
        'toggle-base-md-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-base-md-inactive-pressed-paddingBottom': '0.25rem',
        'toggle-base-md-inactive-pressed-paddingLeft': '0.25rem',
        'toggle-base-md-inactive-pressed-paddingRight': '0.25rem',
        'toggle-base-md-inactive-pressed-paddingTop': '0.25rem',
        'toggle-base-md-inactive-pressed-width': '3rem',
        'toggle-base-sm-active-default-background': 'rgb(0, 123, 192)',
        'toggle-base-sm-active-default-borderRadius': '624.9375rem',
        'toggle-base-sm-active-default-paddingBottom': '0.25rem',
        'toggle-base-sm-active-default-paddingLeft': '0.25rem',
        'toggle-base-sm-active-default-paddingRight': '0.25rem',
        'toggle-base-sm-active-default-paddingTop': '0.25rem',
        'toggle-base-sm-active-default-width': '2rem',
        'toggle-base-sm-active-hover-background': 'rgb(0, 98, 154)',
        'toggle-base-sm-active-hover-borderRadius': '624.9375rem',
        'toggle-base-sm-active-hover-paddingBottom': '0.25rem',
        'toggle-base-sm-active-hover-paddingLeft': '0.25rem',
        'toggle-base-sm-active-hover-paddingRight': '0.25rem',
        'toggle-base-sm-active-hover-paddingTop': '0.25rem',
        'toggle-base-sm-active-hover-width': '2rem',
        'toggle-base-sm-active-pressed-background': 'rgb(0, 73, 117)',
        'toggle-base-sm-active-pressed-borderRadius': '624.9375rem',
        'toggle-base-sm-active-pressed-paddingBottom': '0.25rem',
        'toggle-base-sm-active-pressed-paddingLeft': '0.25rem',
        'toggle-base-sm-active-pressed-paddingRight': '0.25rem',
        'toggle-base-sm-active-pressed-paddingTop': '0.25rem',
        'toggle-base-sm-active-pressed-width': '2rem',
        'toggle-base-sm-inactive-default-background': 'rgb(224, 226, 229)',
        'toggle-base-sm-inactive-default-borderRadius': '624.9375rem',
        'toggle-base-sm-inactive-default-paddingBottom': '0.25rem',
        'toggle-base-sm-inactive-default-paddingLeft': '0.25rem',
        'toggle-base-sm-inactive-default-paddingRight': '0.25rem',
        'toggle-base-sm-inactive-default-paddingTop': '0.25rem',
        'toggle-base-sm-inactive-default-width': '2rem',
        'toggle-base-sm-inactive-hover-background': 'rgb(224, 226, 229)',
        'toggle-base-sm-inactive-hover-borderRadius': '624.9375rem',
        'toggle-base-sm-inactive-hover-paddingBottom': '0.25rem',
        'toggle-base-sm-inactive-hover-paddingLeft': '0.25rem',
        'toggle-base-sm-inactive-hover-paddingRight': '0.25rem',
        'toggle-base-sm-inactive-hover-paddingTop': '0.25rem',
        'toggle-base-sm-inactive-hover-width': '2rem',
        'toggle-base-sm-inactive-pressed-background': 'rgb(224, 226, 229)',
        'toggle-base-sm-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-base-sm-inactive-pressed-paddingBottom': '0.25rem',
        'toggle-base-sm-inactive-pressed-paddingLeft': '0.25rem',
        'toggle-base-sm-inactive-pressed-paddingRight': '0.25rem',
        'toggle-base-sm-inactive-pressed-paddingTop': '0.25rem',
        'toggle-base-sm-inactive-pressed-width': '2rem',
        'toggle-knob-lg-active-default-background': 'rgb(255, 255, 255)',
        'toggle-knob-lg-active-default-borderRadius': '624.9375rem',
        'toggle-knob-lg-active-default-height': '1.5rem',
        'toggle-knob-lg-active-default-opacity': 0.8,
        'toggle-knob-lg-active-default-width': '1.5rem',
        'toggle-knob-lg-active-hover-background': 'rgb(255, 255, 255)',
        'toggle-knob-lg-active-hover-borderRadius': '624.9375rem',
        'toggle-knob-lg-active-hover-height': '1.5rem',
        'toggle-knob-lg-active-hover-opacity': 1,
        'toggle-knob-lg-active-hover-width': '1.5rem',
        'toggle-knob-lg-active-pressed-background': 'rgb(255, 255, 255)',
        'toggle-knob-lg-active-pressed-borderRadius': '624.9375rem',
        'toggle-knob-lg-active-pressed-height': '1.5rem',
        'toggle-knob-lg-active-pressed-opacity': 0.65,
        'toggle-knob-lg-active-pressed-width': '1.5rem',
        'toggle-knob-lg-inactive-default-background': 'rgb(0, 0, 0)',
        'toggle-knob-lg-inactive-default-borderRadius': '624.9375rem',
        'toggle-knob-lg-inactive-default-height': '1.5rem',
        'toggle-knob-lg-inactive-default-opacity': 0.4,
        'toggle-knob-lg-inactive-default-width': '1.5rem',
        'toggle-knob-lg-inactive-hover-background': 'rgb(0, 0, 0)',
        'toggle-knob-lg-inactive-hover-borderRadius': '624.9375rem',
        'toggle-knob-lg-inactive-hover-height': '1.5rem',
        'toggle-knob-lg-inactive-hover-opacity': 0.65,
        'toggle-knob-lg-inactive-hover-width': '1.5rem',
        'toggle-knob-lg-inactive-pressed-background': 'rgb(0, 0, 0)',
        'toggle-knob-lg-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-knob-lg-inactive-pressed-height': '1.5rem',
        'toggle-knob-lg-inactive-pressed-opacity': 0.4,
        'toggle-knob-lg-inactive-pressed-width': '1.5rem',
        'toggle-knob-md-active-default-background': 'rgb(255, 255, 255)',
        'toggle-knob-md-active-default-borderRadius': '624.9375rem',
        'toggle-knob-md-active-default-height': '1rem',
        'toggle-knob-md-active-default-opacity': 0.8,
        'toggle-knob-md-active-default-width': '1rem',
        'toggle-knob-md-active-hover-background': 'rgb(255, 255, 255)',
        'toggle-knob-md-active-hover-borderRadius': '624.9375rem',
        'toggle-knob-md-active-hover-height': '1rem',
        'toggle-knob-md-active-hover-opacity': 1,
        'toggle-knob-md-active-hover-width': '1rem',
        'toggle-knob-md-active-pressed-background': 'rgb(255, 255, 255)',
        'toggle-knob-md-active-pressed-borderRadius': '624.9375rem',
        'toggle-knob-md-active-pressed-height': '1rem',
        'toggle-knob-md-active-pressed-opacity': 0.65,
        'toggle-knob-md-active-pressed-width': '1rem',
        'toggle-knob-md-inactive-default-background': 'rgb(0, 0, 0)',
        'toggle-knob-md-inactive-default-borderRadius': '624.9375rem',
        'toggle-knob-md-inactive-default-height': '1rem',
        'toggle-knob-md-inactive-default-opacity': 0.4,
        'toggle-knob-md-inactive-default-width': '1rem',
        'toggle-knob-md-inactive-hover-background': 'rgb(0, 0, 0)',
        'toggle-knob-md-inactive-hover-borderRadius': '624.9375rem',
        'toggle-knob-md-inactive-hover-height': '1rem',
        'toggle-knob-md-inactive-hover-opacity': 0.65,
        'toggle-knob-md-inactive-hover-width': '1rem',
        'toggle-knob-md-inactive-pressed-background': 'rgb(0, 0, 0)',
        'toggle-knob-md-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-knob-md-inactive-pressed-height': '1rem',
        'toggle-knob-md-inactive-pressed-opacity': 0.4,
        'toggle-knob-md-inactive-pressed-width': '1rem',
        'toggle-knob-sm-active-default-background': 'rgb(255, 255, 255)',
        'toggle-knob-sm-active-default-borderRadius': '624.9375rem',
        'toggle-knob-sm-active-default-height': '0.75rem',
        'toggle-knob-sm-active-default-opacity': 0.8,
        'toggle-knob-sm-active-default-width': '0.75rem',
        'toggle-knob-sm-active-hover-background': 'rgb(255, 255, 255)',
        'toggle-knob-sm-active-hover-borderRadius': '624.9375rem',
        'toggle-knob-sm-active-hover-height': '0.75rem',
        'toggle-knob-sm-active-hover-opacity': 1,
        'toggle-knob-sm-active-hover-width': '0.75rem',
        'toggle-knob-sm-active-pressed-background': 'rgb(255, 255, 255)',
        'toggle-knob-sm-active-pressed-borderRadius': '624.9375rem',
        'toggle-knob-sm-active-pressed-height': '0.75rem',
        'toggle-knob-sm-active-pressed-opacity': 0.65,
        'toggle-knob-sm-active-pressed-width': '0.75rem',
        'toggle-knob-sm-inactive-default-background': 'rgb(0, 0, 0)',
        'toggle-knob-sm-inactive-default-borderRadius': '624.9375rem',
        'toggle-knob-sm-inactive-default-height': '0.75rem',
        'toggle-knob-sm-inactive-default-opacity': 0.4,
        'toggle-knob-sm-inactive-default-width': '0.75rem',
        'toggle-knob-sm-inactive-hover-background': 'rgb(0, 0, 0)',
        'toggle-knob-sm-inactive-hover-borderRadius': '624.9375rem',
        'toggle-knob-sm-inactive-hover-height': '0.75rem',
        'toggle-knob-sm-inactive-hover-opacity': 0.65,
        'toggle-knob-sm-inactive-hover-width': '0.75rem',
        'toggle-knob-sm-inactive-pressed-background': 'rgb(0, 0, 0)',
        'toggle-knob-sm-inactive-pressed-borderRadius': '624.9375rem',
        'toggle-knob-sm-inactive-pressed-height': '0.75rem',
        'toggle-knob-sm-inactive-pressed-opacity': 0.4,
        'toggle-knob-sm-inactive-pressed-width': '0.75rem',
        'trustedShopList-badge-lg-height': '4rem',
        'trustedShopList-badge-sm-height': '3rem',
        'trustedShopList-base-lg-gap': '1.5rem',
        'trustedShopList-base-sm-gap': '1rem',
        'valueClass-large-level1-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level1-fontSize': '2.625rem',
        'valueClass-large-level1-fontWeight': 'bold',
        'valueClass-large-level1-letterSpacing': '0em',
        'valueClass-large-level1-lineHeight': '3.5rem',
        'valueClass-large-level2-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level2-fontSize': '2.25rem',
        'valueClass-large-level2-fontWeight': 'bold',
        'valueClass-large-level2-letterSpacing': '0em',
        'valueClass-large-level2-lineHeight': '2.75rem',
        'valueClass-large-level3-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level3-fontSize': '2rem',
        'valueClass-large-level3-fontWeight': 'bold',
        'valueClass-large-level3-letterSpacing': '0em',
        'valueClass-large-level3-lineHeight': '2.5rem',
        'valueClass-large-level4-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level4-fontSize': '1.75rem',
        'valueClass-large-level4-fontWeight': 'bold',
        'valueClass-large-level4-letterSpacing': '0em',
        'valueClass-large-level4-lineHeight': '2.25rem',
        'valueClass-large-level5-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level5-fontSize': '1.5rem',
        'valueClass-large-level5-fontWeight': 'bold',
        'valueClass-large-level5-letterSpacing': '0em',
        'valueClass-large-level5-lineHeight': '2rem',
        'valueClass-large-level6-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level6-fontSize': '1.25rem',
        'valueClass-large-level6-fontWeight': 'bold',
        'valueClass-large-level6-letterSpacing': '0em',
        'valueClass-large-level6-lineHeight': '1.75rem',
        'valueClass-large-level7-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-large-level7-fontSize': '1rem',
        'valueClass-large-level7-fontWeight': 'bold',
        'valueClass-large-level7-letterSpacing': '0em',
        'valueClass-large-level7-lineHeight': '1.5rem',
        'valueClass-small-level1-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level1-fontSize': '2.25rem',
        'valueClass-small-level1-fontWeight': 'bold',
        'valueClass-small-level1-letterSpacing': '0em',
        'valueClass-small-level1-lineHeight': '2.75rem',
        'valueClass-small-level2-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level2-fontSize': '2rem',
        'valueClass-small-level2-fontWeight': 'bold',
        'valueClass-small-level2-letterSpacing': '0em',
        'valueClass-small-level2-lineHeight': '2.5rem',
        'valueClass-small-level3-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level3-fontSize': '1.75rem',
        'valueClass-small-level3-fontWeight': 'bold',
        'valueClass-small-level3-letterSpacing': '0em',
        'valueClass-small-level3-lineHeight': '2.25rem',
        'valueClass-small-level4-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level4-fontSize': '1.5rem',
        'valueClass-small-level4-fontWeight': 'bold',
        'valueClass-small-level4-letterSpacing': '0em',
        'valueClass-small-level4-lineHeight': '2rem',
        'valueClass-small-level5-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level5-fontSize': '1.25rem',
        'valueClass-small-level5-fontWeight': 'bold',
        'valueClass-small-level5-letterSpacing': '0em',
        'valueClass-small-level5-lineHeight': '1.75rem',
        'valueClass-small-level6-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level6-fontSize': '1rem',
        'valueClass-small-level6-fontWeight': 'bold',
        'valueClass-small-level6-letterSpacing': '0em',
        'valueClass-small-level6-lineHeight': '1.5rem',
        'valueClass-small-level7-fontFamily': 'Bosch Sans, sans-serif',
        'valueClass-small-level7-fontSize': '0.875rem',
        'valueClass-small-level7-fontWeight': 'bold',
        'valueClass-small-level7-letterSpacing': '0em',
        'valueClass-small-level7-lineHeight': '1.25rem',
    },
    transform: {
        'scale-down-lg': 'scale(0.94)',
        'scale-down-md': 'scale(0.96)',
        'scale-down-sm': 'scale(0.98)',
        'scale-up-lg': 'scale(1.06)',
        'scale-up-md': 'scale(1.04)',
        'scale-up-sm': 'scale(1.02)',
    },
    wrapper: {
        'width-2xl': '72.5rem',
        'width-2xs': '23.5rem',
        'width-3xl': '87.5rem',
        'width-3xs': '21.5rem',
        'width-lg': '50rem',
        'width-md': '42rem',
        'width-sm': '28rem',
        'width-xl': '60rem',
        'width-xs': '26rem',
    },
};
//# sourceMappingURL=bosch-light.js.map